const messagesAR = {
    code: "ar",
    messages: {
        cache: {
            management: "إدارة التخزين المؤقت",
            createNew: "إنشاء cache جديد",
            keySearchPlaceholder: "البحث عن المفتاح (wildcard مدعوم: *chat*, chat*, *chat)",
            type: "نوع Cache",
            actorType: "نوع الممثل",
            selectAutomation: "اختر الأتمتة",
            selectChatbot: "اختر الشات بوت",
            selectUser: "اختر المستخدم",
            clearFilters: "مسح الفلاتر",
            deleteSelected: "حذف المحدد",
            extendSelected: "تمديد مدة المحدد",
            makeSelectedNeverExpire: "جعل المحدد لا ينتهي أبداً",
            deleteAllActorCaches: "حذف جميع cache لهذا الممثل",
            emptyState: "لم يتم العثور على cache بعد",
            editCache: "تعديل Cache",
            key: "مفتاح Cache",
            keyPlaceholder: "مثال: user_session_123",
            value: "قيمة Cache",
            stringValuePlaceholder: "قيمة نصية",
            dataType: "نوع البيانات",
            validityDuration: "مدة الصلاحية",
            neverExpire: "لا ينتهي أبداً",
            specifyDuration: "تحديد المدة",
            specifyDate: "تحديد التاريخ",
            minutes: "دقائق",
            hours: "ساعات",
            days: "أيام",
            update: "تحديث",
            create: "إنشاء",
            bulkExtend: "تمديد جماعي",
            bulkExtendInfo: "سيتم تمديد مدة صلاحية {count} cache.",
            newValidityDuration: "مدة صلاحية جديدة",
            extend: "تمديد",
            keyLabel: "المفتاح",
            valueLabel: "القيمة",
            typeLabel: "النوع",
            createdBy: "أنشئ بواسطة",
            createdAt: "تاريخ الإنشاء",
            updatedBy: "تم التحديث بواسطة",
            expiresAt: "تاريخ الانتهاء",
            actions: "الإجراءات",
            edit: "تعديل",
            extendDuration: "تمديد المدة",
            makeNeverExpire: "جعل لا ينتهي أبداً",
            loadError: "فشل تحميل قائمة cache",
            updateSuccess: "تم تحديث cache",
            createSuccess: "تم إنشاء cache",
            saveError: "فشل حفظ cache",
            deleteCache: "حذف Cache",
            confirmDelete: "نعم، احذف",
            deleteSuccess: "تم حذف cache",
            extendSuccess24h: "تم تمديد مدة cache 24 ساعة",
            extendError: "فشل تمديد مدة cache",
            deleteActorCaches: "حذف cache الممثل",
            deleteActorCachesConfirm: "هل أنت متأكد من حذف جميع cache لـ \"{actor}\"؟ لا يمكن التراجع عن هذا الإجراء.",
            confirmDeleteAll: "نعم، احذف الكل",
            countDeleted: "تم حذف {count} cache",
            bulkDelete: "حذف جماعي",
            bulkDeleteConfirm: "سيتم حذف {count} cache. هل أنت متأكد؟",
            bulkMakeNeverExpire: "جعل جماعي لا ينتهي أبداً",
            bulkMakeNeverExpireConfirm: "سيتم إزالة الانتهاء من {count} cache. هل أنت متأكد؟",
            makeNeverExpireSuccess: "تم جعل cache لا ينتهي أبداً",
            makeNeverExpireError: "فشل جعل cache لا ينتهي أبداً",
            bulkExtendError: "فشل تمديد مدة cache",
            bulkExtendSuccess: "تم تمديد مدة {count} cache",
            bulkMakeNeverExpireSuccess: "تم جعل {count} cache لا ينتهي أبداً",
            deleteCacheConfirm: "هل أنت متأكد من حذف cache \"{key}\"؟",
            selectedCount: "تم تحديد {count} cache",
            valueTitle: "قيمة Cache: {key}",
            never: "أبداً",
            automation: "أتمتة",
            chatbot: "شات بوت",
            user: "مستخدم",
            api: "API",
            all: "الكل",
            public: "عام",
            private: "خاص"
        },
        zoho: {
            SETTING_GROUP: "الإعدادات",
            usermapping: "تعيين المستخدمين"
        },
        chatWindow: {
            descending: "تنازلي",
            ascending: "تصاعدي",
            filterTable: "تصفية",
            thereIsNoChatContent: "لا يوجد محتوى للدردشة.",
            thereIsNoChatContentDsc: "يمكنك عرض محتوى الدردشة وإرسال الرسائل هنا.",
            interactions: "التفاعلات:",
            departments: "الأقسام",
            channels: "القنوات",
            date: "التاريخ",
            lastChatStatus: "آخر حالة للدردشة",
            all: "الكل",
            queued: "في الانتظار",
            open: "مفتوح",
            closed: "مغلق",
            private: "خاص",
            chatbot: "روبوت الدردشة",
            lostMissed: "مفقود / غير مستجاب",
            interaction: "التفاعل",
            myActiveInbox: "بريدي الوارد النشط",
            activeQueueInbox: "البريد الوارد النشط + الانتظار",
            chatbotActiveInbox: "البريد الوارد النشط لروبوت الدردشة",
            myDepartmentsActiveInbox: "البريد الوارد النشط لأقسامى",
            notInteractedYesterday: "لا تفاعلات بالأمس",
            queueInbox: "البريد الوارد في الانتظار",
            whatsappActiveInbox: "البريد الوارد النشط لـ WhatsApp",
            socialMediaActiveInbox: "البريد الوارد النشط لوسائل التواصل الاجتماعي",
            missedThisMonth: "الدردشات الفائتة هذا الشهر",
            chooseAFileOrDragItHere: "اختر ملفًا أو اسحبه هنا!",
            watching: "مشاهدة",
            selectFilter: "اختر مرشحًا",
            clearAll: "مسح الكل",
            me: "أنا",
            today: "اليوم",
            yesterday: "أمس",
            thisWeek: "هذا الأسبوع",
            lastWeek: "الأسبوع الماضي",
            last7Days: "آخر 7 أيام",
            last30Days: "آخر 30 يومًا",
            thisMonth: "هذا الشهر",
            lastMonth: "الشهر الماضي",
            last24h: "آخر 24 ساعة",
            custom: "مخصص",
            startMessage: "بدء الرسالة",
            goToAgentReport: "اذهب إلى تقرير الوكيل",
            agentDetail: "تفاصيل الوكيل",
            agentList: "قائمة الوكلاء",
            selectedFilter: "عامل التصفية المحدد",
            groupBy: "تجميع",
            none: "لا توجد مجموعة",
            agent: "ممثل",
            department: "قسم",
            tag: "التسمية",
            website: "الموقع الإلكتروني",
            channel: "القناة",
            platform: "المنصة",
            answerStatus: "حالة الإجابة",
            sortBy: "ترتيب",
            lastPostAbove: "آخر منشور في الأعلى",
            newChatsAbove: "الدردشات الجديدة في الأعلى",
            oldChatsAbove: "الدردشات القديمة في الأعلى",
            live: "يعيش",
            systemStatus: "حالة النظام",
            refresh: "تحديث",
            close: "إغلاق",
            totalCustomers: "إجمالي العملاء",
            totalAnswered: "إجمالي الردود",
            waitingAnswer: "بانتظار الرد",
            totalAgentInChat: "إجمالي الوكلاء في الدردشة",
            onlineAgentCount: "عدد الوكلاء المتصلين",
            totalCustomer: "إجمالي العميل",
            answered: "تم الرد",
            unanswered: "لم يتم الرد",
            noContactWasFoundMatchingTheCurrentFilters: "لم يتم العثور على أي جهة اتصال مطابقة للمرشحات الحالية.",
            you: "أنت",
            others: "الآخرون",
            queue: "قائمة الانتظار",
            chatbotContact: "شات بوت",
            closedContact: "مغلق",
            myInteractions: "تفاعلاتي",
            special: "خاص",
            allInteractions: "جميع جهات الاتصال",
            waiting: "قيد الانتظار",
            departmentToWhichItIsAffiliated: "القسم التابع له",
            owner: "المالك",
            switchToLiveSupportMode: "التبديل إلى وضع الدعم المباشر",
            switchToLiveSupportModeConfirmation: "هل تريد التبديل إلى وضع الدعم المباشر لعرض جهة الاتصال هذه؟",
            hiddenChatsWarning: "هناك {count} دردشات لا يمكنك رؤيتها في هذه القائمة",
            clickToSeeDetails: "انقر لرؤية التفاصيل",
            viewDetails: "عرض التفاصيل",
            hiddenChatsDetails: "تفاصيل الدردشات المخفية",
            totalHiddenChats: "إجمالي الدردشات المخفية",
            examples: "أمثلة",
            reasons: {
                visitorNotFound: "لم يتم العثور على الزائر",
                noChannelAccess: "ليس لديك صلاحية الوصول إلى هذه القناة",
                ownedByOtherNotChannelOwner: "مملوكة لمستخدم آخر (أنت لست مالك القناة)",
                ownedByOtherNoChannel: "مملوكة لمستخدم آخر (بدون قناة)",
                noOwnerAdminOnly: "دردشة بدون مالك (فقط المسؤولون ومالكو القنوات يمكنهم رؤيتها)"
            }
        },
        chat: {
            inbox: "صندوق الوارد",
            layouts: {
                chat: "تخطيط الدردشة",
                table: "تخطيط الجدول",
                kanban: "تخطيط كانبان"
            },
            filters: {
                allContacts: "جميع جهات الاتصال",
                myInbox: "صندوق الوارد الخاص بي",
                myContacts: "جهات الاتصال الخاصة بي",
                missed: "مفقود",
                unanswered: "لم يتم الرد",
                unassigned: "غير معين",
                chatbot: "روبوت الدردشة"
            },
            groups: {
                views: "العروض",
                customFilters: "مرشحات مخصصة",
                team: "الفريق",
                contacts: "جهات الاتصال",
                system: "النظام"
            },
            sidebar: {
                tabScreen: "شاشة التبويب",
                search: "بحث",
                addNewFilter: "إضافة فلتر جديد",
                edit: "تعديل",
                showInTable: "عرض في وضع الجدول",
                showInKanban: "عرض في وضع كانبان",
                rename: "إعادة التسمية",
                makePublic: "جعله عاماً",
                makePrivate: "جعله خاصاً",
                moveToTop: "نقل إلى الأعلى",
                moveToBottom: "نقل إلى الأسفل",
                delete: "حذف",
                renameFilterTitle: "إعادة تسمية الفلتر",
                filterNamePlaceholder: "أدخل اسم الفلتر",
                positionUpdateError: "خطأ في تحديث الموضع",
                filterNameEmpty: "لا يمكن أن يكون اسم الفلتر فارغاً",
                filterNameUpdated: "تم تحديث اسم الفلتر",
                filterNameUpdateError: "خطأ في تحديث اسم الفلتر",
                filterVisibilityUpdateError: "خطأ في تحديث رؤية الفلتر",
                filterMadePrivate: "تم تعيين الفلتر كخاص",
                filterMadePublic: "تم تعيين الفلتر كعام",
                filterMovedToTop: "تم نقل الفلتر إلى الأعلى",
                filterMovedToBottom: "تم نقل الفلتر إلى الأسفل",
                filterMoveError: "خطأ في نقل الفلتر",
                onlyCreatorOrRootCanDeletePublic: "فقط المنشئ أو مستخدم root يمكنه حذف المرشحات العامة",
                deleteFilterTitle: "حذف الفلتر",
                deleteFilterConfirm: "هل أنت متأكد أنك تريد حذف الفلتر \"{name}\"؟",
                deleteFilterOk: "حذف",
                deleteFilterCancel: "إلغاء",
                filterDeleted: "تم حذف الفلتر",
                filterDeleteError: "خطأ في حذف الفلتر",
                websiteAnalytics: "تحليلات الموقع"
            },
            gridContactList: {
                emptyConversationsTitle: "لم يتم العثور على محادثة",
                emptyConversationsDescription: "ليس لديك محادثة نشطة بعد. يمكنك بدء محادثة جديدة من صفحة العميل.",
                markAsUnanswered: "وضع علامة كغير مجاب",
                markAsAnswered: "وضع علامة كمجاب",
                removeVIP: "إزالة علامة VIP",
                markAsVIP: "وضع علامة كـ VIP",
                markAsRead: "وضع علامة كمقروء",
                markAsUnread: "وضع علامة كغير مقروء",
                closeChat: "إغلاق الدردشة",
                markedAsAnswered: "تم وضع علامة كمجاب",
                markedAsUnanswered: "تم وضع علامة كغير مجاب",
                operationFailed: "فشلت العملية",
                markedAsVIP: "تم وضع علامة كـ VIP",
                vipRemoved: "تمت إزالة علامة VIP",
                markedAsUnread: "تم وضع علامة كغير مقروء",
                markedAsRead: "تم وضع علامة كمقروء",
                confirmCloseChat: "هل أنت متأكد أنك تريد إنهاء الدردشة؟",
                chatClosed: "تم إغلاق الدردشة"
            },
            tableContactList: {
                editFilter: "تعديل الفلتر",
                chatStatus: "حالة الدردشة",
                grouping: "التجميع",
                allContacts: "جميع جهات الاتصال",
                groupNone: "لا شيء",
                groupTag: "الوسم",
                groupDepartment: "القسم",
                groupChannel: "القناة",
                groupPlatform: "المنصة",
                groupOwner: "المالك",
                groupUsers: "المشاركون",
                groupAnswerStatus: "حالة الإجابة",
                statusAll: "الكل",
                statusOpen: "مفتوح",
                statusClosed: "مغلق",
                statusUnknown: "غير معروف",
                copyLabel: "نسخة",
                filterCreatedSuccess: "تم إنشاء الفلتر بنجاح",
                filterCreatedNameDuplicate: "الاسم \"{createName}\" مستخدم بالفعل. تم إنشاء الفلتر باسم \"{filterName}\".",
                filterCreateFailed: "تعذر إنشاء الفلتر",
                filterCreateError: "حدث خطأ أثناء إنشاء الفلتر.",
                platformSupsis: "Supsis",
                platformEmail: "البريد الإلكتروني",
                platformWhatsapp: "WhatsApp",
                platformWeb: "الويب",
                platformInstagram: "Instagram",
                platformTelegram: "Telegram",
                platformMessenger: "Messenger",
                platformMetaLeads: "Meta Leads",
                platformTrendyol: "Trendyol",
                platformLinkedin: "LinkedIn",
                answerStatusAnswered: "تم الرد",
                answerStatusUnanswered: "بدون رد"
            },
            kanbanContactList: {
                filterHide: "إخفاء الفلاتر",
                filterAdd: "إضافة فلتر",
                broadcast: "البث",
                broadcastSelectPlaceholder: "اختر البث...",
                loading: "جاري التحميل...",
                broadcastNotFound: "لم يتم العثور على بث",
                broadcastTitle: "العنوان",
                broadcastDate: "التاريخ",
                broadcastStatus: "الحالة",
                broadcastProgress: "التقدم",
                refresh: "تحديث",
                kanbanLoading: "جاري تحميل Kanban...",
                deletedUser: "مستخدم محذوف",
                unowned: "بدون مالك",
                activeInChat: "نشط (في الدردشة)",
                newInQueue: "جديد (في قائمة الانتظار)",
                agentDown: "الممثل غير متصل",
                closed: "مغلق",
                blocked: "محظور",
                unblocked: "غير محظور",
                groupsLoadError: "خطأ في تحميل المجموعات",
                dataLoadError: "خطأ في تحميل البيانات",
                broadcastsLoadError: "خطأ في تحميل البث",
                dataRefreshed: "تم تحديث البيانات",
                refreshError: "خطأ أثناء التحديث",
                unknownContact: "جهة اتصال غير معروفة",
                assigned: "غير معين",
                platformMobile: "الجوال",
                broadcastStatusCreated: "تم الإنشاء",
                broadcastStatusScheduled: "مجدول",
                broadcastStatusQueued: "في قائمة الانتظار",
                broadcastStatusRunning: "جاري الإرسال",
                broadcastStatusCompleted: "مكتمل",
                broadcastStatusFailed: "فشل",
                broadcastStatusCancelled: "ملغى",
                metaLeadNewLead: "عميل محتمل جديد",
                metaLeadInitialContact: "أول اتصال",
                metaLeadNeedsAssessment: "تقييم الاحتياجات",
                metaLeadProposalSent: "تم إرسال العرض",
                metaLeadProposalReview: "مراجعة العرض",
                metaLeadNegotiation: "تفاوض",
                metaLeadDecisionStage: "مرحلة القرار",
                metaLeadClosure: "الإغلاق",
                metaLeadFollowUp: "متابعة",
                broadcastSent: "تم الإرسال",
                broadcastDelivered: "تم التسليم",
                broadcastRead: "تم القراءة",
                broadcastFailed: "فشل",
                broadcastEdited: "تم التعديل",
                broadcastDeleted: "تم الحذف",
                triggerTypeApi: "API",
                triggerTypeBroadcast: "البث",
                triggerTypeAutomation: "الأتمتة",
                emptyGroup: "لا يوجد جهات اتصال في هذه المجموعة",
                loadMore: "تحميل المزيد...",
                groupSelectTitle: "اختر حقل التجميع",
                searchPlaceholder: "بحث...",
                categoryBasic: "أساسي",
                categoryDemographic: "ديموغرافي",
                categoryTags: "الوسوم والفئة",
                categoryMeta: "Meta Leads",
                categoryBroadcast: "البث",
                categoryOther: "أخرى",
                fieldAnswerStatus: "حالة الإجابة",
                fieldLastConversationStatus: "حالة الدردشة",
                fieldOwner: "المالك",
                fieldUsers: "المشاركون",
                fieldChannel: "القناة",
                fieldPlatform: "المنصة",
                fieldCountry: "البلد",
                fieldCity: "المدينة",
                fieldBrowser: "المتصفح",
                fieldPreferredLang: "اللغة",
                fieldTags: "الوسوم",
                fieldDepartment: "القسم",
                fieldMetaLeadStatus: "حالة العميل المحتمل",
                fieldMetaLeadAdName: "اسم الإعلان",
                fieldMetaLeadAdsetName: "مجموعة الإعلانات",
                fieldMetaLeadCampaignName: "الحملة",
                fieldMetaLeadFormName: "اسم النموذج",
                fieldMetaLeadPlatform: "منصة Meta",
                fieldLastBroadcastStatus: "حالة البث",
                fieldLastBroadcastReason: "سبب البث",
                fieldBlockedSnapshot: "حالة الحظر",
                fieldLastTriggerType: "نوع المحفز",
                fieldZohoLeadStatus: "حالة عميل Zoho",
                fieldZohoLeadSource: "مصدر عميل Zoho",
                broadcastTriggerSuccess: "رد على رسالة البث!",
                broadcastTriggerWaiting: "في انتظار الرد...",
                unknownUser: "مستخدم غير معروف",
                unread: "غير مقروء",
                platformIg: "Instagram",
                platformFb: "Facebook"
            },
            gridContactListToolBar: {
                chatStatus: "حالة الدردشة",
                sortBy: "ترتيب حسب",
                all: "الكل",
                open: "مفتوح",
                closed: "مغلق",
                allStatus: "الكل",
                lastActivity: "النشاط الأخير",
                createdAt: "تاريخ الإنشاء",
                unknown: "غير معروف"
            },
            chatCloseSettings: {
                selectPhone: "اختر الهاتف",
                selectPhoneDescription: "أي هاتف تريد الاتصال بـ {number} به؟",
                call: "اتصال",
                unnamedChannel: "قناة بدون اسم",
                typeVisitorName: "اكتب اسم الزائر...",
                webphoneCall: "الاتصال عبر ويب فون",
                hideSystemMessages: "إخفاء رسائل النظام",
                chatbotDebugMode: "وضع تصحيح روبوت الدردشة",
                createTask: "إنشاء مهمة",
                showProfile: "عرض الملف الشخصي",
                sendCapiEvent: "إرسال حدث CAPI",
                noPhoneNumber: "لم يتم العثور على رقم للاتصال",
                noWebphoneChannel: "لم يتم العثور على قناة ويب فون",
                webphoneCalling: "جاري الاتصال بـ {number} عبر ويب فون...",
                unknown: "غير معروف",
                channelTypeKirmiziSantral: "Kırmızı Santral",
                channelTypeTelnyx: "Telnyx",
                channelTypeNetgsm: "NetGSM",
                channelTypeWebPhone: "هاتف الويب",
                platformWeb: "الويب",
                platformWhatsapp: "واتساب",
                platformWhatsappBusiness: "واتساب للأعمال",
                platformInstagram: "إنستغرام",
                platformInstagramV2: "إنستغرام V2",
                platformMessenger: "ماسنجر",
                platformTelegram: "تيليجرام",
                platformTrendyol: "ترنديول",
                platformEmail: "البريد الإلكتروني",
                platformSms: "رسالة قصيرة",
                vipCustomerTooltip: "★ عميل VIP"
            },
            contactDetail: {
                removeVIPTooltip: "إزالة علامة VIP",
                markAsVIPTooltip: "وضع علامة كـ VIP (سيتم عرض المستخدمين المميزين بـ VIP دائمًا في الأعلى في الدردشات).",
                customerOwnership: "ملكية العميل",
                ownershipDescription: "عند تعيين ملكية العميل، يمكن فقط للمالك والمسؤولين الكاملين رؤيتها",
                unowned: "غير مملوك",
                assignToMe: "تعيين لي",
                removeOwnership: "إزالة الملكية",
                dragPlaceholder: "انقل هنا",
                currentConversationDepartment: "قسم المحادثة الحالي",
                pastInteractionDepartments: "أقسام التفاعل السابقة",
                createdAt: "تاريخ الإنشاء",
                updatedAt: "تاريخ التحديث",
                zohoSync: "مزامنة Zoho",
                zohoSyncQuestion: "هل تريد تنفيذ عمليات تغيير جهة الاتصال في Zoho أيضًا؟",
                basicInfo: "معلومات جهة الاتصال",
                loginInfo: "معلومات نموذج جهة الاتصال",
                profileFields: "حقول الملف الشخصي",
                systemInfo: "معلومات النظام"
            },
            contactDetailItem: {
                removeOwnership: "إزالة الملكية",
                assignOwnershipToMe: "تعيين الملكية لي",
                vipCustomer: "عميل VIP",
                contentCopiedSuccess: "تم نسخ المحتوى بنجاح!",
                invalidEmail: "عنوان بريد إلكتروني غير صالح!",
                invalidValue: "قيمة غير صالحة!"
            },
            filtersSection: {
                addFilter: "إضافة مرشح",
                all: "الكل",
                open: "مفتوح",
                closed: "مغلق",
                relevance: "الأكثر صلة",
                lastActivityNewest: "أحدث نشاط",
                lastActivityOldest: "أقدم نشاط",
                noParticipant: "بدون مشارك",
                ownershipFilter: "مرشح الملكية",
                metaReferral: "إحالة Meta",
                userStatus: "حالة المستخدم",
                unowned: "غير مملوك",
                fromAds: "من الإعلانات",
                notFromAds: "ليس من الإعلانات",
                blockedUsers: "المستخدمون المحظورون",
                unblockedUsers: "المستخدمون غير المحظورين",
                unread: "غير مقروء",
                read: "مقروء",
                yes: "نعم",
                no: "لا",
                answered: "تم الرد",
                unanswered: "لم يتم الرد",
                active: "نشط",
                lost: "مفقود",
                new: "جديد",
                chatbot: "روبوت الدردشة",
                closedStatus: "مغلق",
                platform: "المنصة",
                channel: "القناة",
                department: "القسم",
                tag: "العلامة",
                participant: "المشارك",
                ownership: "الملكية",
                lastActivityTime: "وقت آخر نشاط",
                fullName: "الاسم الكامل",
                email: "البريد الإلكتروني",
                phone: "الهاتف",
                vipCustomer: "عميل VIP",
                hasVIP: "لديه VIP",
                noVIP: "لا يوجد VIP",
                operatingSystem: "نظام التشغيل",
                browser: "المتصفح",
                ipAddress: "عنوان IP",
                visitingPage: "الصفحة المزارة",
                adInteraction: "تفاعل الإعلان",
                blockedStatus: "حالة الحظر",
                connectionTime: "وقت الاتصال",
                createdAt: "تاريخ الإنشاء",
                updatedAt: "تاريخ التحديث",
                readStatus: "حالة القراءة",
                missedChat: "المحادثة المفقودة",
                answerStatus: "حالة الرد",
                lastConversationStatus: "حالة آخر محادثة",
                lastTriggerState: "حالة آخر محفز",
                type: "النوع",
                name: "الاسم",
                enterTriggerName: "أدخل اسم المحفز...",
                zohoInfo: "معلومات Zoho",
                id: "المعرف",
                enterContactOrLeadId: "أدخل معرف جهة الاتصال أو العميل المحتمل...",
                broadcastMessage: "رسالة جماعية",
                today: "اليوم",
                yesterday: "أمس",
                thisWeek: "هذا الأسبوع",
                lastWeek: "الأسبوع الماضي",
                last7Days: "آخر 7 أيام",
                last30Days: "آخر 30 يوم",
                thisMonth: "هذا الشهر",
                lastMonth: "الشهر الماضي"
            },
            filterChip: {
                operator: "العامل:",
                enterText: "أدخل النص...",
                enterNumber: "أدخل الرقم...",
                type: "النوع",
                value: "القيمة",
                enterValue: "أدخل القيمة...",
                addFilter: "إضافة مرشح",
                equals: "يساوي",
                contains: "يحتوي",
                startsWith: "يبدأ بـ",
                endsWith: "ينتهي بـ",
                greaterThan: "أكبر من",
                lessThan: "أصغر من",
                greaterThanOrEqual: "أكبر من أو يساوي",
                lessThanOrEqual: "أصغر من أو يساوي",
                between: "بين",
                custom: "مخصص",
                select: "اختر"
            },
            filterPanel: {
                backToChat: "العودة إلى عرض الدردشة",
                publicFilter: "مرشح عام",
                privateFilter: "مرشح خاص",
                editFilterName: "تعديل اسم المرشح",
                contactsFound: " جهة اتصال تم العثور عليها",
                enterFilterName: "أدخل اسم المرشح",
                filterSuggestions: "اقتراحات المرشح",
                private: "خاص",
                public: "عام",
                createFilter: "إنشاء مرشح",
                update: "تحديث",
                changeToPublic: "تغيير إلى عام",
                changeToPrivate: "تغيير إلى خاص",
                delete: "حذف",
                clearSearch: "مسح البحث",
                previous: "السابق",
                next: "التالي",
                searchTerm: "مصطلح البحث:",
                whichFieldToSearch: "في أي حقل تريد البحث؟",
                contactId: "معرف جهة الاتصال",
                conversationId: "معرف المحادثة",
                noSearchAllFields: "لا، البحث في جميع الحقول",
                yesSearchOnlyField: "نعم، البحث فقط في {field}",
                search: "بحث",
                allFields: "جميع الحقول",
                fullname: "الاسم الكامل",
                email: "البريد الإلكتروني",
                whatsappNumber: "رقم WhatsApp",
                phone: "الهاتف",
                contactIdField: "حقل معرف جهة الاتصال",
                conversationIdField: "معرف المحادثة",
                searchAllFieldsPlaceholder: "أدخل ما تريد البحث عنه في جميع الحقول",
                searchFullnamePlaceholder: "أدخل ما تريد البحث عنه بالاسم الكامل",
                searchEmailPlaceholder: "أدخل ما تريد البحث عنه بالبريد الإلكتروني",
                searchWhatsappPlaceholder: "أدخل ما تريد البحث عنه بـ WhatsApp",
                searchPhonePlaceholder: "أدخل ما تريد البحث عنه بالهاتف",
                searchContactIdPlaceholder: "أدخل معرف جهة الاتصال التي تريد البحث عنها",
                searchConversationIdPlaceholder: "أدخل معرف المحادثة التي تريد البحث عنها",
                searchPlaceholder: "بحث",
                edited: " (تم التعديل)",
                unnamedFilter: "مرشح بدون اسم",
                all: "الكل",
                open: "مفتوح",
                closed: "مغلق",
                unknown: "غير معروف",
                filterUpdatedSuccess: "تم تحديث المرشح بنجاح",
                filterUpdatedDescription: "تم تحديث المرشح \"{name}\".",
                filterUpdateFailed: "تعذر تحديث المرشح",
                filterUpdateError: "حدث خطأ أثناء تحديث المرشح.",
                filterSavedSuccess: "تم حفظ المرشح بنجاح",
                filterSavedDescription: "الاسم \"{createName}\" مستخدم بالفعل. تم إنشاء المرشح باسم \"{filterName}\".",
                filterCreatedDescription: "تم إنشاء المرشح \"{filterName}\".",
                filterSaveFailed: "تعذر حفظ المرشح",
                filterSaveError: "حدث خطأ أثناء حفظ المرشح.",
                aiFilterCreatedSuccess: "تم إنشاء مرشح AI بنجاح",
                aiFilterCreatedDescription: "الاسم \"{createName}\" مستخدم بالفعل. تم إنشاء المرشح باسم \"{filterName}\" وتطبيقه.",
                aiFilterCreatedApplied: "تم إنشاء المرشح \"{filterName}\" وتطبيقه.",
                aiFilterCreateFailed: "تعذر إنشاء المرشح",
                aiFilterCreateError: "حدث خطأ أثناء إنشاء مرشح AI.",
                phoneDetected: "تم اكتشاف رقم الهاتف",
                emailDetected: "تم اكتشاف عنوان البريد الإلكتروني",
                idFormatDetected: "تم اكتشاف تنسيق المعرف",
                contactIdDetected: "تم اكتشاف معرف جهة الاتصال",
                conversationIdDetected: "تم اكتشاف معرف المحادثة",
                searchMode: "وضع البحث",
                phoneDetectedMessage: "القيمة التي أدخلتها تبدو كرقم هاتف. هل تريد البحث فقط في حقل رقم الهاتف؟",
                emailDetectedMessage: "القيمة التي أدخلتها تبدو كعنوان بريد إلكتروني. هل تريد البحث فقط في حقل البريد الإلكتروني؟",
                idFormatDetectedMessage: "القيمة التي أدخلتها تبدو كتنسيق معرف. في أي حقل تريد البحث؟",
                phoneField: "حقل رقم الهاتف",
                emailField: "حقل البريد الإلكتروني",
                conversationIdFieldName: "حقل معرف المحادثة",
                idField: "حقل المعرف",
                deleteFilter: "حذف المرشح",
                deleteFilterConfirm: "هل أنت متأكد أنك تريد حذف المرشح \"{name}\"؟ لا يمكن التراجع عن هذا الإجراء.",
                cancel: "إلغاء",
                filterDeletedSuccess: "تم حذف المرشح بنجاح",
                filterDeletedDescription: "تم حذف المرشح \"{name}\".",
                filterDeleteFailed: "تعذر حذف المرشح",
                filterDeleteError: "حدث خطأ أثناء حذف المرشح.",
                visibilityUpdatedSuccess: "تم تحديث الرؤية بنجاح",
                visibilityUpdatedDescription: "تم تعيين المرشح إلى \"{visibility}\".",
                visibilityUpdateFailed: "تعذر تحديث الرؤية",
                visibilityUpdateError: "حدث خطأ أثناء تحديث المرشح.",
                publicVisibility: "عام",
                privateVisibility: "خاص"
            },
            contactList: {
                noContactsFound: "لم يتم العثور على جهات اتصال",
                unknownContact: "جهة اتصال غير معروفة",
                unknown: "غير معروف",
                fullName: "الاسم الكامل",
                platform: "المنصة",
                email: "البريد الإلكتروني",
                phone: "الهاتف",
                tags: "العلامات",
                status: "الحالة",
                lastActivity: "آخر نشاط",
                answerStatus: "حالة الرد",
                channel: "القناة",
                owner: "المالك",
                vip: "VIP",
                connectionTime: "وقت الاتصال",
                unread: "غير مقروء",
                departments: "الأقسام",
                operatingSystem: "نظام التشغيل",
                browser: "المتصفح",
                countryCity: "البلد - المدينة",
                ipAddress: "عنوان IP",
                visitingPage: "الصفحة المزارة",
                lastConversationDate: "تاريخ آخر محادثة",
                blockedStatus: "حالة الحظر",
                lastConversationParticipants: "مشاركو آخر محادثة",
                preferredLanguage: "اللغة المفضلة",
                createdAt: "تاريخ الإنشاء",
                updatedAt: "تاريخ التحديث",
                broadcastStatus: "حالة البث",
                broadcastAnswer: "رد البث",
                zohoContactId: "معرف جهة اتصال Zoho",
                zohoLeadId: "معرف العميل المحتمل Zoho",
                profileFields: "حقول الملف الشخصي",
                closed: "مغلق",
                open: "مفتوح",
                unknownStatus: "غير معروف",
                answered: "تم الرد",
                unanswered: "لم يتم الرد",
                unreadStatus: "غير مقروء",
                readStatus: "مقروء",
                vipStatus: "VIP",
                normal: "عادي",
                blocked: "محظور",
                today: "اليوم",
                yesterday: "أمس",
                enqueued: "في قائمة الانتظار",
                sent: "تم الإرسال",
                delivered: "تم التسليم",
                read: "مقروء",
                deleted: "تم الحذف",
                failed: "فشل",
                replied: "تم الرد",
                notReplied: "لم يتم الرد",
                jsonProperty: "خاصية JSON",
                jsonCopiedSuccess: "تم نسخ محتوى JSON بنجاح!"
            }
        },
        form: {
            title: {
                titleSettings: "إعدادات العنوان",
                fullNameSettings: "إعدادات الاسم الكامل",
                emailSettings: "إعدادات البريد الإلكتروني",
                addressSettings: "إعدادات العنوان",
                phoneSettings: "إعدادات الهاتف",
                datePickerSettings: "إعدادات منتقي التاريخ",
                shortTextSettings: "إعدادات النص القصير",
                longTextSettings: "إعدادات النص الطويل",
                dropDownListSettings: "إعدادات القائمة المنسدلة",
                singleChoiceSettings: "إعدادات الخيار الفردي",
                multipleSelectionSettings: "إعدادات التحديد المتعدد",
                numberSettings: "إعدادات الأرقام",
                hourSettings: "إعدادات الساعة",
                spinnerSettings: "إعدادات الدوار",
                sendSettings: "إعدادات الإرسال",
                starRatingSettings: "إعدادات التقييم بالنجوم",
                ratingScaleSettings: "إعدادات مقياس التقييم",
                separationElementSettings: "إعدادات عنصر الفصل",
                fileUploadSettings: "إعدادات تحميل الملفات",
                imageSettings: "إعدادات الصورة"
            },
            lineColor: "لون الخط",
            separatorColorInfo: "اختر أو أدخل لون الفاصل (مثل #RRGGBB)",
            separatorHeight: "ارتفاع الفاصل",
            separatorHeightInfo: "أدخل ارتفاع الفاصل",
            bottomSpace: "المسافة السفلية",
            bottomSpaceInfo: "أضف مسافة أسفل الفاصل",
            topSpace: "المسافة العلوية",
            topSpaceInfo: "أضف مسافة فوق الفاصل",
            sideSpace: "المسافة الجانبية",
            sideSpaceInfo: "أضف مسافة على اليسار واليمين من الفاصل",
            onlyImageUpload: "يمكنك تحميل صورة فقط!",
            imageSizeLimit: "يجب ألا يتجاوز حجم صورتك 5 ميجابايت!",
            image: "صورة",
            size: "حجم",
            width: "عرض",
            height: "ارتفاع",
            imageAlignment: "محاذاة الصورة",
            wide: "عريض",
            small: "صغير",
            textAlignment: "محاذاة النص",
            chooseHorizontalAlignment: "اختر كيفية محاذاة هذا العنوان أفقيًا.",
            headerSize: "حجم العنوان",
            addSmallTextBelowHeader: "أضف نصًا أصغر أسفل العنوان",
            subHeaderText: "نص العنوان الفرعي",
            subLabel1: "التسمية الفرعية(1)",
            subLabel2: "التسمية الفرعية(2)",
            validPhoneNumber: "الرجاء إدخال رقم هاتف صالح",
            masked: "مقنع",
            copyField: "نسخ الحقل",
            copyFieldDescription: "أنشئ نسخة من هذا الحقل مع الحفاظ على جميع إعداداته المسجلة",
            enterQuestion: "أدخل سؤالا",
            notRequired: "غير مطلوب",
            addDescriptionBelowField: "أضف وصفًا قصيرًا أسفل الحقل",
            setDefault: "تعيين كإفتراضي",
            pleaseSelect: "يرجى الاختيار",
            placeholder: "نص توضيحي",
            required: "إلزامي",
            fieldEmptyError: "لا تسمح بإرسال النموذج إذا كان هذا الحقل فارغًا",
            subLabels: "التسميات الفرعية",
            addressLine1: "العنوان - السطر 1",
            addressLine2: "العنوان - السطر 2",
            postalCode: "الرمز البريدي",
            stateProvince: "الولاية / المقاطعة",
            chooseLabelAlignment: "اختر كيفية محاذاة نص التسمية أفقيًا",
            right: "يمين",
            left: "يسار",
            top: "أعلى",
            labelAlignment: "محاذاة التسمية",
            fieldLabel: "تسمية الحقل",
            read: "تمت القراءة",
            itemsPerPage: "عنصر/صفحة",
            downloadAllDataAsPDF: "تنزيل كل البيانات بصيغة PDF",
            downloadAllDataAsExcel: "تنزيل كل البيانات بصيغة Excel",
            downloadSelectedDataAsPDF: "تنزيل البيانات المحددة بصيغة PDF",
            downloadSelectedDataAsExcel: "تنزيل البيانات المحددة بصيغة Excel",
            selectItemToViewDetails: "اختر عنصرًا لعرض التفاصيل.",
            deleteFormConfirm: "إذا قمت بحذف هذا النموذج، سيتم حذف جميع البيانات المرتبطة به بشكل دائم. هل أنت متأكد أنك تريد المتابعة؟",
            redicetFormAnswer: "إعادة توجيه إجابات النموذج",
            redicetFormAnswerDesc: "عند إعادة توجيه إجابات النموذج إلى نظام التذاكر، تأكد من طلب رقم هاتف أو عنوان بريد إلكتروني من المستخدم في النموذج. هذه المعلومات مهمة للتواصل بشكل أسرع وأكثر فعالية مع المستخدم.",
            redicetFormAnswerDesc2: "يتم توجيه إجابات النموذج إلى النظام كتذاكر.",
            rediectAnswersToTicket: "إعادة توجيه الإجابات الواردة إلى تذكرة.",
            errorTicketMode: "خطأ في تحديث وضع التذكرة:",
            formView: "عرض النموذج",
            formEdit: "نموذج التحديث",
            totalResponse: "إجمالي الاستجابة",
            totalUnreadResponse: "إجمالي الردود غير المقروءة",
            totalReadResponse: "إجمالي الاستجابة للقراءة",
            totalArchivedResponse: "إجمالي الاستجابة المحفوظة في الأرشيف",
            singleChoice: "خيار واحد",
            _delete: "حذف",
            inbox: "صندوق الوارد",
            edit: "تحرير",
            forms: "النماذج",
            formsDesc: "يمكنك إدارة النماذج الخاصة بك هنا.",
            createaForm: "إنشاء نموذج",
            allForms: "جميع الأشكال",
            formPublish: {
                shareFast: "شارك بسرعة",
                shareFastDesc: "رابط النموذج المباشر والمشاركة الاجتماعية",
                add: "الإضافة",
                addDesc: "خيارات تضمين صفحات الويب المختلفة",
                assignForm: "نموذج التعيين",
                assignFormDesc: "تعيين النماذج الخاصة بك للآخرين",
                emails: "الرسائل الإلكترونية",
                emailsDesc: "التذكيرات والمشاركة الفورية",
                prefill: "الملء المسبق",
                prefillDesc: "تعبئة النماذج مسبقاً",
                pdf: "PDF",
                pdfDesc: "تنزيل ملف PDF قابل للتعبئة",
                platforms: "المنصات",
                platformsDesc: "خيارات النشر للجهات الخارجية",
                linkToYour: "عنوان رابط النموذج الخاص بك",
                linkToYourDesc: "تم نشر النموذج الخاص بك بشكل آمن وهو جاهز للاستخدام على هذا العنوان.",
                shareWithLink: "المشاركة مع الرابط",
                publicForm: "النموذج العام",
                copyLink: "رابط النسخ",
                openInNewTab: "فتح في علامة تبويب جديدة",
                linkCopied: "تم نسخ الرابط",
                codeCopied: "تم نسخ الرمز",
                iframe: "إطار IFRAME",
                iframeDesc: "أضف النموذج إلى صفحتك باستخدام iFrame",
                openWindow: "نافذة مفتوحة",
                openWindowDesc: "رابط إلى نموذج منبثق",
                formAddDesc: "انسخ هذا المقتطف والصقه في التعليمات البرمجية الخاصة بك، ثم ضع النموذج على موقعك الإلكتروني."
            },
            formSettings: {
                enterNameForm: "أدخل اسماً لهذا النموذج",
                selectStatusForm: "حدد حالة النموذج الخاص بك",
                disabled: "معاق",
                disableSpecifiedTime: "تعطيل في وقت محدد",
                disableFormResponse: "تعطيل عند الوصول إلى حد استجابة النموذج",
                pageShownAfterForm: "الصفحة التي تظهر بعد إرسال النموذج",
                formNotFound: "النموذج غير موجود.",
                errorLoadingform: "حدث خطأ أثناء تحميل النموذج.",
                formUpdated: "تم تحديث عنوان النموذج بنجاح.",
                formErrorUpdated: "حدث خطأ أثناء تحديث عنوان النموذج",
                formSettings: "إعدادات النموذج",
                changeFormStateAndProperties: "تغيير حالة النموذج والخصائص",
                title: "العنوان",
                newFormSettings: "إعدادات النموذج الجديد",
                formStatus: "حالة النموذج",
                activateOrDeactivate: "تنشيط النموذج الخاص بك أو إلغاء تنشيطه أو تنشيطه بشكل مشروط",
                effective: "فعّال",
                yourFromIsVisible: "أصبح النموذج الخاص بك الآن مرئيًا ويمكنه تلقي ردود النموذج",
                emails: "الرسائل الإلكترونية",
                emailsDesc: "إرسال رسائل البريد الإلكتروني الخاصة بالرد الآلي ورسائل البريد الإلكتروني الخاصة بالإشعارات",
                conditions: "الشروط",
                conditionsDesc: "قسم المنطق الشرطي الذي يقوم بتشغيل الإجراءات بناءً على مدخلات النموذج",
                thankYouPage: "صفحة شكرًا لك",
                thankYouPageDesc: "الصفحة التي تظهر بعد إرسال النموذج",
                integretions: "الاندماجات",
                integretionsDesc: "ربط النموذج الخاص بك بالتطبيقات الأخرى"
            },
            clickToDeleteYourLogo: "انقر لحذف شعارك",
            create: "إنشاء",
            settings: "الإعدادات",
            load: "التحميل",
            insertFormField: "إدراج حقل النموذج",
            addYourLogo: "أضف شعارك",
            surveyElements: {
                surveyElements: "عناصر المسح",
                dataTable: "جدول البيانات",
                starRating: "تصنيف النجوم",
                evaluationScale: "مقياس التقييم"
            },
            pageElements: {
                pageElements: "عناصر الصفحة",
                separationElement: "عنصر الفصل",
                partitionCollapse: "انهيار التقسيم",
                pageBreak: "نهاية الصفحة"
            },
            basicElements: {
                basicElements: "العناصر الأساسية",
                shortText: "نص قصير",
                longText: "نص طويل",
                paragraph: "الفقرة",
                dropDownList: "القائمة المنسدلة",
                singleChoice: "خيار واحد",
                multipleSelection: "اختيار متعدد",
                number: "العدد",
                image: "الصورة",
                fileUpload: "تحميل الملفات",
                hour: "ساعة",
                spinner: "سبينر",
                send: "إرسال"
            },
            formElements: {
                formElements: "عناصر النموذج",
                title: "العنوان",
                fullName: "الاسم الكامل",
                email: "البريد الإلكتروني",
                address: "العنوان",
                phone: "الهاتف",
                datePicker: "منتقي التواريخ",
                appointment: "التعيين",
                signature: "التوقيع",
                productList: "قائمة المنتجات"
            },
            startWithaBlankForm: "ابدأ بنموذج فارغ",
            startFromScratch: "ابدأ من الصفر",
            createOrTransferaForm: "إنشاء أو نقل نموذج لبدء جمع البيانات",
            createForm: "إنشاء نموذج",
            trashBin: "سلة المهملات",
            formAutomations: "أتمتة النماذج",
            trashBinList: {
                title: "سلة المهملات",
                description: "النماذج المحذوفة معروضة هنا",
                loading: "جاري تحميل النماذج المحذوفة...",
                restore: "استعادة",
                permanentDelete: "حذف نهائي",
                delete: "حذف",
                emptyTitle: "سلة المهملات فارغة",
                emptyDescription: "لا توجد نماذج محذوفة",
                totalResponses: "إجمالي الردود",
                unread: "غير مقروء",
                read: "مقروء",
                archived: "مؤرشف",
                restoreConfirmDescription: "هل أنت متأكد من أنك تريد استعادة هذا النموذج؟ سيتم إضافة النموذج وجميع بياناته إلى قائمة النماذج النشطة.",
                deleteConfirmDescription: "هل أنت متأكد من أنك تريد حذف هذا النموذج نهائياً؟ لا يمكن التراجع عن هذا الإجراء وسيتم حذف جميع البيانات المرتبطة بالنموذج.",
                deletedToday: "تم الحذف اليوم",
                deletedYesterday: "تم الحذف أمس",
                deletedDaysAgo: "تم الحذف منذ {count} أيام",
                deletedWeeksAgo: "تم الحذف منذ {weeks} أسابيع",
                deletedMonthsAgo: "تم الحذف منذ {months} أشهر",
                restoreSuccess: "تم استعادة النموذج بنجاح",
                restoreError: "حدث خطأ أثناء استعادة النموذج",
                deleteSuccess: "تم حذف النموذج نهائياً",
                deleteError: "حدث خطأ أثناء حذف النموذج"
            }
        },
        automation: {
            deleteAutomationsTitle: "حذف الأتمتة",
            deleteAutomationsConfirmation: "هل أنت متأكد من أنك تريد حذف {count} أتمتة؟ لا يمكن التراجع عن هذا الإجراء.",
            automationsMoveError: "حدث خطأ أثناء نقل الأتمتة",
            noAutomationToMove: "لم يتم العثور على أتمتة للنقل",
            deleteCategoryConfirmation: "هل أنت متأكد من أنك تريد حذف الفئة \"{categoryName}\"؟ سيتم نقل الأتمتة في هذه الفئة إلى فئة \"{generalCategory}\".",
            automationsMovedToCategory: "تم نقل {count} أتمتة إلى فئة \"{categoryName}\"",
            automationImportedSuccessfully: "تم استيراد الأتمتة {name} بنجاح",
            automationPasteError: "حدث خطأ أثناء لصق الأتمتة",
            invalidAutomationExport: "لم يتم العثور على تصدير أتمتة Supsis صالح في الحافظة",
            invalidAutomationJSON: "لم يتم العثور على JSON أتمتة صالح في الحافظة",
            clipboardNotSupported: "الوصول إلى الحافظة غير مدعوم في هذا المتصفح",
            automationJSONCopyError: "حدث خطأ أثناء نسخ الأتمتة",
            automationCopiedToClipboardFallback: "تم نسخ الأتمتة إلى الحافظة كـ JSON (الطريقة البديلة)",
            automationCopiedToClipboard: "تم نسخ الأتمتة إلى الحافظة كـ JSON. يمكنك لصقها باستخدام Ctrl+V في لوحة عميل أخرى.",
            automationCopyError: "حدث خطأ أثناء نسخ الأتمتة",
            automationCopied: "تم نسخ الأتمتة",
            automationMoveError: "حدث خطأ أثناء نقل الأتمتة",
            automationMovedToCategory: "تم نقل الأتمتة إلى فئة \"{categoryName}\"",
            categoryDeletedSuccessfully: "تم حذف الفئة بنجاح",
            categoryDeleteError: "حدث خطأ أثناء حذف الفئة",
            automationsDeleteError: "حدث خطأ أثناء حذف الأتمتة",
            automationsDeletedSuccessfully: "تم حذف {count} أتمتة بنجاح",
            categoryUpdatedSuccessfully: "تم تحديث الفئة",
            categoryUpdateError: "حدث خطأ أثناء تحديث الفئة",
            categorySaveError: "حدث خطأ أثناء حفظ الفئة",
            categoryCreatedSuccessfully: "تم إنشاء الفئة. يمكنك سحب الأتمتة إلى هذه الفئة.",
            categoryNameAlreadyExists: "فئة بهذا الاسم موجودة بالفعل",
            categoryNameRequired: "اسم الفئة لا يمكن أن يكون فارغاً",
            moveAllAutomations: "نقل جميع الأتمتة",
            deleteAutomations: "تم حذف {count} أتمتة",
            selectedAutomations: "تم تحديد {count} أتمتة",
            pasteInfoMessage: "تم اكتشاف أتمتة منسوخة في الحافظة! أنشئ أتمتة جديدة فوراً عن طريق لصقها باستخدام <strong>Ctrl+V</strong>.",
            categoryName: "اسم الفئة",
            categoryNamePlaceholder: "أدخل اسم الفئة",
            editCategory: "تحرير الفئة",
            deleteCategory: "حذف الفئة",
            createCategory: "إضافة فئة",
            publishAutomation: "منشور",
            unpublishAutomation: "متوقف",
            timerAutomation: "مجدول",
            eventAutomation: "حدث",
            deleteAutomation: "حذف الأتمتة",
            changeCategory: "تغيير الفئة",
            copyAutomation: "نسخ الأتمتة",
            copyAutomationAsJSON: "نسخ كـ JSON",
            emptyCategoryMessage: "يمكنك إضافة أتمتة إلى الفئة عن طريق سحبها هنا",
            whenFormSubmitted: "عند إرسال نموذج",
            taskCreated2: "تم إنشاء المهمة",
            waitingTaskCreation: "في انتظار إنشاء المهمة...",
            calendarEventCreated: "تم إنشاء الحدث في التقويم",
            calendarEventUpdated: "تم تحديث الحدث في التقويم",
            calendarEventDeleted: "تم حذف الحدث من التقويم",
            reservationCreated: "تم إنشاء الحجز",
            reservationDateChanged: "تم تغيير تاريخ الحجز",
            reservationDeleted: "تم حذف الحجز",
            chatLost: "عندما يتم فقدان الدردشة",
            webchatCompleted: "عندما تكتمل الدردشة من الويب",
            instagramCompleted: "عندما تكتمل الدردشة من قناة إنستغرام",
            messengerCompleted: "عندما تكتمل الدردشة من قناة ماسنجر",
            whatsappCompleted: "عندما تكتمل الدردشة من قناة واتساب",
            telegramCompleted: "عندما تكتمل الدردشة من قناة تيليجرام",
            chatAssignedToAgent: "عندما يتم تعيين الدردشة لوكيل",
            profileButtonClicked: "عندما يتم النقر على زر الأتمتة من الملف الشخصي",
            operatedTask: "مهمة قيد التنفيذ",
            tableSelection: "تحديد الجدول",
            selectTable: "تحديد الجدول",
            whichTableAutomationAddRecords: "أي جدول تريد تشغيل الأتمتة عند إضافة سجل؟ الرجاء التحديد.",
            whichTableAutomationUpdateRecords: "هل تريد تشغيل الأتمتة عندما يتم تحديث سجل في أي جدول؟ الرجاء التحديد.",
            whichTableAutomationDeletedRecords: "من أي جدول تريد تشغيل الأتمتة عند حذف سجل؟ الرجاء التحديد.",
            whichTableAutomationClickRecords: "من أي جدول تريد تشغيل الأتمتة عند النقر على زر الأتمتة في سجل؟ الرجاء التحديد.",
            selectAtLeastOneField: "يجب اختيار حقل واحد على الأقل",
            generalCategory: "عام",
            configureTrackFields: "تكوين حقول التتبع",
            configureMessageFilter: "تكوين فلتر الرسائل",
            makeFreeTier: "جعله مجاني",
            revertFreeTier: "إرجاع إلى المستوى العادي",
            webhook: "Webhook",
            system: "النظام",
            freeTierTooltip: "هذه الأتمتة ضمن المستوى المجاني. لن يتم خصم استخدام الأتمتة من حصتك.",
            freeTierBadge: "مستوى مجاني",
            trackFieldsLabel: "الحقول المطلوب تتبعها",
            trackFieldsSelectPlaceholder: "إذا لم يتم اختيار أي حقل، سيتم تتبع جميع الحقول",
            selectFieldPlaceholder: "اختر الحقل",
            tableMustBeSelectedFirst: "يجب اختيار الجدول للأتمتة أولاً",
            fieldsLoadError: "خطأ في تحميل الحقول",
            trackFieldsUpdated: "تم تحديث حقول التتبع",
            updateError: "خطأ أثناء التحديث",
            automationMadeFreeTier: "تم تعيين الأتمتة كمستوى مجاني",
            makeFreeTierError: "خطأ في تعيين المستوى المجاني",
            automationRevertedToNormalTier: "تم إرجاع الأتمتة إلى المستوى العادي",
            revertFreeTierError: "خطأ في الإرجاع إلى المستوى العادي",
            wrongPassword: "كلمة المرور خاطئة!",
            configLoadError: "خطأ في تحميل التكوين",
            messageFilterConfigUpdated: "تم تحديث تكوين فلتر الرسائل",
            freeTierPasswordPrompt: "أدخل كلمة المرور لجعله مجانياً:",
            configurePreFilters: "تكوين الفلاتر المسبقة",
            configureExecutionPrivacy: "تكوين صلاحية التنفيذ",
            editDescription: "تعديل الوصف",
            permissions: {
                title: "صلاحيات الوصول",
                mode: "Permission Mode",
                publicMode: "Public",
                customMode: "Custom",
                publicModeDesc: "All users can access and edit this automation.",
                customModeDesc: "Only specified users and departments can access this automation.",
                confirmPublicMode: "Switch to Public Mode",
                confirmPublicModeDesc: "After this operation, all users will be able to access this automation. Do you want to continue?",
                addUser: "Add User",
                addDepartment: "Add Department",
                selectUser: "Select user",
                selectDepartment: "Select department",
                add: "Add",
                targetHeader: "User/Department",
                matrixInfo: "Select the permissions you want to grant for each user or department.",
                noTargetsAdded: "No users or departments have been added yet. Add one above to grant permissions.",
                confirmRemoveTarget: "Remove Permission",
                confirmRemoveTargetDesc: "Are you sure you want to remove permissions for this user or department?",
                saveSuccess: "Access permissions saved successfully",
                saveError: "An error occurred while saving access permissions",
                unknownUser: "Unknown User",
                unknownDepartment: "Unknown Department",
                noReadAccess: "You do not have access to this automation.",
                usersTab: "Users",
                departmentsTab: "Departments",
                authorizedUsers: "Authorized Users",
                otherUsers: "Other Users",
                authorizedDepartments: "Authorized Departments",
                otherDepartments: "Other Departments",
                cannotChangeOwnPermission: "You cannot change your own permission",
                you: "You",
                customPermissionDefined: "Custom permission defined for this user",
                customPermission: "Custom Permission",
                grantPermission: "Grant Permission",
                revokePermission: "Remove Permission",
                applyToOthers: "Apply to Other Automations",
                applyToOthersDesc: "Apply these permission settings to other automations you select",
                applyToOthersTitle: "Apply Permission Settings to Other Automations",
                applyToOthersWarning: "The existing permission settings of the selected automations will be replaced with this automation's settings.",
                selectAll: "Select All",
                selectedCount: "{count} automations selected",
                applyToSelected: "Apply to Selected",
                noAutomationsFound: "No automations found",
                searchPlaceholder: "Search automation or category...",
                applySuccess: "Permission settings applied to {count} automations successfully",
                applyFailed: "Failed to apply permission settings to {count} automations",
                applyError: "Error applying permission settings",
                groups: {
                    basic: "Basic",
                    flow: "Flow",
                    meta: "Info",
                    publish: "Publish",
                    actions: "Actions",
                    plan: "Plan",
                    filter: "Filter"
                },
                scopes: {
                    read: "View",
                    readDesc: "Permission to view the automation",
                    flowUpdate: "Edit Flow",
                    flowUpdateDesc: "Permission to add, remove, and edit automation blocks",
                    metaUpdate: "Edit Info",
                    metaUpdateDesc: "Permission to edit automation name, description, and category",
                    publish: "Publish",
                    publishDesc: "Permission to publish and unpublish the automation",
                    delete: "Delete",
                    deleteDesc: "Permission to delete the automation",
                    duplicate: "Duplicate",
                    duplicateDesc: "Permission to duplicate the automation",
                    planView: "View Plans",
                    planViewDesc: "Permission to view automation execution plans",
                    planCancel: "Cancel Plan",
                    planCancelDesc: "Permission to cancel scheduled plans",
                    reschedule: "Reschedule",
                    rescheduleDesc: "Permission to reschedule automation",
                    prefilterUpdate: "Edit Filter",
                    prefilterUpdateDesc: "Permission to edit pre-filter configuration"
                }
            },
            planStatus: "حالة الخطة",
            scheduled: "مجدول",
            completed: "مكتمل",
            cancelled: "تم الإلغاء",
            startTest: "بدء الاختبار",
            unpublish: "إلغاء النشر",
            whenMessagePicked: "عند تحديد رسالة عبر واجهة المحادثة",
            whenTaskCompleted: "عند اكتمال مهمة",
            whenTaskDeleted: "عند حذف مهمة",
            whenTaskAssigneeChanged: "عندما يتم تغيير المُعيَّن للمهمة",
            whenTaskPriorityChanged: "عند تغيير أولوية المهمة",
            whenTaskDueDateChanged: "عند تغيير تاريخ استحقاق المهمة",
            whenTaskStatusChanged: "عند تغيير حالة المهمة",
            whenTaskArchived: "عند أرشفة مهمة",
            whenTagAdded: "عند إضافة علامة إلى المهمة",
            whenTagRemovedTask: "عند إزالة علامة من مهمة",
            whenTagChecklist: "عند اكتمال قائمة التحقق من المهمة",
            whenReminderActivated: "عند تنشيط التذكير",
            whenTicketCreated: "عند إنشاء تذكرة",
            whenTicketStageChanged: "عند تغيير مرحلة التذكرة",
            whenTicketAssigneeChanged: "عندما يتم تغيير المُعيَّن للتذكرة",
            whenTicketClosed: "عندما يتم إغلاق التذكرة",
            whenTicketUpdated: "عندما يتم تحديث التذكرة",
            autoPlanAndTaskHistory: "خطة الأتمتة وسجل المهام",
            automation: "الأتمتة",
            botScenario: "سيناريو الروبوت",
            nameSurname: "الاسم واللقب",
            phone164: "*أدخله بتنسيق E164. على سبيل المثال: 905396667744",
            whichWpChannels: "أي قنوات واتساب تريد إضافتها؟",
            findContact: "البحث عن جهة اتصال",
            findContacts: "البحث عن جهات الاتصال",
            offsetDesc: "تخطي أول N من جهات الاتصال. القيمة الافتراضية هي '0'. استخدم هذا للتمرير عبر جهات الاتصال.",
            limitDesc: "الحد الأقصى لعدد جهات الاتصال المراد إرجاعها بعد الإزاحة. القيمة الافتراضية هي '10'. استخدم هذا لترقيم الصفحات",
            contact: "جهة الاتصال",
            selectAction: "تحديد الإجراء",
            addMethod: "طريقة الإضافة",
            selectField: "تحديد حقل",
            schedulerRunningPlanEx: "مثال على خطة تشغيل المجدول",
            schedulerPlanner: "مخطط المجدول",
            taskCreated: "تم إنشاء المهمة؟",
            taskStatus: "حالة المهمة",
            terminateReason: "سبب الإنهاء",
            taskDuration: "مدة المهمة",
            taskWakeUpCount: "عدد استيقاظ المهمة",
            completedAt: "مكتمل",
            cancelledAt: "تم الإلغاء",
            nextRunAt: "التشغيل التالي",
            configSchedulerAuto: "تكوين المؤقِّت للأتمتة",
            saveChanges: "حفظ التغييرات",
            catchAllWebhooks: "التقاط جميع خطافات الويب من عنوان URL هذا",
            webhookDataExPreview: "معاينة نموذج بيانات خطاف الويب (سيتم عرضها بعد إرسال الطلب)",
            webhookUrlCopied: "نسخ عنوان URL لخطاف الويب إلى الحافظة",
            selectAnBlock: "تحديد كتلة",
            dataFormats: "تنسيقات البيانات",
            whenRecordCreated: "عند إنشاء سجل",
            whenRecordUpdated: "عندما يتم تحديث سجل",
            whenRecordDelete: "عندما يتم حذف سجل",
            whenRecordAutomation: "عندما يتم النقر على زر أتمتة السجل",
            whenWebhookTriggered: "عندما يتم تشغيل خطاف الويب",
            whenChatCreated: "عندما يتم إنشاء دردشة",
            whenChatClosed: "عندما يتم إغلاق الدردشة",
            whenChatRated: "عندما يتم تصنيف دردشة",
            whenNewContactCreated: "عند إنشاء جهة اتصال جديدة",
            whenContactUpdate: "عند تحديث جهة اتصال",
            whenContactPropUpdate: "عند تحديث خاصية جهة اتصال",
            whenNewTagAdded: "عند إضافة علامة جديدة",
            whenTagRemoved: "عند إزالة علامة",
            whenNewEmailReceived: "عند استلام بريد إلكتروني جديد",
            whenNewTaskCreated: "عند إنشاء مهمة جديدة",
            whenNewMetaleadCreated: "عند إنشاء عميل تعريف جديد",
            whenNewAgentCreated: "عند إنشاء وكيل جديد",
            whenAgentOnline: "عندما يتصل وكيل بالإنترنت",
            whenAgentOffline: "عندما يخرج وكيل من الإنترنت",
            whenAgentStatusChanged: "عندما يتغير حالة الوكيل",
            whenAgentLogin: "عندما يسجل وكيل دخوله",
            whenNewInvoiceCreated: "عند إنشاء فاتورة جديدة",
            whenNewWpReceived: "عند استلام رسالة واتساب جديدة",
            whenNewReservationCreated: "عند إنشاء حجز جديد",
            whenNewChatbotReceived: "عند استلام رسالة دردشة جديدة",
            chatWebhookAutomation: "التقاط خطاف ويب وتشغيل الأتمتة",
            automationName: "اسم الأتمتة",
            supsisObject: "كائن سوبسيس",
            selectModule: "تحديد النموذج",
            bodyType: "نوع الجسم",
            selectBodyType: "تحديد نوع الجسم",
            selectMethod: "تحديد طريقة",
            trigger: "الزناد",
            published: "منشور",
            createdAt: "تم الإنشاء في",
            action: "الإجراء",
            type: "النوع",
            view: "عرض",
            createTimerAutomation: "إنشاء أتمتة المؤقِّت",
            createEventBasedAutomation: "إنشاء أتمتة قائمة على الأحداث",
            createWebhookAutomation: "إنشاء أتمتة خطاف الويب",
            automationsCouldNotBeDeleted: "تعذر حذف الأتمتة",
            timerAutomationCreatedSuccessfully: "تم إنشاء أتمتة المؤقت بنجاح",
            eventAutomationCreatedSuccessfully: "إنشاء أتمتة الأحداث بنجاح",
            webhookAutomationCutomationCreatedSuccessfully: "تم إنشاء أتمتة خطاف الويب بنجاح",
            automationsCouldNouldNotBeFetched: "تعذر ضبط الأتمتة",
            automationPublishedStateUpdatedSupdatedSuccessfully: "تم تحديث حالة الأتمتة المنشورة بنجاح",
            automations: "الأتمتة",
            allAutomations: "جميع الأتمتة",
            scheduledAutomations: "الأتمتة المجدولة",
            eventBasedAutomations: "الأتمتة المستندة إلى الحدث",
            buttonAutomations: "أتمتة الأزرار",
            webhookAutomations: "أتمتة خطاف الويب",
            analytics: "تحليلات",
            insights: "إحصائيات",
            trash: "سلة المهملات",
            sandboxPage: {
                title: "سيناريوهات الأتمتة المحذوفة",
                description: "سيتم حذف الأتمتة التي لم تتم استعادتها نهائياً بواسطة النظام خلال 30 يوماً",
                emptyState: "لا توجد أتمتة محذوفة في سلة المهملات",
                unnamedAutomation: "أتمتة بدون عنوان",
                restore: "استعادة",
                timerAutomation: "أتمتة المؤقت",
                eventAutomation: "أتمتة الحدث",
                webhook: "خطاف الويب",
                buttonAutomation: "أتمتة الزر",
                tableButtonAutomation: "أتمتة زر الجدول",
                chatbotAutomation: "أتمتة الدردشة الآلية",
                unknown: "غير معروف",
                user: "المستخدم",
                restoreConfirmTitle: "هل أنت متأكد من أنك تريد استعادة هذه الأتمتة؟",
                restoreConfirmContent: "سيتم استعادة أتمتة {name}.",
                restoreSuccess: "تم استعادة الأتمتة",
                restoreFailed: "فشل الاستعادة",
                loadError: "خطأ في تحميل الأتمتة المحذوفة"
            },
            insightsPage: {
                title: "إحصائيات الأتمتة",
                selectAutomation: "اختر الأتمتة",
                dateRange: "نطاق التاريخ",
                datePlaceholderStart: "البداية",
                datePlaceholderEnd: "النهاية",
                lastWeek: "الأسبوع الماضي",
                lastMonth: "الشهر الماضي",
                last3Months: "آخر 3 أشهر",
                statusFilter: "فلتر الحالة",
                statusScheduled: "مجدول",
                statusRunning: "قيد التشغيل",
                statusWaitingReply: "في انتظار الرد",
                statusDone: "مكتمل",
                statusFailed: "فشل",
                statusCancelled: "ملغى",
                clearFilters: "مسح الفلاتر",
                refreshData: "تحديث البيانات",
                activeFilters: "الفلاتر النشطة:",
                totalTasks: "إجمالي المهام",
                executedTasks: "المهام المنفذة",
                successRate: "معدل النجاح",
                successfulTasks: "المهام الناجحة",
                avgDuration: "المدة المتوسطة",
                avgWorkDuration: "متوسط مدة العمل",
                activeTasks: "المهام النشطة",
                runningNow: "قيد التشغيل الآن",
                dailyTaskExecution: "تنفيذ المهام اليومية",
                statusDistribution: "توزيع الحالة",
                durationDistribution: "توزيع المدة",
                terminateReasons: "أسباب الإنهاء",
                automationPerformance: "أداء الأتمتة",
                view: "عرض",
                automationName: "اسم الأتمتة",
                executionCount: "عدد التنفيذ",
                actions: "الإجراءات",
                totalTasksLegend: "إجمالي المهام",
                successfulLegend: "ناجح",
                failedLegend: "فشل",
                taskCount: "عدد المهام",
                ms: "مللي ثانية",
                sec: "ثانية",
                min: "دقيقة",
                hour: "ساعة",
                automationsLoadError: "حدث خطأ أثناء تحميل الأتمتة",
                insightsLoadError: "حدث خطأ أثناء تحميل الإحصائيات"
            },
            settingsWidget: {
                viewActivityLogs: "عرض سجلات النشاط",
                activityLogsTitle: "سجلات النشاط",
                activityLogsEmpty: "لا توجد سجلات نشاط حتى الآن",
                activityLogsLoadError: "حدث خطأ أثناء تحميل سجلات النشاط",
                exportedToClipboard: "تم نسخ الأتمتة إلى الحافظة",
                settings: "الإعدادات"
            },
            blocks: {
                ASSIGN_OWNER: "تعيين الملكية",
                autoForwardToOwnerForce: "إعادة توجيه تلقائية للمالك (حتى عندما يكون روبوت الدردشة نشطًا)",
                SHOW_WIDGET: "عرض الويدجت",
                REPLY_TRENDYOL_QUESTION: "الرد على سؤال Trendyol",
                START_POINT: "نقطة البداية",
                AI_ASSISTANT: "مساعد الذكاء الاصطناعي",
                BOT_RESPONSE: "استجابة الروبوت",
                AI_BOT_RESPONSE: "استجابة الذكاء الاصطناعي (GPT-4o)",
                AI_CLASSIFICATION: "تصنيف الذكاء الاصطناعي",
                AI_MENU_FLOW: "قائمة الذكاء الاصطناعي",
                OTP_WHATSAPP_FLOW: "OTP Whatsapp",
                OTP_SMS_FLOW: "otp sms",
                RUN_JAVASCRIPT: "تشغيل JavaScript",
                OTP_MAIL_FLOW: "بريد otp",
                AI_INSTAGRAM_FLOW: "ai instagram comment",
                PLATFORM_FLOW: "النظام الأساسي",
                DEFAULT_FALLBACK: "الاحتياطي الافتراضي",
                DEFAULT_TIMEOUT: "المهلة الافتراضية",
                AI_FUNCTIONS: "وظائف الذكاء الاصطناعي",
                FILTER: "مرشح",
                FLOW: "FLOW",
                ATTACHMENT_INPUT: "مدخلات المرفقات",
                USER_INPUT: "إدخال المستخدم",
                GO_TO_STEP: "الانتقال إلى الخطوة",
                WEBHOOK: "خطاف الويب",
                SET_ATTRIBUTE: "تعيين السمة",
                QUESTION: "سؤال",
                CLOSE_CHAT: "إغلاق الدردشة",
                CREATE_TICKET: "إنشاء تذكرة",
                TRANSFER_CHAT: "نقل الدردشة",
                TRANSFER_TO_CHATBOT: "إعادة توجيه إلى روبوت الدردشة",
                TAG_CHAT: "إضافة وسم",
                REMOVE_TAG: "إزالة وسم",
                SET_DEPARTMENT: "تعيين قسم",
                SEND_TRANSCRIPT: "إرسال نص",
                SEND_SMS: "إرسال رسائل قصيرة",
                SEND_MAIL: "SEND MAIL",
                CREATE_EVENT: "إنشاء حدث",
                CREATE_RESERVATION: "إنشاء حجز",
                RESERVATION_OPEN_URL: "عنوان URL لفتح الحجز",
                RESERVATION_SELECT_DAY: "تحديد يوم الحجز",
                RESERVATION_EVENT_LIST: "زائر قائمة الحجز",
                RESERVATION_SELECT_TIME: "تحديد وقت الحجز",
                CREATE_TASK: "إنشاء مهمة",
                SHOPIFY_SHOW_PRODUCTS: "عرض منتجات SHOPIFY",
                SHOPIFY_PRODUCT_AVAILABILITY: "توفر المنتج من SHOPIFY",
                SHOPIFY_ORDER_STATUS: "حالة الطلب من SHOPIFY",
                AKINON_SHOW_PRODUCTS: "عرض منتجات AKINON",
                AKINON_FIND_PRODUCT: "العثور على منتج AKINON",
                AKINON_ORDER_STATUS: "حالة الطلب من AKINON",
                AKINON_SELECT_ORDER: "تحديد طلب AKINON",
                AKINON_SELECT_SIZE: "تحديد الحجم من AKINON",
                AKINON_FIND_NEAREST_STOCK: "إظهار مخزون المتجر",
                AKINON_FIND_NEAREST_STORES: "إظهار أقرب المتاجر",
                AKINON_SHOW_DISCOUNT_CODES: "إظهار رموز الخصم",
                SUPPRESSION_ADD: "حظر جهة الاتصال",
                SUPPRESSION_REMOVE: "إلغاء حظر جهة الاتصال",
                IDEASOFT_SELECT_ORDER: "تحديد الطلب",
                IDEASOFT_ORDER_STATUS: "الحصول على حالة الطلب",
                IDEASOFT_GET_MEMBER_INFO: "تعبئة معلومات الأعضاء",
                TICKET_UPDATE: "تحديث التذاكر",
                TSOFT_SELECT_ORDER: "تحديد الطلب",
                TSOFT_ORDER_STATUS: "الحصول على حالة الطلب",
                TICIMAX_V2_SELECT_ORDER: "تحديد الطلب",
                TICIMAX_V2_ORDER_STATUS: "الحصول على حالة الطلب",
                IKAS_GET_MEMBER_INFO: "الحصول على تفاصيل العضو",
                IKAS_SELECT_ORDER: "اختر الطلب",
                IKAS_ORDER_STATUS: "جلب حالة الطلب",
                GET_LOCATION: "الحصول على الموقع",
                FALLBACK: "حالة الطوارئ",
                TIMEOUT: "مهلة",
                SUCCESS: "ناجح",
                FAILURE: "FAIL",
                PROBEL_SELECT_BRANCH: "تحديد فرع",
                PROBEL_SELECT_CLINIC: "تحديد مستوصف",
                PROBEL_SELECT_DAY: "حدد يوم الموعد",
                PROBEL_SELECT_HOUR: "حدد وقت الموعد",
                PROBEL_MAKE_APPOINTMENT: "تحديد موعد",
                PROBEL_CANCEL_APPOINTMENT: "إلغاء الموعد",
                PROBEL_GET_PATIENT_TOKEN: "الحصول على الرمز المميز للمريض",
                PROBEL_FILL_INFO: "الحصول على معلومات MERNIS",
                PROBEL_SELECT_APPOINTMENT: "تحديد موعد",
                SEND_WP_BUSINESS_MESSAGE: "إرسال رسالة واتساب",
                MESSENGER_SEND_MESSAGE: "إرسال رسالة ماسنجر",
                INSTAGRAM_SEND_MESSAGE: "إرسال رسالة إنستغرام",
                INSTAGRAM_COMMENT_REPLY: "الرد على تعليق",
                INSTAGRAM_COMMENT_DELETE: "حذف تعليق",
                INSTAGRAM_COMMENT_SHOW: "إظهار التعليق",
                INSTAGRAM_COMMENT_HIDE: "إخفاء التعليق",
                INSTAGRAM_COMMENT_REPLY_AS_PRIVATE: "الرد كخاص",
                LOOP: "حلقة",
                LOOP_NEXT: "حلقة العنصر التالي",
                LOOP_BREAK: "كسر الحلقة",
                LOOP_CONTINUE: "متابعة الحلقة التالية",
                LOOP_FINISH: "إنهاء الحلقة",
                SLEEP: "النوم",
                NOOP: "Noop",
                CATCH_WEBHOOK: "CATCH_WEBHOOK",
                TERMINATE_AUTOMATION: "إنهاء الأتمتة",
                CREATE_CONTACT: "إنشاء جهة اتصال",
                UPDATE_CONTACT: "تحديث جهة الاتصال",
                FIND_CONTACTS: "البحث عن جهات الاتصال",
                FIND_CONTACT: "البحث عن جهة اتصال",
                FIND_CHATS: "البحث عن الدردشات",
                FIND_CHAT: "البحث عن دردشة",
                WAIT_FOR: "انتظار",
                STRING_FORMAT: "تنسيق سلسلة",
                NUMBER_FORMAT: "تنسيق رقم",
                DATE_FORMAT: "تنسيق التاريخ",
                RECORDS_FROM_CSV: "السجلات من CSV",
                MESSAGE_RECEIVED: "تم استلام الرسالة",
                ASK_AI: "الذكاء الاصطناعي",
                TABLE_CREATE_RECORD: "إنشاء سجل",
                TABLE_DELETE_RECORD: "حذف سجل",
                TABLE_UPDATE_RECORD: "تحديث سجل",
                TABLE_FIND_RECORD: "البحث عن سجل",
                TABLE_FIND_RECORDS: "قائمة السجلات",
                ZOHO_FIND_RECORDS_BY_PHONE: "Zoho البحث عن سجل (بواسطة الهاتف)",
                ZOHO_ADD_ATTACHMENT_TO_RECORD: "Zoho إضافة ملف إلى السجل",
                ZOHO_UPLOAD_IMAGE_TO_RECORD_FIELD: "Zoho تحميل صورة إلى حقل مخصص",
                ZOHO_CREATE_RECORD: "Zoho إنشاء سجل",
                GET_SUPSIS_RECORD_BY_ID: "الحصول على السجل",
                META_SEND_CAPI_EVENT: "إرسال حدث CAPI",
                GOOGLE_DRIVE_UPLOAD_FILE: "رفع ملف",
                GOOGLE_DRIVE_DOWNLOAD_FILE: "تحميل ملف",
                GOOGLE_DRIVE_GET_FILE_INFO: "الحصول على معلومات الملف",
                GOOGLE_DRIVE_DELETE_FILE: "حذف ملف",
                ADD_TO_SEGMENT: "Add to Segment",
                REMOVE_FROM_SEGMENT: "Remove from Segment",
                FEEDBACK_AI_ASSISTANT: "FEEDBACK AI ASSISTANT",
                INSERT_TO_SYSTEM_PROMPT: "INSERT TO SYSTEM PROMPT",
                AI_CALL: "AI CALL",
                TAVILY_WEB_SEARCH: "WEB SEARCH (TAVILY)",
                SEND_JSON_RESPONSE: "RESPOND TO WEBHOOK",
                UPDATE_TASK: "UPDATE TASK",
                CACHE_WRITE: "CACHE WRITE",
                CACHE_READ: "CACHE READ",
                CACHE_EXTEND: "CACHE EXTEND",
                CACHE_DELETE: "CACHE DELETE",
                YOUTUBE_REPLY_COMMENT: "Reply Comment",
                YOUTUBE_UPDATE_COMMENT_STATUS: "Update Comment Status",
                YOUTUBE_SET_MODERATION_STATUS: "Set Moderation Status",
                GOOGLE_BUSINESS_REPLY_REVIEW: "Reply Review",
                GOOGLE_BUSINESS_UPDATE_REVIEW_STATUS: "Update Review Status",
                GOOGLE_PLAY_REPLY_REVIEW: "Reply Review",
                GOOGLE_PLAY_UPDATE_REVIEW_STATUS: "Update Review Status",
                APP_STORE_REPLY_REVIEW: "Reply Review",
                APP_STORE_UPDATE_REVIEW_STATUS: "Update Review Status",
                APP_STORE_DELETE_REVIEW_RESPONSE: "Delete Review Response",
                OPENROUTER_RESPONSE: "OpenRouter AI Response",
                OPENAI_RESPONSE: "Generate with OpenAI",
                GOOGLE_AI_RESPONSE: "Generate with Google AI",
                ANTHROPIC_RESPONSE: "Generate with Anthropic",
                MISTRAL_RESPONSE: "Generate with Mistral",
                AZURE_RESPONSE: "Generate with Azure",
                BEDROCK_RESPONSE: "Generate with AWS Bedrock",
                COHERE_RESPONSE: "Generate with Cohere",
                XAI_RESPONSE: "Generate with xAI",
                DEEPINFRA_RESPONSE: "Generate with DeepInfra",
                TOGETHER_RESPONSE: "Generate with Together",
                FIREWORKS_RESPONSE: "Generate with Fireworks",
                SILICONFLOW_RESPONSE: "Generate with SiliconFlow",
                PARASAIL_RESPONSE: "Generate with Parasail",
                NEBIUS_RESPONSE: "Generate with Nebius",
                ALIBABA_RESPONSE: "Generate with Alibaba",
                XIAOMI_RESPONSE: "Generate with Xiaomi",
                SAMBANOVA_RESPONSE: "Generate with SambaNova",
                MOONSHOT_RESPONSE: "Generate with Moonshot",
                MINIMAX_RESPONSE: "Generate with MiniMax",
                NVIDIA_RESPONSE: "Generate with NVIDIA",
                FALLIMENTO: "FAIL",
                OPENAI_WEB_SEARCH: "WEB SEARCH (OPENAI)",
                OPEN_AI: "OPEN_AI",
                PLATTFORM_FLOW: "PLATTFORM",
                PUNTO_INICIO: "PUNTO DE INICIO",
                SUCCESSO: "SUCCESSO"
            },
            newAutomation: "New Automation",
            totalAutomations: "Total {count} automations",
            totalAutomationsWithHidden: "Total {total} automations ({visible} visible)",
            whenVoiceAgentCallStarted: "When a voice agent call is started",
            whenVoiceAgentCallEnded: "When a voice agent call is ended",
            whenVoiceAgentCallAnalyzed: "When a voice agent call is analyzed",
            createAnEventAutomation: "Create an Event Automation",
            webhookAutomationCreatedSuccessfully: "Webhook Automation Created Successfully",
            automationsCouldNotBeFetched: "Automations Could Not Be Fetched ",
            automationPublishedStateUpdatedSuccessfully: "Automation Published State Updated Successfully",
            automationPublishedStateCouldNotBeUpdated: "تعذر تحديث حالة نشر الأتمتة",
            enablePreFilters: "تفعيل الفلاتر المسبقة",
            preFilterDescription: "تسمح لك الفلاتر المسبقة بتحديد متى يجب تشغيل الأتمتة. عند التفعيل، سيتم تشغيل الأتمتة فقط للأحداث التي تطابق شروطك المحددة.",
            preFilters: "الفلاتر المسبقة",
            executionRules: "قواعد التنفيذ",
            preFilterInfo: "باستخدام الفلاتر المسبقة، يمكنك تحديد متى يجب تشغيل الأتمتة. سيتم تشغيل الأتمتة فقط للأحداث التي تطابق شروطك المحددة.",
            preFiltersSaved: "تم حفظ الفلاتر المسبقة بنجاح",
            preFiltersSaveError: "خطأ في حفظ الفلاتر المسبقة",
            preFiltersConfiguration: "تكوين الفلاتر المسبقة",
            executionPrivacyTitle: "صلاحية التنفيذ",
            executionPrivacyDescription: "من المستخدمين أو الأقسام الذين يمكنهم تنفيذ هذه الأتمتة؟ إذا تركت فارغة، يمكن لجميع المستخدمين تنفيذها.",
            executionPrivacyPublic: "يمكن لجميع المستخدمين تنفيذ هذه الأتمتة",
            executionPrivacyConfiguration: "تكوين صلاحية التنفيذ",
            executionPrivacySaved: "تم حفظ صلاحية التنفيذ بنجاح",
            executionPrivacySaveError: "حدث خطأ أثناء حفظ صلاحية التنفيذ",
            addDescription: "أضف وصفاً...",
            descriptionPlaceholder: "أدخل وصف الأتمتة...",
            descriptionSaved: "تم حفظ الوصف بنجاح",
            descriptionSaveError: "حدث خطأ أثناء حفظ الوصف",
            makePublicExecution: "جعله عاماً",
            makePublicExecutionConfirmTitle: "هل أنت متأكد من أنك تريد جعل هذه الأتمتة عامة؟",
            makePublicExecutionConfirmContent: "بعد هذه العملية، سيتمكن جميع الممثلين من تنفيذ هذه الأتمتة.",
            madePublicExecution: "تم جعل الأتمتة عامة",
            openrouterResponse: "استجابة OpenRouter AI",
            selectProvider: "اختر المزود",
            modelName: "النموذج",
            modelHint: "مثال: google/gemini-2.0-flash-001, openai/gpt-4o",
            systemInstructions: "تعليمات النظام (اختياري)",
            systemInstructionsPlaceholder: "أخبر الذكاء الاصطناعي كيف يتصرف...",
            promptPlaceholder: "اكتب سؤالك للذكاء الاصطناعي...",
            advancedSettings: "إعدادات متقدمة",
            temperatureHint: "القيم الأقل تنتج استجابات أكثر اتساقاً، القيم الأعلى تنتج استجابات أكثر إبداعاً (0-2)",
            maxTokens: "الحد الأقصى للرموز",
            maxTokensHint: "الحد الأقصى لعدد الرموز التي سيتم إنشاؤها",
            maxTokensPlaceholder: "الافتراضي: حد النموذج",
            selectChannel: "اختر القناة (اختياري)",
            autoSelectChannel: "تحديد تلقائي",
            archivingDate: "تاريخ الأرشفة",
            automazioni: "الأتمتة",
            cancelado: "ملغى"
        },
        modules: {
            createFailed: "فشل إنشاء الوحدة",
            createSuccess: "تم إنشاء الوحدة بنجاح",
            moduleDeletedSuccessfully: "تم حذف الوحدة بنجاح",
            deleteModuleTitle: "حذف الوحدة",
            deleteModuleContent: "هل أنت متأكد أنك تريد حذف هذه الوحدة؟",
            modules: "الوحدات",
            relations: "العلاقات",
            newRelation: "علاقة جديدة",
            editRelation: "تحرير العلاقة",
            modulesSettings: "إعدادات الوحدات",
            displayName: "اسم العرض",
            description: "الوصف",
            table: "الجدول",
            menuApiSettings: "إعدادات القائمة وواجهة برمجة التطبيقات",
            icon: "أيقونة",
            save: "حفظ",
            exampleIcon: "مثال: extension, home",
            newModule: "وحدة جديدة",
            moduleName: "اسم الوحدة",
            apiName: "اسم واجهة برمجة التطبيقات",
            type: "نوع",
            apiAccess: "وصول واجهة برمجة التطبيقات",
            actions: "الإجراءات",
            module: "وحدة",
            relation: "علاقة",
            moduleRelationName: "اسم الوحدة / العلاقة",
            moduleRelationTable: "جدول الوحدة / العلاقة",
            showInMainMenu: "إظهار في القائمة الرئيسية",
            apiEnabled: "واجهة برمجة التطبيقات مفعلة",
            settings: "إعدادات",
            createModule: "إنشاء وحدة",
            relationType: "نوع العلاقة",
            relationTypeTableToTable: "جدول إلى جدول",
            relationTypeTableToStandart: "جدول إلى وحدة قياسية",
            relationTypeStandartToTable: "وحدة قياسية إلى جدول",
            fromColumn: "من",
            toColumn: "إلى",
            apiDoc: "توثيق API",
            standartModule: "وحدة قياسية",
            customTable: "جدول خاص",
            localField: "حقل محلي",
            showingRemoteFieldInList: "إظهار حقل منعزل في القائمة",
            relationSettings: "إعدادات العلاقة",
            remoteField: "حقل منعزل",
            localFieldType: "نوع حقل محلي",
            standart: "قياسي",
            custom: "خاص",
            contact: "إتصال",
            viewRecord: "عرض السجل",
            recordDetail: "تفاصيل السجل",
            recordNotFound: "السجل أو معلومات الجدول غير موجودة",
            relatedLists: "القائمة المتعلقة",
            recordViewer: "عارض السجلات",
            kanbanSettings: {
                title: "Settings",
                column: "Column Settings",
                selectField: "Select a field",
                selectFieldPlaceholder: "Select a field",
                card: "Card Settings",
                selectFields: "Select fields to show in card",
                cancel: "Cancel",
                save: "Save",
                kanban: "Kanban Settings"
            },
            updateSuccess: "Module updated successfully",
            updateFailed: "Module update failed",
            editModule: "Edit Module",
            priority_high: "عالية",
            priority_highest: "الأعلى",
            priority_low: "منخفضة",
            priority_lowest: "الأدنى",
            priority_medium: "متوسطة"
        },
        tables: {
            enterWidgetName: "أدخل اسم القطعة",
            widgetName: "اسم القطعة",
            renameWidget: "إعادة تسمية الويدجت",
            assistantCapabilities: "قدرات المساعد",
            addNewFieldsToTable: "يمكنه إضافة حقول جديدة إلى الجدول",
            editExistingFields: "يمكنه تعديل الحقول الموجودة",
            deleteUnnecessaryFields: "يمكنه حذف الحقول غير الضرورية",
            filterRecords: "يمكنه تصفية السجلات",
            groupRecords: "يمكنه تجميع السجلات",
            hideFieldsCapability: "يمكنه إخفاء الحقول",
            createConditionalFormatting: "يمكنه إنشاء تنسيق شرطي",
            createCalculationFormulas: "يمكنه إنشاء صيغ حسابية",
            createSampleRecords: "يمكنه إنشاء سجلات عينة",
            examplePrompt: "مثال: أضف حقول الاسم، اللقب، البريد الإلكتروني، ورقم الهاتف لمعلومات العميل إلى هذا الجدول...",
            supsisAssistantTables: "Supsis Assistant: الجداول",
            supsisAssistantWritePrompt: "وصف ما تريد أن يقوم به Supsis Assistant",
            supsisAssistantExamplePrompt: "إنشاء جدول لتتبع الاجتماعات. قم بتضمين حقول مثل موضوع الاجتماع، التاريخ، المشاركين، الشخص المسؤول، القرارات المتخذة، والإجراءات اللاحقة.",
            sendSupsisAssistant: "إرسال إلى Supsis Assistant",
            examplePromptsTitle: "طلبات مثال:",
            examplePrompts: {
                addCustomerInfoFields: "أضف حقول الاسم، اللقب، البريد الإلكتروني، ورقم الهاتف لمعلومات العميل إلى هذا الجدول.",
                addOrderFields: "أضف حقول اسم المنتج، الكمية، السعر الفردي، المبلغ الإجمالي وتاريخ الطلب إلى جدول الطلبات.",
                addBirthDateField: "أضف حقل تاريخ الميلاد إلى هذا الجدول وحدد تنسيق التاريخ إلى يوم/شهر/سنة.",
                updateStatusField: "قم بتحديث حقل الحالة، اجعله قائمة منسدلة تحتوي على الخيارات: قيد الانتظار، قيد المعالجة، مكتمل، ملغى.",
                replaceAddressFields: "احذف حقل العنوان وأضف بدلاً منه حقول عنوان السطر 1، عنوان السطر 2، المنطقة، المدينة، والرمز البريدي.",
                alignTextFields: "محاذاة جميع حقول النص إلى المنتصف وحدد الحد الأقصى لطول النص إلى 100 حرف.",
                addAutoIncrementID: "أضف حقل معرف تلقائي التزايد مع بادئة PRD- للمنتج.",
                addTotalAmountFormula: "أضف حقل المبلغ الإجمالي كصيغة لحساب حاصل ضرب الكمية والسعر الفردي.",
                createActiveCustomersFilter: "أنشئ فلترًا لعرض العملاء النشطين فقط.",
                filterRecentUsers: "فلتر المستخدمين الذين سجلوا في آخر 30 يومًا.",
                groupByStatus: "قم بتجميع السجلات حسب عمود الحالة.",
                hideAllExceptDeliveryAndOrderNo: "اخفِ جميع الحقول ما عدا تاريخ التسليم ورقم الطلب.",
                colorCodeOrders: "ألون الطلبات المتأخرة باللون الأحمر، والطلبات التي سيتم تسليمها اليوم باللون الأصفر، والطلبات المكتملة باللون الأخضر.",
                highlightHighPaymentRecords: "سلط الضوء على السجلات التي تحتوي على مبلغ دفع أكثر من 1000 ليرة تركية باللون الأرجواني.",
                groupAndHighlightUnpaidOrders: "قم بتجميع السجلات حسب تاريخ الطلب وميز الطلبات غير المدفوعة باللون الأحمر.",
                createSampleRecords: "أنشئ 10 سجلات عينة في هذا الجدول.",
                addSampleRecordsForAliAndAhmet: "أضف 5 سجلات عينة بأسماء العملاء علي وأحمد.",
                createRandomSampleOrders: "أنشئ 20 سجل طلب عشوائي مع حالات عشوائية.",
                hrCandidateTracking: "أريد إنشاء برنامج تتبع المرشحين (ATS) لعمليات الموارد البشرية لدينا. قم بتضمين كل ما يجب أن يحتويه ATS. استخدم أسماء الحقول التركية.",
                crmModuleCreation: "قم بإنشاء جميع الوحدات اللازمة لإدارة علاقات العملاء (CRM). قم بتضمين معلومات العملاء، سجلات الاجتماعات، وإدارة الفرص.",
                realEstatePortfolioManagement: "أريد إعداد نظام إدارة محفظة عقارية. يجب أن يتعامل مع تفاصيل العقارات، طلبات العملاء، وتتبع المبيعات.",
                schoolManagementSystem: "أريد إدارة تتبع الطلاب، المعلمين، وجدول الحصص لنظام إدارة المدرسة. استخدم أسماء الحقول التركية.",
                projectManagementSystem: "أريد إنشاء نظام إدارة المشاريع. قم بتضمين المهام، أعضاء الفريق، تتبع الوقت، وميزات التقارير.",
                inventoryAndWarehouseManagement: "أريد بناء نظام لإدارة المخزون والمستودعات. يجب أن يتعامل مع تسجيلات الدخول/الخروج للمنتجات، مستويات المخزون، وتتبع الموردين.",
                serviceAndMaintenanceTracking: "أريد نظام تتبع للخدمات والصيانة. يجب أن يدير أجهزة العملاء، تاريخ الصيانة، وتعيينات الفنيين.",
                restaurantManagementSystem: "أريد إعداد نظام إدارة مطعم. قم بتضمين تتبع الطاولات، إدارة الطلبات، عرض المطبخ، وعمليات الفوترة."
            },
            createAppWithSupsisAssistant: "إنشاء تطبيق باستخدام Supsis Assistant",
            noWidgets: "لا يوجد ويدجتت إضافة",
            widgetLoadError: "حدث خطأ أثناء تحميل الويدجت",
            createDashboardSupsisAssistant: "إنشاء لوحة تحكم باستخدام Supsis Assistant",
            youtubeDesc: "أدخل فيديوهات YouTube في لوحة التحكم الخاصة بك",
            iframeDesc: "أدخل محتوى الويب الخارجي في لوحة التحكم الخاصة بك",
            countdownDesc: "أضف عداد عودة لتتبع الأوقات المهمة",
            countdown: "عداد العودة",
            textDesc: "أضف محتوى نصي مخصص إلى لوحة التحكم الخاصة بك",
            numbersDesc: "احصل على ملخص سريع لجميع الأعمدة الرقمية",
            numbers: "أرقام",
            addWidget: "إضافة Widget",
            graphDesc: "إنشاء ملف تعريف المخطط لتحديد البيانات التي سيتم عرضها في المخطط",
            graph: "رسم بياني",
            suggested: "مقترح",
            creationDate: "تاريخ الإنشاء",
            today: "اليوم",
            month: "شهر",
            week: "أسبوع",
            day: "يوم",
            table: "جدول",
            kanban: "كانبان",
            calendar: "تقويم",
            calendarSettings: "إعدادات التقويم",
            colorBy: "اللون حسب",
            startDateField: "حقل تاريخ البدء",
            endDateField: "حقل تاريخ الانتهاء (اختياري)",
            eventCardFields: "حقول بطاقة الحدث",
            selectColorField: "اختر حقل اللون",
            selectStartDateField: "اختر حقل تاريخ البدء",
            selectEndDateField: "اختر حقل تاريخ الانتهاء",
            cancel: "إلغاء",
            save: "حفظ",
            kanbanNotAvailable: "عرض كانبان غير متاح",
            needDropdownField: "لاستخدام عرض كانبان، تحتاج إلى حقل قائمة منسدلة ثابت واحد على الأقل في جدولك. يمكنك إضافة حقل جديد أو تعديل حقل موجود من إعدادات الجدول.",
            notAvailable: "عرض التقويم غير متاح",
            needDateField: "تحتاج إلى حقل تاريخ واحد على الأقل في جدولك لاستخدام عرض التقويم. يمكنك إضافة حقل جديد أو تعديل حقل موجود من إعدادات الجدول.",
            switchToTable: "التبديل إلى عرض الجدول",
            operator: "المشغل",
            conditionalColor: "لون مخصص",
            groupField: "حقل المجموعة",
            selectDirection: "إختيار الاتجاه",
            showEmptyGroups: "إظهار المجموعات الفارغة",
            clearGrouping: "تفريغ المجموعة",
            applyGrouping: "تطبيق المجموعة",
            sortDirection: "إختيار الاتجاه",
            downloadSelectedRecords: "تنزيل السجلات المحددة",
            downloadSelected: "تنزيل المحدد",
            downloadSelectedWithCount: "تنزيل المحدد ({count})",
            downloadThisPage: "تنزيل هذه الصفحة",
            downloadAll: "تنزيل الكل",
            downloadRecords: "تنزيل السجلات",
            downloadRecordsSettings: "تنزيل السجلات - الإعدادات",
            recordLimitExceededTooltip: "تم الوصول إلى حد السجلات. تحتاج إلى ترقية خطتك لاستيراد السجلات.",
            zebraMode: "وضع Zebra",
            viewName: "اسم العرض",
            enterViewName: "أدخل اسم العرض",
            enterDesc: "أدخل الوصف",
            viewNameRequired: "اسم العرض مطلوب",
            runWebhookAutomation: "تشغيل أتمتة خطاف الويب",
            downloadAllRecords: "تنزيل جميع السجلات",
            deleteRecords: "حذف السجلات",
            editRecords: "تحديث السجلات",
            duplicateRecords: "تكرار السجلات",
            selected: "محدد",
            sureDeleteRecords: "هل أنت متأكد أنك تريد حذف السجلات؟",
            selectedRecordSucs: "تم حذف السجلات المحددة بنجاح",
            errorDeletingRecords: "حدث خطأ أثناء حذف السجلات.",
            sureCopyRecords: "هل تريد بالتأكيد نسخ السجلات؟",
            copyRecords: "نسخ السجلات",
            recordsCopiedSucs: "تم نسخ السجلات المحددة بنجاح.",
            recordsCopiedError: "حدث خطأ أثناء نسخ السجلات المحددة.",
            viewSucsCreated: "تم إنشاء طريقة العرض بنجاح.",
            editMultipleRecords: "تحرير سجلات متعددة",
            importRecords: "استيراد السجلات",
            importHasStarted: "بدأ الاستيراد. قد يستغرق الأمر بضع دقائق حسب حجم بياناتك. الرجاء الانتظار...",
            anErrorImport: "حدث خطأ أثناء الاستيراد.",
            recordCreated: "إنشاء سجل",
            recordUpdated: "تحديث السجل",
            recordDeleted: "حذف السجل",
            noAutomationDefined: "لم يتم تعريف الأتمتة بعد",
            nameTheAutomationAdd: "اسم الأتمتة التي سيتم تشغيلها عند إضافة سجل إلى هذا الجدول:",
            nameTheAutomationUpdate: "قم بتسمية الأتمتة التي سيتم تشغيلها عند تحديث سجل في هذا الجدول:",
            nameTheAutomationDelete: "قم بتسمية الأتمتة التي سيتم تشغيلها عند حذف سجل من هذا الجدول:",
            editField: "تحرير الحقل",
            sort: "فرز",
            sortAscending: "فرز أ-ي",
            sortDescending: "فرز ي-أ",
            clearSort: "إزالة الفرز",
            markAsIdentifierField: "تعيين كحقل معرف",
            runAI: "تشغيل الذكاء الاصطناعي",
            ascending: "تصاعدي",
            descending: "تنازلي",
            createField: "إنشاء حقل",
            insertBefore: "إدراج قبل",
            insertAfter: "إدراج بعد",
            goToRelatedAuto: "الانتقال إلى الأتمتة ذات الصلة",
            permission: "إذن",
            lockField: "قفل الحقل",
            hideField: "إخفاء الحقل",
            deleteField: "حذف الحقل",
            watchVideo: "مشاهدة الفيديو",
            uploadError: "خطأ في التحميل",
            updateError: "خطأ في التحديث",
            invalidValue: "قيمة غير صالحة. الرجاء استخدام التنسيق الصحيح.",
            errorUpdatingRecord: "حدث خطأ أثناء تحديث السجل.",
            errorCreatingView: "حدث خطأ أثناء إنشاء طريقة العرض.",
            datetimeOptions: "خيارات التاريخ والوقت",
            numberOptions: "خيارات الأرقام",
            currencyOptions: "خيارات العملة",
            dropdownOptions: "خيارات القائمة المنسدلة",
            automationButtonOptions: "خيارات زر التشغيل الآلي",
            defaultLabel: "التسمية الافتراضية",
            disableWhenClicked: "تعطيل عند النقر",
            fieldSucsCreate: "تم إنشاء الحقل بنجاح",
            fieldCreatingFailed: "حدث خطأ أثناء إنشاء الحقل",
            fieldSucsUpdate: "تم تحديث الحقل بنجاح",
            fieldUpdatingFailed: "حدث خطأ أثناء تحديث الحقل",
            showAll: "إظهار الكل",
            hideAll: "إخفاء الكل",
            searchFields: "البحث عن الحقول",
            firstRowHeader: "الصف الأول يحتوي على رأس",
            separatorCharacter: "حرف فاصل",
            comma: "فاصلة",
            semicolon: "فاصلة منقوطة",
            tableFieldOrFileColumns: "تعيين حقل الجدول / أعمدة الملف",
            exampleResultPreview: "مثال على معاينة النتائج",
            newView: "عرض جديد",
            createViewaFiltering: "إنشاء طرق عرض لمتابعة تصفية الحقول وفرزها وإخفائها دون تغيير الجدول الرئيسي.",
            pleaseUpdateSelected: "الرجاء تحديد الحقل الذي تريد تحديثه للسجلات المحددة.",
            pleaseSelectedNewValue: "الرجاء إدخال القيمة الجديدة للحقل المحدد.",
            selectedMenuItem: "عنصر القائمة المحدد:",
            deleteTable: "حذف الجدول",
            sureDeleteTable: "هل أنت متأكد من رغبتك في حذف هذا الجدول؟",
            deleteTableSucs: "تم حذف الجدول بنجاح.",
            deleteTableError: "خطأ في حذف الجدول:",
            editTable: "تحرير الجدول",
            createNewField: "إنشاء حقل جديد",
            tables: "الجداول",
            tableName: "اسم الجدول",
            description: "الوصف",
            createTable: "إنشاء جدول",
            createNewTable: "إنشاء جدول جديد",
            allTables: "كل الجداول",
            myTables: "الجداول الخاصة بي",
            myFavorites: "مفضلاتي",
            errorCreatingTable: "خطأ في إنشاء جدول:",
            customerTable: "جدول العملاء",
            customerTableDesc: "جدول العملاء الافتراضي",
            leadTracking: "تتبع العملاء المحتملين",
            leadTrackingDesc: "جدول تتبع العملاء المحتملين",
            todoList: "قائمة المهام",
            todoListDesc: "قائمة لتتبع المهام",
            approvalReq: "طلب الموافقة",
            approvalReqDesc: "إدارة طلبات الموافقة",
            eventSchedule: "تقويم الأحداث",
            eventScheduleDesc: "جدولة الأحداث القادمة",
            inventoryList: "قائمة الجرد",
            inventoryListDesc: "تتبع مخزون المنتجات",
            bookingForm: "نموذج الحجز",
            bookingFormDesc: "تتبع الحجوزات",
            bugTracker: "تعقب الأخطاء",
            bugTrackerDesc: "تتبع أخطاء البرامج",
            employeeDirectory: "دليل الموظف",
            employeeDirectoryDesc: "يحتوي على معلومات الموظف",
            errorPullTable: "خطأ في سحب بيانات الجدول",
            newRecordSucs: "تم إنشاء سجل جديد بنجاح.",
            failedNewRecord: "فشل إنشاء سجل جديد:",
            newRecordCreateError: "حدث خطأ أثناء إنشاء سجل جديد.",
            recordCount: "عدد السجلات",
            increaseLimit: "زيادة الحد",
            newRecord: "سجل جديد",
            imports: "استيراد",
            exports: "تصدير",
            download: "تنزيل",
            automateYourData: "أتمتة بياناتك",
            recordUpdatedSucs: "تم تحديث السجل بنجاح",
            failToUpdateRecord: "فشل تحديث السجل",
            recordUpdatingError: "خطأ في تحديث السجل",
            mainTable: "الجدول الرئيسي",
            filter: "عامل التصفية",
            hideFields: "إخفاء الحقول",
            saveAsView: "حفظ كطريقة عرض",
            search: "بحث",
            create: "إنشاء",
            left: "يسار",
            center: "متوسط",
            right: "يمين",
            selectTimezone: "تحديد المنطقة الزمنية",
            createFieldSucs: "تم إنشاء الحقل بنجاح.",
            failCreateField: "فشل إنشاء الحقل:",
            createFieldError: "حدث خطأ أثناء إنشاء الحقل.",
            addCondition: "إضافة شرط",
            applyFilter: "تطبيق عامل التصفية",
            fieldType: "نوع الحقل",
            alignment: "محاذاة",
            blankTable: "جدول فارغ",
            templates: "قوالب",
            timezone: "المنطقة الزمنية",
            timeFormat: "تنسيق الوقت",
            includeTime: "تضمين الوقت",
            decimalFormat: "التنسيق العشري",
            currencySymbol: "رمز العملة",
            mode: "الوضع",
            statics: "ثابت",
            dynamic: "ديناميكي",
            multipleSelection: "اختيار متعدد",
            addOption: "إضافة خيار",
            text: "نص",
            longText: "نص طويل",
            number: "رقم",
            currency: "عملة",
            datetime: "التاريخ والوقت",
            dropdown: "قائمة منسدلة",
            checkbox: "خانة اختيار",
            email: "البريد الإلكتروني",
            phone: "هاتف",
            file: "ملف",
            image: "صورة",
            video: "فيديو",
            audio: "صوت",
            colour: "لون",
            automationButton: "زر التشغيل الآلي",
            trashBin: "سلة المهملات",
            pasteInfoDetected: "تم اكتشاف جدول منسوخ في الحافظة! الصق باستخدام Ctrl+V لإنشاء جدول جديد.",
            addCategory: "إضافة فئة",
            editCategory: "تحرير الفئة",
            deleteCategory: "حذف الفئة",
            moveAllTables: "نقل جميع الجداول",
            dragTablesToCategory: "اسحب الجداول هنا لإضافتها إلى هذه الفئة",
            deleteProtectionActive: "حماية الحذف نشطة",
            copyTable: "نسخ الجدول",
            copyAsJSON: "نسخ كـ JSON",
            changeCategory: "تغيير الفئة",
            turnOffDeleteProtection: "إيقاف حماية الحذف",
            turnOnDeleteProtection: "تفعيل حماية الحذف",
            privacySettings: "إعدادات الخصوصية",
            categoryName: "اسم الفئة",
            categoryNamePlaceholder: "أدخل اسم الفئة",
            categoryUpdate: "تحديث",
            categoryCreate: "إنشاء",
            categoryNameRequired: "اسم الفئة لا يمكن أن يكون فارغاً",
            categoryAlreadyExists: "فئة بهذا الاسم موجودة بالفعل",
            categoryCreated: "تم إنشاء الفئة. يمكنك سحب الجداول إلى هذه الفئة.",
            categorySaveError: "خطأ في حفظ الفئة",
            categoryUpdated: "تم تحديث الفئة",
            categoryUpdateError: "خطأ في تحديث الفئة",
            deleteCategoryConfirm: "حذف الفئة",
            deleteCategoryConfirmContent: "هل أنت متأكد من حذف \"{name}\"؟ سيتم نقل الجداول في هذه الفئة إلى \"العامة\".",
            categoryDeleted: "تم حذف الفئة",
            categoryDeleteError: "خطأ في حذف الفئة",
            tableMovedToCategory: "تم نقل الجدول إلى فئة \"{name}\"",
            tableMoveError: "خطأ في نقل الجدول",
            tableProtectedWarning: "هذا الجدول محمي من الحذف. قم بإزالة الحماية أولاً للحذف.",
            deleteProtectionEnabled: "تم تفعيل حماية الحذف",
            deleteProtectionDisabled: "تم إيقاف حماية الحذف",
            protectionUpdateError: "خطأ في تحديث حالة الحماية",
            tableCopied: "تم نسخ الجدول",
            tableCopyError: "خطأ في نسخ الجدول",
            tableJsonCopied: "تم نسخ الجدول إلى الحافظة كـ JSON. يمكنك اللصق باستخدام Ctrl+V في لوحة عميل أخرى.",
            tableJsonCopiedFallback: "تم نسخ الجدول إلى الحافظة كـ JSON (طريقة احتياطية)",
            tableJsonCopyError: "خطأ في نسخ الجدول كـ JSON",
            clipboardNotSupported: "الوصول إلى الحافظة غير مدعوم في هذا المتصفح",
            noValidTableJson: "لم يتم العثور على JSON جدول صالح في الحافظة",
            noValidSupsisExport: "لم يتم العثور على تصدير جدول Supsis صالح في الحافظة",
            tableImported: "تم استيراد جدول \"{name}\" بنجاح",
            tablePasteError: "خطأ في لصق الجدول",
            noTablesToMove: "لا توجد جداول للنقل",
            tablesMovedToCategory: "تم نقل {count} جدول إلى فئة \"{name}\"",
            tablesMoveError: "خطأ في نقل الجداول",
            noPermissionEditPrivacy: "ليس لديك إذن لتحرير إعدادات الخصوصية لهذا الجدول",
            sandboxTitle: "سيناريوهات الجداول المحذوفة",
            sandboxDesc: "يتم حذف الجداول المحذوفة نهائياً تلقائياً بعد 30 يوماً في سلة المهملات",
            sandboxEmpty: "لا توجد جداول محذوفة في سلة المهملات",
            unnamedTable: "جدول بدون اسم",
            restore: "استعادة",
            permanentlyDelete: "حذف نهائي",
            unknown: "غير معروف",
            user: "مستخدم",
            restoreTableConfirm: "هل أنت متأكد من استعادة هذا الجدول؟",
            restoreTableContent: "سيتم استعادة جدول {name}.",
            tableRestored: "تم استعادة الجدول",
            restoreFailed: "فشلت الاستعادة",
            permanentlyDeleteConfirm: "هل أنت متأكد من الحذف النهائي لهذا الجدول؟",
            permanentlyDeleteContent: "سيتم حذف جدول {name} نهائياً. لا يمكن التراجع عن هذا الإجراء.",
            yesPermanentlyDelete: "نعم، حذف نهائي",
            tablePermanentlyDeleted: "تم حذف الجدول نهائياً",
            permanentDeleteFailed: "فشل الحذف النهائي",
            deletedTablesLoadError: "خطأ في تحميل الجداول المحذوفة",
            otherTables: "Other Tables",
            noTablesFound: "No tables found",
            renameView: "Rename View",
            enterNewViewName: "Enter New View Name",
            viewRenamedSuccess: "View renamed successfully.",
            viewRenameError: "An error occurred while renaming the view.",
            deleteView: "Delete View",
            confirmDeleteView: "Are you sure you want to delete this view?",
            viewDuplicatedSuccess: "View duplicated successfully.",
            viewDuplicateError: "An error occurred while duplicating the view.",
            duplicateView: "Duplicate View",
            confirmDuplicateView: "Are you sure you want to duplicate this view?",
            viewDeletedSuccess: "View deleted successfully.",
            viewDeleteError: "An error occurred while deleting the view.",
            seperatorCharacter: "Ayırıcı Karakter",
            semicolan: "Noktalı Virgül",
            errorProcessingFile: "An error occurred while processing the file",
            failedToUpdateRecord: "Failed to Update Record",
            failedCreateField: "Failed to create field:",
            color: "Color",
            upload: "Upload",
            permissions: {
                title: "Table Privacy Settings",
                mode: "Permission Mode",
                publicMode: "Public",
                customMode: "Custom",
                publicModeDesc: "In this mode, all users have full access to the table.",
                customModeDesc: "In this mode, only certain users and departments have access to the table.",
                confirmPublicMode: "Switch to Public Mode",
                confirmPublicModeDesc: "If you switch to public mode, all custom permissions will be deleted. Do you want to continue?",
                addUser: "Add User",
                addDepartment: "Add Department",
                selectUser: "Select User",
                selectDepartment: "Select Department",
                add: "Add",
                matrixInfo: "You can manage permissions for users and departments from the matrix below. The checked boxes mean authorized.",
                targetHeader: "User / Department",
                noTargetsAdded: "No users or departments added yet",
                confirmRemoveTarget: "Remove Target",
                confirmRemoveTargetDesc: "Are you sure you want to remove this user/department from the permissions?",
                saveSuccess: "Permission settings saved successfully",
                saveError: "Error saving permission settings",
                unknownUser: "Unknown User",
                unknownDepartment: "Unknown Department",
                noPermission: "You don't have permission to do this action",
                groups: {
                    basic: "Basic Permissions",
                    record: "Record Permissions",
                    view: "View Permissions",
                    page: "Page Permissions",
                    field: "Field Permissions",
                    widget: "Widget Permissions",
                    importExport: "Import/Export"
                },
                scopes: {
                    tableRead: "View",
                    tableReadDesc: "View table",
                    tableMetaEdit: "Table Edit",
                    tableMetaEditDesc: "Edit table name, category and description",
                    recordCreate: "Record Create",
                    recordCreateDesc: "Create a new record",
                    recordUpdate: "Record Update",
                    recordUpdateDesc: "Update existing records",
                    recordDelete: "Record Delete",
                    recordDeleteDesc: "Delete records",
                    viewCreate: "View Create",
                    viewCreateDesc: "Create a new view",
                    viewUpdate: "View Update",
                    viewUpdateDesc: "Update existing views",
                    viewDelete: "View Delete",
                    viewDeleteDesc: "Delete views",
                    pageRead: "Page View",
                    pageReadDesc: "View special pages",
                    pageCreate: "Page Create",
                    pageCreateDesc: "Create a new page",
                    pageUpdate: "Page Update",
                    pageUpdateDesc: "Update existing pages",
                    pageDelete: "Page Delete",
                    pageDeleteDesc: "Delete pages",
                    fieldCreate: "Field Create",
                    fieldCreateDesc: "Create a new field",
                    fieldUpdate: "Field Update",
                    fieldUpdateDesc: "Update existing fields",
                    fieldDelete: "Field Delete",
                    fieldDeleteDesc: "Delete fields",
                    widgetCreate: "Widget Create",
                    widgetCreateDesc: "Create a new widget",
                    widgetUpdate: "Widget Update",
                    widgetUpdateDesc: "Update existing widgets",
                    widgetDelete: "Widget Delete",
                    widgetDeleteDesc: "Delete widgets",
                    bulkImport: "Bulk Import",
                    bulkImportDesc: "Bulk import records",
                    export: "Export",
                    exportDesc: "Export records"
                }
            },
            ascendente: "تصاعدي",
            centro: "وسط",
            colore: "لون",
            company: "شركة",
            createFailed: "فشل إنشاء الوحدة",
            createSuccess: "تم إنشاء الوحدة بنجاح",
            destra: "يمين",
            dinamico: "ديناميكي",
            discendente: "تنازلي",
            dynamisch: "ديناميكي",
            immagine: "صورة",
            individual: "فردي",
            izquierda: "يسار",
            priority_high: "مرتفع",
            priority_highest: "أعلى",
            priority_low: "منخفض",
            priority_lowest: "أدنى",
            priority_medium: "متوسط",
            rechts: "يمين",
            sinistra: "يسار",
            statica: "ثابت",
            tabelle: "جدول"
        },
        plans: {
            manageWithChatbot: "Manage with Chatbot",
            manageInbox: "Manage Inbox",
            commentManagement: "Manage Comments",
            privateReplyMessage: "Private Reply Comments",
            mentionTicket: "Convert Mentions to Tickets",
            week: "أسبوع",
            readyContents: "المحتويات الجاهزة",
            webhookIntegration: "تكامل ويب هوك",
            businessChannel: "قناة واتساب للأعمال",
            confirmationFeature: "ميزة التأكيد",
            specialReporting: "تقارير خاصة",
            aiAssistant: "مساعد الذكاء الاصطناعي",
            flexibleBilling: "الفوترة المرنة",
            automaticReservation: "الحجز التلقائي",
            taskManagement: "إدارة المهام",
            calendarIntegration: "تكامل التقويم",
            activeChatbot: "الشات بوت النشط",
            smsIntegration: "تكامل الرسائل القصيرة",
            mailIntegration: "تكامل البريد",
            startChatWithVisitor: "بدء محادثة مع الزائر",
            whatsappManaging: "إدارة الواتساب",
            automaticChatbotButton: "زر / روبوت دردشة تلقائي",
            personalizedBroadcasts: "البث المخصص",
            chatWithNonContacts: "الدردشة مع غير المتصلين",
            broadcastMessaging: "الرسائل الجماعية",
            perBroadcast: "لكل بث",
            extraPricePerMessage: "سعر إضافي لكل رسالة",
            smartTrigger: "زنة ذكية",
            telegramIntegration: "تكامل تلغرام",
            instagramIntegration: "تكامل إنستجرام",
            ticketFeature: "ميزة التذاكر",
            storage: "تخزين",
            onePanelManagement: "إدارة لوحة واحدة",
            isolatedDatabaseConnection: "اتصال قاعدة بيانات معزول",
            removeLogo: "إزالة شعار Supsis",
            chatBaloonCustomization: "تخصيص بالون الدردشة",
            chatAndNotifications: "الدردشة والإشعارات",
            unlimited: "غير محدود",
            specialCustomerSupport: "دعم العملاء الخاص",
            softwareSupport: "دعم البرمجيات",
            standardSupport: "الدعم القياسي",
            teamChatIntegration: "تكامل دردشة الفريق",
            fileAndVoiceShare: "مشاركة الملفات والصوت",
            instantVisitor: "تتبع الزائر الفوري",
            detailedReporting: "تقارير مفصلة",
            normalreporting: "تقارير عادية",
            noExtraCosts: "لا تكاليف إضافية",
            accessibleToAllAgents: "يمكن الوصول إليها من قبل جميع الوكلاء",
            dataSecurity: "أمان البيانات",
            autoTranslate: "الترجمة التلقائية",
            chatbotVersionHistory: "سجل إصدارات الدردشة الآلية",
            chatbotStory: "قصة الدردشة الآلية",
            freeAgent: "العميل المجاني",
            stableAgentCount: "عدد الوكلاء الثابتة",
            stableChannelCount: "Stable Channel Count",
            chipPlans: "خطط بأسعار معقولة",
            generalPlan: "خطة عامة",
            specialPlan: "خطة خاصة",
            currentPlan: "الخطة الحالية",
            selected: "مختار",
            popular: "شائع",
            trialPkg: "حزمة تجريبية",
            support: "الدعم على مدار الساعة",
            flexiblePricing: "تسعير مرن",
            rightToCancel: "الحق في الإلغاء في أي وقت",
            unlimitedCBScenario: "سيناريوهات الدردشة غير المحدودة",
            freeFirstScenario: "السيناريو الأول مجانًا",
            unlimitedLearn: "تدريب الدردشة غير المحدود",
            allPlatformIntegration: "التكامل مع جميع البنيات التحتية",
            detailedReports: "تقارير مفصلة",
            aiSupport: "دعم الذكاء الصناعي",
            creativeAI: "مساعد دردشة ذكاء اصطناعي سريع وواقعي",
            unlimitedSession: "جلسات غير محدودة في نفس الوقت",
            assistantFromWebsite: "إنشاء مساعد من الموقع الإلكتروني",
            assistantFromDoc: "إنشاء Chatbot من المستند",
            mobileApp: "تطبيق الجوال",
            commentManage: "Manage Comments"
        },
        messenger: {
            channel: "قناة المسنجر",
            manageChannel: "إدارة القناة",
            channelDetail: "تفاصيل القناة",
            integrationTitle: "تكامل Messenger",
            deleteDesc: "هل أنت متأكد أنك تريد حذف قناة Messenger؟",
            channels: "قنوات المراسل",
            connectMessenger: "الاتصال بالمراسل",
            detail: "تفصيل",
            visibility: "رؤية",
            settings_group: "الإعدادات",
            commentsettings: "إدارة التعليقات",
            commentSettingsTitle: "إدارة تعليقات الماسنجر",
            commentSettingsDesc: "إدارة تعليقاتك على Messenger",
            adoptimization: "Ad Optimization"
        },
        instagram: {
            channel: "قناة إنستجرام",
            detail: "تفصيل",
            visibility: "رؤية",
            settings_group: "الإعدادات",
            commentsettings: "إدارة التعليقات",
            commentSettingsTitle: "إدارة التعليقات على إنستغرام",
            commentSettingsDesc: "إدارة تعليقاتك على إنستغرام",
            commentSettingsTicket: "يضمن تسجيل التعليقات الواردة في النظام كتذاكر.",
            commentSettingsChatbot: "حدد سيناريو شات بوت الذي يجب توجيه التعليقات الواردة إليه.",
            leads: "Leads",
            forms: "Forms",
            showAllInstagramChannels: "عرض كل Instagram القنوات",
            brand: "Marka",
            questions: "Sorular",
            showAllLinkedinChannels: "Show All Linkedin Channels",
            showAllTelegramChannels: "Show All Telegram Channels",
            adoptimization: "Ad Optimization"
        },
        calendar: {
            calendarsDesc: "تجنب تعارضات الجداول الزمنية.",
            generalAvailability: "التوفر العام",
            generalAvailabilityDesc: "تحديد الأوقات التي تكون متاحًا فيها بانتظام للمواعيد.",
            appointmentDuration: "مدة الموعد",
            appointDurationDesc: "كم من الوقت يجب أن يستمر كل موعد؟",
            customDuration: "المدة المخصصة",
            descriptionDesc: "إضافة ملاحظة تصف خدمتك. ستظهر الملاحظة التي تضيفها في صفحة الحجز وفي رسائل البريد الإلكتروني للتأكيد.",
            resForm: "نموذج الحجز",
            resFormDesc: "تخصيص النموذج الذي سيستخدمه الأشخاص لحجز موعد.",
            addField: "إضافة حقل",
            addAnItem: "إضافة عنصر",
            saveItem: "حفظ عنصر",
            planningTimeframe: "تخطيط الإطار الزمني",
            planningTimeframeDesc: "تحديد الإطار الزمني الذي يمكن فيه تحديد موعد.",
            availableAtMoment: "متاح الآن",
            startAndEndDate: "تواريخ البدء والانتهاء",
            maxNumberAppoint: "الحد الأقصى لعدد الأيام التي يمكن تحديد موعد بعدها",
            howLongMinAppoint: "المدة التي يمكن حجز الموعد بعدها",
            planningIntervalStartEnd: "تواريخ بدء فترة التخطيط وانتهائها",
            startTime: "وقت البدء",
            done: "تم",
            receivedAppointInterval: "الفاصل الزمني للمواعيد المستلمة",
            receivedAppointIntervalDesc: "إدارة المواعيد المستلمة لتظهر في التقويم الخاص بك",
            interimTime: "الوقت المؤقت",
            interimTimeDesc: "إضافة وقت بين فترات الاجتماعات",
            dayMaxRes: "الحد الأقصى لعدد الحجوزات في اليوم الواحد",
            dayMaxResDesc: "تحديد عدد المواعيد المحجوزة التي يمكن قبولها في يوم واحد",
            customise: "تعيين مخصص",
            noAvatar: "لا توجد صورة رمزية",
            organizationName: "اسم المنظمة",
            enterFullAdress: "أدخل العنوان الكامل",
            noCoverPhoto: "لا توجد صورة غلاف",
            enterAboutInfo: "أدخل معلومات عن",
            service: "الخدمة",
            deleteService: "حذف الخدمة",
            enterGoogleMapsUrl: "أدخل عنوان URL لخرائط Google",
            enterLatitude: "أدخل خط العرض",
            enterLongitude: "أدخل خط الطول",
            enterNumber: "أدخل رقم الهاتف",
            uploadAvatar: "تحميل صورة رمزية",
            teamMemberDeleteError: "خطأ في حذف عضو الفريق:",
            setupBookingWebsite: "إعداد موقع الحجز على الويب",
            bookingLandingPageBuilder: "منشئ صفحة الحجز",
            coverPhoto: "صورة الغلاف",
            enterOrganisationName: "أدخل اسم المؤسسة",
            about: "حول",
            services: "الخدمات",
            deleteServices: "حذف الخدمة",
            selectReservationPlan: "تحديد خطة الحجز",
            addNewService: "إضافة خدمة جديدة",
            addNewMember: "إضافة عضو جديد",
            fullAddress: "العنوان الكامل",
            latitude: "خط العرض",
            longitude: "خط الطول",
            contactDetails: "تفاصيل جهة الاتصال",
            emailAddress: "عنوان البريد الإلكتروني",
            enterEmail: "أدخل عنوان البريد الإلكتروني",
            websiteURL: "عنوان URL للموقع الإلكتروني",
            enterWebsiteURL: "أدخل عنوان URL للموقع الإلكتروني",
            reservationPolicy: "سياسة الحجز",
            enterResPolicy: "أدخل سياسة الحجز",
            workingHours: "ساعات العمل",
            selectEndHour: "تحديد وقت الانتهاء",
            addNewHour: "إضافة ساعة جديدة",
            updateMemberInfo: "تحديث معلومات العضو",
            errorRecevingData: "خطأ في استرداد البيانات:",
            anonymService: "خدمة مجهولة",
            unknownPlan: "خطة غير معروفة",
            errorCreatingMockPage: "خطأ في إنشاء صفحة وهمية:",
            failedToCreateBookingPage: "فشل في إنشاء صفحة الحجز",
            fileSizeToolLarge: "حجم الملف كبير جدًا",
            errorLoadingTheLogo: "خطأ في تحميل الشعار:",
            failedToLoadLogo: "فشل تحميل الشعار",
            errorUpdating: "خطأ في التحديث:",
            failedToUpdate: "فشل في التحديث",
            newMember: "عضو جديد",
            errorLoadingAvatar: "خطأ في تحميل الصورة الرمزية:",
            avatarFailedToLoad: "فشل تحميل الصورة الرمزية",
            teamMemberSuccessfullyDeleted: "تم حذف عضو الفريق بنجاح",
            teamMemberNotDelete: "فشل حذف عضو الفريق",
            yesDelete: "نعم، حذف",
            sureResDelete: "هل أنت متأكد من رغبتك في حذف هذا الحجز؟",
            resDetails: "تفاصيل الحجز",
            infoPersonMakingRes: "معلومات الشخص الذي قام بالحجز",
            appointmentProgram: "جدول المواعيد",
            goToAppointSettings: "الانتقال إلى إعدادات برنامج الموعد",
            resPlanCreateSuccess: "تم إنشاء خطة الحجز بنجاح",
            pleaseEnterTitle: "الرجاء إدخال العنوان",
            sureContinueSaving: "هل أنت متأكد من رغبتك في المتابعة بدون حفظ؟",
            appointProgram: "برنامج الحجز",
            everyMonth: "كل شهر",
            firstEveryMonth: "أول كل شهر",
            dayOf: "اليوم",
            notRepeat: "عدم التكرار",
            daily: "يومياً",
            weekly: "مرة في الأسبوع",
            monthly: "شهرياً",
            annually: "سنوي",
            custom: "مخصص",
            eventSaved: "حدث محفوظ",
            createAppoint: "إنشاء موعد",
            calendarSetting: "إعدادات التقويم",
            notAuthezord: "غير مصرح لك بإجراء هذه العملية",
            notAuthorizedToPerformOperation: "غير مصرح لك بتنفيذ هذه العملية.",
            reservationWebPage: "صفحة الحجز على الويب",
            reservationBuilder: "موقع الحجز",
            reservationPrograms: "برامج الحجز",
            automations: "الأتمتة",
            addReservationProgram: "إضافة برنامج حجز",
            resPlanError: "خطأ في استلام خطط الحجز:",
            resDeleteSure: "هل أنت متأكد من أنك تريد حذف برنامج الحجز هذا؟",
            resDeleteSuccess: "تم حذف برنامج الحجز بنجاح.",
            resDeleteError: "خطأ في حذف برنامج الحجز:",
            unkownUser: "مستخدم غير معروف",
            eventNotFound: "لم يتم العثور على الحدث",
            reservations: "الحجوزات",
            events: "الفعاليات",
            upcoming: "القادم",
            past: "الماضي",
            setting: "الإعدادات",
            delete: "حذف",
            cancel: "إلغاء",
            save: "حفظ",
            close: "إغلاق",
            deleteRepeatEvent: "حذف الحدث المتكرر",
            thisEvent: "هذا الحدث",
            thisAndOtherEvent: "هذا الحدث والأحداث التالية",
            allEvent: "جميع الأحداث",
            ok: "موافق",
            googleCalendarLink: "إضافة إلى تقويم Google",
            yahooCalendarLink: "إضافة إلى تقويم Yahoo",
            subject: "الموضوع",
            visitor: "الزائر",
            allDay: "طوال اليوم",
            title: "العنوان",
            deleteEvent: "حذف الحدث",
            deleteEvents: "حذف الأحداث",
            deleteEventsSure: "هل أنت متأكد من أنك تريد حذف الأحداث من هذا التقويم؟",
            deleteEventConfirm: "هل أنت متأكد من أنك تريد حذف هذا الحدث؟",
            notEmptyTitle: "لا يمكن ترك العنوان فارغًا!",
            tasks: "المهام",
            googleConnect: "دمج Google",
            googleDisconnect: "إلغاء دمج Google",
            sure: "هل أنت متأكد؟",
            disconnectGoogleSure: "هل أنت متأكد من أنك تريد إلغاء دمج Google؟",
            yes: "نعم",
            no: "لا",
            customRepeat: "تكرار مخصص",
            recurrenceFrequency: "تكرار الحدوث",
            repeatDays: "تكرار في الأيام:",
            never: "أبدًا",
            thisDate: "في هذا التاريخ:",
            recurrenceCount: "عدد مرات التكرار:",
            end: "النهاية",
            event: "الحدث",
            calendars: "التقاويم",
            newCalendar: "إنشاء تقويم جديد",
            changeColor: "تغيير اللون",
            addCalendar: "إضافة تقويم",
            nameCalendar: "اسم التقويم",
            description: "الوصف",
            change: "تغيير",
            deleteCalendar: "حذف التقويم",
            deleteCalendarSure: "هل أنت متأكد من أنك تريد حذف هذا التقويم؟",
            notEmptyCalendarName: "لا يمكن أن يكون اسم التقويم فارغًا",
            myEvents: "أحداثي",
            everyoneEvents: "جميع الأحداث",
            haveEvent: "أحداث الوكيل",
            goCalendar: "اذهب إلى التقويم",
            goReservation: "إنشاء حجز",
            agents: "الوكلاء",
            today: "اليوم",
            month: "شهر",
            week: "أسبوع",
            day: "يوم",
            list: "قائمة",
            appointDuration: "مدة الموعد",
            planingIntervalStartEnd: "تاريخ بدء وانتهاء فترة التخطيط",
            customize: "تخصيص",
            enterOrganizationName: "أدخل اسم المنظمة",
            weely: "أسبوعياً",
            annualy: "سنوياً",
            appointmentSchedule: "جدول المواعيد",
            calendari: "التقاويم",
            goToAppointmentSettings: "الانتقال إلى إعدادات جدول المواعيد",
            infoPersonMakingReservation: "معلومات الشخص الذي يقوم بالحجز",
            reservationDetails: "تفاصيل الحجز",
            sureReservationDelete: "هل أنت متأكد من أنك تريد حذف هذا الحجز؟",
            teamMemberNotDeleted: "لم يتم حذف عضو الفريق"
        },
        ticimax: {
            segment: "قطاع",
            settings_group: "مجموعة الإعدادات",
            waitDayFromLastSend: "يوم الانتظار منذ آخر رسالة تم إرسالها",
            automationRuleName: "اسم قاعدة الأتمتة",
            time: "زمن",
            year: "سنة",
            month: "شهر",
            dayOfMonth: "يوم الشهر",
            day: "يوم",
            bySecond: "لكل ثانية",
            byMinute: "لكل دقيقة",
            byHour: "لكل ساعة",
            byWeekNo: "لكل رقم أسبوع",
            byYearDay: "لكل يوم في السنة",
            byMonthDay: "لكل يوم في الشهر",
            byMonth: "لكل شهر",
            december: "ديسمبر",
            november: "نوفمبر",
            october: "أكتوبر",
            september: "سبتمبر",
            august: "أغسطس",
            july: "يوليو",
            june: "يونيو",
            may: "مايو",
            april: "أبريل",
            march: "مارس",
            february: "فبراير",
            january: "يناير",
            byWeekDay: "لكل يوم في الأسبوع",
            interval: "فاصل زمني",
            seconds: "ثواني",
            minutes: "دقائق",
            hourly: "كل ساعة",
            daily: "يوميًا",
            weekly: "أسبوعيًا",
            monthly: "شهريًا",
            yearly: "سنويًا",
            frequency: "تكرار",
            attributes: {
                vip: "VIP",
                segment: "قطاع",
                province: "مقاطعة",
                country: "بلد",
                phone: "هاتف",
                email: "البريد الإلكتروني",
                fullname: "الاسم الكامل",
                couponPercent: "% من القسيمة",
                lastOrderDate: "آخر طلب",
                firstOrderDate: "أول طلب",
                county: "مقاطعة",
                lastSource: "آخر مصدر",
                firstSource: "أول مصدر",
                lastPaymentType: "آخر طريقة دفع",
                firstPaymentType: "أول طريقة دفع",
                maxOrderAmount: "الحد الأقصى لمبلغ الطلب",
                minOrderAmount: "الحد الأدنى لمبلغ الطلب",
                totalOrderAmount: "إجمالي مبلغ الطلب",
                totalOrderCount: "إجمالي عدد الطلبات",
                usedCouponAmount: "مبلغ القسيمة المستخدمة",
                usedCouponCount: "عدد القسائم المستخدمة",
                tookDayFromLastOrder: "أيام منذ آخر طلب",
                isCouponUser: "هل هو مستخدم قسيمة؟"
            },
            createAutomation: "إنشاء التلقائي",
            previous: "سابق",
            createAutomationDesc: "إنشاء وإدارة الأتمتة الرسائل",
            newTicimaxChannel: "قناة Ticimax الجديدة",
            connextToTicimaxXml: "الاتصال بخدمة XML Ticimax",
            connectTicimax: "الاتصال بـ Ticimax",
            examplePreview: "معاينة المثال",
            completeAutomationRule: "قاعدة الأتمتة الكاملة",
            configureMessage: "تكوين الرسالة",
            automationTimer: "المؤقت الآلي",
            findTargetMembers: "العثور على الأعضاء المستهدفين",
            createAutomationRule: "إنشاء قاعدة الأتمتة",
            action: "عمل",
            status: "الحالة",
            triggeredUserCount: "عدد المستخدمين المفعلين",
            nextScheduled: "المقررة التالية",
            timerRule: "قاعدة المؤقت",
            automationRules: "قواعد الأتمتة",
            apply: "تطبيق",
            searchAMember: "البحث عن عضو",
            segmentedMembersDesc: "قائمة وأتمتة الأعضاء المجزأين",
            manageVisibilityDesc: "إدارة رؤية القناة",
            xmlOrderListURL: "عنوان URL لقائمة الطلبات XML",
            manageIntegrationDesc: "إدارة تكامل Ticimax الخاص بك",
            detail: "التفاصيل",
            ticimaxChannelsTitle: "قنوات Ticimax",
            ticimaxDetail: "تفاصيل Ticimax",
            settingsGroup: "الإعدادات",
            visibility: "الرؤية",
            members: "الأعضاء",
            automation: "الأتمتة",
            integrationChannel: "قناة التكامل",
            channelUpdated: "تم تحديث القناة بنجاح",
            channelUpdateFailed: "فشل تحديث القناة"
        },
        notification: {
            taskArchive: "تم إنشاء إشعار عندما يتم أرشفة المهمة.",
            taskComplet: "تم إنشاء إشعار عندما يتم إغلاق المهمة المكتملة.",
            adjustNow: "تعديل الآن",
            chatAssignedMe: "عندما يتم تعيين دردشة لي.",
            ticketAssignedMe: "عندما يتم تعيين تذكرة لي.",
            myChatClosed: "عندما يتم إغلاق دردشة أملكها.",
            contactOwner: "عندما يتغير مالك الدردشة، عندما يتم تعيين الملكية أو إزالتها.",
            tagActionsToVisitor: "عندما تتم إضافة أو إزالة علامة من زائر.",
            ticketCreated: "عندما يقوم زائر أو روبوت دردشة بإنشاء تذكرة.",
            notesActions: "عندما تتم إضافة أو إزالة ملاحظة من عميل.",
            visitorProfileUpdated: "عندما يتم تحديث ملف زائر.",
            chatStartedByAnyPlatform: "عندما يتم بدء دردشة من أي قناة.",
            userActions: "عندما يتم إنشاء مستخدم أو تحديثه أو حذفه.",
            departmentActions: "عندما يتم إنشاء قسم أو تحديثه أو حذفه.",
            settingsActions: "عندما يتم إنشاء إعدادات أو تحديثها أو حذفها.",
            integrationsActions: "عندما يتم إنشاء قناة تكامل أو تحديثها أو حذفها.",
            loginFormActions: "عندما يتم تحديث أو تفعيل نموذج تسجيل الدخول.",
            bannedWordActions: "عندما يتم إنشاء أو تحديث أو حذف كلمة محظورة.",
            emailActions: "عندما يتم إنشاء أو تحديث أو حذف حساب بريد إلكتروني.",
            preparedContentActions: "عندما يتم إنشاء أو تحديث أو حذف محتوى جاهز.",
            roleActions: "عندما يتم إنشاء أو تحديث أو حذف دور.",
            tagActions: "عندما يتم إنشاء أو تحديث أو حذف علامة.",
            welcomeMessageActions: "عندما يتم إنشاء أو تحديث أو حذف رسالة ترحيب.",
            webhookActions: "عندما يتم إنشاء أو تحديث أو حذف ويب هوك.",
            billingEvents: "عندما يتم إنشاء فاتورة أو تحديث حالتها.",
            systemStatus: "عندما يتم تحديث حالة نظام الدعم المباشر.",
            reservationMessageCrud: "عندما يتم إنشاء أو تحديث أو حذف حجز.",
            ipAddressWhiteListEvents: "عندما تتم إضافة أو تحديث أو حذف عنوان IP مسموح به.",
            taskAssignedMe: "عندما يتم تعيين مهمة لي.",
            workflowCreated: "عندما يتم إنشاء سير عمل.",
            workflowDeleted: "عندما يتم حذف سير عمل.",
            createdTask: "عندما يتم إنشاء مهمة.",
            deletedTask: "عندما يتم حذف مهمة.",
            chatbotStoryCrud: "عندما يتم إنشاء أو تحديث أو حذف قصة روبوت دردشة.",
            chatbotForwardAgent: "روبوت الدردشة يحول دردشة إلى وكيل.",
            userSegmentCrud: "عندما يتم إنشاء أو تحديث أو حذف شريحة مستخدم.",
            chatbotCreditLow: "عندما يكون رصيد روبوت الدردشة منخفضًا.",
            wpCreditLow: "عندما ينخفض رصيد WhatsApp إلى أقل من 100 ليرة تركية.",
            wpCustomerGroupCrud: "عندما يتم إنشاء أو تحديث أو حذف مجموعة عملاء WhatsApp.",
            wpBroadcastMessageStatus: "عندما يبدأ أو يكتمل أو يتم إلغاء إرسال رسالة جماعية عبر WhatsApp.",
            wpTemplateMesssageCrud: "عندما يتم إنشاء أو تحديث أو حذف رسالة نموذج WhatsApp.",
            whatsappQrChannelStatusUpdated: "عندما يتم تحديث حالة اتصال قناة WhatsApp QR.",
            activityTypeLabels: {
                "chat-assign": "عندما يتم تعيين محادثة لي",
                "ticket-assign": "عندما يتم تعيين تذكرة لي",
                "task-assign": "عندما يتم تعيين مهمة لي",
                "task-complet": "عندما يتم إكمال مهمة",
                "chat-close-own": "عندما يتم إغلاق محادثة أملكها",
                "tag-actions-to-visitor": "تمت إضافة أو إزالة العلامات من جهة اتصال",
                "create-ticket": "تم إنشاء تذكرة بواسطة زائر أو روبوت محادثة. أيضًا، عند إرسال رسالة غير متصلة من نافذة الدردشة",
                "note-actions-to-visitor": "تمت إضافة أو إزالة الملاحظات من جهة اتصال",
                "visitor-profile-updates": "تحديثات ملف الزائر",
                "chat-start": "تم بدء الدردشة على أي منصة بواسطة جهة اتصال أو وكيل",
                "user-crud": "تم إنشاء أو تحديث أو حذف مستخدم",
                "department-crud": "تم إنشاء أو تحديث أو حذف قسم",
                "settings-crud": "تم إنشاء أو تحديث أو حذف الإعدادات",
                "integration-channel-crud": "تم إنشاء أو تحديث أو حذف قناة التكامل",
                "login-form-crud": "تم تحديث أو تفعيل أو إلغاء تفعيل نموذج تسجيل الدخول",
                "banned-word-crud": "تم إنشاء أو تحديث أو حذف كلمة محظورة",
                "email-account-crud": "تم إنشاء أو حذف حساب بريد إلكتروني",
                "prepared-content-crud": "تم إنشاء أو حذف محتوى جاهز",
                "role-crud": "تم إنشاء أو تحديث أو حذف دور",
                "tag-crud": "تم إنشاء أو تحديث أو حذف علامة",
                "welcome-message-crud": "تم إنشاء أو تحديث أو حذف رسالة ترحيب",
                "webhook-crud": "تم إنشاء أو تحديث أو حذف webhook",
                "automation-created": "تم إنشاء الأتمتة",
                "automation-deleted": "تم حذف الأتمتة",
                "automation-published": "تم نشر الأتمتة",
                "automation-unpublished": "تم إلغاء نشر الأتمتة",
                "automation-updated": "تم تحديث الأتمتة",
                "billing-events": "أحداث الفوترة",
                "task-workflow-crud": "تم إنشاء أو تحديث أو حذف سير عمل المهمة",
                "task-crud": "تم إنشاء أو تحديث أو حذف مهمة",
                "system-status": "تغييرات حالة النظام عبر الإنترنت أو غير متصل",
                "chatbot-story-crud": "تم إنشاء أو تحديث أو حذف قصة روبوت المحادثة",
                "chatbot-forward-chat": "يقوم روبوت المحادثة بإعادة توجيه محادثة إلى وكيل",
                "chatbot-user-segment-crud": "تم إنشاء أو تحديث أو حذف جزء المستخدم",
                "chatbot-credit-low": "عندما يكون رصيد روبوت المحادثة منخفضًا",
                "whatsapp-credit-low": "عندما يكون رصيد WhatsApp منخفضًا",
                "whatsapp-customer-group-crud": "عندما يتم إنشاء أو تحديث أو حذف مجموعة عملاء WhatsApp",
                "whatsapp-broadcast-message-crud": "عندما يتم إرسال أو إكمال أو إلغاء رسالة بث WhatsApp",
                "whatsapp-template-message-crud": "عندما يتم إنشاء أو تحديث أو حذف رسالة قالب WhatsApp",
                "form-created": "تم إنشاء النموذج",
                "form-updated": "تم تحديث النموذج",
                "form-deleted": "تم حذف النموذج",
                "form-restored": "تم استعادة النموذج",
                "form-downloaded": "تم تنزيل النموذج",
                "user-role-changed": "تم تغيير دور المستخدم",
                "user-password-changed": "تم تغيير كلمة مرور المستخدم",
                "user-email-changed": "تم تغيير عنوان بريد المستخدم الإلكتروني",
                "user-name-changed": "تم تغيير اسم المستخدم",
                "user-phone-changed": "تم تغيير هاتف المستخدم",
                "user-disabled": "تم تعطيل/تفعيل المستخدم",
                "role-updated": "تم تحديث الدور",
                "task-workflow-updated": "تم تحديث سير عمل المهمة",
                "task-workflow-pipeline-stage-added": "تمت إضافة مرحلة خط أنابيب سير عمل المهمة",
                "task-workflow-pipeline-stage-updated": "تم تحديث مرحلة خط أنابيب سير عمل المهمة",
                "task-workflow-pipeline-stage-deleted": "تم حذف مرحلة خط أنابيب سير عمل المهمة",
                "drive-folder-created": "تم إنشاء مجلد Drive",
                "drive-folder-deleted": "تم حذف مجلد Drive",
                "drive-folder-renamed": "تمت إعادة تسمية مجلد Drive",
                "drive-file-added": "تمت إضافة ملف إلى Drive",
                "drive-file-deleted": "تم حذف ملف من Drive",
                "task-module-rules-enabled": "تم تفعيل قواعد وحدة المهمة",
                "task-module-rules-disabled": "تم تعطيل قواعد وحدة المهمة",
                "task-module-rules-rule-added": "تمت إضافة قاعدة إلى سير عمل المهمة",
                "task-module-rules-rule-deleted": "تم حذف قاعدة من سير عمل المهمة",
                "task-module-rules-rule-updated": "تم تحديث قاعدة في سير عمل المهمة",
                "task-module-rules-rule-enabled": "تم تفعيل قاعدة في سير عمل المهمة",
                "task-module-rules-rule-disabled": "تم تعطيل قاعدة في سير عمل المهمة",
                "contact-module-rules-enabled": "تم تفعيل قواعد وحدة جهة الاتصال",
                "contact-module-rules-disabled": "تم تعطيل قواعد وحدة جهة الاتصال",
                "contact-module-rules-rule-added": "تمت إضافة قاعدة إلى وحدة جهة الاتصال",
                "contact-module-rules-rule-updated": "تم تحديث قاعدة في وحدة جهة الاتصال",
                "contact-module-rules-rule-deleted": "تم حذف قاعدة من وحدة جهة الاتصال",
                "contact-module-rules-rule-enabled": "تم تفعيل قاعدة في وحدة جهة الاتصال",
                "contact-module-rules-rule-disabled": "تم تعطيل قاعدة في وحدة جهة الاتصال",
                "developer-token-changed": "تم تحديث رمز المطور",
                "table-created": "تم إنشاء الجدول",
                "table-field-added": "تمت إضافة حقل إلى الجدول",
                "table-field-updated": "تم تحديث حقل في الجدول",
                "table-field-deleted": "تم حذف حقل من الجدول",
                "table-view-added": "تمت إضافة عرض إلى الجدول",
                "table-view-updated": "تم تحديث عرض في الجدول",
                "table-view-deleted": "تم حذف عرض من الجدول",
                "table-page-added": "تمت إضافة صفحة إلى الجدول",
                "table-page-updated": "تم تحديث صفحة في الجدول",
                "table-page-deleted": "تم حذف صفحة من الجدول",
                "table-widget-added": "تمت إضافة عنصر واجهة إلى صفحة الجدول",
                "table-widget-updated": "تم تحديث عنصر واجهة في صفحة الجدول",
                "table-widget-deleted": "تم حذف عنصر واجهة من صفحة الجدول",
                "table-privacy-changed": "تم تحديث إعدادات خصوصية الجدول",
                "web-app-created": "تم إنشاء تطبيق ويب",
                "web-app-updated": "تم تحديث تطبيق ويب",
                "web-app-deleted": "تم حذف تطبيق ويب",
                "web-tab-created": "تم إنشاء علامة تبويب ويب",
                "web-tab-updated": "تم تحديث علامة تبويب ويب",
                "web-tab-deleted": "تم حذف علامة تبويب ويب",
                "module-created": "تم إنشاء الوحدة",
                "module-updated": "تم تحديث الوحدة",
                "module-deleted": "تم حذف الوحدة",
                "relation-created": "تم إنشاء العلاقة",
                "relation-updated": "تم تحديث العلاقة",
                "voice-agent-created": "تم إنشاء وكيل الصوت",
                "voice-agent-updated": "تم تحديث وكيل الصوت",
                "voice-agent-deleted": "تم حذف وكيل الصوت",
                "voice-agent-phone-number-inbound-agent-changed": "تم تغيير وكيل المكالمة الواردة لرقم الهاتف",
                "voice-agent-phone-number-outbound-agent-changed": "تم تغيير وكيل المكالمة الصادرة لرقم الهاتف",
                "voice-agent-batch-call-created": "تم إنشاء مكالمة مجمعة",
                "voice-agent-knowledge-base-created": "تم إنشاء قاعدة المعرفة",
                "voice-agent-knowledge-base-deleted": "تم حذف قاعدة المعرفة",
                "table-data-downloaded": "تم تنزيل بيانات الجدول",
                "table-data-imported": "تم استيراد بيانات مجمعة إلى الجدول",
                "table-data-batch-updated": "تم تحديث بيانات الجدول بشكل مجمع",
                "table-data-batch-deleted": "تم حذف بيانات الجدول بشكل مجمع",
                "contact-batch-updated": "تم تحديث جهات الاتصال بشكل مجمع",
                "chat-data-downloaded": "تم تنزيل سجل الدردشة",
                "automation-restored": "عند استعادة الأتمتة من سلة المحذوفات",
                "waba-supsis-partner-remove": "عند إزالة شريك واتساب للأعمال API V2",
                "waba-supsis-account-deleted": "عند حذف حساب واتساب للأعمال API V2",
                "waba-supsis-account-violation": "عند اكتشاف مخالفة لحساب واتساب للأعمال API V2",
                "waba-supsis-ad-account-linked": "عند ربط حساب إعلانات واتساب للأعمال API V2",
                "waba-supsis-auth-intl-price-eligibility-update": "عند تحديث أهلية الأسعار الدولية لواتساب للأعمال API V2",
                "waba-supsis-disabled-update": "عند تحديث تعطيل واتساب للأعمال API V2",
                "waba-supsis-mm-lite-terms-signed": "عند توقيع شروط MM Lite لواتساب للأعمال API V2",
                "waba-supsis-partner-app-installed": "عند تثبيت تطبيق شريك واتساب للأعمال API V2",
                "waba-supsis-partner-app-uninstalled": "عند إلغاء تثبيت تطبيق شريك واتساب للأعمال API V2",
                "waba-supsis-partner-client-certification-status-update": "عند تحديث حالة شهادة عميل شريك واتساب للأعمال API V2",
                "waba-supsis-business-primary-location-country-update": "عند تحديث دولة الموقع الأساسي لواتساب للأعمال API V2",
                "waba-supsis-volume-based-pricing-tier-update": "عند تحديث مستوى التسعير الحجمي لواتساب للأعمال API V2",
                "waba-supsis-message-template-components-update": "عند تحديث مكونات قالب الرسالة لواتساب للأعمال API V2",
                "waba-supsis-message-template-status-update": "عند تحديث حالة قالب الرسالة لواتساب للأعمال API V2",
                waba_supsis_partner_remove: "تم إزالة شريك واتساب للأعمال API V2",
                waba_supsis_account_deleted: "تم حذف حساب واتساب للأعمال API V2",
                waba_supsis_account_violation: "تم اكتشاف مخالفة لحساب واتساب للأعمال API V2",
                waba_supsis_ad_account_linked: "تم ربط حساب إعلانات واتساب للأعمال API V2",
                waba_supsis_auth_intl_price_eligibility_update: "تم تحديث أهلية الأسعار الدولية لواتساب للأعمال API V2",
                waba_supsis_disabled_update: "تم تحديث تعطيل واتساب للأعمال API V2",
                waba_supsis_mm_lite_terms_signed: "تم توقيع شروط MM Lite لواتساب للأعمال API V2",
                waba_supsis_partner_added: "تمت إضافة شريك واتساب للأعمال API V2",
                waba_supsis_partner_app_installed: "تم تثبيت تطبيق شريك واتساب للأعمال API V2",
                waba_supsis_partner_app_uninstalled: "تم إلغاء تثبيت تطبيق شريك واتساب للأعمال API V2",
                waba_supsis_partner_client_certification_status_update: "تم تحديث حالة شهادة عميل شريك واتساب للأعمال API V2",
                waba_supsis_business_primary_location_country_update: "تم تحديث دولة الموقع الأساسي لواتساب للأعمال API V2",
                waba_supsis_volume_based_pricing_tier_update: "تم تحديث مستوى التسعير الحجمي لواتساب للأعمال API V2",
                waba_supsis_message_template_components_update: "تم تحديث مكونات قالب الرسالة لواتساب للأعمال API V2",
                waba_supsis_message_template_status_update: "تم تحديث حالة قالب الرسالة لواتساب للأعمال API V2",
                waba_supsis_template_category_update: "تم تحديث فئة القالب لواتساب للأعمال API V2",
                waba_supsis_PARTNER_REMOVE: "تم إزالة شريك واتساب للأعمال API V2",
                waba_supsis_ACCOUNT_DELETED: "تم حذف حساب واتساب للأعمال API V2",
                "task-workflow-restored": "عند استعادة سير العمل من سلة المحذوفات",
                "task-workflow-permanently-deleted": "عند حذف سير العمل نهائياً من سلة المحذوفات",
                "table-deleted": "عند حذف الجدول",
                "table-restored": "عند استعادة الجدول من سلة المحذوفات",
                "table-permanently-deleted": "عند حذف الجدول نهائياً من سلة المحذوفات"
            },
            crmActions: "إجراءات إدارة علاقات العملاء",
            mobileApp: "التطبيق المحمول",
            webPanel: "لوحة الويب",
            notifications: "الإشعارات",
            whatsappActions: "إجراءات الواتساب",
            chatbotActions: "إجراءات الدردشة الآلية",
            companyActions: "إجراءات الشركة",
            basicActions: "الإجراءات الأساسية",
            notificationSettingsDesc: "اختر الإشعارات التي تريد تلقيها وأين تريد تلقيها.",
            noNotificationDesc2: "هنا سترى جميع الإشعارات المتعلقة بالوظائف والمرشحين وحمامات المواهب التي تتابعها. يمكنك تخصيص الإشعارات عن طريق ضبط الإعدادات.",
            noNotificationTitle2: "لا يوجد إشعارات بعد.",
            noNotificationTitle1: "لا توجد إشعارات. استمتع بالسكون.",
            adjustSettings: "ضبط الإعدادات",
            showAll: "إظهار الكل",
            showOnlyUnread: "عرض فقط غير المقروءة",
            mailWasSent: "تم إرسال البريد الإلكتروني.",
            mailAdressRemoved: "تمت إزالة عنوان البريد الإلكتروني.",
            chatbotPublished: "تم نشر الإصدار <b>{version}</b> من الدردشة الآلية بواسطة <b>{user}</b>.",
            chatbotDeleted: "تم حذف الدردشة الآلية <b>{chatbot}</b> بواسطة <b>{user}</b>.",
            settingsUpdatedWoDetail: "تم تحديث الإعدادات بواسطة <b>{user}</b>.",
            noActivityDesc: "لا توجد حاليًا أي أنشطة في النظام. يجب أن تحدث بعض الأحداث",
            noActivityTitle: "لا يوجد نشاط بعد",
            actionType: "نوع الحركة",
            dateBetween: "تاريخ بين",
            selectActor: "اختر المستخدم",
            activities: "أنشطة",
            chatbotCreated: "تم إنشاء الدردشة الآلية ذات الاسم <b>{chatbot}</b> بواسطة <b>{user}</b>.",
            taskAddedTags: "<b>{user}</b> أضاف هذه العلامات إلى المهمة (<b>{taskTitle}</b>): <b>{tags}</b>",
            taskStageChanged: "تم تغيير مرحلة المهمة <b>{task}</b> من <b>{oldStage}</b> إلى <b>{newStage}</b> بواسطة <b>{user}</b>.",
            taskCreated: "تم إنشاء المهمة <b>{task}</b> بواسطة <b>{user}</b>.",
            contactPropRemoved: "تمت إزالة خاصية الزائر <b>{prop}</b> بواسطة <b>{user}</b>.",
            contactPropAdded: "تمت إضافة خاصية الزائر <b>{prop}</b> بواسطة <b>{user}</b>.",
            userRemoved: "تمت إزالة المستخدم <b>{oldUser}</b> بواسطة <b>{user}</b>.",
            loginFormUpdated: "تم تحديث نموذج تسجيل الدخول للزائر بواسطة <b>{user}</b>.",
            loginFormDeactivated: "تم تعطيل نموذج تسجيل الدخول بواسطة <b>{user}</b>.",
            loginFormActivated: "تم تنشيط نموذج تسجيل الدخول بواسطة <b>{user}</b>.",
            invoiceRefunded: "تمت عملية الاسترداد بواسطة <b>{user}</b>.",
            paymentMethodAdded: "تمت إضافة طريقة دفع جديدة بواسطة <b>{user}</b>.",
            invoicePaymentFailed: "لم يتم قبول دفع الفاتورة من قبل <b>{user}</b>.",
            invoicePaymentReceived: "تم قبول دفع الفاتورة بواسطة <b>{user}</b>.",
            planStarted: "<b>{user}</b> بدأ المستخدم الاشتراك في <b>{title}</b> (<b>{altTitle}</b>).",
            planStartedAgent: "<b>{user}</b> بدأ المستخدم الاشتراك في <b>{title}</b> <b>{altTitle}</b> (<b>{details} مندوب</b>).",
            planStartedChatbot: "<b>{user}</b> بدأ المستخدم الاشتراك في <b>{title}</b> <b>{altTitle}</b> (<b>{chatbot} جلسة</b>).",
            planStartedWhatsapp: "<b>{user}</b> بدأ المستخدم الاشتراك في <b>{title}</b> <b>{altTitle}</b> (<b>{whatsapp} قنوات واتساب</b>).",
            planStartedWhatsappApi: "<b>{user}</b> بدأ المستخدم الاشتراك في <b>{title}</b> <b>{altTitle}</b> (<b>{whatsappApi} قنوات واتساب للأعمال</b>).",
            PlanCanceled: "<b>{user}</b> ألغى المستخدم الاشتراك في <b>{title}</b> (<b>{altTitle}</b>).",
            planCanceledAgent: "<b>{user}</b> ألغى المستخدم الاشتراك في <b>{title}</b> <b>{altTitle}</b> (<b>{details} مندوب</b>).",
            planCanceledChatbot: "<b>{user}</b> ألغى المستخدم الاشتراك في <b>{title}</b> <b>{altTitle}</b> (<b>{chatbot} جلسة</b>).",
            planCanceledWhatsapp: "<b>{user}</b> ألغى المستخدم الاشتراك في <b>{title}</b> <b>{altTitle}</b> (<b>{whatsapp} قنوات واتساب</b>).",
            planCanceledWhatsappApi: "<b>{user}</b> ألغى المستخدم الاشتراك في <b>{title}</b> <b>{altTitle}</b> (<b>{whatsappApi} قنوات واتساب للأعمال</b>).",
            invoiceCreated: "تم إنشاء الفاتورة بواسطة <b>{user}</b>.",
            billingAddressUpdated: "تم تحديث معلومات العنوان بواسطة <b>{user}</b>.",
            taskWorkflowDeleted: "تم حذف سير العمل <b>{workflow}</b> بواسطة <b>{user}</b>.",
            whatsappBroadcastFailed: "فشل إرسال رسالة البث ذات العنوان <b>{title}</b>.",
            whatsappBroadcastCancelled: "تم إلغاء إرسال رسالة البث ذات العنوان <b>{title}</b>.",
            whatsappBroadcastCompleted: "تم إرسال رسالة بث بعنوان <b>{title}</b> بنجاح إلى <b>{numbers}</b> مستلمين.",
            whatsappBroadcastCreated: "تم إرسال رسالة بث بعنوان <b>{title}</b> إلى <b>{numbers}</b> مستلمين بواسطة <b>{user}</b>.",
            ticketAssigned: "تم تعيين تذكرة لـ <b>{user2}</b> بواسطة <b>{user1}</b>.",
            userLoggedIn: "قام <b>{user}</b> بتسجيل الدخول إلى SUPSIS.",
            chatJoined: "انضم <b>{agent}</b> إلى المحادثة مع <b>{visitor}</b>.",
            chatForwarded: "تم تحويل المحادثة مع <b>{visitor}</b> إلى <b>{agent}</b> بواسطة <b>{user}</b>.",
            chatAssigned: "تم تعيين الدردشة مع <b>{visitor}</b> إلى <b>{agent}</b> من قبل النظام.",
            customerGroupUpdated: "تم تحديث المجموعة <b>{group}</b> بواسطة <b>{user}</b>.",
            customerGroupRemoved: "تمت إزالة المجموعة <b>{group}</b> بواسطة <b>{user}</b>.",
            customerGroupAdded: "تم إنشاء المجموعة <b>{group}</b> بواسطة <b>{user}</b>.",
            contentRemoved: "تمت إزالة المحتوى الجاهز <b>{content}</b> بواسطة <b>{user}</b>.",
            contentAdded: "تمت إضافة المحتوى الجاهز <b>{content}</b> بواسطة <b>{user}</b>.",
            channelVisibilityChanged: "تم تغيير رؤية قناة التكامل <b>{channel}</b> بواسطة <b>{user}</b>.",
            taskDeleted: "تم حذف المهمة <b>{task}</b> بواسطة <b>{user}</b>.",
            taskCompleted: "<b>{task}</b> المهمة اكتملت بواسطة <b>{user}</b>.",
            taskArchived: "<b>{user}</b> بواسطة، <b>{task}</b> تم أرشفة المهمة.",
            userRemovedToDepartment: "تمت إزالة المستخدم <b>{user2}</b> من قسم <b>{department}</b> بواسطة <b>{user1}</b>.",
            userAddedToDepartment: "تمت إضافة المستخدم <b>{user2}</b> إلى قسم <b>{department}</b> بواسطة <b>{user1}</b>.",
            mailAddressAdded: "تمت إضافة عنوان البريد الإلكتروني <b>{email}</b> بواسطة <b>{user}</b>",
            settingUpdate: "تم التحديث بواسطة <b>{user}</b>:",
            taskWFlowCreated: "تم إنشاء تدفق العمل للمهام <b>{Wflow}</b> بواسطة <b>{user}</b>.",
            bannedWordRemoved: "تمت إزالة الكلمة المحظورة <b>{bWord}</b> بواسطة <b>{user}</b>.",
            bannedWordCreated: "تم إنشاء الكلمة المحظورة <b>{bWord}</b> بواسطة <b>{user}</b>.",
            taskPriorityUpdated: "<b>{user}</b> قام بتغيير أولوية المهمة <b>{taskTitle}</b> من <b>{oldPriority}</b> إلى <b>{newPriority}</b>",
            welcomeMessageRemoved: "تمت إزالة رسالة الترحيب <b>{welcome}</b> بواسطة <b>{user}</b>.",
            welcomeMessageAdded: "تم إنشاء رسالة ترحيب <b>{welcome}</b> بواسطة <b>{user}</b>.",
            tagRemoved: "تمت إزالة العلامة <b>{tag}</b> بواسطة <b>{user}</b>.",
            tagAdded: "تمت إضافة العلامة <b>{tag}</b> بواسطة <b>{user}</b>.",
            roleRemoved: "تمت إزالة الدور <b>{role}</b> بواسطة <b>{user}</b>.",
            roleAdded: "تمت إضافة الدور <b>{role}</b> بواسطة <b>{user}</b>.",
            departmentRemoved: "تمت إزالة القسم <b>{department}</b> بواسطة <b>{user}</b>.",
            departmentAdded: "تمت إضافة القسم <b>{department}</b> بواسطة <b>{user}</b>.",
            triggerUpdated: "تم تحديث المشغل بواسطة <b>{user}</b>.",
            triggerRemoved: "تمت إزالة المشغل بواسطة <b>{user}</b>.",
            triggerAdded: "تم إنشاء مشغل جديد بواسطة <b>{user}</b>.",
            webhookRemoved: "تمت إزالة webhook <b>{user1}</b> بواسطة <b>{user2}</b>",
            webhookAdded: "تمت إضافة Webhook بواسطة <b>{user1}</b>, تمت إضافتها بواسطة <b>{user2}</b>.",
            chatClosed: "تم إنهاء المحادثة مع <b>{visitor}</b> بواسطة <b>{agent}</b>.",
            chatOpenedByAgent: "<b>{agent}</b> بدأ دردشة <b>{platform}</b> مع <b>{visitor}</b>.",
            chatOpenedByVisitor: "دردشة <b>{platform}</b> تم بدءها بواسطة <b>{visitor}</b>.",
            channelRemoved: "تمت إزالة القناة <b>{channel}</b> بواسطة <b>{agent}</b>.",
            userAdded: "<b>{agent}</b> أنشأ ممثلاً يدعى <b>{newAgent}</b>.",
            visitorUnblocked: "الزائر <b>{visitor}</b> تم إلغاء حظره بواسطة المستخدم <b>{agent}</b>.",
            visitorBlocked: "تم حظر الزائر <b>{visitor}</b> بواسطة <b>{agent}</b>.",
            userStatusChanged: "قام المستخدم <b>{name}</b> بتغيير الحالة من <b>{oldStatus}</b> إلى <b>{newStatus}</b>.",
            channelCreated: "تم إنشاء القناة <b>{channel}</b> بواسطة <b>{name}</b>.",
            reservationCreatedPlan: "قام <b>{name}</b> بجدولة الموعد بعنوان <b>{title}</b> لتاريخ <b>{date}</b>.",
            chatOwnerUpdated: "<b>{agent}</b> أعاد تعيين <b>{visitor}</b> من <b>{oldOwner}</b> إلى <b>{newOwner}</b>.",
            customerOwnershipRemoved: "<b>{actor}</b> أزال ملكية <b>{visitor}</b> من <b>{oldOwner}</b> وتركه دون مالك.",
            customerOwnershipAssigned: "<b>{actor}</b> قام بتعيين ملكية <b>{visitor}</b> من دون مالك إلى <b>{newOwner}</b>.",
            customerOwnershipReassigned: "<b>{actor}</b> أعاد تعيين ملكية <b>{visitor}</b> من <b>{oldOwner}</b> إلى <b>{newOwner}</b>.",
            reservationUpdatedPlan: "قام <b>{name}</b> بتحديث الموعد بعنوان <b>{title}</b>.",
            reservationDeletedPlan: "قام <b>{name}</b> بحذف الموعد بعنوان <b>{title}</b>.",
            reservationCreated: "تم إنشاء حجز للمستخدم <b>{name}</b> والزائر <b>{visitor}</b> في تاريخ <b>{date}</b>.",
            reservationDeleted: "تم إلغاء الموعد المقرر بين المستخدم <b>{name}</b> والزائر <b>{visitor}</b> في تاريخ <b>{date}</b>.",
            taskStatusChanged: "عند تغيير حالة المهمة",
            taskWorkflowCrud: "تم إنشاء سير عمل المهمة أو تحديثه أو حذفه",
            taskCrud: "تم إنشاء المهمة أو تحديثها أو حذفها",
            autoRebalanceEvents: "عند اكتمال إعادة التوازن التلقائي أو فشلها أو تعطيلها.",
            automationActions: "إجراءات الأتمتة",
            automationCreated: "قام <b>{user}</b> بإنشاء أتمتة باسم <b>{automation}</b>.",
            automationDeleted: "قام <b>{user}</b> بحذف أتمتة باسم <b>{automation}</b>.",
            automationRestored: "قام <b>{user}</b> باستعادة الأتمتة <b>{automation}</b> من سلة المحذوفات.",
            automationPublished: "قام <b>{user}</b> بنشر أتمتة باسم <b>{automation}</b>.",
            automationUnpublished: "قام <b>{user}</b> بإلغاء نشر أتمتة باسم <b>{automation}</b>.",
            automationUpdated: "قام <b>{user}</b> بتحديث أتمتة باسم <b>{automation}</b>.",
            automationCreatedNotification: "عند إنشاء أتمتة.",
            automationDeletedNotification: "عند حذف أتمتة.",
            automationRestoredNotification: "عند استعادة الأتمتة من سلة المحذوفات.",
            automationPublishedNotification: "عند نشر أتمتة.",
            automationUnpublishedNotification: "عند إلغاء نشر أتمتة.",
            automationUpdatedNotification: "عند تحديث أتمتة.",
            formDeleted: "قام <b>{user}</b> بحذف النموذج \"<b>{formName}</b>\" (المعرف: {formId}).",
            formDeletedPermanent: "قام <b>{user}</b> بحذف النموذج \"<b>{formName}</b>\" (المعرف: {formId}) حذفاً نهائياً.",
            formRestored: "قام <b>{user}</b> باستعادة النموذج \"<b>{formName}</b>\" (المعرف: {formId}) من سلة المحذوفات.",
            formCreated: "قام <b>{user}</b> بإنشاء النموذج \"<b>{formName}</b>\".",
            formUpdated: "قام <b>{user}</b> بتحديث النموذج \"<b>{formName}</b>\".",
            formDownloaded: "قام <b>{user}</b> بتنزيل بيانات النموذج \"<b>{formName}</b>\" (المعرف: {formId}).",
            userRoleChanged: "قام <b>{actor}</b> بتغيير دور المستخدم \"<b>{userName}</b>\" من \"<b>{oldRoleName}</b>\" إلى \"<b>{newRoleName}</b>\".",
            userPasswordChanged: "قام <b>{actor}</b> بتغيير كلمة مرور المستخدم \"<b>{userName}</b>\".",
            userEmailChanged: "قام <b>{actor}</b> بتغيير البريد الإلكتروني للمستخدم \"<b>{userName}</b>\" من \"<b>{oldEmail}</b>\" إلى \"<b>{newEmail}</b>\".",
            userNameChanged: "قام <b>{actor}</b> بتغيير اسم المستخدم \"<b>{userName}</b>\" من \"<b>{oldName}</b>\" إلى \"<b>{newName}</b>\".",
            userPhoneChanged: "قام <b>{actor}</b> بتغيير رقم هاتف المستخدم \"<b>{userName}</b>\" من \"<b>{oldPhone}</b>\" إلى \"<b>{newPhone}</b>\".",
            userDisabled: "قام <b>{actor}</b> بتعطيل المستخدم \"<b>{userName}</b>\".",
            userEnabled: "قام <b>{actor}</b> بتفعيل المستخدم \"<b>{userName}</b>\".",
            roleUpdated: "قام <b>{actor}</b> بتحديث الدور \"<b>{roleName}</b>\".",
            taskWorkflowUpdated: "قام <b>{actor}</b> بتحديث سير العمل \"<b>{workflowTitle}</b>\".",
            taskWorkflowPipelineStageAdded: "قام <b>{actor}</b> بإضافة المرحلة \"<b>{stageName}</b>\" إلى سير العمل \"<b>{workflowTitle}</b>\".",
            taskWorkflowPipelineStageUpdated: "قام <b>{actor}</b> بتحديث المرحلة \"<b>{stageName}</b>\" في سير العمل \"<b>{workflowTitle}</b>\".",
            taskWorkflowPipelineStageDeleted: "قام <b>{actor}</b> بحذف المرحلة \"<b>{stageName}</b>\" من سير العمل \"<b>{workflowTitle}</b>\".",
            driveFolderCreated: "قام <b>{actor}</b> بإنشاء المجلد \"<b>{folderName}</b>\".",
            driveFolderDeleted: "قام <b>{actor}</b> بحذف المجلد \"<b>{folderName}</b>\".",
            driveFolderRenamed: "قام <b>{actor}</b> بإعادة تسمية المجلد \"<b>{oldName}</b>\" إلى \"<b>{newName}</b>\".",
            driveFileAdded: "قام <b>{actor}</b> بإضافة الملف \"<b>{fileName}</b>\".",
            driveFileDeleted: "قام <b>{actor}</b> بحذف الملف \"<b>{fileName}</b>\".",
            taskModuleRulesEnabled: "قام <b>{actor}</b> بتفعيل قواعد المهام لسير العمل \"<b>{workflowTitle}</b>\".",
            taskModuleRulesDisabled: "قام <b>{actor}</b> بتعطيل قواعد المهام لسير العمل \"<b>{workflowTitle}</b>\".",
            taskModuleRulesRuleAdded: "قام <b>{actor}</b> بإضافة القاعدة \"<b>{ruleName}</b>\" إلى سير العمل \"<b>{workflowTitle}</b>\".",
            taskModuleRulesRuleDeleted: "قام <b>{actor}</b> بحذف القاعدة \"<b>{ruleName}</b>\" من سير العمل \"<b>{workflowTitle}</b>\".",
            taskModuleRulesRuleUpdated: "قام <b>{actor}</b> بتحديث القاعدة \"<b>{ruleName}</b>\" في سير العمل \"<b>{workflowTitle}</b>\".",
            taskModuleRulesRuleEnabled: "قام <b>{actor}</b> بتفعيل القاعدة \"<b>{ruleName}</b>\" في سير العمل \"<b>{workflowTitle}</b>\".",
            taskModuleRulesRuleDisabled: "قام <b>{actor}</b> بتعطيل القاعدة \"<b>{ruleName}</b>\" في سير العمل \"<b>{workflowTitle}</b>\".",
            contactModuleRulesEnabled: "قام <b>{actor}</b> بتفعيل قواعد وحدة جهات الاتصال.",
            contactModuleRulesDisabled: "قام <b>{actor}</b> بتعطيل قواعد وحدة جهات الاتصال.",
            contactModuleRulesRuleAdded: "قام <b>{actor}</b> بإضافة القاعدة \"<b>{ruleName}</b>\" إلى وحدة جهات الاتصال.",
            contactModuleRulesRuleUpdated: "قام <b>{actor}</b> بتحديث القاعدة \"<b>{ruleName}</b>\" في وحدة جهات الاتصال.",
            contactModuleRulesRuleDeleted: "قام <b>{actor}</b> بحذف القاعدة \"<b>{ruleName}</b>\" من وحدة جهات الاتصال.",
            contactModuleRulesRuleEnabled: "قام <b>{actor}</b> بتفعيل القاعدة \"<b>{ruleName}</b>\" في وحدة جهات الاتصال.",
            contactModuleRulesRuleDisabled: "قام <b>{actor}</b> بتعطيل القاعدة \"<b>{ruleName}</b>\" في وحدة جهات الاتصال.",
            developerTokenChanged: "قام <b>{actor}</b> بتحديث رمز وصول المطور.",
            tableCreated: "قام <b>{actor}</b> بإنشاء الجدول \"<b>{tableName}</b>\".",
            tableDeleted: "قام <b>{actor}</b> بحذف الجدول \"<b>{tableName}</b>\".",
            tableRestored: "قام <b>{actor}</b> باستعادة الجدول \"<b>{tableName}</b>\" من سلة المحذوفات.",
            tablePermanentlyDeleted: "قام <b>{actor}</b> بحذف الجدول \"<b>{tableName}</b>\" نهائياً من سلة المحذوفات.",
            tableFieldAdded: "قام <b>{actor}</b> بإضافة الحقل \"<b>{fieldName}</b>\" إلى الجدول \"<b>{tableName}</b>\".",
            tableFieldUpdated: "قام <b>{actor}</b> بتحديث الحقل \"<b>{fieldName}</b>\" في الجدول \"<b>{tableName}</b>\".",
            tableFieldDeleted: "قام <b>{actor}</b> بحذف الحقل \"<b>{fieldName}</b>\" من الجدول \"<b>{tableName}</b>\".",
            tableViewAdded: "قام <b>{actor}</b> بإضافة العرض \"<b>{viewName}</b>\" إلى الجدول \"<b>{tableName}</b>\".",
            tableViewUpdated: "قام <b>{actor}</b> بتحديث العرض \"<b>{viewName}</b>\" في الجدول \"<b>{tableName}</b>\".",
            tableViewDeleted: "قام <b>{actor}</b> بحذف العرض \"<b>{viewName}</b>\" من الجدول \"<b>{tableName}</b>\".",
            tablePageAdded: "قام <b>{actor}</b> بإضافة الصفحة \"<b>{pageName}</b>\" إلى الجدول \"<b>{tableName}</b>\".",
            tablePageUpdated: "قام <b>{actor}</b> بتحديث الصفحة \"<b>{pageName}</b>\" في الجدول \"<b>{tableName}</b>\".",
            tablePageDeleted: "قام <b>{actor}</b> بحذف الصفحة \"<b>{pageName}</b>\" من الجدول \"<b>{tableName}</b>\".",
            tableWidgetAdded: "قام <b>{actor}</b> بإضافة عنصر الواجهة \"<b>{widgetTitle}</b>\" ({widgetType}) إلى الصفحة \"<b>{pageName}</b>\" في الجدول \"<b>{tableName}</b>\".",
            tableWidgetUpdated: "قام <b>{actor}</b> بتحديث عنصر الواجهة \"<b>{widgetTitle}</b>\" ({widgetType}) في الصفحة \"<b>{pageName}</b>\" بالجدول \"<b>{tableName}</b>\".",
            tableWidgetDeleted: "قام <b>{actor}</b> بحذف عنصر الواجهة \"<b>{widgetTitle}</b>\" ({widgetType}) من الصفحة \"<b>{pageName}</b>\" بالجدول \"<b>{tableName}</b>\".",
            tablePermissionChanged: "قام <b>{actor}</b> بتحديث إعدادات خصوصية الجدول \"<b>{tableName}</b>\".",
            tableDataDownloaded: "قام <b>{actor}</b> بتنزيل {recordCount} سجل من الجدول \"<b>{tableName}</b>\".",
            tableDataImported: "قام <b>{actor}</b> بإضافة {successCount}/{recordCount} سجل إلى الجدول \"<b>{tableName}</b>\".",
            tableDataBatchUpdated: "قام <b>{actor}</b> بتحديث الحقل \"<b>{fieldName}</b>\" بشكل مجمع لـ {recordCount} سجل في الجدول \"<b>{tableName}</b>\".",
            tableDataBatchDeleted: "قام <b>{actor}</b> بحذف {recordCount} سجل بشكل مجمع من الجدول \"<b>{tableName}</b>\".",
            contactDataDownloaded: "قام <b>{actor}</b> بتنزيل بيانات {contactCount} جهة اتصال.",
            contactBatchUpdated: "قام <b>{actor}</b> بتنفيذ عملية {action} المجمعة لـ {contactCount} جهة اتصال.",
            chatDataDownloaded: "قام <b>{actor}</b> بتنزيل سجل {chatCount} محادثة.",
            chatDataDownloadedWithVisitor: "قام <b>{actor}</b> بتنزيل سجل المحادثة مع \"<b>{visitorName}</b>\".",
            visitorTagAdded: "{actor} أضاف الوسم {tagNames} إلى {visitorName}.",
            visitorTagRemoved: "{actor} أزال الوسم {tagNames} من {visitorName}.",
            unknownVisitor: "جهة اتصال غير معروفة",
            tagsLabel: "العلامات",
            webAppCreated: "قام <b>{actor}</b> بإنشاء تطبيق الويب \"<b>{appName}</b>\" ({appSlug}).",
            webAppUpdated: "قام <b>{actor}</b> بتحديث تطبيق الويب \"<b>{appName}</b>\" ({appSlug}).",
            webAppDeleted: "قام <b>{actor}</b> بحذف تطبيق الويب \"<b>{appName}</b>\" ({appSlug}).",
            webTabCreated: "قام <b>{actor}</b> بإضافة تبويب الويب \"<b>{tabName}</b>\" في {placement}.",
            webTabUpdated: "قام <b>{actor}</b> بتحديث تبويب الويب \"<b>{tabName}</b>\".",
            webTabDeleted: "قام <b>{actor}</b> بحذف تبويب الويب \"<b>{tabName}</b>\" ({placement}).",
            moduleCreated: "قام <b>{actor}</b> بإنشاء الوحدة \"<b>{moduleName}</b>\" {moduleType}.",
            moduleUpdated: "قام <b>{actor}</b> بتحديث الوحدة \"<b>{moduleName}</b>\" {moduleType}.",
            moduleDeleted: "قام <b>{actor}</b> بحذف الوحدة \"<b>{moduleName}</b>\" {moduleType}.",
            relationCreated: "قام <b>{actor}</b> بإنشاء العلاقة \"<b>{relationName}</b>\".",
            relationUpdated: "قام <b>{actor}</b> بتحديث العلاقة \"<b>{relationName}</b>\".",
            voiceAgentCreated: "قام <b>{actor}</b> بإنشاء وكيل الصوت \"<b>{agentName}</b>\" ({agentId}).",
            voiceAgentUpdated: "قام <b>{actor}</b> بتحديث وكيل الصوت \"<b>{agentName}</b>\" ({agentId}).",
            voiceAgentDeleted: "قام <b>{actor}</b> بحذف وكيل الصوت \"<b>{agentName}</b>\" ({agentId}).",
            voiceAgentPhoneNumberInboundAgentChanged: "قام <b>{actor}</b> بتغيير وكيل المكالمات الواردة للرقم {phoneNumber} إلى \"<b>{agentName}</b>\".",
            voiceAgentPhoneNumberOutboundAgentChanged: "قام <b>{actor}</b> بتغيير وكيل المكالمات الصادرة للرقم {phoneNumber} إلى \"<b>{agentName}</b>\".",
            voiceAgentBatchCallCreated: "قام <b>{actor}</b> بإنشاء المكالمة المجمعة \"<b>{batchCallName}</b>\" ({taskCount} جهة اتصال).",
            voiceAgentKnowledgeBaseCreated: "قام <b>{actor}</b> بإنشاء قاعدة المعرفة \"<b>{knowledgeBaseName}</b>\".",
            voiceAgentKnowledgeBaseDeleted: "قام <b>{actor}</b> بحذف قاعدة المعرفة \"<b>{knowledgeBaseName}</b>\".",
            webTabCreatedNotification: "عند إنشاء تبويب ويب.",
            webTabUpdatedNotification: "عند تحديث تبويب ويب.",
            webTabDeletedNotification: "عند حذف تبويب ويب.",
            moduleCreatedNotification: "عند إنشاء وحدة أو علاقة.",
            moduleUpdatedNotification: "عند تحديث وحدة أو علاقة.",
            moduleDeletedNotification: "عند حذف وحدة أو علاقة.",
            relationCreatedNotification: "عند إنشاء علاقة.",
            relationUpdatedNotification: "عند تحديث علاقة.",
            voiceAgentCreatedNotification: "عند إنشاء وكيل صوت.",
            voiceAgentUpdatedNotification: "عند تحديث وكيل صوت.",
            voiceAgentDeletedNotification: "عند حذف وكيل صوت.",
            voiceAgentPhoneNumberInboundAgentChangedNotification: "عند تغيير وكيل المكالمات الواردة للرقم.",
            voiceAgentPhoneNumberOutboundAgentChangedNotification: "عند تغيير وكيل المكالمات الصادرة للرقم.",
            voiceAgentBatchCallCreatedNotification: "عند إنشاء مكالمة مجمعة.",
            voiceAgentKnowledgeBaseCreatedNotification: "عند إنشاء قاعدة معرفة.",
            voiceAgentKnowledgeBaseDeletedNotification: "عند حذف قاعدة معرفة.",
            formDeletedNotification: "عند حذف النموذج.",
            formRestoredNotification: "عند استعادة النموذج من سلة المحذوفات.",
            formCreatedNotification: "عند إنشاء النموذج.",
            formUpdatedNotification: "عند تحديث النموذج.",
            formDownloadedNotification: "عند تنزيل بيانات النموذج.",
            userRoleChangedNotification: "عند تغيير دور المستخدم.",
            userPasswordChangedNotification: "عند تغيير كلمة مرور المستخدم.",
            userEmailChangedNotification: "عند تغيير البريد الإلكتروني للمستخدم.",
            userNameChangedNotification: "عند تغيير اسم المستخدم.",
            userPhoneChangedNotification: "عند تغيير رقم هاتف المستخدم.",
            userDisabledNotification: "عند تعطيل المستخدم أو تفعيله.",
            roleUpdatedNotification: "عند تحديث الدور.",
            taskWorkflowUpdatedNotification: "عند تحديث سير العمل.",
            taskWorkflowPermanentlyDeletedNotification: "عند حذف سير العمل نهائياً من سلة المحذوفات.",
            taskWorkflowPipelineStageAddedNotification: "عند إضافة مرحلة جديدة لسير العمل.",
            taskWorkflowPipelineStageUpdatedNotification: "عند تحديث مرحلة في سير العمل.",
            taskWorkflowPipelineStageDeletedNotification: "عند حذف مرحلة من سير العمل.",
            driveFolderCreatedNotification: "عند إنشاء مجلد في Drive.",
            driveFolderDeletedNotification: "عند حذف مجلد من Drive.",
            driveFolderRenamedNotification: "عند إعادة تسمية مجلد في Drive.",
            driveFileAddedNotification: "عند إضافة ملف إلى Drive.",
            driveFileDeletedNotification: "عند حذف ملف من Drive.",
            taskModuleRulesEnabledNotification: "عند تفعيل قواعد المهام.",
            taskModuleRulesDisabledNotification: "عند تعطيل قواعد المهام.",
            taskModuleRulesRuleAddedNotification: "عند إضافة قاعدة جديدة لسير العمل.",
            taskModuleRulesRuleDeletedNotification: "عند حذف قاعدة من سير العمل.",
            taskModuleRulesRuleUpdatedNotification: "عند تحديث قاعدة في سير العمل.",
            taskModuleRulesRuleEnabledNotification: "عند تفعيل قاعدة في سير العمل.",
            taskModuleRulesRuleDisabledNotification: "عند تعطيل قاعدة في سير العمل.",
            contactModuleRulesEnabledNotification: "عند تفعيل قواعد وحدة جهات الاتصال.",
            contactModuleRulesDisabledNotification: "عند تعطيل قواعد وحدة جهات الاتصال.",
            contactModuleRulesRuleAddedNotification: "عند إضافة قاعدة جديدة لوحدة جهات الاتصال.",
            contactModuleRulesRuleUpdatedNotification: "عند تحديث قاعدة في وحدة جهات الاتصال.",
            contactModuleRulesRuleDeletedNotification: "عند حذف قاعدة من وحدة جهات الاتصال.",
            contactModuleRulesRuleEnabledNotification: "عند تفعيل قاعدة في وحدة جهات الاتصال.",
            contactModuleRulesRuleDisabledNotification: "عند تعطيل قاعدة في وحدة جهات الاتصال.",
            developerTokenChangedNotification: "عند تحديث رمز وصول المطور.",
            tableCreatedNotification: "عند إنشاء جدول جديد.",
            tableDeletedNotification: "عند حذف الجدول.",
            tableRestoredNotification: "عند استعادة الجدول من سلة المحذوفات.",
            tablePermanentlyDeletedNotification: "عند حذف الجدول نهائياً من سلة المحذوفات.",
            tableFieldAddedNotification: "عند إضافة حقل جديد للجدول.",
            tableFieldUpdatedNotification: "عند تحديث حقل في الجدول.",
            tableFieldDeletedNotification: "عند حذف حقل من الجدول.",
            tableViewActionsNotification: "عند إضافة عرض للجدول أو تحديثه أو حذفه.",
            tablePageActionsNotification: "عند إضافة صفحة للجدول أو تحديثها أو حذفها.",
            tableWidgetActionsNotification: "عند إضافة عنصر واجهة لصفحة الجدول أو تحديثه أو حذفه.",
            tablePermissionChangedNotification: "عند تحديث إعدادات خصوصية الجدول.",
            tableDataDownloadedNotification: "عند تنزيل بيانات الجدول.",
            tableDataImportedNotification: "عند إضافة سجلات مجمعة للجدول.",
            tableDataBatchUpdatedNotification: "عند تنفيذ تحديث مجمع على الجدول.",
            tableDataBatchDeletedNotification: "عند حذف سجلات مجمعة من الجدول.",
            contactBatchUpdatedNotification: "عند تحديث جهات الاتصال بشكل مجمع.",
            chatDataDownloadedNotification: "عند تنزيل سجل المحادثة.",
            webAppCreatedNotification: "عند إنشاء تطبيق ويب.",
            webAppUpdatedNotification: "عند تحديث تطبيق ويب.",
            webAppDeletedNotification: "عند حذف تطبيق ويب.",
            formActions: "عند إنشاء النموذج أو تحديثه أو حذفه.",
            userInfoActions: "عند تغيير معلومات المستخدم مثل الدور أو كلمة المرور أو البريد أو الاسم أو الهاتف أو الحالة.",
            driveActions: "عمليات مجلدات وملفات Drive.",
            developerActions: "عند تحديث رمز وصول المطور.",
            contactModuleRulesActions: "عند تفعيل أو تعطيل قواعد وحدة جهات الاتصال، أو إضافة أو تحديث أو حذف قاعدة، أو تفعيل أو تعطيل قاعدة.",
            tableActions: "عند إنشاء الجدول، أو إضافة حقل أو تحديثه أو حذفه.",
            wabaSupsisPartnerRemove: "عند إزالة شريك واتساب للأعمال API V2.",
            wabaSupsisAccountDeleted: "عند حذف حساب واتساب للأعمال API V2.",
            wabaSupsisAccountViolation: "عند اكتشاف مخالفة لحساب واتساب للأعمال API V2.",
            wabaSupsisAdAccountLinked: "عند ربط حساب إعلانات واتساب للأعمال API V2.",
            wabaSupsisAuthIntlPriceEligibilityUpdate: "عند تحديث أهلية الأسعار الدولية لواتساب للأعمال API V2.",
            wabaSupsisDisabledUpdate: "عند تحديث تعطيل واتساب للأعمال API V2.",
            wabaSupsisMmLiteTermsSigned: "عند توقيع شروط MM Lite لواتساب للأعمال API V2.",
            wabaSupsisPartnerAdded: "عند إضافة شريك واتساب للأعمال API V2.",
            wabaSupsisPartnerAppInstalled: "عند تثبيت تطبيق شريك واتساب للأعمال API V2.",
            wabaSupsisPartnerAppUninstalled: "عند إلغاء تثبيت تطبيق شريك واتساب للأعمال API V2.",
            wabaSupsisPartnerClientCertificationStatusUpdate: "عند تحديث حالة شهادة عميل شريك واتساب للأعمال API V2.",
            wabaSupsisBusinessPrimaryLocationCountryUpdate: "عند تحديث دولة الموقع الأساسي لواتساب للأعمال API V2.",
            wabaSupsisVolumeBasedPricingTierUpdate: "عند تحديث مستوى التسعير الحجمي لواتساب للأعمال API V2.",
            wabaSupsisMessageTemplateComponentsUpdate: "عند تحديث مكونات قالب الرسالة لواتساب للأعمال API V2.",
            wabaSupsisMessageTemplateStatusUpdate: "عند تحديث حالة قالب الرسالة لواتساب للأعمال API V2.",
            wabaSupsisTemplateCategoryUpdate: "عند تحديث فئة القالب لواتساب للأعمال API V2.",
            chatbotRestored: "قام <b>{user}</b> باستعادة الدردشة الآلية <b>{chatbot}</b> من سلة المحذوفات.",
            taskWorkflowRestored: "قام <b>{user}</b> باستعادة سير العمل <b>{workflow}</b> من سلة المحذوفات.",
            taskWorkflowPermanentlyDeleted: "قام <b>{user}</b> بحذف سير العمل <b>{workflow}</b> نهائياً من سلة المحذوفات.",
            userLoggenIn: "قام <b>{user}</b> بتسجيل الدخول إلى SUPSIS.",
            channelForwardConfigUpdated: "قام <b>{actor}</b> بتحديث إعدادات توجيه القناة \"<b>{channelName}</b>\" {channelType}.",
            channelZohoConfigUpdated: "قام <b>{actor}</b> بتحديث إعدادات تكامل Zoho للقناة \"<b>{channelName}</b>\" {channelType}.",
            webhookUpdated: "قام <b>{actor}</b> بتحديث الـ webhook \"<b>{webhookName}</b>\" ({webhookUrl})."
        },
        search: {
            prefix: {
                jump: "انتقل",
                new: "جديد",
                visitor: "شخص",
                dm: "رسالة مباشرة",
                chatbot: "روبوت الدردشة",
                automation: "الأتمتة",
                table: "طاولة",
                module: "وحدة",
                message: "رسالة"
            },
            calendar: "التقويم",
            audioSettings: "إعدادات الصوت",
            allNotificationSettings: "إعدادات الإشعارات",
            allAuditLogs: "جميع سجلات التدقيق",
            allNotifications: "جميع الإعلامات",
            allActivities: "جميع الأنشطة",
            workflow: "سير العمل",
            editTask: "تحرير مهمة",
            tasks: "المهام",
            todo: "أشياء يجب القيام بها",
            tapTo: "اضغط على ⇥ لـ '{البداية}",
            newUsers: "مستخدم جديد ⇥ مستخدم جديد",
            newTags: "علامة جديدة ⇥ علامة جديدة",
            newRole: "دور جديد",
            newTrigger: "مشغل جديد",
            newSection: "قسم جديد",
            newTicket: "تذكرة جديدة",
            jumpSettings: "إعدادات القفز",
            jumpIntegrations: "التكاملات",
            jumpTeam: "فريق",
            jumpUsers: "المستخدمون",
            jumpReport: "تقرير",
            timingSettings: "إعدادات التوقيت",
            exampleVisitorMail: "البريد الإلكتروني للزائر@example.com",
            languageAndRegion: "اللغة والمنطقة",
            theme: "السمة",
            appearance: "المظهر",
            color: "اللون",
            background: "الخلفية",
            smart: "ذكي",
            teamChat: "دردشة الفريق",
            chatbot: "روبوت الدردشة",
            chatbotTraining: "تدريب روبوت الدردشة الآلية",
            chatbotUserSegments: "شرائح مستخدم روبوت الدردشة الآلية",
            chatbotIntegration: "تكامل روبوت الدردشة الآلية",
            chatbotEntities: "كيانات روبوت الدردشة الآلية",
            chatbotIntegrationWebHook: "تكامل خطاف الويب لروبوت الدردشة الآلي",
            chatbotArchive: "أرشيف روبوت الدردشة الآلية",
            chatbotTemplatesAI: "قوالب الذكاء الاصطناعي لروبوت الدردشة الآلية",
            chatbotTemplates: "قوالب روبوت الدردشة الآلية",
            chatbotReportsOverall: "التقارير الإجمالية لروبوت الدردشة الآلية",
            chatbotReportsAllChats: "تقارير روبوت الدردشة الآلية جميع الدردشات",
            chatbotReportsRatingDistribution: "توزيع تصنيف تقارير روبوت الدردشة الآلية",
            chatbotReportsPaidChats: "تقارير روبوت الدردشة الآلية للمحادثات المدفوعة",
            chatbotReportsBusiestPeriod: "الفترة الأكثر انشغالاً في روبوت الدردشة الآلية",
            chatbotTemplatesAllMessages: "قوالب جميع رسائل روبوت الدردشة الآلية",
            chatbotTemplatesAverage: "متوسط قوالب روبوت الدردشة الآلية",
            chatbotTemplatesPopularity: "شعبية قوالب روبوت الدردشة الآلية",
            chatbotTemplatesAllUser: "قوالب جميع مستخدمي روبوت الدردشة الآلية",
            ticket: "طلبات الدعم",
            archives: "الأرشيفات",
            tags: "الوسوم",
            offlineSupportRequests: "طلبات الدعم غير المتصلة بالإنترنت",
            roles: "الأدوار",
            users: "المستخدمون",
            topics: "الموضوعات",
            contents: "المحتويات",
            welcomeMessages: "رسائل الترحيب",
            catalog: "كتالوج",
            forbiddenWords: "الكلمات المحظورة",
            bannedVisitors: "الزائرون المحظورون",
            application: "التطبيق",
            mailMessages: "رسائل البريد",
            visitors: "الزائرون",
            webhookIntegration: "تكامل خطاف الويب",
            invoices: "الفاتورة",
            newReport: "تقرير جديد",
            integrationOperations: "عمليات التكامل",
            chatbotStory: "قصص روبوت المحادثة",
            searchPlaceHolder: "بحث أو انتقال أو إضافة...",
            searchAreaTitle: "بحث سوبسيس",
            searchAreaDesc1: "يمكنك البحث عن أي شيء. فقط",
            searchAreaDesc2: "أو",
            searchAreaDesc3: "اكتب أو ابحث عن أي شيء.",
            navigation: "التنقل",
            selectBtn: "تحديد",
            cancelBtn: "إلغاء",
            integration: {
                shouldByInstaPack: "يجب عليك شراء حزمة Instagram لإنشاء قناة Instagram. يمكنك الوصول إلى الباقات بأسعار معقولة على الفور.",
                createInstaInstaLimitMax: "لقد وصلت إلى الحد الأقصى لإنشاء قناة Instagram. الحد الأقصى.",
                createInstaContinue: "يمكنك إنشاء قناة على Instagram. للمتابعة، قم بترقية الحزمة الخاصة بك أو احذف بعض قنوات Instagram الخاصة بك.",
                privatePolicy: "سياسة خاصة.",
                termsAndCondition: "الشروط والأحكام.",
                readAndAgree: "لقد قرأت وأوافق.",
                shouldByByMessengerPack: "يجب عليك شراء باقة ماسنجر لإنشاء قناة ماسنجر. يمكنك الوصول إلى الباقات بأسعار معقولة على الفور.",
                createMessengerMessengerLimitMax: "لقد وصلت إلى الحد الأقصى لإنشاء قناة مسنجر. الحد الأقصى.",
                createMessengerContinue: "يمكنك إنشاء قناة مسنجر. للمتابعة، قم بترقية الحزمة الخاصة بك أو احذف بعض قنوات المسنجر الخاصة بك.",
                selectMessengerAccount: "تحديد حساب مسنجر.",
                directClientsForward: "👉 وكلاء مباشرون إلى الأمام",
                allSections: "جميع الأقسام",
                deleteAll: "حذف الكل",
                wpBusinessAPI: "عمليات التكامل - قنوات واجهة برمجة تطبيقات واتساب للأعمال",
                wpV1: "التكاملات - قنوات واتساب المتعددة",
                instagram: "التكاملات - إنستغرام",
                instagramContactList: "التكاملات - قائمة جهات اتصال إنستغرام",
                mail: "التكاملات - البريد",
                whatsapp: "التكاملات - واتساب",
                whatsappContactList: "التكاملات - قائمة جهات اتصال واتساب",
                wpBCRequests: "عمليات التكامل - طلبات رسائل واتساب المجمعة",
                wpBCCustomerGroups: "عمليات التكامل - مجموعات عملاء واتساب المجمعة",
                wpBCTemplates: "عمليات التكامل - قوالب الرسائل المجمعة على واتساب",
                chatbot: "التكاملات - روبوت الدردشة",
                createInstaLimitMax: "لقد وصلت إلى الحد الأقصى لإنشاء قناة إنستغرام.",
                shouldByMessengerPack: "يجب عليك شراء باقة ماسنجر لإنشاء قناة ماسنجر. يمكنك الوصول إلى الباقات بأسعار معقولة على الفور.",
                createMessengerLimitMax: "لقد وصلت إلى الحد الأقصى لإنشاء قناة ماسنجر.",
                forwardLiveAgents: "👉 توجيه إلى الوكلاء المباشرين",
                allDepartments: "جميع الأقسام",
                wpBCRichieste: "التكاملات - طلبات رسائل واتساب المجمعة",
                messenger: "التكاملات - ماسنجر",
                telegram: "التكاملات - تيليجرام",
                whatsappV3: "التكاملات - واتساب V3",
                waba: "التكاملات - واتساب بزنس API V2",
                metaLeads: "التكاملات - Meta Leads",
                linkedin: "التكاملات - لينكد إن",
                youtubeComments: "التكاملات - تعليقات يوتيوب",
                googleBusinessReviews: "التكاملات - مراجعات Google Business",
                googlePlayReviews: "التكاملات - مراجعات Google Play",
                appstoreReviews: "التكاملات - مراجعات App Store",
                googleDrive: "التكاملات - Google Drive",
                openai: "التكاملات - OpenAI",
                openrouter: "التكاملات - OpenRouter AI",
                ideasoft: "التكاملات - Ideasoft",
                bitrix24: "التكاملات - Bitrix24",
                zoho: "التكاملات - Zoho CRM",
                ticimax: "التكاملات - Ticimax",
                ticimaxV2: "التكاملات - Ticimax V2",
                teamgram: "التكاملات - TeamGram",
                holidayplus: "التكاملات - HolidayPlus",
                trendyol: "التكاملات - Trendyol",
                tSoft: "التكاملات - T-Soft",
                ikas: "التكاملات - Ikas",
                postacell: "التكاملات - PostaCell SMS",
                telnyx: "التكاملات - Telnyx",
                netgsm: "التكاملات - NetGSM",
                webtabs: "التكاملات - Web Tabs",
                webapps: "التكاملات - Web Apps",
                instagramV2: "التكاملات - Instagram V2",
                voiceAgent: "التكاملات - وكيل صوت الذكاء الاصطناعي",
            },
            settings: {
                settings: "الإعدادات",
                features: "الإعدادات - الميزات",
                languageAndRegion: "الإعدادات - اللغة والمنطقة",
                bubbleSettings: "الإعدادات - إعدادات الفقاعة",
                bubbleActions: "الإعدادات - إجراءات الفقاعة",
                themeSettings: "الإعدادات - إعدادات السمة",
                visitorLoginForm: "الإعدادات - نموذج تسجيل دخول الزائر",
                visitorAttribute: "الإعدادات - سمات الزائر",
                talkSettings: "الإعدادات - إعدادات المحادثة",
                autoAssign: "الإعدادات - تعيين تلقائي",
                chatTimingSettings: "الإعدادات - إعدادات وقت الدردشة",
                availability: "الإعدادات - التوفر",
                websiteIntegration: "الإعدادات - تكامل موقع الويب",
                developer: "الإعدادات - المطور",
                wallet: "الإعدادات - المحفظة",
                accessControl: "الإعدادات - التحكم في الوصول",
                sessions: "الإعدادات - إدارة الجلسات",
                contactModuleRules: "الإعدادات - قواعد وحدة جهات الاتصال",
                taskModuleRules: "الإعدادات - قواعد وحدة المهام",
                notifications: "الإعدادات - الإشعارات",
                billing: "الإعدادات - الفوترة",
                company: "الإعدادات - معلومات الشركة",
                companyUsers: "الإعدادات - المستخدمون",
                departments: "الإعدادات - الأقسام",
                roles: "الإعدادات - الأدوار",
                systemMessages: "الإعدادات - رسائل النظام",
                templates: "الإعدادات - المحتويات الجاهزة",
                forbiddenInputs: "الإعدادات - الكلمات المحظورة",
                timingsSettings: "الإعدادات - إعدادات التوقيت",
                autoAssignSettings: "الإعدادات - التعيين التلقائي",
                availabilitySettings: "الإعدادات - التوفر",
            },
            soundSettings: "إشعارات الصوت",
            workFlow: "سير العمل",
            newDepartment: "قسم جديد ⇥ قسم",
            chatbotTemplatesAvarage: "متوسط قوالب روبوت الدردشة",
            subjects: "الموضوعات",
            bannedWords: "الكلمات المحظورة",
            mails: "البريد",
            integrationsWebhook: "تكامل خطاف الويب",
            billing: "الفوترة",
            reportNew: "تقرير جديد",
            integrations: "التكاملات",
            navigateBtn: "انتقل",
            applicazione: "التطبيق",
            archivi: "الأرشيف",
            chatbotArchiv: "أرشيف روبوت الدردشة",
            content: "المحتوى الفوري",
            contenuti: "المحتويات الفورية",
            departments: "الأقسام",
            emails: "البريد",
            fondo: "الخلفية",
            integraciones: "التكاملات",
            integrazioni: "التكاملات",
            integrazioniWebhook: "تكامل خطاف الويب",
            intelligent: "ذكي",
            kalender: "التقويم",
            mail: "البريد",
            ruoli: "الأدوار",
            soggetti: "الأقسام",
            tag: "الوسم",
            utenti: "المستخدمون",
            visitatori: "الزوار",
            profile: "الملف الشخصي",
            chatbotBlockMarket: "سوق كتل روبوت الدردشة",
            chatbotSandbox: "وضع الحماية لروبوت الدردشة",
            allAutomations: "جميع الأتمتة",
            scheduledAutomations: "الأتمتة المجدولة",
            eventBasedAutomations: "الأتمتة القائمة على الأحداث",
            buttonAutomations: "أتمتة الأزرار",
            webhookAutomations: "أتمتة Webhook",
            automationInsights: "إحصائيات الأتمتة",
            automationSandbox: "وضع الحماية للأتمتة",
            mailInbox: "صندوق الوارد",
            mailTemplates: "قوالب البريد",
            mailBroadcast: "البريد الجماعي",
            mailCustomerGroups: "مجموعات العملاء",
            reservation: "الحجز",
            reservationLandingPage: "صفحة الحجز",
            reservationPrograms: "برامج الحجز",
            reservationAutomations: "أتمتة الحجز",
            calendarEvents: "أحداث التقويم",
            calendarReservations: "حجوزات التقويم",
        },
        mail: {
            errorStatus: "حالة الخطأ",
            mailSendErrorTitle: "البريد غير المرسل",
            mailSendErrorDescription: "إجمالي رسائل البريد الإلكتروني غير المرسلة",
            fixGrammarTitle: "تصحيح القواعد",
            expandTextTitle: "توسيع النص",
            summaryTitle: "الملخص",
            changeToneTitle: "تغيير النبرة",
            translationTitle: "الترجمة",
            replyTitle: "الرد",
            customRequestTitle: "الرد على الطلب المخصص",
            viewMode: "وضع العرض",
            singleView: "عرض فردي",
            splitView: "عرض مقسّم",
            folders: "المجلدات",
            sendError: "حدث خطأ أثناء إرسال البريد الإلكتروني. يرجى المحاولة مرة أخرى لاحقًا.",
            visitorCreationError: "فشل في إنشاء الزائر. يرجى المحاولة مرة أخرى لاحقًا.",
            onlyImageAllowed: "يسمح فقط بملفات الصور.",
            imageFileTooLarge: "ملف الصورة كبير جدًا. الحد الأقصى للحجم هو 10 ميغابايت.",
            imageUploaded: "تم تحميل الصورة بنجاح.",
            imageUploadError: "حدث خطأ أثناء تحميل الصورة.",
            mailAiAssistant: {
                aiCreateSummarized: "إنشاء ملخص بواسطة الذكاء الاصطناعي",
                aiSentimentAnalysis: "تحليل المشاعر بواسطة الذكاء الاصطناعي",
                contentRequired: "محتوى البريد الإلكتروني مطلوب لاستخدام هذه الميزة",
                grammarFixed: "تم تصحيح القواعد اللغوية",
                aiError: "واجه مساعد الذكاء الاصطناعي خطأً",
                contentExpanded: "تم توسيع محتوى البريد الإلكتروني",
                emailSummarized: "تم تلخيص البريد الإلكتروني",
                toneChanged: "تم تغيير النبرة إلى {tone}",
                emailTranslated: "تمت ترجمة البريد الإلكتروني إلى {language}",
                replyGenerated: "تم إنشاء رد تلقائي",
                contentUpdated: "تم تحديث المحتوى",
                contentRebuilt: "تمت إعادة بناء المحتوى",
                contentRebuildFailed: "فشل في إعادة بناء المحتوى",
                customRequestEmpty: "يرجى إدخال طلب",
                customRequestApplied: "تم تطبيق محتوى الطلب المخصص",
                loadingText: "الذكاء الاصطناعي يعمل",
                loadingDescription: "يتم تحليل النص، يرجى الانتظار...",
                aiTitle: "مساعد البريد الإلكتروني بالذكاء الاصطناعي",
                aiDescription: "أدوات ذكاء اصطناعي لتحسين البريد الإلكتروني وتحريره وتحليله",
                emptyContentTitle: "لا يوجد محتوى للبريد الإلكتروني",
                emptyContentDescription: "مطلوب محتوى بريد إلكتروني لاستخدام ميزات الذكاء الاصطناعي.",
                limitedAccessDescription: "يتم عرض ميزات محدودة فقط لعدم وجود محتوى.",
                resultEmotions: "المشاعر المكتشفة",
                analysisDescription: "وصف التحليل",
                recommendationsList: "اقتراحات التحسين",
                mailSummarize: "ملخص البريد",
                aiResponse: "تم إنشاؤه بواسطة الذكاء الاصطناعي",
                rebuild: "إعادة البناء",
                applyText: "تطبيق النص",
                specialRequest: "طلب مخصص",
                specialRequestPlaceholder: "أدخل تعليماتك المخصصة هنا...",
                sendRequest: "إرسال الطلب",
                fixGrammarTitle: "تصحيح القواعد",
                fixGrammardescription: "يصصح تلقائيًا الأخطاء الإملائية والنحوية",
                expandTextTitle: "توسيع النص",
                expandTextDescription: "يجعل النص أكثر تفصيلاً وشمولاً",
                changeToneTitle: "تغيير النبرة",
                changeToneDescription: "يحوّل نبرة النص وأسلوبه إلى الشكل المطلوب",
                changeTone_ProfessionalTitle: "احترافي",
                changeTone_ProfessionalDescription: "نبرة رسمية واحترافية لبيئة العمل",
                changeTone_FriendlyTitle: "ودّي",
                changeTone_FriendlyDescription: "أسلوب دافئ وودّي",
                changeTone_CasualTitle: "غير رسمي",
                changeTone_CasualDescription: "أسلوب محادثة يومي وغير رسمي",
                changeTone_FormalTitle: "رسمي",
                changeTone_FormalDescription: "أسلوب رسمي وشديد الرسمية",
                changeTone_ConfidentTitle: "واثق",
                changeTone_ConfidentDescription: "أسلوب تعبير قوي ومؤثر",
                translateTitle: "ترجمة",
                translateDescription: "يترجم النص إلى لغات مختلفة",
                generateReplyTitle: "إنشاء رد",
                generateReplyDescription: "ينشئ ردًا تلقائيًا مناسبًا للبريد المستلم",
                customPromptTitle: "طلب مخصص",
                customPromptDescription: "ينشئ محتوى بريد إلكتروني وفقًا لتعليماتك المخصصة"
            },
            searchEmail: "بحث في البريد...",
            emailAttachments: "المرفقات ({count})",
            signatureMessage: "لديك توقيع بريد إلكتروني. هل ترغب في إضافته إلى محتوى البريد؟",
            emailSubject: "موضوع البريد الإلكتروني",
            takeItBack: "تراجع",
            fastForward: "إعادة",
            addEmoji: "إضافة رمز تعبيري",
            addLink: "إضافة رابط",
            bold: "عريض",
            italic: "مائل",
            underline: "تحته خط",
            fontFamily: "الخط",
            textColor: "لون النص",
            stringFormats: "تنسيقات النص",
            alignLeft: "محاذاة إلى اليسار",
            alignRight: "محاذاة إلى اليمين",
            alignCenter: "توسيط",
            normalText: "نص عادي",
            participantList: "{first}، {second}، {third} و+{remaining} آخرين",
            noMailFound: "لم يتم العثور على أي بريد",
            selectedMail: "{count} بريد محدد",
            recipientEmailAddress: "عنوان بريد المستلم",
            CCreceivers: "المستلمون في النسخة (CC)",
            BCCreceivers: "المستلمون في النسخة المخفية (BCC)",
            emptyStateMessage: "اختر بريدًا أو أنشئ واحدًا جديدًا",
            FromName: "اسم المرسل",
            broadcastCreatedSuccess: "تم إنشاء البث بنجاح",
            confirmArchive: "هل أنت متأكد أنك تريد أرشفة هذا البث؟",
            archive: "أرشفة",
            cancel: "إلغاء",
            archiveSuccess: "تم أرشفة البث بنجاح",
            archiveError: "خطأ أثناء أرشفة البث",
            empty: "فارغ",
            summerDiscounts: "خصومات الصيف",
            opportunities: "فرص",
            newMailTemplateCreated: "إنشاء قالب بريد إلكتروني جديد",
            dateRange: "نطاق التاريخ",
            templateName: "اسم القالب",
            category: "الفئة",
            templateUpdateSucs: "تم تحديث القالب بنجاح.",
            templateUpdateError: "حدث خطأ أثناء تحديث القالب.",
            marketing: "تسويق",
            operational: "تشغيلي",
            custom: "خاص",
            pleaseEnterTemplateName: "الرجاء إدخال اسم القالب",
            pleaseEnterTemplateSubject: "الرجاء إدخال موضوع القالب",
            pleaseSelectTemplateCategories: "الرجاء تحديد فئات القالب",
            representMails: "رسائل تمثيلية",
            otherRepresentMails: "يمكنك تتبع رسائل البريد الإلكتروني الواردة والصادرة من وإلى عناوين البريد الإلكتروني للممثلين الآخرين.",
            signatureAutoAdd: "تم تغيير حالة الإضافة التلقائية للتوقيع بنجاح",
            autoAdd: "إضافة تلقائية",
            forwardEmailAddSucs: "تمت إضافة عنوان بريد إلكتروني لإعادة التوجيه بنجاح",
            errorAddingForwardEmail: "حدث خطأ أثناء إضافة عنوان بريد إلكتروني معاد توجيهه.",
            mailAddForward: "تمت الإضافة اليدوية (تمت إعادة التوجيه)",
            mailAddForwarding: "إضافة يدوية (اكتملت إعادة التوجيه)",
            broadcast: "منشورات",
            templates: "قوالب",
            newMailArrived: "وصل بريد جديد",
            mailSentSucs: "تم إرسال البريد بنجاح.",
            representativeMails: "بريد تمثيلي",
            createNewEmail: "إنشاء بريد إلكتروني جديد",
            canNotUserMail: "تعذر إرسال بريد إلكتروني لعدم وجود بريد مستخدم",
            mailAddressReq: "عنوان البريد مطلوب",
            emailAddressInvalid: "عنوان البريد غير صالح",
            departmentIsNotValid: "القسم غير صالح",
            mailSendNotValid: "غير صالح من عنوان البريد",
            routingSteps: "خطوات التوجيه",
            owner: "المالك",
            whereHeDirected: "إلى أين وجه",
            forwardingEmailAddress: "إعادة توجيه عنوان البريد الإلكتروني",
            deleteMailDesc: "لا يمكن التراجع عن هذا الإجراء.",
            deleteMailTitle: "هل أنت متأكد أنك تريد حذف عنوان البريد الإلكتروني هذا؟",
            gmailForwardMail: "إعادة توجيه البريد الإلكتروني في Gmail",
            senderMailAddressDesc: "يرجى إدخال عنوان بريد الإلكتروني للمرسل",
            verified: "تم التحقق",
            notForwarded: "غير معاد توجيهه",
            notVerified: "غير مؤكد",
            default: "افتراضي",
            isVerified: "تم التحقق",
            forwarding: "إعادة التوجيه",
            mailAdress: "عنوان البريد الإلكتروني",
            addSenderAddress: "إضافة عنوان المُرسِل",
            outlookForward: "توجيه Microsoft (Outlook/Exchange)",
            gmailForward: "توجيه Google (Gmail)",
            senderMail: "بريد المُرسِل",
            mailDetail: "تفاصيل البريد",
            mailNotFound: "البريد غير موجود",
            mailSelecting: "اختيار البريد",
            newMail: "بريد جديد",
            myMails: "رسائلي البريدية",
            inbox: "صندوق الوارد",
            sent: "تم الإرسال",
            departmentMails: "رسائل البريد الإلكتروني للقسم",
            newTemplate: "قالب جديد",
            unread: "غير مقروء",
            unreply: "بدون رد",
            ly: "الرد",
            attachments: "مرفقات البريد",
            To: "إلى",
            From: "من",
            placeHolders: "عناصر البديل",
            attacheFiles: "إرفاق الملفات",
            replyAll: "الرد على الجميع",
            forward: "إعادة توجيه",
            deleteThread: "حذف المحادثة",
            markAsRead: "وضع علامة كمقروء",
            markAsAllRead: "وضع علامة على الكل كمقروء",
            emailEditor: "محرر البريد الإلكتروني",
            integrateYourMail: "ادمج بريدك الإلكتروني",
            connect: "اتصل",
            departmentMail: "البريد الإلكتروني للقسم",
            createMailAddress: "إنشاء عنوان بريد إلكتروني",
            createNewMail: "إنشاء بريد جديد",
            composeNewEmail: "إنشاء بريد جديد",
            couldNotUserMail: "تعذر إرسال البريد لعدم وجود بريد مستخدم",
            reply: "الرد",
            operativ: "تشغيلي",
            ply: "الرد"
        },
        visitor: {
            ownership: "الملكية",
            visitors: "الزوار",
            bannedVisitors: "الزوار المحظورون",
            tags: "العلامات",
            profileFields: "حقول الملف الشخصي",
            downloadAll: "تحميل الكل",
            saveAsCustomerGroup: "الحفظ كمجموعة عملاء",
            saveSearchFavorite: "حفظ البحث كمفضلة",
            editOrDeleteFavorite: "تعديل أو حذف المفضلة",
            mail: "بريد",
            visitorDetail: "تفاصيل الزائر",
            selectedUser: "{selectedUser} من بين {totalUsers} مستخدم محدد",
            uncheck: "إلغاء تحديد الكل",
            checkAll: "تحديد الكل",
            matchedUsers: "{checkedCount} مستخدم مطابق",
            more: "المزيد",
            exportUsers: "تصدير المستخدمين المحددين",
            exportAllUsers: "تصدير جميع المستخدمين",
            addSegment: "إضافة قطاع",
            deleteCheckedUser: "حذف المستخدمين المحددين",
            deleteAllUser: "حذف جميع المستخدمين",
            matchedFilter: "مطابقة جميع الفلاتر",
            visitor: "الزائر",
            deleteUser: "حذف المستخدم",
            userData: "بيانات المستخدم",
            lastSession: "الجلسة الأخيرة",
            notUserData: "لا توجد بيانات مستخدم",
            segments: "الأقسام",
            addTag: "إضافة علامة",
            userChats: "محادثات المستخدم",
            seeAll: "عرض الكل",
            confirm: "تأكيد",
            manageSegments: "إدارة الأقسام",
            search: "بحث",
            manageTags: "إدارة العلامات",
            allAttributes: "عرض جميع الخصائص",
            noData: "لا توجد بيانات",
            noEmail: "لا يوجد بريد إلكتروني",
            noIpAddress: "العنوان IP غير موجود.",
            noWpNumber: "الرقم غير موجود.",
            filterName: "اسم الفلتر..",
            matchedContacts: "{chechkedCount} الاتصالات المتطابقة",
            channelContacts: "جهات اتصال القناة",
            searchInAllFields: "البحث في جميع الحقول",
            searchInName: "البحث في الاسم",
            importContacts: "استيراد جهات الاتصال",
            addNewContact: "إضافة جهة اتصال جديدة",
            importContactsTitle: "استيراد جهات الاتصال",
            addSingleContactTitle: "إضافة جهة اتصال واحدة",
            downloadRecordsSettings: "تنزيل السجلات - الإعدادات",
            excelExport: "تصدير Excel",
            exportTotalRecords: "إجمالي {total} سجل",
            exportCancel: "إلغاء",
            whatsappContacts: "جهات اتصال واتساب",
            instagramContacts: "جهات اتصال إنستغرام",
            messengerContacts: "جهات اتصال ماسنجر",
            linkedinContacts: "جهات اتصال لينكد إن",
            telegramContacts: "جهات اتصال تيليجرام",
            metaLeadsContacts: "جهات اتصال MetaLeads",
            searchPlaceholderAll: "اكتب هنا للبحث في جميع الحقول",
            searchPlaceholderFullname: "اكتب هنا للبحث بالاسم",
            searchPlaceholderEmail: "اكتب هنا للبحث بالبريد الإلكتروني",
            searchPlaceholderPhone: "اكتب هنا للبحث بالهاتف",
            searchPlaceholderWhatsapp: "اكتب هنا للبحث بواتساب",
            searchPlaceholderDefault: "بحث",
            searchFieldAll: "جميع الحقول",
            searchFieldName: "الاسم",
            searchFieldEmail: "البريد الإلكتروني",
            searchFieldPhone: "رقم الهاتف",
            searchFieldWhatsapp: "رقم واتساب",
            searchModePhoneDetected: "تم اكتشاف رقم الهاتف",
            searchModeEmailDetected: "تم اكتشاف عنوان البريد الإلكتروني",
            searchModeNotPhone: "ليس رقم هاتف",
            searchModeNotEmail: "ليس بريداً إلكترونياً",
            searchMode: "وضع البحث",
            searchModePhoneMessage: "تم اكتشاف \"{query}\" كرقم هاتف. أنت حالياً في حقل {field}. هل تريد البحث في حقل رقم الهاتف؟",
            searchModeEmailMessage: "تم اكتشاف \"{query}\" كعنوان بريد إلكتروني. أنت حالياً في حقل {field}. هل تريد البحث في حقل البريد الإلكتروني؟",
            searchModeNotPhoneMessage: "\"{query}\" ليس بتنسيق رقم الهاتف. هل تريد البحث في جميع الحقول أو حقل الاسم؟",
            searchModeNotEmailMessage: "\"{query}\" ليس بتنسيق البريد الإلكتروني. هل تريد البحث في جميع الحقول أو حقل الاسم؟",
            unknownTag: "غير معروف",
            noRecordsToDownload: "لا توجد سجلات للتنزيل",
            excelCreatedSuccess: "تم إنشاء ملف Excel بنجاح",
            exportCancelled: "تم إلغاء التصدير",
            excelCreateError: "حدث خطأ أثناء إنشاء ملف Excel",
            yes: "نعم",
            no: "لا",
            unowned: "غير معين",
            whatsappGroupCreatedSuccess: "تم إنشاء مجموعة عملاء واتساب بنجاح.",
            whatsappGroupCreateError: "حدث خطأ أثناء إنشاء مجموعة عملاء واتساب.",
            mailGroupCreatedSuccess: "تم إنشاء مجموعة عملاء البريد بنجاح.",
            mailGroupCreateError: "حدث خطأ أثناء إنشاء مجموعة عملاء البريد.",
            messageHistory: "سجل الرسائل",
            pastConversations: "المحادثات السابقة",
            defaultUser: "مستخدم",
            blockManagement: "إدارة الحظر",
            vipCustomer: "عميل VIP",
            startChat: "بدء المحادثة",
            createEvent: "إنشاء حدث",
            createTask: "إنشاء مهمة",
            selectTask: "اختر المهمة",
            webphoneCall: "الاتصال عبر Webphone",
            capiEventSend: "إرسال حدث CAPI",
            defaultName: "الزائر",
            notAvailable: "غير متوفر",
            relatedList: "القائمة ذات الصلة",
            adReferrals: "إحالات الإعلانات",
            calls: "المكالمات",
            generalInfo: "معلومات عامة",
            callHistory: "سجل المكالمات",
            webTab: "تبويب الويب",
            widgetUrlError: "تعذر إنشاء رابط الودجت",
            deleteSuccess: "تم حذف الزائر بنجاح.",
            taskStatusUpdateSuccess: "تم تحديث حالة المهمة بنجاح",
            taskStatusUpdateError: "حدث خطأ أثناء تحديث حالة المهمة",
            copyToClipboard: "تم النسخ إلى الحافظة",
            noPhoneNumber: "لا يوجد رقم للاتصال",
            webphoneCalling: "جاري الاتصال بـ {phoneNumber} عبر Webphone...",
            filterResultMax5000: "نتيجة الفلتر محدودة بحد أقصى 5000 جهة اتصال",
            onlyContactsPhoneNumber: "سيتم نقل جهات الاتصال التي لديها رقم هاتف فقط إلى المجموعة",
            enterGroupName: "أدخل اسم المجموعة",
            showInColumns: "عرض في الأعمدة",
            sendMailSucs: "تم إرسال البريد بنجاح",
            equal: "يساوي",
            notEqual: "لا يساوي",
            contains: "يحتوي",
            notContains: "لا يحتوي",
            startsWith: "يبدأ بـ",
            endWith: "ينتهي بـ",
            deletedCheckedUser: "حذف المستخدمين المحددين",
            userMails: "بريد المستخدمين"
        },
        chatbotv2: {
            Ticket_Actions: "إجراءات التذكرة",
            Task_Actions: "إجراءات المهمة",
            Contact_Actions: "إجراءات جهة الاتصال",
            Calendar_Actions: "إجراءات التقويم",
            "T-Soft_Actions": "إجراءات T-Soft",
            "Ticimax-V2_Actions": "إجراءات Ticimax ",
            TSOFT_SELECT_ORDER: "تحديد الطلب",
            TSOFT_ORDER_STATUS: "الحصول على حالة الطلب",
            TICIMAX_V2_SELECT_ORDER: "تحديد الطلب",
            TICIMAX_V2_ORDER_STATUS: "الحصول على حالة الطلب",
            Ikas_Actions: "إجراءات Ikas",
            IKAS_GET_MEMBER_INFO: "الحصول على تفاصيل العضو",
            IKAS_SELECT_ORDER: "اختيار الطلب",
            IKAS_ORDER_STATUS: "الحصول على حالة الطلب",
            IDEASOFT_PRODUCT_SEARCH: "بحث المنتج",
            privateMessageDescription: "الرسالة الخاصة مرئية فقط للممثلين وتظل مخفية عن الزوار.",
            AI_RANDOM_TEXT: "نص عشوائي بالذكاء الاصطناعي",
            AI_IMAGE: "صورة الذكاء الاصطناعي",
            PRIVATE_MESSAGE: "رسالة خاصة",
            aiPrompt: "موجه",
            variants: "المتغيرات",
            Zoho_Actions: "إجراءات زوهو",
            Table_Actions: "إجراءات الجدول",
            Cache_Actions: "إجراءات التخزين المؤقت",
            File_Actions: "إجراءات الملفات",
            Google_Drive_Actions: "إجراءات Google Drive",
            Artificial_Intelligence: "الذكاء الاصطناعي",
            Data_Formatters: "منسقات البيانات",
            Loop_Actions: "إجراءات التكرار",
            importSuccess: "تم استيراد القالب بنجاح",
            importFailed: "حدث خطأ أثناء استيراد القالب",
            creatingBlank: "إنشاء ChatBOT فارغ...",
            untitledChatbot: "ChatBOT لا يحتوي على عنوان",
            errorCreating: "حدث خطأ أثناء إنشاء ChatBOT",
            typeAutomationTitle: "اكتب عنوان الأتمتة",
            typeStoryTitle: "أكتب عنوان القصة",
            setUpUpYourChatbot: "إعداد روبوت الدردشة الآلي الخاص بك",
            setUpUpYourChatbotDesc: "تدريب روبوت الدردشة الآلي الخاص بك باستخدام البيانات، استخدم قوالبنا الجاهزة للاستخدام أو ابدأ من الصفر.",
            blankBot: "روبوت فارغ",
            blankBotDesc: "إنشاء روبوت محادثة فارغ يمكنك تدريبه وتخصيصه لاحقًا.",
            aiBotDesc: "إنشاء روبوت دردشة ذكاء اصطناعي يعتمد على RAG. أضف قاعدة معرفة واختر نموذج LLM.",
            recommended: "موصى به",
            websiteDesc: "فحص محتوى موقعك الإلكتروني للحصول على إجابات لأسئلة المستخدمين الشائعة.",
            yourNeedEnterEnterYourOpenAi: "تحتاج إلى إدخال مفتاح OpenAI API الخاص بك لإنشاء روبوت دردشة آلي عن طريق الزحف إلى موقعك الإلكتروني.",
            createOpenAiKey: "إنشاء مفتاح واجهة برمجة التطبيقات",
            aiKnowledge: "معرفة الذكاء الاصطناعي",
            modalUsage: "استخدام مشروط",
            usedContentSources: "مصادر المحتوى المستخدمة",
            websites: "مواقع الويب",
            articles: "المقالات",
            faq: "الأسئلة الشائعة",
            files: "الملفات",
            functions: "الوظائف",
            settings: "الإعدادات",
            disableAi: "تعطيل الذكاء الاصطناعي",
            enableAi: "تمكين الذكاء الاصطناعي",
            lastEdited: "آخر تعديل",
            state: "الحالة",
            frequentlyAskedQuestions: "الأسئلة المتداولة (FAQ)",
            faqIsCreated: "الأسئلة الشائعة التي تم إنشاؤها",
            selectKnowEnabled: "تمكين قواعد المعرفة المحددة...",
            selectKnowDisabled: "تم تعطيل قواعد المعرفة المحددة...",
            selectKnowNotEnabled: "قواعد المعرفة المحددة غير ممكّنة...",
            selectKnowNotDisabled: "قواعد المعرفة المحددة غير معطلة.",
            answered: "تمت الإجابة",
            answer: "تمت الإجابة",
            addFile: "إضافة ملف",
            fileDeleted: "تم حذف الملفات",
            fileDeletedFailed: "كانت هناك مشكلة في حذف الملفات",
            noFileAdded: "لم تتم إضافة أي ملف",
            aiFunctions: "وظائف الذكاء الاصطناعي",
            addFunction: "إضافة دالة",
            aiFunctionCreateHint: "لا تستخدم أحرفاً خاصة عند إنشاء دوال الذكاء الاصطناعي. استخدم فقط الأحرف الإنجليزية والأرقام والشرطات السفلية في أسماء الدوال.",
            builtInFunctionsTitle: "الدوال المدمجة",
            builtInFunctionsDesc: "هذه دوال محددة مسبقاً يمكن للذكاء الاصطناعي استخدامها.",
            builtInFunctionsOptionButtonsTitle: "الذكاء الاصطناعي يمكنه إرسال رسائل بأزرار",
            builtInFunctionsOptionButtonsDesc: "يتيح للذكاء الاصطناعي عرض أزرار قابلة للنقر للمستخدم. عند التفعيل، يمكن للذكاء الاصطناعي تقديم أزرار خيارات للمستخدم.",
            builtInFunctionsCloseConversationTitle: "الذكاء الاصطناعي يمكنه إنهاء المحادثة",
            builtInFunctionsCloseConversationDesc: "يتيح للذكاء الاصطناعي إنهاء المحادثة عند الحاجة. عند التفعيل، يمكن للذكاء الاصطناعي إغلاق المحادثة.",
            builtInFunctionsTransferChatTitle: "الذكاء الاصطناعي يمكنه التحويل للدعم المباشر",
            builtInFunctionsTransferChatDesc: "يتيح للذكاء الاصطناعي تحويل المحادثة للدعم المباشر عند الحاجة. عند التفعيل، يمكن للذكاء الاصطناعي تحويل المحادثة لممثل بشري.",
            parameterCount: "عدد المعلمات",
            auto: "تلقائي",
            usedByAI: "يستخدمه الذكاء الاصطناعي",
            usedByAi: "مستخدم من قبل الذكاء الاصطناعي",
            notUsed: "غير مستخدم",
            saveAndClose: "حفظ وإغلاق",
            contentPreview: "معاينة المحتوى",
            addContent: "إضافة محتوى",
            populerUserQuestion: "مسح محتوى موقع الويب الخاص بك للحصول على إجابات لأسئلة المستخدم الشائعة",
            enterUrlAddress: "أدخل عنوان URL",
            sharingYourUrl: "من خلال مشاركة عنوان URL الخاص بك، فإنك تؤكد أن لديك الحقوق اللازمة لمشاركة محتواه.",
            pageSelected: "الصفحات المحددة",
            trainChatbot: "تدريب روبوت الدردشة",
            thereAreOnePages: "توجد صفحة واحدة بالداخل",
            categoryDesc: "الفئة. اختر الفئة التي تريد استخدامها لتدريب نموذج الذكاء الاصطناعي الخاص بك.",
            scarpOrAddContent: "قص أو إضافة محتوى، يمكن لمساعد الذكاء الاصطناعي استخدامه للرد على استفسارات عملائك",
            noContentAdded: "لا يوجد محتوى مضاف",
            howItWorks: "كيف يعمل",
            editEntries: "تحرير الإدخالات",
            newEntries: "إدخالات جديدة",
            chatbotManagement: "إدارة روبوت المحادثة",
            chatbotScenarioList: "قائمة شينيريو الدردشة الآلية",
            exportDiagramToClipboard: "تصدير الرسم البياني إلى الحافظة",
            selectedStory: "{count} قصة محددة",
            Meta_Actions: "إجراءات ميتا",
            suppressionRemoved: "تمت إزالة القمع",
            suppressionAdded: "تمت إضافة القمع",
            didntSuppression: "لم تقم بأي قمع.",
            whatsappIntegrationTitle: "تكامل واتساب V1 وواتساب V2",
            whatsappApiIntegrationTitle: "تكامل واجهة برمجة تطبيقات واتساب للأعمال",
            ReadyTemplateBadge: "قالب جاهز",
            readyTemplates: "قوالب جاهزة",
            regex: "Regex",
            regexDescription: "التقاط أي شيء باستخدام Regex",
            chatbotLogo: "شعار الدردشة الآلية",
            chatbotName: "اسم الدردشة الآلية",
            allSecnario: "قائمة سيناريوهات Chatbot",
            ChatbotScenarioList: "قائمة سيناريوهات Chatbot",
            Scenario: "سيناريو",
            filters: {
                equal: "مساوي ل",
                not_equal: "ليس متساويًا",
                contain: "يحتوي",
                not_contain: "لا تحتوي",
                starts_with: "ابدا ب",
                ends_with: "ينتهي",
                empty: "فارغ",
                non_empty: "غير فارغ",
                longer_than: "اطول من",
                shorter_than: "اقصر من",
                less_than: "أقل من",
                less_or_equal: "أقل أو متساوية",
                greater_than: "أكثر من",
                greater_or_equal: "أكبر من أو يساوي"
            },
            planRequired: "{integratable} الخطة المطلوبة",
            noDefaultStoryTitle: "قصة افتراضية",
            noDefaultStory: "لا توجد قصة افتراضية.",
            noMessage: "لا توجد رسالة",
            loading: "تحميل",
            loadMore: "تحميل المزيد",
            hostname: "اسم المضيف",
            goToStory: "اذهب إلى القصة",
            noResultFound: "لم يتم العثور على نتائج",
            checkYourFilterCombination: "تحقق من مزيج المرشح الخاص بك",
            clearYourSearch: "امسح بحثك",
            andTryAgain: "وحاول مرة أخرى",
            allTemplates: "جميع القوالب",
            allAITemplates: "جميع قوالب الذكاء الاصطناعي",
            templatesFromTheIndustry: "قوالب من الصناعة",
            basicTemplate: "القالب الأساسي",
            proTemplate: "قالب متقدم",
            withBot: "& bot",
            userWithBot: "المستخدم والوبوت",
            chatDetail: "تفاصيل الدردشة",
            allUserDetail: "انظر كل تفاصيل المستخدم",
            sessionData: "بيانات الجلسة",
            supsisChatWidget: "supsis دردشة القطعة",
            integratedWith: "تتكامل مع :",
            botStory: "قصة الروبوت",
            integration: "اندماج",
            Users: "مستخدم",
            user_id: "معرف المستخدم",
            categories: "فئات",
            worksWith: "يعمل مع",
            importBot: "استيراد روبوت",
            keyFeatures: "دلائل الميزات",
            importing: "الاستيراد",
            comingSoon: "قريباً",
            pickStory: "اختر قصة",
            conversationId: "معرف المحادثة",
            integrateStoryWithSupsisWidget: "دمج أداة Supsis مع قصة chatbot",
            integrateStoryWithWhatsapp: "دمج WhatsApp مع قصة chatbot",
            integrateStoryWithInstagram: "دمج Instagram مع قصة chatbot",
            selectIntegratingStory: "حدد القصة التي سيتم دمجها",
            install: "تثبيت",
            attr: {
                weekday: "يوم الأسبوع",
                channelId: "القناة",
                email: "بريد إلكتروني",
                phone: "هاتف",
                language: "لغة",
                timezone: "وحدة زمنية",
                gender: "جنس",
                country: "دولة",
                referrer: "المرجع",
                department: "قسم",
                url: "عنوان URL",
                ip: "IP",
                last_seen: "اخر ظهور",
                name: "اسم",
                user_id: "معرف المستخدم",
                message: "رسالة",
                akinon_brand: "ماركة",
                akinon_order_id: "رقم التعريف الخاص بالطلب",
                akinon_product_id: "معرف المنتج",
                akinon_user_id: "معرف المستخدم",
                akinon_user_name: "اسم المستخدم",
                akinon_user_email: "البريد الالكتروني للمستخدم",
                akinon_invoice_url: "عنوان URL فاتورة",
                akinon_order_status: "حالة الطلب",
                akinon_order_price: "سعر الطلب",
                akinon_shipper_name: "اسم المورد",
                akinon_product_size: "حجم المنتج",
                akinon_sku: "SKU",
                akinon_product_url: "عنوان URL للمنتج",
                akinon_product_title: "عنوان المنتج",
                akinon_product_image: "صورة المنتج",
                akinon_product_stock: "مخزون المنتج",
                akinon_order_date: "تاريخ الطلب",
                akinon_track_number: "رقم الشاحنة",
                akinon_track_url: "تتبع عنوان URL",
                akinon_latitude: "خط العرض",
                akinon_longitude: "خط الطول",
                idleUserTime: "آخر إجراء للمستخدم (بالثواني)",
                ai_class_result: "نتيجة تصنيف الذكاء الاصطناعي",
                meta_comment_id: "معرف تعليق ميتا",
                meta_comment: "تعليق ميتا",
                meta_post_id: "معرف منشور ميتا",
                last_meta_post_id: "آخر معرف مشاركة",
                last_meta_post_caption: "آخر تسمية مشاركة",
                last_meta_post_type: "آخر نوع مشاركة",
                visitor_trigger_type: "نوع مشغل الزائر",
                visitor_trigger_name: "اسم مشغل الزائر",
                ideasoft_user_id: "معرف العضو",
                ideasoft_invoice_url: "رابط الفاتورة",
                ideasoft_order_id: "رقم الطلب",
                ideasoft_order_status: "حالة الطلب",
                ideasoft_order_price: "سعر الطلب",
                ideasoft_shipper_name: "اسم الشاحن",
                ideasoft_product_size: "حجم المنتج",
                ideasoft_sku: "رمز المنتج",
                ideasoft_product_url: "رابط المنتج",
                ideasoft_product_title: "عنوان المنتج",
                ideasoft_product_image: "صورة المنتج",
                ideasoft_product_stock: "مخزون المنتج",
                ideasoft_order_date: "تاريخ الطلب",
                ideasoft_track_number: "رقم التتبع",
                ideasoft_track_url: "رابط التتبع",
                offline_mode: "وضع غير متصل بالشبكة",
                available_agents: "الوكلاء المتاحين",
                probel_sube_kodu: "كود الفرع",
                probel_brans_adi: "اسم الفرع",
                probel_brans_kodu: "كود الفرع",
                probel_doktor_adi: "اسم الطبيب",
                probel_doktor_kodu: "كود الطبيب",
                probel_poliklinik_adi: "اسم العيادة",
                probel_poliklinik_kodu: "كود العيادة",
                probel_randevu_tarihi: "تاريخ الموعد",
                probel_date: "تاريخ الموعد",
                probel_randevu_saati: "وقت الموعد",
                probel_randevu_id: "معرف الموعد",
                probel_hasta_token: "رمز المريض",
                probel_kimlik_tipi: "نوع الهوية",
                probel_kimlik_no: "رقم الهوية",
                probel_hasta_adi: "اسم المريض",
                probel_hasta_soyadi: "لقب المريض",
                probel_hasta_cinsiyet: "الجنس",
                probel_hasta_dogum_tarihi: "تاريخ الميلاد",
                probel_hasta_telefon: "الهاتف",
                platform: "منصة",
                hour: "ساعة",
                segments: "الشرائح",
                tags: "الوسوم",
                ticket: "تذكرة",
                metaReferrals: "إحالات ميتا",
                owner: "المالك",
                trendyol_question: "سؤال المنتج",
                trendyol_question_id: "معرف سؤال المنتج",
                trendyol_product_id: "معرف المنتج",
                trendyol_product: "بيانات المنتج",
                id: "المعرف",
                conversationId: "معرف المحادثة",
                b2cargo_companyCode: "رمز الشركة",
                b2cargo_takipNo: "رقم التتبع",
                b2cargo_takipseri: "السلسلة",
                b2cargo_evrakdurum: "حالة الطلب",
                b2cargo_teslimtar: "تاريخ التسليم",
                b2cargo_gonderen: "اسم المرسل",
                b2cargo_aliciAdi: "اسم المستلم",
                b2cargo_cikisIl: "محافظة المغادرة",
                b2cargo_varisIl: "محافظة الوصول",
                b2cargo_teslim: "حالة المنتج",
                b2cargo_urun: "نوع المنتج",
                b2cargo_atfTarih: "تاريخ ATF للمنتج",
                b2cargo_palet: "البليت",
                b2cargo_koli: "الطرد",
                b2cargo_kg: "الوزن",
                b2cargo_desi: "الديسي",
                b2cargo_zimmetno: "رقم التسليم",
                b2cargo_varissube: "فرع الوصول",
                b2cargo_atfDurum: "حالة ATF",
                holiday_plus_room_id: "معرف الغرفة",
                holiday_plus_room_title: "عنوان الغرفة",
                holiday_plus_room_description: "وصف الغرفة",
                holiday_plus_room_size: "حجم الغرفة",
                holiday_plus_room_price: "سعر الغرفة",
                holiday_plus_room_price_offer: "عرض سعر الغرفة",
                holiday_plus_room_discount_price: "سعر خصم الغرفة",
                holiday_plus_selected_hotel_id: "معرف الفندق المحدد",
                holiday_plus_checkin: "تاريخ الوصول",
                holiday_plus_checkout: "تاريخ المغادرة",
                holiday_plus_child_count: "عدد الأطفال",
                holiday_plus_adult_count: "عدد البالغين",
                holiday_plus_child_dates: "تواريخ الأطفال",
                reservation_time: "وقت الحجز",
                reservation_day: "يوم الحجز"
            },
            storyList: "قائمة القصة",
            douYouWannaDeleteItem: "هل تريد حذف هذا البند؟",
            douYouWannaDeleteWithChildren: "هل تريد حذف هذا العنصر مع أطفاله؟",
            stories: "قصص",
            templates: "قوالب",
            aitemplates: "قوالب الذكاء الاصطناعي",
            integrations: "التكامل",
            all: "الجميع",
            installed: "المثبتة",
            installationOK: "المثبتة",
            uninstall: "الغاء التثبيت",
            remainingMessageDesc: "الرسائل المجانية المتبقية:",
            openAISiteRoutingDescStart: "يمكنك النقر على الرابط",
            openAISiteRoutingDescEnd: "للحصول على مفتاح API.",
            integrationOK: "مدمج",
            chatWidget: "supsis دردشة القطعة",
            artificialIntelligence: "الذكاء الاصطناعي",
            integratePlatform: "يمكن دمج chatbot مع {integretable}.",
            integrateOpenAIWithChatbot: "دمج الدردشة GPT-4 مع chatbot",
            integrateChatBotWithChatGPT3: "تكامل chatbot مع الدردشة GPT-4",
            integrateStoryWithTelegram: "دمج القصة مع Telegram",
            webhooks: "Webhooks",
            archive: "أرشيف",
            reports: "التقارير",
            uncheckAll: "إلغاء تحديد الكل",
            userSegments: "شرائح المستخدم",
            sandbox: "سلة المهملات",
            sandboxPage: {
                title: "سيناريوهات الشات بوت المحذوفة",
                description: "سيتم حذف السيناريوهات المحذوفة تلقائياً بعد 30 يوماً في سلة المهملات",
                emptyState: "لا توجد سيناريوهات محذوفة في سلة المهملات",
                unnamedScenario: "سيناريو بدون عنوان",
                restore: "استعادة",
                permanentlyDelete: "حذف نهائي",
                unknown: "غير معروف",
                user: "مستخدم",
                restoreConfirmTitle: "هل أنت متأكد أنك تريد استعادة هذا السيناريو؟",
                restoreConfirmContent: "سيتم استعادة سيناريو {story}.",
                restoreSuccess: "تم استعادة السيناريو بنجاح",
                restoreError: "فشل الاستعادة",
                permanentDeleteConfirmTitle: "هل أنت متأكد أنك تريد حذف هذا السيناريو نهائياً؟",
                permanentDeleteConfirmContent: "لا يمكن التراجع عن هذا الإجراء. سيتم حذف السيناريو نهائياً.",
                permanentDeleteSuccess: "تم حذف السيناريو نهائياً",
                permanentDeleteError: "فشلت عملية الحذف",
                loadError: "خطأ في تحميل السيناريوهات المحذوفة"
            },
            customBlocks: "الكتل المخصصة",
            blockMarket: "سوق الكتل",
            browseBlockMarket: "تصفح سوق الكتل",
            searchBlocks: "البحث في الكتل...",
            unknownBlock: "كتلة غير معروفة",
            aiModelsComparison: "مقارنة نماذج الذكاء الاصطناعي",
            aiModelsChangeModel: "تغيير النموذج",
            aiModelsRecommended: "موصى به",
            aiModelsEconomic: "اقتصادي",
            aiModelsCodex: "Codex",
            comingSoonVectorIntro: "مع تخزين OpenAI المتجه، يمكنك تدريب الشات بوت بمحتواك المخصص.",
            comingSoonStep1Title: "رفع ملفاتك",
            comingSoonStep1Desc: "أضف ملفات PDF أو Word أو Excel أو النصوص أو المستندات الأخرى إلى النظام.",
            comingSoonStep2Title: "المعالجة التلقائية",
            comingSoonStep2Desc: "يتم تحليل ملفاتك بواسطة OpenAI وتحويلها إلى تنسيق متجه.",
            comingSoonStep3Title: "ردود ذكية",
            comingSoonStep3Desc: "يقدم الشات بوت ردودًا دقيقة وذات مغزى بناءً على المحتوى الذي قمت برفعه.",
            comingSoonTip: "نصيحة: كلما أضفت المزيد من المحتوى، تتوسع قاعدة معرفة الشات بوت ويمكنه تقديم ردود أكثر شمولاً.",
            comingSoonGotIt: "فهمت",
            imageProcessingSettings: {
                title: "إعدادات معالجة الصور",
                description: "حدد كيفية معالجة الصور المرسلة إلى الشات بوت.",
                processingMode: "وضع المعالجة",
                processWithBlock: "المعالجة مع الكتلة",
                processWithBlockDesc: "توجيه الصور إلى تدفق الكتلة المحلي",
                processWithAI: "المعالجة مع الذكاء الاصطناعي",
                processWithAIDesc: "معالجة الصور بالذكاء الاصطناعي",
                fallbackBlock: "كتلة الاحتياط",
                fallbackBlockDesc: "الكتلة التي سيتم التوجيه إليها عند حدوث خطأ أثناء معالجة الصور",
                fallbackBlockPlaceholder: "اختر كتلة الاحتياط",
                directJumpBlock: "كتلة القفز المباشر",
                directJumpBlockDesc: "توجيه جميع الصور مباشرة إلى هذه الكتلة",
                directJumpBlockPlaceholder: "اختر كتلة القفز المباشر (اختياري)",
                aiProcessingMode: "وضع معالجة الذكاء الاصطناعي",
                processIndividual: "المعالجة واحدة تلو الأخرى",
                processIndividualDesc: "إرسال كل صورة إلى الذكاء الاصطناعي بشكل منفصل",
                processParallel: "المعالجة بالتوازي",
                processParallelDesc: "جمع الصور خلال فترة زمنية محددة وإرسالها معاً",
                bufferTime: "مدة المخزن المؤقت (ثواني)",
                bufferTimeDesc: "الوقت الانتظار لجمع الصور",
                saveSuccess: "تم تحديث إعدادات معالجة الصور بنجاح",
                saveError: "حدث خطأ أثناء حفظ الإعدادات"
            },
            addSegment: "إضافة الجزء",
            addToSegment: "أضف إلى المقطع",
            removeFromSegment: "ترفع من الجزء",
            plansVTippyContent: "سيتم الفوترة لهذه الحزمة في بداية كل شهر ، وفي حالة رغبتك في الإلغاء ، سيتم فرض رسوم على استخدامك حتى بداية الشهر وستنتهي حزمتك.<br><br>سعر الحزمة هو سعر خارجي لضريبة القيمة المضافة.<br><br>تظهر التغييرات في الحزمة في الفاتورة في اليوم التالي.",
            segmentName: "اسم الجزء",
            sameSegment: "هناك قطاع بنفس الاسم!",
            usersInSegment: "المستخدمون في المقطع",
            noUsersAdded: "لم يضف أي مستخدمين",
            updateSegment: "تحديث الجزء",
            newSegment: "شريحة جديدة",
            selectAll: "اختر الكل",
            queriesSelected: "الاستعلامات المحددة",
            noBlocksFound: "لم يتم العثور على كتل!",
            userQuery: "استعلام المستخدم",
            date: "تاريخ",
            unmatched: "لا مثيل له",
            goToChat: "اذهب للدردشة",
            selectStory: "حدد القصة",
            selectBlock: "حدد كتلة",
            training: "تمرين",
            trainingAlert: "لتنفيذ التغييرات التي أجريتها في صفحة تدريب الروبوت، يجب عليك نشر النسخة الجديدة من السيناريو الذي قمت بتعديله.",
            unmatchedPhrases: "عبارات لا مثيل لها",
            ignored: "تجاهل",
            story: "قصة",
            timePeriod: "فترة زمنية",
            wholeTimeSpan: "فترة زمنية كاملة",
            selectAStory: "حدد قصة",
            searchUserQuery: "البحث عن استعلام المستخدم",
            time: {
                today: "اليوم",
                yesterday: "أمس",
                last7: "اخر 7 ايام",
                last30: "آخر 30 يومًا",
                "this-month": "هذا الشهر",
                "last-month": "الشهر الماضي",
                "last-3-month": "آخر 3 أشهر",
                "this-year": "هذا العام",
                "last-year": "العام الماضي",
                custom: "اختر تاريخًا مختلفًا"
            },
            emailProvider: "مزوِّد بريد إلكتروني",
            triggerFromAnywhere: "الزناد من أي مكان",
            allIntegrations: "جميع التكامل",
            integrateYourCBwithChatWidget: "دمج chatbot الخاص بك مع القطعة الدردشة.",
            integrateYourCBwithChatGpt3: "يمكن دمج chatbot مع GPT-4. مفتاح GPT-4 API المطلوب.",
            integrateYourCBwithWebHook: "تمرير معلومات الدردشة بين chatbot وخدمات الويب الخاصة بك بسهولة.",
            integrateYourCBwithIntegratable: "تمرير معلومات الدردشة بين chatbot و {integratable} بسهولة.",
            addWebhook: "إضافة webhook",
            editWebhook: "تحرير webhook",
            newWebhook: "خطاف ويب جديد",
            webhookTitle: "عنوان خطاف الويب",
            webhookUrl: "رابط خطاف الويب",
            webhookToken: "رمز webhook",
            webhookUsername: "Webhook اسم المستخدم",
            webhookPassword: "كلمة مرور webhook",
            editBlock: "يحرر",
            moveBlock: "يتحرك",
            copyBlock: "ينسخ",
            addFilter: "إضافة مرشح",
            addFilterGroup: "إضافة مجموعة مرشح",
            clearFilter: "مسح المرشح",
            in: "في",
            and: "و",
            or: "أو",
            chatbot: "روبوت الدردشة",
            allStories: "كل القصص",
            addBot: "إنشاء بوت",
            testBot: "اختبر روبوتك",
            publish: "ينشر",
            editName: "تعديل الاسم",
            search: "ابحث في قصتك ...",
            typeMoreThan3Char: "اكتب 3 حرف على الأقل",
            expand: "يوسع",
            expandAll: "توسيع الكل",
            noMatchingItem: "لا يوجد عنصر مطابق",
            hint: "تَلمِيح",
            select: "يختار",
            navigate: "التنقل",
            dismiss: "رفض",
            choseAttribute: "اختار السمة",
            selectReply: "حدد الرد",
            preview: "معاينة",
            draft: "مسودة",
            lastUpdate: "اخر تحديث",
            published: "نشرت",
            newStory: "قصة جديدة",
            updateStory: "تحديث القصة",
            storyDescription: "وصف القصة",
            storyTitle: "عنوان القصة",
            deleteSingleBlock: "حذف كتلة واحدة",
            deleteWithChildren: "حذف مع الأطفال",
            startTestFromHere: "ابدأ الاختبار من هنا",
            copyBlockId: "نسخ معرف الكتلة",
            gotoLiveLink: "اذهب إلى الرابط المباشر",
            copyBlockIdSuccessfull: "تم نسخ معرف الكتلة إلى الحافظة",
            collapse: "ينهار",
            collapseAll: "انهيار جميع",
            snDelay: "تأخير {delay} ثانية",
            blockUpdated: "كتلة تحديث",
            addPayload: "إضافة الحمولة",
            previewModeCaution: "أنت الآن تقوم بمعاينة أحد إصدارات قصتك. لا يمكنك حفظ التغييرات في وضع المعاينة!",
            enterText: "أدخل النص...",
            trackpad: "لوحة التتبع",
            navigation: "ملاحة",
            navigationDesc: "يرجى اختيار وضع التنقل الخاص بك. الأمر متروك لك إذا كان سيتم تتبعه أو الماوس.",
            botSetting: "إعداد الروبوت",
            botSettingDesc: "يرجى تعيين مستوى الثقة. هذه نسبة مئوية بين 0 و 100. يحدد المستوى صحة chatbot التي ترتبط بمدخلات المستخدم.",
            languageSettingsDesc: "يرجى التأكد من أن لغة الروبوت التي تستجيب لها هي لغتك المفضلة.",
            mouse: "الفأر",
            Interactions: "التفاعلات",
            Actions: "أجراءات",
            Supsis_Actions: "تصرفات supsis",
            Shopify_Actions: "الإجراءات المتسوق",
            Akinon_Actions: "أفعال أكينون",
            IdeaSoft_Actions: "إجراءات Ideasoft",
            START_POINT: "نقطة البداية",
            AI_ASSISTANT: "مساعد الذكاء الاصطناعي",
            BOT_RESPONSE: "استجابة الروبوت",
            AI_BOT_RESPONSE: "استجابة الذكاء الاصطناعي (GPT-4o)",
            AI_CLASSIFICATION: "تصنيف الذكاء الاصطناعي",
            Templates: "كتل القوالب",
            AI_MENU_FLOW: "قائمة الذكاء الاصطناعي",
            OTP_WHATSAPP_FLOW: "OTP واتساب",
            OTP_SMS_FLOW: "OTP SMS",
            RUN_JAVASCRIPT: "تشغيل JavaScript",
            OTP_MAIL_FLOW: "OTP البريد",
            AI_INSTAGRAM_FLOW: "تعليق إنستغرام بالذكاء الاصطناعي",
            PLATFORM_FLOW: "المنصة",
            DEFAULT_FALLBACK: "الافتراضي",
            FILTER: "منقي",
            addNewFilter: "إضافة مرشح جديد",
            FLOW: "تدفق",
            ATTACHMENT_INPUT: "إدخال المرفق",
            USER_INPUT: "إدخال المستخدم",
            GO_TO_STEP: "اذهب إلى الخطوة",
            WEBHOOK: "webhook",
            SET_ATTRIBUTE: "تعيين السمة",
            QUESTION: "سؤال",
            CLOSE_CHAT: "إغلاق الدردشة",
            CREATE_TICKET: "إنشاء تذكرة",
            TRANSFER_CHAT: "نقل الدردشة",
            TRANSFER_TO_CHATBOT: "التوجيه إلى روبوت الدردشة",
            TAG_CHAT: "إضافة وسم",
            REMOVE_TAG: "إزالة الوسم",
            SET_DEPARTMENT: "تعيين القسم",
            SEND_TRANSCRIPT: "إرسال النص",
            SEND_SMS: "إرسال رسالة SMS",
            SEND_MAIL: "إرسال بريد",
            CREATE_EVENT: "إنشاء حدث",
            CREATE_RESERVATION: "إنشاء حجز",
            RESERVATION_OPEN_URL: "فتح صفحة الحجز",
            RESERVATION_SELECT_DAY: "اختيار يوم الحجز",
            RESERVATION_SELECT_TIME: "اختيار وقت الحجز",
            RESERVATION_EVENT_LIST: "قائمة حجوزات الزائر",
            CREATE_TASK: "إنشاء مهمة",
            SHOPIFY_SHOW_PRODUCTS: "Shopify Show Products",
            SHOPIFY_PRODUCT_AVAILABILITY: "توافر المنتج المتسوق",
            SHOPIFY_ORDER_STATUS: "حالة الطلب المتسوق",
            AKINON_SHOW_PRODUCTS: "Akinon عرض المنتجات",
            AKINON_FIND_PRODUCT: "AKINON Find Product",
            AKINON_ORDER_STATUS: "حالة أمر AKINON",
            AKINON_SELECT_ORDER: "AKINON SELECT ORDER",
            AKINON_SELECT_SIZE: "AKINON SELECT SIZE",
            AKINON_FIND_NEAREST_STOCK: "عرض مخزن المتجر",
            AKINON_FIND_NEAREST_STORES: "عرض أقرب المتاجر",
            AKINON_SHOW_DISCOUNT_CODES: "عرض رموز الخصم",
            IDEASOFT_SELECT_ORDER: "تحديد الطلب",
            IDEASOFT_ORDER_STATUS: "الحصول على حالة الطلب",
            IDEASOFT_GET_MEMBER_INFO: "ملء معلومات العضو",
            MESSENGER_SEND_MESSAGE: "إرسال رسالة ماسنجر",
            INSTAGRAM_SEND_MESSAGE: "إرسال رسالة إنستغرام",
            INSTAGRAM_COMMENT_REPLY: "الرد على التعليق",
            INSTAGRAM_COMMENT_DELETE: "حذف التعليق",
            INSTAGRAM_COMMENT_SHOW: "عرض التعليق",
            INSTAGRAM_COMMENT_HIDE: "إخفاء التعليق",
            INSTAGRAM_COMMENT_REPLY_AS_PRIVATE: "الرد بشكل خاص",
            followingAttributesFilled: "سوف تأتي السمات التالية مملوءة.",
            GET_LOCATION: "احصل على الموقع",
            FALLBACK: "تراجع",
            SUCCESS: "نجاح",
            FAILURE: "فشل",
            message: "رسالة",
            condition: "حالة",
            score: "نتيجة",
            equal: "متساوي",
            not_equal: "ليس متساويًا",
            contain: "يحتوي",
            not_contain: "لا تحتوي",
            starts_with: "ابدا ب",
            ends_with: "ينتهي",
            empty: "فارغ",
            longer_than: "اطول من",
            shorter_than: "اقصر من",
            less_than: "أقل من",
            less_than_equal: "أقل من متساوٍ",
            greater_than: "أكثر من",
            greater_than_equal: "أكبر من المتساوية",
            value: "قيمة",
            failures: "الفشل",
            email: "بريد إلكتروني",
            name: "اسم",
            username: "اسم المستخدم",
            source: "مصدر",
            language: "لغة",
            timezone: "وحدة زمنية",
            region: "منطقة",
            country: "دولة",
            referrer: "المرجع",
            url: "عنوان URL",
            ip: "IP",
            city: "مدينة",
            lastSeen: "اخر ظهور",
            userId: "معرف المستخدم",
            selectStep: "حدد الخطوة",
            keywords: "الكلمات الدالة",
            userSays: "يقول المستخدم",
            addKeyword: "أضف الكلمة الرئيسية",
            addUserMessage: "أضف رسالة المستخدم",
            set: "تعيين",
            to: "ل",
            gender: "جنس",
            go_to_failure: "اذهب إلى الفشل",
            go_to_success: "اذهب إلى النجاح",
            untilFilled: "حتى تملأ",
            time1: "مرة واحدة",
            time2: "2 مرات",
            time3: "ثلاث مرات",
            time4: "4 مرات",
            time5: "5 مرات",
            any: "أي",
            anytext: "أي نص",
            anytextDescription: "يطابق الكلمات والمسافات فقط",
            alphanumeric: "أبجدي رقمي",
            integer: "عدد صحيح",
            no: "لا",
            number: "رقم",
            phone: "هاتف",
            yes: "نعم",
            yesNo: "نعم / لا",
            anyDescription: "يطابق أي شيء غير فارغ.",
            alphanumericDescription: "يطابق كل من الرسائل والأرقام",
            integerDescription: "يطابق رقم عدد صحيح",
            noDescription: "لا يطابق أي مرادفات",
            numberDescription: "يطابق الرقم الترتيبي والكارد",
            phoneDescription: "يطابق رقم الهاتف",
            yesDescription: "تطابق نعم المرادفات",
            yesNoDescription: "تطابق نعم ولا مرادفات",
            emailDescription: "تطابق البريد الإلكتروني",
            urlDescription: "يطابق عنوان URL",
            temperature: "درجة حرارة",
            askWhenInvalid: "اسأل عندما غير صالح",
            applyFilter: "تطبيق المرشح",
            RANDOM_TEXT: "نص عشوائي",
            QUICK_REPLY: "رد سريع",
            FILE: "ملف",
            notificationMessageStartSuccess: "الكتلة",
            notificationMessageEndSuccess: "تمت إضافة",
            notificationMessageStartError: "حدث خطأ ، الكتلة",
            notificationMessageEndError: "لم تتم إضافته",
            blockChangedWannaUpdate: "أريد التحديث تغيير",
            responses: "استجابات",
            TEXT: "نص",
            IMAGE: "صورة",
            GALLERY: "صالة عرض",
            BUTTON: "زر",
            flow: "تدفق",
            active: "نشيط",
            passive: "سلبي",
            chooseAttributeType: "اختر نوع السمة",
            imageAttachment: "مرفق الصورة",
            audioAttachment: "مرفق الصوت",
            videoAttachment: "مرفق الفيديو",
            documentAttachment: "مرفق المستند",
            anyAttachment: "أي ارتباط",
            typeAttributeValue: "اكتب قيمة السمة",
            typeSearchValue: "اكتب قيمة البحث",
            addAttribute: "اضف ميزة",
            addAttributeDescription: "لا يمكن أن يحتوي اسم السمة على أحرف أبجدية رقمية فقط هي الحروف A-Z أو NUMBERS 0-9 أو DASH أو SHOFSCORE.",
            male: "ذكر",
            USER_DATA: "بيانات المستخدم",
            CUSTOM_ATTRIBUTES: "سمات مخصصة",
            enterBotResponseHere: "أدخل استجابة الروبوت هنا ...",
            enterPrivateBotResponseHere: "أدخل الرسالة الخاصة التي سيرسلها البوت...",
            addCard: "إضافة بطاقة",
            addButton: "إضافة زر",
            typeCardTitle: "اكتب عنوان البطاقة",
            typeCardDescription: "اكتب وصف البطاقة",
            dragAndDropBrowse: "سحب وإسقاط تصفح",
            dragAndDropBrowseFile: "رفع ملف",
            button: "زر",
            enterYourMessage: "أدخل رسالتك",
            imageView: "عرض الصورة",
            imageUploading: "تحميل الصور",
            fileUploading: "تحميل الملف ...",
            clickToChooseNewImage: "انقر لاختيار صورة جديدة",
            clickToChooseNewFile: "انقر لاختيار ملف جديد",
            removeTheExistingOne: "إزالة واحد الموجود",
            validateResponseWithEntity: "التحقق من صحة الاستجابة مع الكيان",
            actionOnFailureInput: "عمل على مدخلات الفشل",
            askNextQuestion: "اطرح السؤال التالي",
            goToSuccessBlock: "اذهب إلى كتلة النجاح",
            goToFailureBlock: "اذهب إلى كتلة الفشل",
            saveResposeToAttribute: "حفظ respose ليعزو",
            selectReplyType: "حدد نوع الرد",
            questionVariants: "المتغيرات سؤال",
            systemEntities: "كيانات النظام",
            delay: "تأخير",
            retrySectionTextPart: "بسأل",
            retrySectionText: "، إذا كانت استجابة المستخدم غير صالحة",
            addNextQuestion: "أضف السؤال التالي",
            typeBlockTitle: "اكتب عنوان الكتلة",
            versionHistory: "تاريخ النسخة",
            restore: "يعيد",
            versionName: "اسم الإصدار",
            restoreModalText: "سيقوم هذا الإجراء بإعادة الإصدار المحدد. هل أنت متأكد من أنك تريد استعادة هذا الإصدار؟",
            restoreVersion: "استعادة النسخة",
            newVersion: "نسخة جديدة",
            synonymMustBeUnique: "يجب أن يكون المرادف فريدًا",
            save: "يحفظ",
            entries: "إدخالات",
            youHaveNoEntries: "ليس لديك إدخالات",
            inputsCantBeEmpty: "لا يمكن أن تكون المدخلات فارغة",
            entryNamesMustBeUnique: "يجب أن تكون أسماء الدخول فريدة من نوعها",
            entityNameMustBeUnique: "يجب أن يكون اسم الكيان فريدًا",
            synonyms: "المرادفات",
            entities: "جهات",
            title: "عنوان",
            entryName: "اسم الدخول",
            entityhasbeenUpdatedSuccessfully: "تم تحديث الكيان بنجاح",
            emptyError: "لا يمكن أن تكون الإدخالات فارغة",
            entityNameCantBeEmpty: "الكيان لا يمكن أن يكون فارغا",
            allChats: "كل الدردشات",
            paidChats: "دردشات مدفوعة الأجر",
            busiestPeriod: "فترة ازدحام",
            ratingDistribution: "توزيع التصنيف",
            allMessages: "جميع الرسائل",
            avarageMessages: "رسائل Avarage",
            popularity: "شعبية",
            allUsers: "جميع المستخدمين",
            interactionName: "اسم التفاعل",
            numberOfMessage: "عدد الرسالة",
            ofAllUsersMessage: "٪ من جميع رسائل المستخدمين",
            totalData: "إجمالي البيانات",
            avgData: "بيانات AVG",
            exportToCsv: "التصدير إلى CSV",
            exportToExcel: "تصدير إلى Excel",
            inMaintenance: "في الصيانة",
            ADD_TO_SEGMENT: "إضافة إلى الجزء",
            REMOVE_FROM_SEGMENT: "ترفع من الجزء",
            users: "المستخدمون",
            webhookName: "اسم webhook",
            webHookUrl: "Webhook url",
            webHookToken: "رمز webhook",
            delete: "يمسح",
            basicAuth: "مصادقة أساسية",
            requiredFieldsCannotBeLeftBlank: "لا يمكن ترك الحقول المطلوبة فارغة",
            headerValue: "قيمة",
            yourVerificationToken: "رمز",
            yourWebHookName: "اسم webhook الخاص بك",
            yourWebHookUrl: "عنوان URL الخاص بك webhook",
            enterKey: "مفتاح الادخال",
            password: "كلمة المرور",
            saveSuccessfully: "تم حفظ معاملتك بنجاح",
            urlTypeError: "يرجى ملء الحقل بشكل صحيح (https://api.example.com/webhook)",
            gpt3: {
                apiKeyRequired: "Openai Chat GPT-4 API مفتاح مطلوب.",
                apiKeyDesc: "يتطلب تكامل chatbot + الدردشة GPT-4 مفتاح API. يرجى الحصول على مفتاح API الخاص بك أو استخدام مفتاح API أدناه للتجربة. يمكنك استخدام 20 رسالة فقط للتجربة.",
                getApiKey: "احصل على مفتاح AI AI AI",
                typeApiKey: "اكتب مفتاح API",
                ownApiKey: "مفتاح OpenAI API الخاص بك",
                trialApiKey: "مفتاح API التجريبي (مقيد بـ 20 رسالة)",
                useOurTrial: "استخدم تجريمنا المجاني",
                twentyMessages: "يمكنك المحاولة باستخدام 20 رسالة مجانية.",
                enableChatGpt3: "تمكين الدردشة GPT-4"
            },
            YouTube_Actions: "YouTube Actions",
            Google_Business_Actions: "Google Business Actions",
            Google_Play_Actions: "Google Play Actions",
            App_Store_Actions: "App Store Actions",
            META_SEND_CAPI_EVENT: "إرسال حدث CAPI",
            META_SEND_CAPI_EVENTDesc: "يرسل أحداث التحويل لتحسين الإعلانات باستخدام Meta Conversions API (CAPI). يساعد في تحسين أداء إعلانات إنستغرام وماسنجر.",
            CUSTOM_BLOCK: "كتلة مخصصة",
            CUSTOM_BLOCKDesc: "تنفيذ كود JavaScript مخصص مع معلمات قابلة للتكوين. توسيع روبوت الدردشة باستخدام كتل مشتركة من السوق.",
            exampleOutput: "مثال على المخرجات",
            outputSchema: "مخطط المخرجات (JSON)",
            FEEDBACK_AI_ASSISTANTDesc: "Supsis AI Artificial Intelligence Assistant is an intelligent solution that optimizes customer service and business processes. It provides 24/7 service by automatically responding to customer inquiries, offers multilingual support, and integrates with platforms like WhatsApp, Instagram, and Facebook. It facilitates sales, marketing, and appointment scheduling processes while offering personalized experiences to increase customer satisfaction. This assistant, which enhances efficiency and cost savings, provides businesses with a modern and effective customer service solution through fast and accurate information flow.",
            INSERT_TO_SYSTEM_PROMPTDesc: "The Insert to System Prompt block allows the chatbot to insert a message into the system prompt. The message is inserted into the system prompt at the specified position. The message is inserted into the system prompt at the specified position. The message is inserted into the system prompt at the specified position.",
            API_REQUESTDesc: "This block defines the structure and parameters used to send a request to an API. The API Request URL specifies the address where the data will be sent, while the method (GET, POST, etc.) determines the type of request. Headers include authentication and content type information, Body Type defines the format of the data being sent, and the Body section contains the main data to be sent to the API. Finally, the Example Response shows an example of the expected response from the API. This block facilitates API integrations and automates data exchange.",
            BOT_RESPONSEDesc: "The Bot’s Response block enhances interaction by responding to the user with different content types such as text, images, and files. This block is used to send plain text messages (Text), randomly selected text variants (Random Text), images (Image), or files (File). It also provides button responses to offer options to the user: Gallery presents interactive displays with images and descriptions; Button offers options and is persistent across all platforms; Quick Reply allows the user to make quick selections and disappears after selection. Gallery supports unlimited buttons on the website platform, while only one card can be sent on WhatsApp. On Instagram and Messenger, each gallery card is sent as a separate message. Quick Reply offers more than 3 buttons on Instagram and Messenger, and the buttons appear above the message box.",
            TAVILY_WEB_SEARCHDesc: "Web search allows retrieving information from various websites through AI-powered systems. When a search query is entered, the most relevant results are scanned based on the specified search depth, providing information tailored to the user's needs. Raw content, images, and image descriptions can also be included for a more comprehensive information transfer. Additionally, the obtained data can be summarized or presented in its raw form. Users can filter search results by including specific domains, ensuring access to information from the most reliable sources. Thus, AI-powered web searches optimize the process of obtaining fast and accurate information.",
            AI_BOT_RESPONSEDesc: "This system enables AI to generate personalized responses based on user inputs and predefined instructions; it provides accurate and comprehensive answers using pre-prepared templates while recording user feedback to improve future responses.",
            AI_CLASSIFICATIONDesc: "The AI Classification Block analyzes user messages and categorizes them into predefined categories, automatically triggering relevant actions. Automatic classification ensures correct routing based on message content, while flexible category management allows adding or editing categories. Classified data is filtered to take the most appropriate actions based on user requests. Additionally, Instagram messages and comments can be classified through this block, enabling automated responses or actions.",
            DEFAULT_TIMEOUTDesc: "The default timeout is triggered at the start of the scenario and takes precedence if it is shorter than the local timeout duration; to use only the local timeout, the default must be deleted. The timeout duration cannot exceed the session duration, and multiple timeouts can be used in conjunction with user inputs. This structure, triggered when no response is received from the user, is suitable for sending reminder messages or restarting specific flows.",
            FILTERDesc: "The Supsis AI platform allows chatbots to filter user data based on customized attributes, user information (name, email, phone, language, time zone, gender, etc.), and visitor profile information (country, IP, referrer, visit address, etc.). Filtering operations enable the creation of complex conditions using 'and' and 'or' operators; for example, providing live support during working hours or offering special responses based on specific countries, phone numbers, or visit addresses. These features analyze user behavior, enabling the chatbot to provide more personalized, fast, and effective responses, thereby increasing customer satisfaction and optimizing chatbot efficiency.",
            ATTACHMENT_INPUTDesc: "The File Input block allows the chatbot to securely store and generate a downloadable URL for files received from users; this URL can be shared via channels like email or WhatsApp. The user can only send files in a defined file input; otherwise, the system redirects to the local or default 'Otherwise' flow. Images, audio, video, documents, or other attachments are supported, and the system automatically initiates the relevant process for each file type, redirecting the file to relevant units if necessary.",
            USER_INPUTDesc: "The User Input block allows the chatbot to process, validate, and save data received from users, triggering relevant actions. Global keywords are valid everywhere, while local keywords work in specific steps. Inputs can be validated using regex and saved to the user profile. The confidence level determines how the chatbot responds to inputs. With the 'Go to Block' and 'Send Message' buttons, users can be directed to specific steps or interact with the chatbot. This structure enables the chatbot to manage user interactions more efficiently.",
            GO_TO_STEPDesc: "The Go to Step Action is a mechanism that directs chatbot users to predefined steps. Dynamic routing ensures users are directed to the correct flow based on their queries or triggered actions. Block name editing ensures the flow is understandable and connections are easily managed. Users can edit block names from the block or within the block. The 'Go to Step' action is particularly useful for organizing transitions in complex chatbot flows. The Go to Block button type works similarly, directing users who click the defined button to a predefined block. The Go To selection determines the block the button will direct to, optimizing the user experience.",
            WEBHOOKDesc: "The Webhook Action facilitates data sharing between the chatbot and external systems. It directs the user flow based on successful and failed scenarios. In a successful scenario, the user flow continues when data is successfully sent; in a failed scenario, an error message is displayed, and the user is redirected. Webhook integration enables interaction with external systems and data exchange. Webhooks enhance the chatbot's flexibility and enrich the flow. For integration, adjustments must be made according to the system's API documentation.",
            SET_ATTRIBUTEDesc: "The Set Attribute block allows data received from users to be saved to their profile card, classifying data as static, dynamic, or special. Static data saves fixed values, dynamic data saves information that changes based on user inputs, and special data saves randomly generated values (e.g., random numbers or OTP). User and visitor profile information is collected and stored during user interactions, making it available for future interactions. This block is useful for managing user data and providing more personalized and accurate responses.",
            ASSIGN_OWNERDesc: "The Assign Owner Block is used to assign an ongoing chat to a selected representative through the chatbot. The assignment algorithm determines the most suitable representative based on the number of contacts they have and specific date ranges. Additionally, assignments can be made only to online representatives, and certain representatives can be excluded from the assignment pool. This process is synchronized with Zoho CRM, saving the assigned representative's data to the CRM system, thereby managing customer support processes more efficiently.",
            QUESTIONDesc: "The Question block allows the chatbot to ask users questions and validate and process their responses. When the user provides the correct answer, the successful scenario is triggered, and the flow continues. If the user provides an incorrect answer, the failed scenario is activated, giving the user another chance to respond. Additionally, user responses are validated using validation parameters, and correct data is saved to the profile card. For example, email addresses are validated, and correctly formatted information is saved to the profile card. In case of incorrect responses, the user is given the opportunity to correct them. This feature makes the chatbot's interaction with users more personalized and accurate.",
            TRANSFER_TO_CHATBOTDesc: "The Transfer to Chatbot block directs the user to a predefined different chatbot flow, offering a personalized experience. Users can transition from one flow to another and are directed to the correct scenario based on their needs. Scenario selection uses filtering and tagging processes to ensure users are directed to the correct flow based on their specific attributes. This feature provides flexible and dynamic responses to user requests.",
            TAG_CHATDesc: "The Add Tag block adds tags to profiles based on user interactions, enabling segmentation and chatbot filtering. User inputs are analyzed to direct them to the correct department, followed by representative transfer. Tags are used to optimize customer support and sales processes.",
            REMOVE_TAGDesc: "The Remove Tag block removes unnecessary or outdated tags from user profiles, ensuring chatbot analyses remain current and accurate. Tags are automatically cleaned, making segmentation and data management more efficient.",
            SET_DEPARTMENTDesc: "The Set Department block automatically or manually directs users to the correct department based on their needs. The appropriate department is determined based on user selections or system data, tags are added for segmentation, and representative transfer is performed if necessary.",
            SEND_TRANSCRIPTDesc: "The Send Transcript block automatically sends a record of the chat with the user to a specified email address, contributing to support and analysis processes. The transcript can be sent to the email address in the user profile card or a manually entered address.",
            SEND_SMSDesc: "The Send SMS block enables the sending of automated and personalized messages using Supsis's integration with Postacell or another SMS provider. The SMS content is dynamically generated using the phone number in the user's profile card and system data. For integration and additional information, contact live support or info@supsis.com.",
            SEND_MAILDesc: "The Send Mail block enables automated email sending using information collected through the chatbot. Personalized email content can be created based on attributes in the user's profile card. The email subject and content can be dynamically customized, and automatic notifications can be sent to both users and relevant teams for support requests. Supsis's email module integrates with existing mail infrastructures, simplifying the process.",
            CREATE_EVENTDesc: "The Create Event block automatically adds events to users' calendars through the chatbot. The event title, description, and duration are determined using data from the user's profile information, and event owners and additional representatives can be assigned. Automatic notifications inform participants, and event details can be managed through calendar integrations (Google Calendar, Microsoft Teams), speeding up the process and optimizing time management.",
            CREATE_RESERVATIONDesc: "The Create Reservation block automatically initiates a reservation process using attributes from the user's profile card or manually entered form data. Information from the user's profile, such as email addresses, can be used for calendar events, and event details can be retrieved from these attributes. This block organizes information received through the reservation form by interacting with other blocks and initiates the reservation process, making it faster and more personalized.",
            RESERVATION_OPEN_URLDesc: "The View Reservation Screen block lists available appointments for the user through a predefined reservation calendar. The user can view available appointments on the calendar through this screen. Additionally, predefined duration options (e.g., 5 minutes, 15 minutes, 30 minutes) can be selected for the appointment duration. This feature only works on website chatbots and offers users convenient reservation options.",
            RESERVATION_SELECT_DAYDesc: "The Select Reservation Day block offers users a selection of weekly reservation days, and the selected reservation day is saved in the system. Relevant information is automatically retrieved from the user's profile card attributes, and the reservation day is determined. This block offers users options through buttons, directing them to the appropriate reservation day. This process is personalized with user-specific information and integrated with the event calendar.",
            RESERVATION_EVENT_LISTDesc: "The Customer Reservation List quickly and efficiently presents reservation data associated with users' email information. This process is performed using a specific customer's email address, and all reservations linked to that email address are listed for the user.",
            RESERVATION_SELECT_TIMEDesc: "The Select Reservation Time block offers users available times for the selected reservation day. The user selects a suitable time from the available options for the previously selected day. This block lists available times for the day based on data received from the Select Reservation Day block and offers options to the user. The selected reservation time is saved in the system and integrated appropriately using the user's profile information and attributes.",
            CREATE_TASKDesc: "The Create Task block automatically or manually adds tasks to the Task Management Module based on user requests. The task title, description, urgency level, workflow, and pipeline (column) are determined and assigned to relevant representatives. Tasks personalized with information from the user's profile card are notified to relevant individuals through system and email notifications. Google Calendar and Microsoft Teams integrations make the process easy to track. For example, when a customer requests additional information, the chatbot automatically creates a task in the 'Awaiting Contact' column of the sales process and notifies the relevant representative.",
            GET_LOCATIONDesc: "The Get Location Module allows the chatbot to collect geographic location information from users. When requesting location information from the user, a special message is displayed, and the location's latitude and longitude are saved to the profile card. The user can share their location manually by entering an address or selecting it on the map. This feature is particularly useful in e-commerce, logistics, and delivery sectors, personalizing the user experience. For example, an e-commerce chatbot can use this module to collect a delivery address from the user and complete the process.",
            SUPPRESSION_ADDDesc: "The Suppression block blocks a user on a specified platform (WhatsApp, Web Visitor, Instagram, Messenger). The value of the user to be blocked can be automatically retrieved from attributes or entered manually. Blocking can be applied to inbound (message reception), outbound (message sending), or both. For example, to block a user causing discomfort on WhatsApp, 'WhatsApp' is selected as the platform, the user's phone number is specified, and both inbound and outbound blocking are activated.",
            SUPPRESSION_REMOVEDesc: "The Remove Suppression block unblocks a previously blocked user on a specified platform (WhatsApp, Web, Instagram, etc.) using the value used for blocking (e.g., phone number, user ID). The value for unblocking can be automatically retrieved from the profile card attributes. This allows the unblocking process to be performed quickly and automatically.",
            SEND_WP_BUSINESS_MESSAGEDesc: "The Send WhatsApp Message block enables sending personalized messages to users using the WhatsApp Business API. When this action is triggered, a message is sent through the WhatsApp channel using a predefined template. The message content can be personalized using attributes from the profile card and manual inputs. The number to be sent can be entered manually or automatically retrieved from user information. Templates are approved formats in the WhatsApp Business API, and existing templates can be selected or new ones created. Variables within the template can be used to create personalized messages. Additionally, media files (JPEG, PNG, etc.) can be added to messages. This block enables automated message sending for scenarios like campaign messages, support requests, or special notifications.",
            MESSENGER_SEND_MESSAGEDesc: "This block allows the CHATBOT to send messages via Messenger. The CHATBOT can send messages containing text, images, or other media types to a specific recipient.",
            INSTAGRAM_SEND_MESSAGEDesc: "This block allows the CHATBOT to send direct messages via the Instagram platform. The CHATBOT can send messages containing text or media to a specific user.",
            INSTAGRAM_COMMENT_REPLYDesc: "This block is used to reply to a comment on an Instagram post. The CHATBOT can interact by replying to a specific comment.",
            INSTAGRAM_COMMENT_DELETEDesc: "This block is used to delete a comment on an Instagram post. The CHATBOT can remove unwanted or inappropriate comments.",
            INSTAGRAM_COMMENT_SHOWDesc: "This block is used to view a comment on an Instagram post. The CHATBOT can review a specific comment and see other users' opinions.",
            INSTAGRAM_COMMENT_HIDEDesc: "This block is used to hide a comment on an Instagram post. The CHATBOT can make a specific comment invisible, preventing followers from seeing it.",
            INSTAGRAM_COMMENT_REPLY_AS_PRIVATEDesc: "This block is used to reply to a comment on an Instagram post with a private message (DM). The CHATBOT can send a private response to the commenter, establishing a more personal communication.",
            TABLE_CREATE_RECORDDesc: "This block adds a new record to a specific table. Using information received from the user or other attributes in the system, a new record is created and added to the relevant table. Adding a new record is used for processes such as creating new customer information or product records.",
            TABLE_DELETE_RECORDDesc: "This block deletes a record from the data table. When the user wants to remove a record that is no longer valid or contains errors, this block is triggered. The deleted record is completely removed from the table and cannot be recovered. For example, this process is used to delete a customer's record or an invalid order.",
            TABLE_UPDATE_RECORDDesc: "This block updates the content of a record in the table. When the user wants to change information in an existing record, this block can be used. For example, this process is used to update a customer's address or product price. This operation only changes the specified record and does not affect other records in the table.",
            TABLE_FIND_RECORDDesc: "This block allows finding a specific record in the data table. When the user wants to search for specific data (e.g., a username or product ID) recorded in the table, this block is used. The search process allows users to quickly access a specific record.",
            TABLE_FIND_RECORDSDesc: "This block displays existing records in the table to the user. When the user wants to see all records in the table or filtered records based on specific criteria, this block is used. The listing process can include operations such as sorting and filtering data.",
            ADD_TO_SEGMENTDesc: "The Add to Segment Action allows adding users to defined segments after they go through specific steps. This action helps analyze user behavior by dividing it into segments and creating custom reports. Users are added to appropriate segments through the segment selection bar, and new segments can be created from the chatbot menu. For example, when a VIP customer makes a special campaign query, the Add to Segment action adds the user to the VIP segment. Segment reports can be reviewed through reporting, providing detailed data on which segments users are added to and their requests.",
            REMOVE_FROM_SEGMENTDesc: "The Remove from Segment Action is used to remove users from specific segments. This action updates segments, enabling more accurate analysis of users on a segment basis. Users are automatically removed from the relevant segment after selecting the segment to be removed through the segment selection bar. Segment updates and analyses of removed users can be performed through reporting, allowing clearer tracking of segment changes and user behavior.",
            setUpYourChatbot: "إعداد روبوت الدردشة",
            setUpYourChatbotDesc: "درّب روبوت الدردشة بالبيانات، أو استخدم قوالبنا الجاهزة أو ابدأ من الصفر.",
            yourNeedEnterYourOpenAi: "تحتاج إلى إدخال مفتاح OpenAI API لإنشاء روبوت دردشة يزحف إلى موقعك.",
            Messaging_Actions: "إجراءات المراسلة",
            exportDiagram: "تصدير الرسم البياني",
            exportDiagramDescription: "حدد المكونات التي تريد تصديرها. سيتم نسخ البيانات إلى الحافظة ويمكن استيرادها إلى سيناريو آخر.",
            diagram: "الرسم البياني",
            diagramExportDesc: "رسم تدفق روبوت الدردشة (مطلوب)",
            aiSettings: "إعدادات الذكاء الاصطناعي",
            aiSettingsExportDesc: "إعدادات النموذج والموجه والمعلمات",
            aiFunctionsExportDesc: "حدد دوال الذكاء الاصطناعي للتصدير",
            knowledgeBase: "قاعدة المعرفة",
            knowledgeBaseExportDesc: "حدد أنواع قاعدة المعرفة للتصدير",
            webPages: "صفحات الويب",
            noKnowledgeBase: "لم يتم العثور على قاعدة معرفة للتصدير",
            exportToClipboard: "نسخ إلى الحافظة",
            exportSuccess: "تم نسخ السيناريو إلى الحافظة بنجاح",
            exportError: "حدث خطأ أثناء التصدير",
            exportDataFetchError: "خطأ في جلب بيانات التصدير",
            model: "النموذج",
            topP: "Top P",
            toolChoice: "اختيار الأداة",
            prompt: "الموجه",
            B2Cargo_Actions: "إجراءات B2Cargo",
            Holiday_Plus_Actions: "إجراءات Holiday+",
            HOLIDAY_PLUS_GET_ROOMS: "قائمة الغرف",
            HOLIDAY_PLUS_GET_HOTELS: "قائمة الفنادق",
            ZOHO_CREATE_RECORD: "إنشاء سجل Zoho",
            B2CARGO_LOGIN_USER: "تسجيل دخول المستخدم",
            B2CARGO_PRODUCT_STATUS: "حالة المنتج",
            createNewBlock: "إنشاء كتلة جديدة",
            marketplace: "السوق",
            myBlocks: "كتلي",
            importedBlocks: "الكتل المستوردة",
            pendingApproval: "في انتظار الموافقة",
            utility: "أداة مساعدة",
            dataTransform: "تحويل البيانات",
            custom: "مخصص",
            mostUsed: "الأكثر استخداماً",
            topRated: "الأعلى تقييماً",
            newest: "الأحدث",
            uses: "الاستخدامات",
            import: "استيراد",
            imported: "مستورد",
            pending: "قيد الانتظار",
            approved: "موافق عليه",
            rejected: "مرفوض",
            unlist: "إلغاء الإدراج",
            confirmDeleteBlock: "هل أنت متأكد من حذف هذه الكتلة؟",
            noBlocksCreated: "لم يتم إنشاء أي كتل بعد",
            enterChangelog: "أدخل سجل التغييرات (اختياري)",
            publishBlock: "نشر الكتلة",
            blockPublished: "تم نشر الكتلة بنجاح",
            blockUnlisted: "تم إلغاء إدراج الكتلة بنجاح",
            blockDeleted: "تم حذف الكتلة بنجاح",
            cannotDeleteActiveBlock: "لا يمكن حذف كتلة قيد الاستخدام",
            noImportedBlocks: "لا توجد كتل مستوردة",
            confirmRemoveImport: "هل أنت متأكد من إزالة هذا الاستيراد؟",
            remove: "إزالة",
            importRemoved: "تم إزالة الاستيراد بنجاح",
            creator: "المنشئ",
            viewDetails: "عرض التفاصيل",
            approve: "موافقة",
            reject: "رفض",
            noPendingBlocks: "لا توجد كتل قيد الانتظار",
            enterRejectionReason: "أدخل سبب الرفض",
            rejectBlock: "رفض الكتلة",
            blockApproved: "تمت الموافقة على الكتلة بنجاح",
            blockRejected: "تم رفض الكتلة",
            blockImported: "تم استيراد الكتلة بنجاح",
            parameters: "المعلمات",
            noParameters: "لا توجد معلمات مطلوبة",
            ratings: "التقييمات",
            writeReview: "اكتب مراجعتك...",
            selectOrTypeCategory: "حدد أو اكتب الفئة",
            changelogPlaceholder: "أدخل سجل التغييرات (اختياري)",
            category: "الفئة",
            description: "الوصف",
            tags: "الوسوم",
            submitRating: "إرسال التقييم",
            noRatings: "لا توجد تقييمات بعد",
            latest: "الأحدث",
            pinned: "مثبت",
            createBlock: "إنشاء كتلة",
            basicInfo: "المعلومات الأساسية",
            blockName: "اسم الكتلة",
            enterBlockName: "أدخل اسم الكتلة",
            enterDescription: "أدخل الوصف",
            icon: "الأيقونة",
            addTags: "إضافة وسوم",
            javascriptCode: "كود JavaScript",
            addParameter: "إضافة معلمة",
            parameterName: "اسم المعلمة (متغير)",
            parameterLabel: "تسمية العرض",
            parameterDescription: "الوصف (نص مساعد)",
            defaultValue: "القيمة الافتراضية",
            allowAutoUpdate: "تحديث مخطط المخرجات تلقائياً عند التنفيذ",
            visibility: "الرؤية",
            allowedSiteIds: "معرفات المواقع المسموحة",
            enterSiteIds: "أدخل معرفات المواقع",
            saveDraft: "حفظ كمسودة",
            fillRequired: "يرجى ملء الحقول المطلوبة",
            blockCreated: "تم إنشاء الكتلة",
            selectCustomBlock: "حدد كتلة مخصصة",
            selectCustomBlockDesc: "اختر كتلة مخصصة من الكتل المستوردة",
            outputPreview: "معاينة المخرجات",
            blockNotFound: "الكتلة غير موجودة",
            pleaseSelectRating: "يرجى اختيار تقييم",
            ratingSubmitted: "تم إرسال التقييم",
            plans: "الباقات",
            chatBotPlans: "باقات روبوت الدردشة",
            FEEDBACK_AI_ASSISTANT: "مساعد الذكاء الاصطناعي للتغذية الراجعة",
            INSERT_TO_SYSTEM_PROMPT: "إدراج في موجه النظام",
            API_REQUEST: "طلب API",
            AI_CALL: "مكالمة الذكاء الاصطناعي",
            TAVILY_WEB_SEARCH: "البحث على الويب",
            OPENAI_WEB_SEARCH: "البحث على الويب (OpenAI)",
            DEFAULT_TIMEOUT: "المهلة الافتراضية",
            AI_FUNCTIONS: "دوال الذكاء الاصطناعي",
            ASSIGN_OWNER: "تعيين المالك",
            CACHE_WRITE: "كتابة التخزين المؤقت",
            CACHE_READ: "قراءة التخزين المؤقت",
            CACHE_EXTEND: "تمديد التخزين المؤقت",
            CACHE_DELETE: "حذف التخزين المؤقت",
            YOUTUBE_REPLY_COMMENT: "الرد على تعليق يوتيوب",
            YOUTUBE_UPDATE_COMMENT_STATUS: "تحديث حالة تعليق يوتيوب",
            YOUTUBE_SET_MODERATION_STATUS: "تعيين حالة إشراف يوتيوب",
            GOOGLE_BUSINESS_REPLY_REVIEW: "الرد على مراجعة Google Business",
            GOOGLE_BUSINESS_UPDATE_REVIEW_STATUS: "تحديث حالة مراجعة Google Business",
            GOOGLE_PLAY_REPLY_REVIEW: "الرد على مراجعة Google Play",
            GOOGLE_PLAY_UPDATE_REVIEW_STATUS: "تحديث حالة مراجعة Google Play",
            APP_STORE_REPLY_REVIEW: "الرد على مراجعة App Store",
            APP_STORE_UPDATE_REVIEW_STATUS: "تحديث حالة مراجعة App Store",
            APP_STORE_DELETE_REVIEW_RESPONSE: "حذف رد مراجعة App Store",
            TIMEOUT: "المهلة",
            Probel_Actions: "إجراءات Probel",
            PROBEL_SELECT_BRANCH: "اختيار الفرع",
            PROBEL_SELECT_CLINIC: "اختيار العيادة",
            PROBEL_SELECT_DAY: "اختيار يوم الموعد",
            PROBEL_SELECT_HOUR: "اختيار وقت الموعد",
            PROBEL_MAKE_APPOINTMENT: "إنشاء موعد",
            PROBEL_CANCEL_APPOINTMENT: "إلغاء الموعد",
            PROBEL_GET_PATIENT_TOKEN: "الحصول على رمز المريض",
            PROBEL_FILL_INFO: "جلب معلومات MERNIS",
            PROBEL_SELECT_APPOINTMENT: "اختيار الموعد",
            SUPPRESSION_ADD: "حظر جهة الاتصال",
            SUPPRESSION_REMOVE: "إلغاء حظر جهة الاتصال",
            SEND_WP_BUSINESS_MESSAGE: "إرسال رسالة واتساب",
            TABLE_CREATE_RECORD: "إنشاء سجل",
            TABLE_DELETE_RECORD: "حذف سجل",
            TABLE_UPDATE_RECORD: "تحديث سجل",
            TABLE_FIND_RECORD: "البحث عن سجل",
            TABLE_FIND_RECORDS: "البحث عن سجلات",
            OPENAI_WEB_SEARCHDesc: "Web search allows retrieving information from various websites through AI-powered systems. When a search query is entered, the most relevant results are scanned based on the specified search depth, providing information tailored to the user's needs. Raw content, images, and image descriptions can also be included for a more comprehensive information transfer. Additionally, the obtained data can be summarized or presented in its raw form. Users can filter search results by including specific domains, ensuring access to information from the most reliable sources. Thus, AI-powered web searches optimize the process of obtaining fast and accurate information.",
            TICKET_UPDATE: "تحديث التذكرة",
            b2cargo_login_user: "تسجيل دخول المستخدم",
            b2cargo_product_status: "حالة المنتج",
            cardInfos: "معلومات البطاقة",
            ficheros: "الملفات",
            file: "الملف",
            fileCancellato: "تم حذف الملف",
            impostazioni: "الإعدادات",
            risposta: "الرد"
        },
        "Would you like to make default this story?": "#VALUE!",
        coupon: {
            code: "شفرة",
            discount: "تخفيض",
            endDate: "تاريخ الانتهاء",
            name: "اسم",
            email: "بريد إلكتروني",
            phone: "هاتف",
            add: "أضف عرض",
            coupons: "كوبونات",
            couponDeleted: "حذف القسيمة",
            limit: "حد",
            visitorBan: "تم حظر الزائر.",
            visitorUnBlock: "تم رفع الحظر."
        },
        instagramTitle: "انقر فوق الزر أدناه لتمكين ميزات Instagram.",
        instegramFunctionActive: "تمكين ميزة Instagram",
        ChatBOT: "روبوت الدردشة",
        WhatsappContacts: "جهات اتصال Whatsapp",
        InstagramContacts: "جهات اتصال Instagram",
        MessengerContacts: "Messenger Contacts",
        volumeUp: "رفع مستوى الصوت",
        minimize: "تقليل",
        maximize: "تحقيق أقصى قدر",
        auditLogs: {
            auditLogsTitle: "سجلات التدقيق",
            auditLogsSub: "تتيح لك سجلات التدقيق تتبع الأحداث التي وقعت في شركتك خلال الـ 30 يومًا الماضية.",
            actor: "الممثل",
            actorSelect: "اختر الممثل",
            actorSystem: "System (Supsis Ai)",
            actorChatbot: "Chatbot",
            actorApi: "API",
            actorVisitor: "أي زائر",
            actorAgent: "أي وكيل",
            adminUserSuffix: "(مستخدم مسؤول)",
            activityType: {
                blocked: "Blocked",
                unblocked: "Unblocked",
                "chat-opened": "Chat opened",
                "chat-closed": "Chat closed",
                "chat-rating": "Chat rated",
                "chat-assigned-to-user": "Chat assigned to user",
                "chat-forwarded-to-user": "Chat forwarded to user",
                "contact-owner-updated": "Contact owner updated",
                "user-joined-to-chat": "User joined chat",
                "ticket-assigned-to-user": "Ticket assigned to user",
                online: "Online",
                offline: "Offline",
                "page-changed": "Page changed",
                "create-ticket": "Ticket created",
                "video-calling-started": "Video call started",
                "video-calling-closed": "Video call closed",
                "voice-calling-started": "Voice call started",
                "voice-calling-closed": "Voice call closed",
                "visitor-tag-added": "Visitor tag added",
                "visitor-tag-removed": "Visitor tag removed",
                "note-created": "Note created",
                "note-updated": "Note updated",
                "visitor-profile-updated": "Visitor profile updated",
                "user-added": "User added",
                "user-removed": "User removed",
                "user-status-changed": "User status changed",
                "user-logged-in": "User logged in",
                "user-added-to-department": "User added to department",
                "user-removed-from-depart": "User removed from department",
                "user-role-changed": "User role changed",
                "user-password-changed": "User password changed",
                "user-email-changed": "User email changed",
                "user-name-changed": "User name changed",
                "user-phone-changed": "User phone changed",
                "user-disabled": "User disabled",
                "user-enabled": "User enabled",
                "settings-updated": "Settings updated",
                "whatsapp-broadcast-created": "WhatsApp broadcast created",
                "whatsapp-broadcast-completed": "WhatsApp broadcast completed",
                "whatsapp-broadcast-canceled": "WhatsApp broadcast canceled",
                "whatsapp-broadcast-failed": "WhatsApp broadcast failed",
                "whatsapp-v1-bot-state-changed": "WhatsApp v1 bot state changed",
                "whatsapp-v2-bot-state-changed": "WhatsApp v2 bot state changed",
                "channel-created": "Channel created",
                "channel-removed": "Channel removed",
                "channel-visibility-changed": "Channel visibility changed",
                "channel-zoho-config-updated": "Channel Zoho config updated",
                "channel-forward-config-updated": "Channel forward config updated",
                "login-form-activated": "Login form activated",
                "login-form-deactivated": "Login form deactivated",
                "login-form-updated": "Login form updated",
                "chatbot-created": "Chatbot created",
                "chatbot-deleted": "Chatbot deleted",
                "chatbot-restored": "Chatbot restored from trash",
                "chatbot-published": "Chatbot published",
                "chatbot-webhook-added": "Chatbot webhook added",
                "chatbot-webhook-removed": "Chatbot webhook removed",
                "banned-word-added": "Banned word added",
                "banned-word-removed": "Banned word removed",
                "mail-address-added": "Email address added",
                "mail-address-removed": "Email address removed",
                "mail-was-sent": "Email sent",
                "content-added": "Content added",
                "content-removed": "Content removed",
                "role-added": "Role added",
                "role-removed": "Role removed",
                "role-updated": "Role updated",
                "department-added": "Department added",
                "department-removed": "Department removed",
                "tags-added": "Tags added",
                "tags-removed": "Tags removed",
                "trigger-added": "Trigger added",
                "trigger-removed": "Trigger removed",
                "trigger-updated": "Trigger updated",
                "welcome-message-added": "Welcome message added",
                "welcome-message-removed": "Welcome message removed",
                "customer-group-added": "Customer group added",
                "customer-group-removed": "Customer group removed",
                "customer-group-updated": "Customer group updated",
                "webhook-added": "Webhook added",
                "webhook-removed": "Webhook removed",
                "webhook-updated": "Webhook updated",
                "contact-prop-added": "Contact property added",
                "contact-prop-removed": "Contact property removed",
                "invoice-created": "Invoice created",
                "invoice-updated": "Invoice updated",
                "invoice-payment-received": "Invoice payment received",
                "invoice-payment-failed": "Invoice payment failed",
                "invoice-refunded": "Invoice refunded",
                "invoice-deleted": "Invoice deleted",
                "payment-method-added": "Payment method added",
                "billing-address-updated": "Billing address updated",
                "plan-started": "Plan started",
                "plan-canceled": "Plan canceled",
                "task-workflow-created": "Task workflow created",
                "task-workflow-deleted": "Task workflow deleted",
                "task-workflow-restored": "Task workflow restored from trash",
                "task-workflow-permanently-deleted": "Task workflow permanently deleted",
                "task-workflow-updated": "Task workflow updated",
                "task-workflow-pipeline-stage-added": "Task workflow stage added",
                "task-workflow-pipeline-stage-updated": "Task workflow stage updated",
                "task-workflow-pipeline-stage-deleted": "Task workflow stage deleted",
                "task-created": "Task created",
                "task-deleted": "Task deleted",
                "task-stage-changed": "Task stage changed",
                "task-workflow-changed": "Task workflow changed",
                "task-assigned-to-user": "Task assigned to user",
                "task-update-priority": "Task priority updated",
                "task-added-tags": "Tags added to task",
                "task-removed-tags": "Tags removed from task",
                "task-update-title": "Task title updated",
                "task-update-description": "Task description updated",
                "task-update-start-date": "Task start date updated",
                "task-update-end-date": "Task end date updated",
                "task-update-owner": "Task owner updated",
                "task-added-followers": "Followers added to task",
                "task-removed-followers": "Followers removed from task",
                "task-added-collaborators": "Collaborators added to task",
                "task-update-checklist": "Task checklist updated",
                "task-added-subtask": "Subtask added to task",
                "task-removed-subtask": "Subtask removed from task",
                "task-added-attachment": "Attachment added to task",
                "task-comment-added": "Comment added to task",
                "task-comment-updated": "Task comment updated",
                "task-comment-deleted": "Task comment deleted",
                "task-completed": "Task completed",
                "task-archived": "Task archived",
                "task-restored": "Task restored from trash",
                "task-unarchived": "Task unarchived",
                "chatbot-credit-low": "Chatbot credit low",
                "chatbot-credit-done": "Chatbot credit depleted",
                "system-status": "System status",
                "whatsapp-credit-low": "WhatsApp credit low",
                "reservation-created-plan": "Reservation plan created",
                "reservation-updated-plan": "Reservation plan updated",
                "reservation-deleted-plan": "Reservation plan deleted",
                "reservation-created": "Reservation created",
                "reservation-updated": "Reservation updated",
                "reservation-deleted": "Reservation deleted",
                "white-list-added": "Whitelist added",
                "white-list-removed": "Whitelist removed",
                "site-suspended": "Site suspended",
                "site-dead": "Site disabled",
                "site-enabled": "Site enabled",
                custom: "Custom activity",
                "auto-rebalance-success": "Auto balance reload successful",
                "auto-rebalance-failed": "Auto balance reload failed",
                "auto-rebalance-disabled": "Auto balance reload disabled",
                "automation-created": "Automation created",
                "automation-deleted": "Automation deleted",
                "automation-restored": "Automation restored from trash",
                "automation-published": "Automation published",
                "automation-unpublished": "Automation unpublished",
                "automation-updated": "Automation updated",
                "form-created": "Form created",
                "form-updated": "Form updated",
                "form-deleted": "Form deleted",
                "form-restored": "Form restored from trash",
                "form-downloaded": "Form data downloaded",
                "table-created": "Table created",
                "table-deleted": "Table deleted",
                "table-restored": "Table restored from trash",
                "table-permanently-deleted": "Table permanently deleted",
                "table-field-added": "Table field added",
                "table-field-updated": "Table field updated",
                "table-field-deleted": "Table field deleted",
                "table-view-added": "Table view added",
                "table-view-updated": "Table view updated",
                "table-view-deleted": "Table view deleted",
                "table-page-added": "Table page added",
                "table-page-updated": "Table page updated",
                "table-page-deleted": "Table page deleted",
                "table-widget-added": "Table widget added",
                "table-widget-updated": "Table widget updated",
                "table-widget-deleted": "Table widget deleted",
                "table-permission-changed": "Table permissions changed",
                "table-data-downloaded": "Table data downloaded",
                "table-data-imported": "Table data imported",
                "table-data-batch-updated": "Table data batch updated",
                "table-data-batch-deleted": "Table data batch deleted",
                "contact-data-downloaded": "Contact data downloaded",
                "contact-batch-updated": "Contact data batch updated",
                "chat-data-downloaded": "Chat data downloaded",
                "voice-agent-created": "Voice agent created",
                "voice-agent-updated": "Voice agent updated",
                "voice-agent-deleted": "Voice agent deleted",
                "voice-agent-phone-number-inbound-agent-changed": "Inbound call agent changed",
                "voice-agent-phone-number-outbound-agent-changed": "Outbound call agent changed",
                "voice-agent-batch-call-created": "Voice agent batch call created",
                "voice-agent-knowledge-base-created": "Voice agent knowledge base created",
                "voice-agent-knowledge-base-updated": "Voice agent knowledge base updated",
                "drive-folder-created": "Drive folder created",
                "drive-folder-deleted": "Drive folder deleted",
                "drive-folder-renamed": "Drive folder renamed",
                "drive-file-added": "Drive file added",
                "drive-file-deleted": "Drive file deleted",
                "task-module-rules-rule-added": "Task module rule added",
                "task-module-rules-rule-updated": "Task module rule updated",
                "task-module-rules-rule-deleted": "Task module rule deleted",
                "task-module-rules-rule-enabled": "Task module rule enabled",
                "task-module-rules-rule-disabled": "Task module rule disabled",
                "task-module-rules-enabled": "Task module rules enabled",
                "task-module-rules-disabled": "Task module rules disabled",
                "contact-module-rules-rule-added": "Contact module rule added",
                "contact-module-rules-rule-updated": "Contact module rule updated",
                "contact-module-rules-rule-deleted": "Contact module rule deleted",
                "contact-module-rules-rule-enabled": "Contact module rule enabled",
                "contact-module-rules-rule-disabled": "Contact module rule disabled",
                "contact-module-rules-enabled": "Contact module rules enabled",
                "contact-module-rules-disabled": "Contact module rules disabled",
                "module-created": "Module created",
                "module-updated": "Module updated",
                "module-deleted": "Module deleted",
                "relation-created": "Relation created",
                "relation-updated": "Relation updated",
                "relation-deleted": "Relation deleted",
                "web-app-created": "Web app created",
                "web-app-updated": "Web app updated",
                "web-app-deleted": "Web app deleted",
                "web-tab-created": "Web tab created",
                "web-tab-updated": "Web tab updated",
                "web-tab-deleted": "Web tab deleted",
                "developer-token-created": "Developer token created",
                "developer-token-changed": "Developer token changed"
            },
            activityTypeSelect: "اختر نوع النشاط",
            dateRange: "نطاق التاريخ",
            startDate: "تاريخ البداية",
            endDate: "تاريخ النهاية",
            reset: "إعادة تعيين",
            filter: "تصفية",
            activeFilters: "الفلاتر النشطة:",
            auditLogsTable: "سجلات التدقيق",
            noActivityYet: "لا يوجد نشاط بعد",
            ipAddress: "عنوان IP",
            tablePagination: {
                goto: "انتقل",
                pagePer: " / صفحة",
                total: "المجموع",
                prev5: "الصفحات الخمس السابقة",
                next5: "الصفحات الخمس التالية",
                cut: "قص",
                copy: "نسخ",
                insertRowAbove: "إدراج صف أعلاه",
                insertRowBelow: "إدراج صف أدناه",
                removeRow: "إزالة الصف",
                emptyRow: "تفريغ الصف",
                emptyColumn: "تفريغ العمود",
                emptyCell: "تفريغ الخلية",
                leftFixedColumnTo: "تثبيت العمود لليسار",
                cancelLeftFixedColumnTo: "إلغاء تثبيت العمود لليسار",
                rightFixedColumnTo: "تثبيت العمود لليمين",
                cancelRightFixedColumnTo: "إلغاء تثبيت العمود لليمين"
            }
        },
        task: {
            taskID: "معرف المهمة",
            completeTask: "إنهاء المهمة",
            closedTasks: "المهام المغلقة",
            moveToArchive: "نقل إلى الأرشيف",
            changeWorkflow: "نقل إلى سير عمل آخر",
            selectWorkflow: "اختر سير العمل",
            taskNumber: "المهمة #",
            kanbanSettings: {
                title: "الإعدادات",
                column: "إعدادات العمود",
                selectField: "اختر حقلًا",
                selectFieldPlaceholder: "اختر حقلًا",
                card: "إعدادات البطاقة",
                selectFields: "اختر الحقول التي ستظهر في البطاقة",
                cancel: "إلغاء",
                save: "حفظ",
                kanban: "إعدادات كانبان"
            },
            priority_lowest: "الأدنى",
            priority_low: "منخفض",
            priority_medium: "متوسط",
            priority_high: "مرتفع",
            priority_highest: "الأعلى",
            workflowTitle: "عنوان سير العمل",
            workflowActions: "إجراءات سير العمل",
            deleteTask: "حذف المهمة",
            archivingDate: "تاريخ الأرشفة",
            selectOption: "تحديد خيار",
            notAuthorisedCreateTask: "غير مصرح لك بإنشاء مهمة",
            notAuthorisedCreateTaskDesc: "غير مصرح لك بتنفيذ هذه المهمة.",
            goToMessage: "الانتقال إلى الرسالة",
            goToChat: "الانتقال إلى الدردشة",
            showVisitor: "إظهار الزائر",
            closeTheTask: "إغلاق المهمة",
            sureAddCompletedList: "هل أنت متأكد من أنك تريد إضافة المهمة إلى القائمة المكتملة؟",
            success: "نجاح",
            successDesc: "تمت إضافة حقل جديد بنجاح",
            moveAndDeleteTask: "نقل المهام وحذفها",
            justDelete: "حذف فقط",
            selectColumnMoveTask: "حدد العمود الذي تريد نقل المهام إليه",
            todos: "مهام يجب القيام بها",
            inProgress: "قيد التنفيذ",
            approval: "معتمد",
            addAComment: "أضف تعليقاً...",
            deleteComment: "هل أنت متأكد أنك تريد حذف التعليق؟",
            edited: "تم التعديل",
            comments: "التعليقات",
            addComment: "أضف تعليقًا",
            workflow: "سير العمل",
            workflowDetail: "تفاصيل سير العمل",
            workflowPerm: "أذونات سير العمل",
            perm: "أذونات",
            detail: "التفاصيل",
            userPerm: "أذونات المستخدم",
            deleteCard: "حذف البطاقة",
            createCard: "إنشاء بطاقة",
            editCard: "تعديل البطاقة",
            dragCard: "سحب البطاقة",
            allWorkflow: "كل عمليات سير العمل",
            createworkflow: "إنشاء سير العمل",
            editDragActive: "التعديل نشط",
            editSortOrder: "تعديل الترتيب",
            deleteWorkflow: "هل أنت متأكد أنك تريد حذف سير العمل هذا؟",
            permEditTask: "ليست لديك صلاحية تعديل هذه المهمة",
            permEditTaskDes: "اتصل بالمسؤول الخاص بك للحصول على أذونات التعديل.",
            createTaskError: "ليست لديك صلاحية إنشاء مهام",
            createTaskErrorDesc: "اتصل بالمسؤول الخاص بك للحصول على أذونات إنشاء المهام.",
            moveTaskError: "ليست لديك صلاحية تغيير حالة المهمة",
            moveTaskErrorDesc: "اتصل بالمسؤول الخاص بك للحصول على أذونات تغيير حالة المهمة.",
            deleteTaskError: "ليست لديك صلاحية حذف المهام",
            deleteTaskErrorDesc: "اتصل بالمسؤول الخاص بك للحصول على أذونات حذف المهام.",
            permissionError: "ليس لديك إذن بإنشاء المهام",
            permissionErrorDesc: "يرجى الاتصال بالمسؤول الخاص بك للحصول على إذن إنشاء المهام",
            whatsappContactProfileTitle: "ملف تعريف {name} / {number}",
            createTaskVisitor: "إنشاء مهمة (زائر)",
            editWorkflow: "تحرير سير العمل",
            visitor: "ملف الزائر",
            createTaskMessage: "إنشاء مهمة (رسالة)",
            createStage: "إنشاء مرحلة",
            stagesAndStatuses: "المراحل والحالات",
            workflowCreateDesc: "وصف التدفق العملي",
            subTasks: "المهام الفرعية",
            followers: "متابعون",
            collaborators: "المتعاونون",
            addRelations: "إضافة علاقات",
            relations: "العلاقات",
            main: "رئيسي",
            name: "الاسم",
            completedOfCheck: "تم إكمال {completed} من إجمالي {total} المهام",
            workflowUpdateMs: "تم تحديث سير العمل بنجاح",
            taskUpdateMs: "تم تحديث المهمة بنجاح",
            workflowCreatedMs: "تم إنشاء سير العمل بنجاح",
            workflowCreateError: "لا يمكن إنشاء سير العمل",
            taskCreatedMs: "تم إنشاء المهمة بنجاح",
            settingsDesc3: "بالإضافة إلى ذلك، يتيح لك موديل المهام Supsis إنشاء سير عمل خاص بك مع أتمتة قابلة للتخصيص، مما يتيح لك إدارة المهام بشكل أكثر فعالية وتعزيز التعاون داخل الفريق.",
            settingsDesc4: "بهذه الطريقة، يمكنك تتبع كل من مهامك بالتفصيل، وتعيين المهام لأعضاء الفريق، وإدارة عمليات الأعمال الخاصة بك بشكل أكثر كفاءة. يوفر لك موديل المهام Supsis حلاً شاملاً لإدارة المهام وتنسيق الفريق.",
            settingsDesc2: "يترك موديل المهام Supsis أي مهمة دون أن تلاحظ. يمكنك تصفية المهام بناءً على أي معلمة، وتتبع أعباء العمل لكل مرحلة من مراحل سير العمل، وتنظيم التقويم الخاص بك ليتماشى مع جداولك.",
            settingsDesc1: "يتيح لك موديل المهام تنظيم العمل التعاوني، وتفويض المهام، وتتبع تقدم فريقك. يمكنك تخصيص المهام الخاصة بك حسب احتياجاتك عن طريق تحديد أي عرض وإنشاء سير عمل مخصصة خاصة بك باستخدام الأتمتة.",
            taskModuleSettingsTitle: "إعدادات وحدة المهام",
            high: "مرتفع",
            medium: "متوسط",
            low: "منخفض",
            priority: "الأولوية",
            addExistsSubtask: "إضافة مهمة فرعية موجودة",
            addSubtask: "إضافة مهمة فرعية",
            add: "أضف",
            newCheckList: "قائمة مراجعة جديدة",
            subtaskTitle: "عنوان الوظيفة الفرعية",
            view: "عرض",
            attachFiles: "إرفاق الملفات",
            createTaskDesc: "وصف المهمة",
            title: "عنوان",
            createWorkflow: "إنشاء سير العمل",
            editTask: "تحرير المهمة",
            createTask: "إنشاء مهمة",
            deleteColumnCont: "هل أنت متأكد أنك تريد حذف هذا العمود؟",
            changeStage: "تغيير المرحلة",
            filterBar: {
                searchTasksPlaceholder: "البحث في المهام...",
                otherUsers: "مستخدمون آخرون",
                searchUserPlaceholder: "البحث عن مستخدم...",
                filter: "تصفية",
                clearFilters: "مسح التصفيات",
                apply: "تطبيق",
                prioritySelection: "اختيار أولوية المهمة",
                priorityDescription: "يمكنك تصفية المهام حسب مستوى الأولوية. حدد مستويات الأولوية التي تريد تصفية المهام بها.",
                aboutPriorityLevels: "حول مستويات الأولوية",
                priorityInfoText: "مستويات الأولوية تشير إلى أهمية المهام. المهام ذات الأولوية العالية تُظهر العمل الذي يجب أن يركز عليه فريقك أولاً، بينما المهام ذات الأولوية المنخفضة تشير إلى عمل أقل إلحاحاً.",
                userSelection: "اختيار المستخدم",
                assigneesDescription: "يمكنك التصفية حسب المستخدمين المعينين للمهام. حدد المستخدمين لرؤية المهام المعينة لهم فقط.",
                unassigned: "غير معين",
                ownerSelection: "اختيار مالك المهمة",
                ownerDescription: "يمكنك التصفية حسب مالكي المهام. حدد المستخدمين لرؤية المهام التي يمتلكونها فقط.",
                searchOwnerPlaceholder: "البحث عن مالك المهمة...",
                followersSelection: "اختيار متابعي المهمة",
                followersDescription: "يمكنك التصفية حسب متابعي المهام. حدد المستخدمين لرؤية المهام التي يتابعونها فقط.",
                searchFollowerPlaceholder: "البحث عن متابع...",
                creatorSelection: "اختيار منشئ المهمة",
                creatorDescription: "يمكنك التصفية حسب من أنشأ المهمة أو النظام. حدد المستخدمين أو أنواع النظام لتصفية المهام.",
                createdBySystem: "تم الإنشاء بواسطة النظام",
                createdByUsers: "تم الإنشاء بواسطة المستخدمين",
                searchCreatorPlaceholder: "البحث عن مستخدم...",
                filterByCreatedDate: "التصفية حسب تاريخ الإنشاء",
                today: "اليوم",
                thisWeek: "هذا الأسبوع",
                thisMonth: "هذا الشهر",
                startDate: "تاريخ البدء",
                endDate: "تاريخ الانتهاء",
                aboutDateFilter: "حول تصفية التاريخ",
                filterByStartDate: "التصفية حسب تاريخ البدء",
                filterByEndDate: "التصفية حسب تاريخ الانتهاء",
                overdueTasks: "المهام المتأخرة",
                showOverdueTasks: "إظهار المهام المتأخرة",
                importantInfo: "معلومات مهمة",
                filterByUpdateDate: "التصفية حسب تاريخ التحديث",
                taskTags: "وسوم المهام",
                searchTagPlaceholder: "البحث عن وسم...",
                tagsLoading: "جاري تحميل الوسوم...",
                noTagsMatchingSearch: "لا توجد وسوم تطابق معايير البحث.",
                noTagsCreated: "لم يتم إنشاء وسوم بعد.",
                aboutTags: "حول الوسوم",
                pipelineSelection: "اختيار حالة المسار",
                searchPipelinePlaceholder: "البحث في المسار...",
                order: "الترتيب",
                pipelinesLoading: "جاري تحميل المسارات...",
                noPipelinesMatchingSearch: "لا توجد مسارات تطابق معايير البحث.",
                noPipelinesCreated: "لم يتم إنشاء مسارات بعد.",
                aboutPipelines: "حول المسارات",
                selected: "محدد",
                closeTask: "إغلاق المهمة",
                tabPriorities: "الأولوية",
                tabOwners: "مالك المهمة",
                tabFollowers: "متابعو المهمة",
                tabCreatedBy: "المنشئ",
                tabCreatedDate: "تاريخ الإنشاء",
                tabUpdateDate: "تاريخ التحديث",
                tabStartDate: "تاريخ البدء",
                tabEndDate: "تاريخ الانتهاء",
                tabTags: "الوسوم",
                tabOverdue: "المهام المتأخرة",
                tabStatus: "الحالة",
                tabSortBy: "ترتيب حسب",
                sortBySelection: "اختيار الترتيب",
                sortByDescription: "اختر الترتيب الذي تُعرض به المهام. تظهر المهام الأحدث في الأعلى.",
                sortByCreatedAt: "حسب تاريخ الإنشاء",
                sortByCreatedAtDescription: "تُرتَّب المهام من الأحدث إلى الأقدم حسب تاريخ الإنشاء.",
                sortByUpdatedAt: "حسب تاريخ التحديث",
                sortByUpdatedAtDescription: "تُرتَّب المهام من الأحدث تحديثاً إلى الأقدم.",
                sortByEndDate: "حسب تاريخ الانتهاء",
                sortByEndDateDescription: "تُرتَّب المهام حسب تاريخ الانتهاء من الأقرب إلى الأبعد.",
                aboutSortBy: "حول الترتيب",
                sortByInfoText: "بدون ترتيب محدد، تستخدم عرض كانبان ترتيب السحب والإفلات، ويستخدم عرض القائمة تاريخ الإنشاء.",
                priorityLowest: "أدنى أولوية",
                priorityLow: "أولوية منخفضة",
                priorityMedium: "أولوية متوسطة",
                priorityHigh: "أولوية عالية",
                priorityHighest: "أعلى أولوية",
                createdByApi: "المهام المنشأة بواسطة API",
                createdByChatbot: "المهام المنشأة بواسطة Chatbot",
                createdByAutomation: "المهام المنشأة بواسطة الأتمتة",
                dateRangeCreatedDescription: "حدد تواريخ البدء والانتهاء لتصفية المهام المنشأة ضمن النطاق الزمني المحدد. يقوم هذا الفلتر بتصفية المهام حسب تاريخ إنشائها (createdAt).",
                dateInfoCreatedText: "يحد فلتر التاريخ النتائج حسب تاريخ إنشاء المهام. بهذه الطريقة يمكنك بسهولة العثور على المهام المنشأة ضمن فترة زمنية محددة.",
                dateRangeStartDescription: "حدد تاريخ البدء لتصفية المهام المنشأة ضمن النطاق الزمني المحدد. يقوم هذا الفلتر بتصفية المهام حسب تاريخ بدئها (startDate).",
                dateInfoStartText: "يحد فلتر التاريخ النتائج حسب تاريخ بدء المهام. بهذه الطريقة يمكنك بسهولة العثور على المهام التي ستبدأ ضمن فترة زمنية محددة.",
                dateRangeEndDescription: "حدد تاريخ الانتهاء لتصفية المهام المنشأة ضمن النطاق الزمني المحدد. يقوم هذا الفلتر بتصفية المهام حسب تاريخ انتهائها (endDate).",
                dateInfoEndText: "يحد فلتر التاريخ النتائج حسب تاريخ انتهاء المهام. بهذه الطريقة يمكنك بسهولة العثور على المهام التي ستنتهي ضمن فترة زمنية محددة.",
                dateRangeUpdateDescription: "حدد تواريخ البدء والانتهاء لتصفية المهام المحدثة ضمن النطاق الزمني المحدد. يقوم هذا الفلتر بتصفية المهام حسب تاريخ تحديثها (updatedAt).",
                dateInfoUpdateText: "يحد فلتر التاريخ النتائج حسب تاريخ آخر تحديث للمهام. بهذه الطريقة يمكنك بسهولة العثور على المهام المحدثة ضمن فترة زمنية محددة.",
                overdueDescription: "يمكنك تصفية المهام التي انتهى تاريخ استحقاقها ولم تكتمل بعد. عند تفعيل هذا الفلتر، ستُعرض المهام المتأخرة فقط.",
                overdueDetail: "ستُعرض المهام التي انتهى تاريخ استحقاقها ولم تكتمل بعد عند تفعيل هذا الفلتر. عادةً ما تكون هذه المهام هي التي يحتاج فريقك إلى معالجتها في أقرب وقت ممكن.",
                overdueInfoText: "المهام المتأخرة هي المهام التي انتهى تاريخ استحقاقها ولكنها لم تكتمل بعد. تشير هذه المهام إلى العمل المهم الذي يحتاج فريقك إلى الانتباه إليه.",
                tagsDescription: "يمكنك تصفية المهام حسب وسومها. ستُعرض المهام التي تحتوي على الوسوم التي تختارها.",
                tagsInfoText: "تساعدك الوسوم في تصنيف المهام والعثور عليها بسهولة أكبر. إذا اخترت وسوماً متعددة، ستُعرض المهام التي تحتوي على أي من الوسوم المحددة.",
                pipelineDescription: "يمكنك تصفية المهام حسب حالة المسار. باختيار المسارات التي تريدها، يمكنك رؤية المهام في تلك المراحل فقط.",
                pipelinesInfoText: "تُظهر المسارات المرحلة التي تكون فيها المهام. إذا اخترت مسارات متعددة، ستُعرض المهام الموجودة في أي من المسارات المحددة."
            },
            assignees: "المعينين",
            owner: "صاحب",
            stage: "مرحلة",
            writeSomething: "اكتب شيئًا",
            selectAssginee: "حدد المعين",
            assignee: "المعين",
            enterNewTaskDesc: "أدخل وصف المهمة الجديدة",
            enterNewTaskTitle: "أدخل عنوان المهمة الجديدة",
            task: "مهمة",
            deleteTaskCont: "هل أنت متأكد أنك تريد حذف هذه المهام؟",
            deleteWorkFlowCont: "هل أنت متأكد أنك تريد حذف سير العمل هذا؟",
            completed: "مكتمل",
            todo: "مهمة",
            kanbanBoard: "لوحة كانبان",
            listView: "عرض القائمة",
            taskNotifications: "إشعارات المهام",
            reports: "التقارير",
            workflowSettings: "إعدادات سير العمل",
            trashBin: "سلة المهملات",
            taskReports: {
                title: "تقارير المهام",
                selectWorkflow: "اختر سير العمل",
                filters: "التصفيات",
                clear: "مسح",
                dateRange: "نطاق التاريخ:",
                dateRangePlaceholder: "البداية - النهاية",
                assignees: "المعينون:",
                selectUser: "اختر المستخدم",
                unassigned: "غير معين",
                priority: "الأولوية:",
                selectPriority: "اختر الأولوية",
                emptyTitle: "اختر سير العمل لعرض التقارير",
                emptyDescription: "اختر سير عمل من الأعلى لعرض تقارير المهام.",
                loadingTitle: "جاري إعداد التقرير",
                loadingSubtitle: "جاري تحليل بيانات المهام...",
                tasksClosed: "مهام مغلقة",
                tasksUpdated: "مهام محدثة",
                tasksCreated: "مهام منشأة",
                upcomingDeadlines: "المواعيد النهائية القادمة",
                statusOverview: "نظرة عامة على الحالة",
                statusOverviewSubtitle: "اعرض حالة تذاكرك في لمحة.",
                totalTickets: "إجمالي التذاكر",
                priorityDistribution: "توزيع الأولوية",
                teamWorkload: "عبء عمل الفريق",
                tooltipTasks: "{name}: {count} مهام ({percentage}%)",
                errorTitle: "خطأ في تحميل التقرير",
                retry: "حاول مرة أخرى",
                last7Days: "آخر 7 أيام",
                dateRangeIn: "بين {start} - {end}",
                upcomingCount: "{count} عناصر لها مواعيد نهائية قادمة (الأيام القادمة 7)",
                upcomingCountZero: "0 عناصر لها مواعيد نهائية قادمة (الأيام القادمة 7)",
                upcomingInRange: "{count} عناصر لها مواعيد نهائية ({start} - {end})",
                upcomingInRangeZero: "0 عناصر لها مواعيد نهائية ({start} - {end})",
                invalidWorkflowId: "تنسيق معرف سير العمل غير صالح: {id}",
                loadSuccess: "تم تحميل بيانات التقرير بنجاح.",
                unknownError: "حدث خطأ غير معروف",
                error: "خطأ"
            },
            taskNotification: {
                title: "إعدادات إشعارات المهام",
                description: "يمكنك إدارة إعدادات إشعارات المهام من هنا."
            },
            workflowSandbox: {
                title: "سير العمل المحذوفة",
                description: "يتم حذف سير العمل التي لا تُستخدم لمدة 30 يوماً تلقائياً بواسطة النظام",
                emptyState: "لا توجد سير عمل محذوفة في سلة المهملات",
                unnamedWorkflow: "سير عمل بدون اسم",
                restore: "استعادة",
                permanentlyDelete: "حذف نهائي",
                unknown: "غير معروف",
                user: "مستخدم",
                restoreConfirmTitle: "هل أنت متأكد من أنك تريد استعادة سير العمل هذا؟",
                restoreConfirmContent: "سيتم استعادة سير العمل {title}.",
                restoreSuccess: "تم استعادة سير العمل بنجاح",
                restoreFailed: "فشل الاستعادة",
                deleteConfirmTitle: "هل أنت متأكد من أنك تريد حذف سير العمل هذا نهائياً؟",
                deleteConfirmContent: "سيتم حذف سير العمل {title} نهائياً. لا يمكن التراجع عن هذا الإجراء.",
                deleteOkText: "نعم، حذف نهائي",
                cancel: "إلغاء",
                deleteSuccess: "تم حذف سير العمل نهائياً",
                deleteFailed: "فشل الحذف النهائي",
                loadError: "حدث خطأ أثناء تحميل سير العمل المحذوفة"
            },
            notAuthorizedCreateTask: "غير مصرح لك بإنشاء مهمة",
            notAuthorizedCreateTaskDesc: "غير مصرح لك بتنفيذ هذا الإجراء.",
            taskDesc: "وصف المهمة",
            archiveAndTrash: "الأرشيف وسلة المحذوفات",
            trash: "سلة المحذوفات",
            loading: "جاري التحميل...",
            startDate: "تاريخ البداية",
            endDate: "تاريخ النهاية",
            clearFilter: "مسح المرشح",
            noArchivedTasks: "لا توجد مهام مؤرشفة",
            noDeletedTasks: "لا توجد مهام في سلة المحذوفات",
            total: "الإجمالي",
            error: "خطأ",
            moveToBoard: "نقل إلى اللوحة",
            unarchive: "استعادة من الأرشيف",
            taskMovedToBoard: "تم نقل المهمة إلى اللوحة",
            taskMoveError: "حدث خطأ أثناء نقل المهمة إلى اللوحة",
            taskDeleted: "تم حذف المهمة",
            taskDeleteError: "حدث خطأ أثناء حذف المهمة",
            taskUnarchived: "تم استعادة المهمة من الأرشيف",
            taskUnarchiveError: "حدث خطأ أثناء استعادة المهمة من الأرشيف",
            aprobado: "موافق عليه"
        },
        permissionErrors: {
            userCreate: "ليس لديك إذن لإضافة المستخدمين. يرجى استشارة المسؤول الخاص بك.",
            userRead: "ليس لديك إذن لعرض المستخدمين. يرجى استشارة المسؤول الخاص بك.",
            userUpdate: "ليس لديك إذن لتحديث المستخدمين. يرجى استشارة المسؤول الخاص بك.",
            userDelete: "ليس لديك إذن لحذف المستخدمين. يرجى استشارة المسؤول الخاص بك.",
            visitorBlock: "ليس لديك إذن لحظر الزوار. يرجى استشارة المسؤول الخاص بك.",
            visitorUnblock: "ليس لديك إذن لإلغاء حظر الزوار. يرجى استشارة المسؤول الخاص بك.",
            visitorDetailRead: "ليس لديك إذن لعرض تفاصيل الزوار. يرجى استشارة المسؤول الخاص بك.",
            visitorListRead: "ليس لديك إذن لعرض قائمة الزوار. يرجى استشارة المسؤول الخاص بك.",
            visitorDelete: "ليس لديك إذن لحذف الزوار. يرجى استشارة المسؤول الخاص بك.",
            visitorExcel: "ليس لديك إذن للحصول على مخرجات Excel. يرجى استشارة المسؤول الخاص بك.",
            visitorUpdate: "ليس لديك إذن لتحديث الزوار. يرجى استشارة المسؤول الخاص بك.",
            bannedVisitorRead: "ليس لديك إذن لعرض قائمة الزوار المحظورين. يرجى استشارة المسؤول الخاص بك.",
            bannedWordCreate: "ليس لديك إذن لإضافة كلمات محظورة. يرجى استشارة المسؤول الخاص بك.",
            bannedWordRead: "ليس لديك إذن لعرض الكلمات المحظورة. يرجى استشارة المسؤول الخاص بك.",
            bannedWordDelete: "ليس لديك إذن لحذف الكلمات المحظورة. يرجى استشارة المسؤول الخاص بك.",
            chatRead: "ليس لديك إذن لعرض الدردشات. يرجى استشارة المسؤول الخاص بك.",
            chatUpdate: "ليس لديك الإذن لتحرير المحادثات. يرجى التشاور مع المسؤول الخاص بك.",
            archiveRead: "ليس لديك الإذن لعرض الأرشيف. يرجى التشاور مع المسؤول الخاص بك.",
            roleCreate: "ليس لديك الإذن لإضافة الأدوار. يرجى التشاور مع المسؤول الخاص بك.",
            roleRead: "ليس لديك الإذن لعرض الأدوار. يرجى التشاور مع المسؤول الخاص بك.",
            roleUpdate: "ليس لديك الإذن لتحديث الأدوار. يرجى التشاور مع المسؤول الخاص بك.",
            roleDelete: "ليس لديك الإذن لحذف الأدوار. يرجى التشاور مع المسؤول الخاص بك.",
            departmentCreate: "ليس لديك الإذن لإضافة الأقسام. يرجى التشاور مع المسؤول الخاص بك.",
            departmentRead: "ليس لديك الإذن لعرض الأقسام. يرجى التشاور مع المسؤول الخاص بك.",
            departmentUpdate: "ليس لديك الإذن لتحديث الأقسام. يرجى التشاور مع المسؤول الخاص بك.",
            departmentDelete: "ليس لديك الإذن لحذف الأقسام. يرجى التشاور مع المسؤول الخاص بك.",
            preparedContentCreate: "ليس لديك الإذن لإنشاء المحتوى المعد. يرجى التشاور مع المسؤول الخاص بك.",
            preparedContentRead: "ليس لديك الإذن لعرض المحتوى المعد. يرجى التشاور مع المسؤول الخاص بك.",
            preparedContentUpdate: "ليس لديك الإذن لتحديث المحتوى المعد. يرجى التشاور مع المسؤول الخاص بك.",
            preparedContentDelete: "ليس لديك الإذن لحذف المحتوى المعد. يرجى التشاور مع المسؤول الخاص بك.",
            welcomeCreate: "ليس لديك الإذن لإنشاء رسائل الترحيب. يرجى التشاور مع المسؤول الخاص بك.",
            welcomeRead: "ليس لديك الإذن لعرض رسائل الترحيب. يرجى التشاور مع المسؤول الخاص بك.",
            welcomeUpdate: "ليس لديك الإذن لتحديث رسائل الترحيب. يرجى التشاور مع المسؤول الخاص بك.",
            welcomeDelete: "ليس لديك الإذن لحذف رسائل الترحيب. يرجى التشاور مع المسؤول الخاص بك.",
            settingCreate: "ليس لديك الإذن لإنشاء الإعدادات. يرجى التحدث مع المسؤول الخاص بك.",
            settingRead: "ليس لديك الإذن لعرض الإعدادات. يرجى التحدث مع المسؤول الخاص بك.",
            settingUpdate: "ليس لديك الإذن لتحديث الإعدادات. يرجى التحدث مع المسؤول الخاص بك.",
            settingDelete: "ليس لديك الإذن لحذف الإعدادات. يرجى التحدث مع المسؤول الخاص بك.",
            reportCreate: "ليس لديك الإذن لإنشاء التقارير. يرجى التحدث مع المسؤول الخاص بك.",
            reportRead: "ليس لديك الإذن لعرض التقارير. يرجى التحدث مع المسؤول الخاص بك.",
            reportUpdate: "ليس لديك الإذن لتحديث التقارير. يرجى التحدث مع المسؤول الخاص بك.",
            reportDelete: "ليس لديك الإذن لحذف التقارير. يرجى التحدث مع المسؤول الخاص بك.",
            offlineSupportRequestCreate: "ليس لديك الإذن لإنشاء طلبات الدعم غير المتصلة. يرجى التحدث مع المسؤول الخاص بك.",
            offlineSupportRequestRead: "ليس لديك الإذن لعرض طلبات الدعم غير المتصلة. يرجى التحدث مع المسؤول الخاص بك.",
            offlineSupportRequestUpdate: "ليس لديك الإذن للرد على طلبات الدعم غير المتصلة. يرجى التحدث مع المسؤول الخاص بك.",
            offlineSupportRequestDelete: "ليس لديك الإذن لحذف طلبات الدعم غير المتصلة. يرجى التحدث مع المسؤول الخاص بك.",
            catalogCreate: "ليس لديك الإذن لإنشاء الفهرس. يرجى التحدث مع المسؤول الخاص بك.",
            catalogRead: "ليس لديك الإذن لعرض الفهرس. يرجى التحدث مع المسؤول الخاص بك.",
            catalogUpdate: "ليس لديك الإذن لتحديث الفهرس. يرجى التحدث مع المسؤول الخاص بك.",
            catalogDelete: "ليس لديك الإذن لحذف الفهرس. يرجى التحدث مع المسؤول الخاص بك.",
            chatbotStoryCreate: "ليس لديك الإذن لإنشاء قصص الدردشة. يرجى التحدث مع المسؤول الخاص بك.",
            chatbotStoryRead: "ليس لديك الإذن لعرض قصص الدردشة. يرجى التحدث مع المسؤول الخاص بك.",
            chatbotStoryUpdate: "ليس لديك الإذن لتحديث قصص الدردشة. يرجى التحدث مع المسؤول الخاص بك.",
            chatbotStoryDelete: "ليس لديك الإذن لحذف قصص الدردشة. يرجى التحدث مع المسؤول الخاص بك.",
            chatbotTemplateRead: "ليس لديك الإذن لعرض قوالب الدردشة. يرجى التحدث مع المسؤول الخاص بك.",
            chatbotTemplateAiRead: "ليس لديك الإذن لعرض قوالب الدردشة الذكية. يرجى التحدث مع المسؤول الخاص بك.",
            chatbotIntegrationsRead: "ليس لديك الإذن لعرض تكاملات الدردشة. يرجى التحدث مع المسؤول الخاص بك.",
            chatbotArchiveRead: "ليس لديك الإذن لعرض أرشيف الدردشة. يرجى التحدث مع المسؤول الخاص بك.",
            chatbotEntitiesRead: "ليس لديك الإذن لعرض كيانات الدردشة. يرجى التحدث مع المسؤول الخاص بك.",
            chatbotEntitiesCreate: "ليس لديك الإذن لإنشاء كيانات الدردشة. يرجى التحدث مع المسؤول الخاص بك.",
            chatbotEntitiesUpdate: "ليس لديك الإذن لتحديث كيانات الدردشة. يرجى التحدث مع المسؤول الخاص بك.",
            chatbotEntitiesDelete: "ليس لديك الإذن لحذف كيانات الدردشة. يرجى التحدث مع المسؤول الخاص بك.",
            chatbotReportRead: "ليس لديك الإذن لعرض تقارير الدردشة الآلية. يرجى التواصل مع المسؤول الخاص بك.",
            chatbotTrainRead: "ليس لديك الإذن لعرض تدريب الدردشة الآلية. يرجى التواصل مع المسؤول الخاص بك.",
            chatbotSegmentCreate: "ليس لديك الإذن لإنشاء شرائح المستخدمين للدردشة الآلية. يرجى التواصل مع المسؤول الخاص بك.",
            chatbotSegmentRead: "ليس لديك الإذن لعرض شرائح المستخدمين للدردشة الآلية. يرجى التواصل مع المسؤول الخاص بك.",
            chatbotSegmentUpdate: "ليس لديك الإذن لتحديث شرائح المستخدمين للدردشة الآلية. يرجى التواصل مع المسؤول الخاص بك.",
            chatbotSegmentDelete: "ليس لديك الإذن لحذف شرائح المستخدمين للدردشة الآلية. يرجى التواصل مع المسؤول الخاص بك.",
            integrationsRead: "ليس لديك الإذن لعرض صفحة التكاملات. يرجى التواصل مع المسؤول الخاص بك.",
            whatsappIntegrationRead: "ليس لديك الإذن لعرض صفحة تكامل WhatsApp. يرجى التواصل مع المسؤول الخاص بك.",
            instagramIntegrationRead: "ليس لديك الإذن لعرض صفحة تكامل Instagram. يرجى التواصل مع المسؤول الخاص بك.",
            telegramIntegrationRead: "ليس لديك الإذن لعرض صفحة تكامل Telegram. يرجى التواصل مع المسؤول الخاص بك.",
            integrationCreate: "ليس لديك الإذن لتمكين التكاملات. يرجى التواصل مع المسؤول الخاص بك.",
            triggerCreate: "ليس لديك الإذن لإنشاء المشغلات. يرجى التواصل مع المسؤول الخاص بك.",
            triggerRead: "ليس لديك الإذن لعرض المشغلات. يرجى التواصل مع المسؤول الخاص بك.",
            triggerUpdate: "ليس لديك الإذن لتحديث المشغلات. يرجى التواصل مع المسؤول الخاص بك.",
            triggerDelete: "ليس لديك الإذن لحذف المشغلات. يرجى التواصل مع المسؤول الخاص بك.",
            billingRead: "ليس لديك إذن لعرض الفواتير. يرجى التواصل مع مسؤول النظام الخاص بك.",
            taskCreate: "ليس لديك إذن لإنشاء المهام. يرجى التواصل مع مسؤول النظام الخاص بك.",
            taskRead: "ليس لديك إذن لعرض المهام. يرجى التواصل مع مسؤول النظام الخاص بك.",
            taskUpdate: "ليس لديك إذن لتحديث المهام. يرجى التواصل مع مسؤول النظام الخاص بك.",
            taskDelete: "ليس لديك إذن لحذف المهام. يرجى التواصل مع مسؤول النظام الخاص بك.",
            calendarCreate: "ليس لديك إذن لإنشاء التقويم/الحجوزات. يرجى التواصل مع مسؤول النظام الخاص بك.",
            calendarRead: "ليس لديك إذن لعرض التقويم/الحجوزات. يرجى التواصل مع مسؤول النظام الخاص بك.",
            calendarUpdate: "ليس لديك إذن لتحديث التقويم/الحجوزات. يرجى التواصل مع مسؤول النظام الخاص بك.",
            calendarDelete: "ليس لديك إذن لحذف التقويم/الحجوزات. يرجى التواصل مع مسؤول النظام الخاص بك.",
            mailCreate: "ليس لديك إذن لإنشاء البريد الإلكتروني. يرجى التواصل مع مسؤول النظام الخاص بك.",
            mailRead: "ليس لديك إذن لعرض البريد الإلكتروني. يرجى التواصل مع مسؤول النظام الخاص بك.",
            mailUpdate: "ليس لديك إذن لتحديث البريد الإلكتروني. يرجى التواصل مع مسؤول النظام الخاص بك.",
            mailDelete: "ليس لديك إذن لحذف البريد الإلكتروني. يرجى التواصل مع مسؤول النظام الخاص بك."
        },
        message: {
            artificialIntelligence: "الذكاء الاصطناعي",
            appBreadcrumb: {
                tasks: "المهام",
                broadcastLabel: "رسالة جماعية",
                walletBalanceTooltip: "رصيد محفظتك: {amount}₺",
                broadcastStatusCreated: "تم الإنشاء",
                broadcastStatusScheduled: "مجدول",
                broadcastStatusQueued: "في قائمة الانتظار",
                broadcastStatusRunning: "جاري الإرسال",
                broadcastStatus: "الحالة",
                broadcastProgress: "التقدم"
            },
            confirmDeleteRedStationIntegration: "هل أنت متأكد من أنك تريد حذف قناة Kırmızı Santral هذه؟",
            enterRedStationIntegration: "أدخل بيانات اعتماد API الخاصة بـ Kırmızı Santral",
            redStationIntegration: "تكامل Kırmızı Santral",
            copyChannelID: "نسخ معرف القناة",
            redStationChannels: "قنوات Kırmızı Santral",
            bannedUserError: "حدث خطأ أثناء إضافة الحظر.",
            bannedUserSuccess: "تم إضافة الحظر بنجاح.",
            selectAtLeastOneOption: "يرجى اختيار خيار واحد على الأقل.",
            enterValidValue: "يرجى إدخال قيمة صحيحة.",
            enterValidIpAddress: "يرجى إدخال عنوان IP صحيح.",
            enterValidVisitorId: "يرجى إدخال معرف زائر صحيح.",
            enterValidWhatsappNumber: "يرجى إدخال رقم واتساب صحيح.",
            invalidEmailAddress: "يرجى إدخال عنوان بريد إلكتروني صحيح.",
            bannedUser: "محظور",
            unbannedUser: "غير محظور",
            banModalDescription: "أدخل المنصة والقيمة لحظر المستخدم.",
            exampleNumber: "رقم المثال: 905551111111",
            clearSelectedFiltersTooltip: "يمسح قيم المرشحات المحددة في الصفحة",
            minutesText: "{count} دقيقة",
            secondsText: "{count} ثانية",
            downloadCooldownWarning: "يرجى الانتظار {time} لإنشاء طلب تنزيل جديد.",
            excelExportReceiveQuestion: "كيف تريد استلام ملف Excel؟",
            sendToMe: "أرسل لي",
            sendToSomeoneElse: "أرسل لشخص آخر",
            enterEmailAddress: "أدخل عنوان البريد الإلكتروني",
            exportRequestSuccess: "تم إنشاء طلبك، سنرسله إليك عبر البريد الإلكتروني في أقرب وقت ممكن",
            maxDateRangeWarning: "يمكن أن يكون نطاق التاريخ المحدد 45 يوماً كحد أقصى",
            ticketOnlyMail: "يمكن الرد على هذا الطلب عبر البريد الإلكتروني فقط. لن يتم إرسال الرسائل المرسلة عبر WhatsApp.",
            cardInfoUpdateError: "حدث خطأ أثناء تحديث معلومات البطاقة",
            billingInfoSavedSuccessfully: "تم حفظ معلومات الفوترة الخاصة بك بنجاح",
            billingInfoSaveError: "خطأ في حفظ معلومات الفوترة:",
            paymentInfoSavedSuccessfully: "تم حفظ معلومات الدفع الخاصة بك بنجاح",
            annualDiscount: "احصل على خصم 20% على المشتريات السنوية",
            annualDiscountDescription: "يمكنك تحقيق وفورات كبيرة من خلال اختيار الاشتراك السنوي.",
            payOnlyForUsedFeatures: "ادفع فقط مقابل ما تستخدمه",
            payOnlyForUsedFeaturesDescription: "ادفع فقط مقابل الميزات التي تستخدمها، لا تدفع مقابل المزيد.",
            cancelAnytime: "إلغاء في أي وقت",
            cancelAnytimeDescription: "لا حاجة للعقود طويلة الأجل، يمكنك الإلغاء متى تريد.",
            noPermissionDescription: "ليس لديك <strong>إذن</strong> لتنفيذ هذه العملية. يرجى التواصل مع مسؤول النظام الخاص بك.",
            creditCardRequired: "معلومات بطاقة الائتمان مطلوبة",
            creditCardRequiredDescription: "لديك اشتراكات مدفوعة. يمكنك المتابعة بإدخال معلومات بطاقة الائتمان الخاصة بك أو بإلغاء اشتراكاتك.",
            creditCardRequiredDescription2: "تحتاج إلى إدخال معلومات بطاقة الائتمان لأن لديك اشتراكات مدفوعة في حسابك.",
            subscriptionManagement: "إدارة الاشتراكات",
            addCreditCard: "إضافة معلومات بطاقة الائتمان",
            transferOwnership: "نقل الملكية وإعادة التوجيه",
            errorLoadingAgents: "حدث خطأ أثناء تحميل الوكلاء",
            pleaseFillRequiredFields: "يرجى ملء الحقول المطلوبة",
            callStartedSuccessfully: "تم بدء المكالمة بنجاح",
            errorStartingCall: "حدث خطأ أثناء بدء المكالمة",
            errorLoadingData: "حدث خطأ أثناء تحميل البيانات",
            errorLoadingDataPhoneNumbers: "حدث خطأ أثناء تحميل أرقام الهواتف",
            noVariablesFound: "لم يتم العثور على متغيرات في النص. يجب أن تكون المتغيرات بصيغة <code v-pre>{{ اسم_المتغير }}</code>.",
            aiVoiceAgentSpecialVariables: "قيم المتغيرات الخاصة",
            addAiVoiceAgentChannel: "إضافة قناة",
            multiLanguageSupport: "دعم متعدد اللغات",
            customerService247: "خدمة العملاء على مدار الساعة",
            autoCallAnswer: "الرد التلقائي على المكالمات",
            aiVoiceAgentChannelRequired: "قناة الوكيل الصوتي بالذكاء الاصطناعي مطلوبة",
            aiVoiceAgentChannelRequiredDescription: "تحتاج إلى إضافة قناة الوكيل الصوتي بالذكاء الاصطناعي لاستخدام هذه الميزة.",
            aiVoiceAgentChannelRequiredDescription2: "الوكيل الصوتي بالذكاء الاصطناعي هو مساعد مدعوم بالذكاء الاصطناعي يمكنه إجراء مكالمات هاتفية مع عملائك.",
            startCall: "بدء المكالمة",
            selectContactFieldPlaceholder: "اختر معلومات الاتصال",
            aiVoiceAgentVariableValuePlaceholder: "أدخل القيمة",
            aiVoiceAgentVariables: "معلومات متغيرات الوكيل",
            aiVoiceAgentVariableManual: "يدوي",
            aiVoiceAgentVariableContact: "معلومات الاتصال",
            toNumberHelpText: "يجب أن يكون بصيغة E.164. مثال: +905321234567",
            toNumber: "الرقم المراد الاتصال به",
            selectAiVoiceAgentHelpText: "إذا لم يتم الاختيار، سيتم استخدام الوكيل الصادر الافتراضي للرقم",
            selectAiVoiceAgent: "اختر الوكيل (اختياري)",
            aiVoiceAgent: "الوكيل",
            selectFromNumber: "اختر رقم المتصل",
            fromNumber: "رقم المتصل",
            startAiCall: "بدء المكالمة مع الوكيل الصوتي بالذكاء الاصطناعي",
            aiCall: "إجراء مكالمة مع الوكيل الصوتي بالذكاء الاصطناعي",
            groupByNone: "لا يتم تطبيق التجميع",
            groupByAgent: "تجميع جهات الاتصال حسب الوكلاء من جلستهم الأخيرة",
            groupByDepartment: "تجميع جهات الاتصال حسب القسم المختار في جلستهم الأخيرة",
            groupByChannel: "تجميع جهات الاتصال حسب القناة التي أتوا منها",
            groupByPlatform: "تجميع جهات الاتصال حسب المنصة التي أتوا منها",
            groupByWebsite: "تجميع جهات الاتصال حسب الموقع الإلكتروني الذي أتوا منه",
            groupByTag: "تجميع جهات الاتصال حسب علاماتهم",
            groupByAnswerStatus: "تجميع جهات الاتصال حسب حالة الرد من جلستهم الأخيرة",
            groupByOwner: "تجميع جهات الاتصال حسب مالكيهم",
            changeGroupBy: "تغيير وضع التجميع",
            changeSortMode: "تغيير وضع الترتيب",
            selectIcon: "اختيار الأيقونة",
            iconPickerTitle: "منتقي الأيقونات",
            searchIconPlaceholder: "البحث عن أيقونة...",
            profileFieldsDescriptionChat: "انقر لتخصيص حقول ملفك الشخصي",
            createCommentSuccess: "تم إنشاء التعليق بنجاح",
            createCommentError: "حدث خطأ أثناء إنشاء التعليق",
            updateCommentSuccess: "تم تحديث التعليق بنجاح",
            updateCommentError: "حدث خطأ أثناء تحديث التعليق",
            deleteCommentSuccess: "تم حذف التعليق بنجاح",
            deleteCommentError: "حدث خطأ أثناء حذف التعليق",
            formSubmission: "إرسال النموذج",
            selectForm: "اختر النموذج",
            updateOwnerUsers: "تحديث المالكين",
            updateOwnerUsersDesc: "هل تريد إعادة تعيين مالكي هذا المستخدم؟ يمكنك تعيينه إلى مستخدم آخر أو إلغاء تعيينه.",
            deposit: "إيداع",
            creditUsage: "استخدام الائتمان",
            businessMarketing: "تسويق",
            businessUtility: "فائدة",
            businessAuthentication: "مصادقة",
            businessService: "خدمة",
            incomingSessionMessage: "رسالة واردة",
            outgoingSessionMessage: "رسالة صادرة",
            freeTierConversation: "محادثة مجانية (FTC)",
            chatStart: "بدء الدردشة",
            wpMessage: "رسالة جماعية على واتساب",
            pin: "تثبيت",
            rename: "إعادة تسمية",
            browserSpeechRecognitionNotSupported: "متصفحك لا يدعم التعرف على الصوت. نوصي باستخدام متصفح Chrome.",
            spaceKeyReleaseToSave: "سيتم حفظه عند تحرير مفتاح المسافة",
            spaceKeyHint: "يمكنك التحدث عن طريق الضغط على مفتاح المسافة",
            listeningInProgress: "الاستماع...",
            speakNow: "تحدث الآن...",
            toggleAllPermissions: "تفعيل/تعطيل جميع صلاحيات الدور",
            rolePermissions: "صلاحيات الدور",
            roleSaved: "تم حفظ الدور بنجاح",
            creatingRole: "يتم إنشاء الدور...",
            savingRole: "يتم حفظ الدور...",
            editRole: "تعديل الدور",
            newRoleCreate: "إنشاء دور جديد",
            descriptionEmail: "يضيف تلقائيًا عنوان البريد الإلكتروني للزائر في المحادثة إلى مربع الرسائل ويتيح لك إرساله",
            exampleEmail: "مثال: @email مرحباً",
            nameDescription: "يضيف اسم الزائر في المحادثة تلقائيًا إلى مربع الرسائل ويتيح لك إرساله",
            exampleName: "مثال: @name مرحباً",
            pmDescription: "يتيح لك إرسال رسالة خاصة. يمكن لممثلي خدمة العملاء الآخرين فقط رؤية هذه الرسائل، ولا يمكن للزوار رؤيتها.",
            examplePm: "مثال: pm: هذه رسالة خاصة",
            chatShortcuts: "اختصارات الدردشة",
            showSystemStatus: "عرض حالة النظام",
            endChatWizard: "معالج إنهاء الجلسة",
            terminationError: "حدث خطأ أثناء إنهاء الجلسة",
            profileFieldsUpdateError: "حدث خطأ أثناء تحديث الحقول الملفية",
            profileFieldsUpdated: "تم تحديث الحقول الملفية",
            aiSuggestionError: "لم يتم جلب الاقتراحات الذكاء الاصطناعي",
            profileFieldsDescription: "يمكنك ملء الحقول الملفية المخصصة لهذا الشخص لتزويد الفريق بمعلومات أكثر.",
            categoryTags: "يمكنك إضافة التصنيفات إلى هذا الشخص لتصنيفه بسرعة.",
            manageTags: "إدارة التصنيفات",
            enterNote: "أدخل الملاحظة",
            noteDescription: "يمكنك إضافة ملاحظات عن هذا الشخص. سيتم عرض هذه الملاحظات بعد المحادثة.",
            suggestedProfileFields: "اقتراحات الحقول الملفية:",
            suggestedTags: "اقتراحات التصنيفات",
            suggestedNote: "اقتراح الملاحظة:",
            applyAll: "تطبيق الكل",
            aiSuggestionTitle: "اقتراحات الذكاء الاصطناعي",
            aiSuggestion: "استفسارات Supsis Asistan",
            searchItem: "ابحث عن عنصر",
            makeSelection: "قم بالاختيار",
            channel: "القناة",
            taskClosingDate: "تاريخ إغلاق المهمة",
            confirmDeleteTask: "هل أنت متأكد أنك تريد حذف هذه المهمة؟",
            taskDeletedSuccess: "تم حذف المهمة بنجاح",
            taskDeleteError: "حدث خطأ أثناء حذف المهمة",
            selectColumns: "حدد الأعمدة التي تريد رؤيتها في الجدول",
            linkedinChannels: "قنوات لينكد إن",
            updateLinkedinChannelDesc: "تحديث قناة لينكد إن الخاصة بك",
            deleteLinkedinChannel: "حذف قناة لينكد إن",
            confirmDeleteLinkedinChannel: "هل أنت متأكد أنك تريد حذف قناة لينكد إن هذه؟",
            contactIdPlaceholder: "معرف جهة الاتصال",
            contactId: "معرف جهة الاتصال",
            enterOwnerId: "أدخل معرف المالك",
            selectOwner: "اختر المالك",
            dynamic: "ديناميكي",
            addCollaborator: "إضافة متعاون",
            dynamicValue: "قيمة ديناميكية",
            selectCollaborator: "اختر متعاون",
            collaborator: "متعاون",
            collaborators: "المتعاونون",
            addFollower: "إضافة متابع",
            selectFollower: "اختر متابع",
            followers: "المتابعون",
            follower: "متابع",
            addAssignee: "إضافة معين",
            selectUser: "اختر مستخدم",
            assignees: "المعينون",
            assignee: "معين",
            pipelineStage: "مرحلة خط الأنابيب",
            selectPipelineStage: "اختر مرحلة خط الأنابيب",
            taskTitle: "عنوان المهمة",
            description: "الوصف",
            taskDescription: "وصف المهمة",
            priority: "الأولوية",
            selectPriority: "اختر الأولوية",
            workflow: "سير العمل",
            selectWorkflow: "اختر سير العمل",
            packagePurchase: "شراء الباقة",
            upcomingInvoice: "الفاتورة القادمة",
            invoiceUpdated: "تم تحديث الفاتورة",
            invoiceMarkedInvalid: "تم تحديد الفاتورة كغير صالحة.",
            invoiceUpdateError: "خطأ في تحديث الفاتورة",
            invoiceMarkInvalidError: "حدث خطأ أثناء تحديد الفاتورة كغير صالحة.",
            refunded: "تم الاسترداد",
            paid: "مدفوع",
            pending: "قيد الانتظار",
            unpaid: "غير مدفوع",
            paymentFailed: "فشل الدفع",
            paymentProcessError: "حدث خطأ أثناء عملية الدفع.",
            paymentSuccessful: "تم الدفع بنجاح",
            paymentProcessSuccessful: "تمت عملية الدفع بنجاح.",
            invoiceRefund: "استرداد الفاتورة",
            invoiceRefundedSuccessfully: "تم استرداد الفاتورة بنجاح.",
            invoicePaymentError: "خطأ في دفع الفاتورة",
            invoicePaymentProcessError: "حدث خطأ أثناء عملية دفع الفاتورة.",
            invoicePaid: "تم دفع الفاتورة",
            invoiceMarkedAsPaid: "تم تحديد الفاتورة كمدفوعة بنجاح.",
            invoicePriceUpdateError: "حدث خطأ أثناء تحديث سعر الفاتورة.",
            invoicePriceUpdatedSuccessfully: "تم تحديث سعر الفاتورة بنجاح.",
            invoicePdf: "فاتورة PDF",
            viewInvoice: "عرض الفاتورة",
            makePayment: "إجراء الدفع",
            autoForwardToOwnerForceDescription: "في جميع الحالات، يتم تحويل جهات الاتصال المملوكة تلقائياً إلى مالكها. لا يتم الاحتفاظ بها في قائمة الانتظار ولا يتم تحويلها إلى روبوت المحادثة. حتى إذا كان هذا الإعداد متوقفاً، إذا كان روبوت المحادثة غير نشط في النظام، سيتم تحويلها إلى مالكها.",
            autoForwardToOwnerForce: "إعادة توجيه تلقائية للمالك (حتى عندما يكون روبوت الدردشة نشطًا)",
            socialMedia: "وسائل التواصل الاجتماعي",
            web: "الويب",
            sms: "الرسائل القصيرة",
            crm: "إدارة علاقات العملاء",
            ecommerce: "التجارة الإلكترونية",
            utilities: "الأدوات",
            advertising: "الإعلانات",
            cancelPlanTitle: "إلغاء الخطة",
            cancelPlanDescription: "بعد إلغاء الخطة، يمكن استخدام الحزمة حتى نهاية اليوم.",
            voteSuccess: "تم حفظ التصويت بنجاح",
            voteSuccessDescription: "تم استلام طلبك لإضافة تكامل {integrationName} إلى Supsis",
            companyName: "اسم الشركة",
            company: "شركة",
            languageTitle1: "لغة اللوحة الافتراضية",
            languageTitle2: "لغة الرسائل الافتراضية",
            languageTitle3: "المنطقة و المنطقة الزمنية",
            languageTitle4: "إعداد اللغة التلقائي للعميل",
            languageTitle5: "اختيار لغة الرسائل للعميل في WebChat",
            languageDesc1: "يحدد لغة لوحة Supsis AI",
            languageDesc2: "يمكنك تغيير لغة الرسائل الافتراضية من هنا.",
            languageDesc3: "يحدد المنطقة والمنطقة الزمنية",
            languageDesc4: "يمكنه اكتشاف لغة الرسائل الخاصة بالعميل تلقائيًا بدعم من الذكاء الاصطناعي.",
            languageDesc5: "يُفعل الميزة التي تسمح للعميل باختيار لغته المحكية في قناة WebChat.",
            featuresTitle1: "اختيار القسم",
            featuresTitle2: "عرض عدد العملاء في الانتظار",
            featuresTitle3: "تقييد الكلمات المحظورة",
            featuresTitle4: "السماح للعملاء بإنشاء تذاكر",
            featuresTitle5: "مكالمة صوتية",
            featuresTitle6: "مكالمة فيديو",
            featuresTitle7: "إرسال رسائل صوتية (وكيل)",
            featuresTitle8: "إرسال رسائل صوتية (عميل)",
            featuresTitle9: "نقل المكالمات تلقائيًا",
            featuresTitle10: "عرض الدردشة بين الممثلين",
            featuresTitle11: "إرسال الملفات (وكيل)",
            featuresTitle12: "إرسال الملفات عبر WebChat (عميل)",
            featuresTitle13: "السماح بإرسال الرسائل قبل اتصال الوكيل",
            featuresTitle14: "إخفاء الرسائل النظامية من الممثلين",
            featuresTitle15: "السماح للعميل بحذف المعلومات الشخصية",
            featuresTitle16: "إشعار العميل عند الاتصال",
            featuresTitle17: "ترجمة تلقائية",
            featuresTitle18: "تسجيل دخول الزائر تلقائيًا",
            featuresTitle19: "مشاركة الموقع عبر WebChat (عميل)",
            featuresTitle20: "مشاركة الموقع (وكيل)",
            featuresTitle21: "مساعد الدردشة الذكي",
            featuresTitle22: "تأخير المحادثات غير المملوكة",
            featuresTitle23: "إخفاء معلومات الاتصال",
            featuresDesc1: "توجيه إلزامي إلى الأقسام بناءً على المواضيع التي يختارها العميل.",
            featuresDesc2: "يظهر للعملاء موقعهم في الطابور عندما يكون الممثلون مشغولين.",
            featuresDesc3: "يمنع الممثلين من إرسال الكلمات المحظورة المحددة في النظام للعملاء عندما تكون قيود الكلمات المحظورة نشطة.",
            featuresDesc4: "يُفعل خيار إنشاء تذكرة في نافذة WebChat.",
            featuresDesc5: "يُفعل وظيفة المكالمة الصوتية في نافذة WebChat.",
            featuresDesc6: "يُفعل وظيفة مكالمة الفيديو في نافذة WebChat.",
            featuresDesc7: "يسمح للممثلين بإرسال رسائل صوتية.",
            featuresDesc8: "يسمح للعملاء بإرسال رسائل صوتية في قناة WebChat.",
            featuresDesc9: "يُعين المكالمات المعلقة تلقائيًا إلى الممثلين المتاحين.",
            featuresDesc10: "يعرض لوحة المحادثة بين الممثلين.",
            featuresDesc11: "يسمح للممثلين بإرسال الملفات.",
            featuresDesc12: "يسمح للعملاء بإرسال الملفات في قناة WebChat.",
            featuresDesc13: "يسمح للعملاء بإرسال الرسائل قبل أن يتصل الوكيل.",
            featuresDesc14: "يخفي الرسائل النظامية من الممثلين، مما يمنع العملاء من رؤيتها.",
            featuresDesc15: "يُفعل إمكانية حذف العملاء لمعلوماتهم الشخصية بنقرة واحدة في نافذة WebChat.",
            featuresDesc16: "يُعلم الممثلين برسالة نظامية عندما يغادر العميل أو يعود إلى قناة WebChat.",
            featuresDesc17: "يترجم تلقائيًا الرسائل الواردة من العملاء إلى لغة الممثل.",
            featuresDesc18: "يبدأ المحادثة بمجرد أن ينقر الزائر على النافذة.",
            featuresDesc19: "يُفعل إمكانية مشاركة العملاء لموقعهم في قناة WebChat.",
            featuresDesc20: "يُفعل إمكانية مشاركة الممثلين لموقعهم.",
            featuresDesc21: "يُفعل استخدام المساعدة الذكية للممثلين لتصحيح الأخطاء الإملائية، وتغيير نبرة الرسائل، وتوليد ردود مدعومة بالذكاء الاصطناعي.",
            featuresDesc22: "يُفعل هذه الميزة لإبقاء الأشخاص غير المملوكين في الطابور.",
            featuresDesc23: "يمنع الممثلين من رؤية أرقام هواتف العملاء وعناوين البريد الإلكتروني.",
            featuresTitle24: "معالج نهاية الجلسة",
            featuresDesc24: "يعرض معالج إنهاء الجلسة للممثلين قبل إغلاق المحادثة",
            groupBy: "تجميع",
            privacyPolicyAndTerms: "سياسة الخصوصية / شروط الخدمة",
            privacyPolicyTitle: "سياسة الخصوصية لأنظمة الدعم والدردشة Supsis",
            privacyPolicyDescription: "تصف سياسة الخصوصية هذه كيف تقوم شركة Softcand Yazılım Hizmetleri A.S. (\"Softcand\"، \"نحن\"، \"لنا\" أو \"خاصتنا\") بجمع واستخدام والكشف عن المعلومات حول المستخدمين (\"أنت\" أو \"خاصتك\") لتطبيق الويب Supsis (\"Supsis\"). تنطبق سياسة الخصوصية هذه على المعلومات التي نجمعها عندما تستخدم Supsis؛ تكون هذه المعلومات سارية عند الوصول إليها من خلال موقعنا الإلكتروني أو تطبيقاتنا المحمولة أو منصات أخرى حيث يتم نشر سياسة الخصوصية.",
            informationWeCollect: "المعلومات التي نجمعها",
            weCollectFollowingInformation: "نجمع المعلومات التالية",
            customerAccountInformation: "معلومات حساب العميل",
            customerAccountData: "عند إنشاء حساب Supsis، نجمع البيانات التالية: الاسم الأول، الاسم الأخير، رقم الهاتف، وعنوان البريد الإلكتروني.",
            userInformation: "معلومات المستخدم",
            userProvidedInformation: "المعلومات المقدمة من قبل مستخدمي التطبيق، بما في ذلك الاسم الأول، الاسم الأخير، وعنوان البريد الإلكتروني.",
            dataDeletionProcess: "عملية حذف البيانات",
            dataDeletionProcedures: "نتبع هذه الإجراءات لحذف البيانات",
            automaticDeletion: "الحذف التلقائي",
            automaticDeletionInfo: "يتم حذف حسابات العملاء تلقائيًا عند إغلاقها أو بعد ستة أشهر من عدم النشاط.",
            directRequest: "طلب مباشر",
            directRequestInfo: "يمكن للعملاء طلب حذف جميع بياناتهم عن طريق الاتصال بنا مباشرة.",
            websiteVisitorDataDeletion: "حذف بيانات زوار الموقع",
            websiteVisitorDataDeletionInfo: "يمكن لزوار الموقع حذف بياناتهم، بما في ذلك سجل الدردشة، الرسائل، والملفات، مباشرة من خلال واجهة الدردشة على الويب.",
            howToContactUs: "كيفية الاتصال بنا",
            contactChannels: "يمكنك الاتصال بنا من خلال القنوات التالية",
            dataProcessingAndSharing: "معالجة البيانات ومشاركتها",
            handleCustomerData: "نقوم بمعالجة بيانات العملاء على النحو التالي",
            noThirdPartySharing: "لا مشاركة مع أطراف ثالثة",
            noThirdPartySharingInfo: "لا تشارك Supsis بيانات العملاء مع أي منظمة أو شركة أو فرد من الأطراف الثالثة.",
            promotionalEmails: "رسائل البريد الإلكتروني الترويجية",
            promotionalEmailsInfo: "يمكننا إرسال رسائل بريد إلكتروني ترويجية للعملاء؛ يمكنهم اختيار إلغاء الاشتراك من هذه الرسائل.",
            visitorAndConversationData: "بيانات الزوار والمحادثات",
            noSharingVisitorData: "لا نشارك أو نستخدم معلومات زوار الدردشة وبيانات العملاء.",
            thirdPartyServices: "خدمات الطرف الثالث",
            googleOAuth: "Google OAuth",
            googleCalendar: "تقويم Google",
            googleCalendarInfo: "تستخدم Supsis تقويم Google لتفعيل الميزات المتعلقة بالتقويم داخل التطبيق. البيانات المتزامنة من التقويمات لا تتم مشاركتها مع أي شخص وتكون مرئية فقط للمستخدم. عندما تنتهي صلاحية Google OAuth، يتم حذف جميع الأحداث المتزامنة من Supsis وتقويم Google تلقائيًا.",
            googleAccountPublicProfile: "الملف الشخصي العام لحساب Google",
            googleAccountPublicProfileInfo: "تجمع Supsis معلومات عن الاسم وعنوان البريد الإلكتروني للتحقق من المستخدمين وتوثيقهم أثناء تسجيل الدخول. لا يتم تخزين هذه المعلومات بعد التحقق.",
            changesToPrivacyPolicy: "تغييرات في سياسة الخصوصية هذه",
            privacyPolicyUpdateInfo: "يمكننا تحديث سياسة الخصوصية هذه من وقت لآخر. إذا أجرينا تغييرات جوهرية، سنقوم بإبلاغك من خلال موقعنا الإلكتروني أو قنوات الاتصال الأخرى.",
            privacyPolicyContactInfo: "إذا كان لديك أي أسئلة حول سياسة الخصوصية هذه، يرجى الاتصال بنا على m@softcand.com.",
            termsOfServiceTitle: "شروط الخدمة لأنظمة الدعم والدردشة Supsis",
            lastUpdated: "آخر تحديث",
            inEffect: "ساري المفعول",
            importantTerms: "مهم: تشكل هذه الشروط، التي تتضمن أيضًا سياسة الخصوصية الخاصة بنا، عقدًا ملزمًا بين الشخص الذي تم تعيينه خلال عملية \"التسجيل\" كمستخدم للخدمة (\"أنت\") وشركة Softcand Yazılım Hizmetleri Anonim Şirketi (التي تعمل تحت اسم Supsis أو Supsis Live Support أو Supsis Live Support وأنظمة الدردشة) (\"نحن\") وتحدد استخدامك لمواقعنا الإلكترونية الموجودة على supsis.com (صفحة المنتج)، softcand.com (موقع الشركة) أو supsis.live (تطبيق المنتج) أو beta.supsis.live (الإصدار التجريبي من تطبيق المنتج). لهذا السبب، تعتبر هذه الشروط مهمة ويجب عليك التأكد من قراءتها بعناية والاتصال بنا إذا كان لديك أي أسئلة قبل استخدام الخدمة.",
            termsDescription: "تنظم هذه الشروط استخدامك لمواقعنا الإلكترونية الموجودة على supsis.com (صفحة المنتج)، softcand.com (موقع الشركة) أو supsis.live (تطبيق المنتج) أو beta.supsis.live (الإصدار التجريبي من تطبيق المنتج).",
            applicationOfTerms: "تطبيق الشروط",
            termsApplyToAllUsers: "تنطبق هذه الشروط على جميع مستخدمي الخدمة، سواء كنت تستخدم الخدمة باسمك أو باسم شخص آخر أو منظمة.",
            termsUpdateNotice: "يمكننا تحديث أو تعديل الشروط في أي وقت حسب تقديرنا. إذا قمنا بتغيير الشروط، سنقوم بإبلاغك من خلال إشعار عبر منصتنا الإلكترونية وعبر البريد الإلكتروني.",
            termsDisagreementNotice: "يجب عليك قبول الالتزام بالشروط المحدثة من خلال النقر على قبولك في الإشعار الذي يتم تقديمه لك قبل الاستمرار في استخدام الخدمة.",
            consumerRightsNotice: "إذا تم تصنيفك كـ \"مستهلك\" بموجب القانون المعمول به، فقد يكون لديك حقوق قانونية بموجب هذا القانون المحلي تمنع تطبيق كل أو جزء من بعض القيود والاستثناءات المنصوص عليها في هذه الشروط عليك، وفي هذه الحالة، لن تنطبق هذه الأجزاء عليك.",
            theService: "الخدمة",
            serviceGrant: "نمنحك حقًا غير حصري، عالمي، غير قابل للتحويل وقابل للإلغاء لاستخدام الخدمة وفقًا لهذه الشروط.",
            serviceAccess: "يمكنك الوصول إلى الخدمة واستخدامها (بما في ذلك أي نسخ عرضية تحدث في إطار هذا الاستخدام) وفقًا لهذه الشروط.",
            serviceAgentAppointment: "عند تسجيل الدخول إلى الخدمة وربط حساب وسائط اجتماعية بالخدمة، تعيننا وكيلك فيما يتعلق بهذا الحساب للقيام بإجراءات نيابة عنك، وفقًا لتوجيهاتك (على سبيل المثال، الرد على رسالة مباشرة على Instagram أو منصة أخرى) عند تقديم الخدمة.",
            additionalAccountsAppointment: "عند ربط حسابات إضافية بالخدمة، تعيننا أيضًا وكيلك فيما يتعلق بهذه الحسابات للقيام بالأنشطة في إطار الوكالة.",
            accountControl: "تضمن أنك تتحكم في كل حساب وأنك مخول لنا كوكيلك مع السلطة للقيام بالأنشطة في إطار الوكالة نيابة عنك لكل حساب.",
            serviceAffiliation: "تقر وتوافق على أن الخدمة ليست مرتبطة أو مصرح بها من قبل Instagram أو Facebook أو Twitter أو أي خدمة وسائط اجتماعية أخرى نقدم الخدمة لها، وأن أي وصول إلى كل منصة (بما في ذلك عبر الخدمة) يخضع لشروط استخدام المنصة المعنية.",
            serviceLinks: "تحتوي الخدمة على روابط لمواقع إلكترونية أخرى بالإضافة إلى محتوى أضافه أشخاص غيرنا. نحن لا نؤيد أو نرعى أو نوافق على أي محتوى تم إنشاؤه بواسطة المستخدمين أو أي محتوى متاح على أي موقع ويب مرتبط.",
            contentMonitoring: "ليس لدينا أي التزام بمراقبة أو تعديل أو حذف المحتوى الذي يحمّله أو ينشره مستخدمونا في الخدمة ثم يتم نشره على حساب على أي من المنصات.",
            serviceControl: "تقر وتوافق على أن: (1) نحتفظ بالتحكم على الخدمة ويمكننا تعديل أو إضافة أو إنهاء تشغيل الخدمة في أي وقت حسب تقديرنا الخاص (سنقوم بإبلاغك بشكل معقول عن أي تعديل يؤثر بشكل كبير على وظيفة الخدمة)؛ (2) قد تكون الخدمة غير متاحة من وقت لآخر (بما في ذلك لأغراض الصيانة)، وفي حدود الممكن، سنقوم بإبلاغك عن أي فترات توقف مخطط لها؛ و (3) يمكننا رفض نشر المحتوى الذي تضيفه إلى الخدمة والذي نعتبره، وفقًا لتقديرنا، لا يتوافق مع القسم 3 من هذه الشروط.",
            yourRightsAndObligations: "حقوقك والتزاماتك",
            contentAdditionRestriction: "لا يجب عليك إضافة أي محتوى إلى الخدمة: (1) ما لم تكن تمتلك جميع الحقوق والتراخيص والموافقات اللازمة للقيام بذلك؛ (2) التي قد تؤدي إلى انتهاكك أو انتهاكنا لأي قانون أو لائحة أو أي قاعدة أو قانون ملزم آخر؛ (3) التي هي أو التي نعتبرها، وفقًا لتقديرنا، بريدًا مزعجًا، أو فاحشًا، أو غير مناسب، أو تشهيريًا، أو مهينًا، أو غير لائق، أو تحريضيًا، أو مسيئًا، أو إباحيًا، أو مهددًا، أو مسيئًا، أو تحريضًا على الكراهية، أو غير قانوني، أو تمييزيًا، أو تجديفيًا، أو ينتهك الثقة أو أي قانون للخصوصية؛ (4) التي قد تسيء إلينا أو إلى الخدمة؛ أو (5) التي تنتهك حقوق الملكية الفكرية أو حقوق أخرى لأي شخص.",
            restrictionsOnServiceUse: "لا يجب عليك: (1) محاولة تكرار أو استنساخ، أو تعديل، أو تغيير، أو إعداد أعمال مشتقة من الخدمة، أو المحتوى الذي ننشره فيما يتعلق بالخدمة، أو أي مادة أخرى لا تمتلكها أو ليس لديك ترخيص مناسب لها؛ (2) توزيع الفيروسات أو التعليمات البرمجية الضارة؛ (3) استخدام الخدمة لنشر معلومات مضللة أو خادعة؛ (4) الوصول إلى حساب شخص آخر في خدمتنا دون إذنه؛ (5) تعديل أو تعطيل أو التدخل أو تجاوز أي جانب من جوانب الخدمة أو اختبار أو عكس هندسة الخدمة للعثور على قيود أو ثغرات أو تجاوز قدرات الفلترة؛ أو (6) القيام بأي شيء قد يؤثر على الوصول إلى الخدمة أو سلامتها.",
            payments: "المدفوعات",
            paymentAcknowledgment: "تقر وتوافق على أن:",
            paymentMethodDebit: "سنقوم بخصم المبلغ من طريقة الدفع المحددة لديك في تاريخ الفوترة المحدد (اليوم الذي تنتهي فيه فترة التجربة الخاصة بك) كل شهر، أو سنة، أو فترة فوترة أخرى (حسب الاقتضاء) مقدمًا عن فترة الفوترة التالية، ما لم تقم بإلغاء الخدمة قبل هذا التاريخ؛ و",
            cancellationPolicy: "إذا قمت بإلغاء الخدمة، فستستمر في الوصول إلى الخدمة حتى تاريخ الفوترة التالي، وأي استرداد لأي مبالغ مدفوعة عن فترة الفوترة الحالية يكون وفقًا لتقديرنا (أي أن المدفوعات غير قابلة للاسترداد، إلا وفقًا لتقديرنا).",
            intellectualProperty: "الملكية الفكرية",
            contentDefinition: "في هذه الشروط، تشمل \"المحتوى\" المواد في شكل نص، أو صوت، أو رسومات، أو صور، أو فيديو، أو أي مزيج من المواد، بأي شكل.",
            intellectualPropertyRightsTransfer: "لا شيء في هذه الشروط يمثل نقلًا لحقوق الملكية الفكرية. أنت تقر وتوافق على أنه بينك وبيننا، نمتلك جميع حقوق الملكية الفكرية في الخدمة (أي أننا نمتلك حقوق التطبيقات التي نقدمها لك - نحن لا نمتلك حقوق الملكية الفكرية على محتواك - انظر أدناه في 5(3)).",
            userContentRights: "نحن نعترف بأنك، بينك وبيننا، تمتلك أو لديك ترخيص على جميع حقوق الملكية الفكرية في المحتوى الذي تقدمه للخدمة أو الذي تقدمه لنا بطريقة أخرى بغرض تقديم الخدمة.",
            grantLicense: "أنت تمنحنا حقًا وترخيصًا غير محددين، وغير حصريين، وخاليين من الرسوم، وغير قابلين للإلغاء، وعالميين وقابلين للتحويل لاستخدامه بأي طريقة (بما في ذلك النشر على حساب على أي منصة كما تحدده): (أ) المحتوى الذي تضيفه إلى الخدمة؛ و (ب) محتوى الملف الشخصي على منصات الوسائط الاجتماعية المرتبطة بحسابك (بما في ذلك، على سبيل المثال لا الحصر، من خلال النسخ، أو التعديل، أو التكييف، وإبلاغ هذا المحتوى للجمهور) بغرض تقديم الخدمة لك.",
            subLicense: "يمكننا منح ترخيص فرعي للترخيص في الفقرة 5(4) إلى مقدمي خدمات من الأطراف الثالثة الذين يساعدوننا في تقديم الخدمة.",
            moralRights: "في بعض البلدان التي تعمل فيها الخدمة، تعترف التشريعات المحلية بأن مؤلفي المحتوى قد يكون لديهم \"حقوق معنوية\" فيما يتعلق بالمحتوى. تشمل أمثلة الحقوق المعنوية الحق في أن يُنسب إليك ككاتب المحتوى، والحق في الاعتراض على نسبة خاطئة لملكية المحتوى، والحق في الاعتراض على المعاملة المهينة للمحتوى في بعض الظروف.",
            licenseSurvival: "ستظل الرخصة في الفقرة 5(4) سارية بعد إنهاء هذه الشروط.",
            rightsRepresentation: "أنت تقر وتضمن أن لديك جميع الحقوق اللازمة لمنح التراخيص والالتزامات الأخرى المنصوص عليها في هذا البند 5.",
            warranties: "الضمانات",
            warrantiesAcknowledgment: "أنت تقر وتضمن لنا أن:",
            accountOwnership: "جميع الحسابات، على أي منصة، المضافة إلى الخدمة مملوكة أو خاضعة لسيطرتك؛",
            serviceUsageAgreement: "ستستخدم الخدمة وفقًا لهذه الشروط؛ و",
            legalCapacity: "لديك القدرة القانونية والسلطة للدخول في هذه الشروط.",
            liability: "المسؤولية",
            liabilityForLoss: "أنت مسؤول عن أي خسارة أو ضرر يحدث إذا انتهكت التزاماتك بموجب هذه الشروط أو إذا لم تمارس العناية المعقولة في استخدامك للخدمة. ستقلل مسؤوليتك إلى الحد الذي نتسبب فيه أو نساهم في تلك الخسارة أو الضرر من خلال انتهاكنا لهذه الشروط أو من خلال إهمالنا في تقديم الخدمة.",
            indemnification: "أنت تعوضنا عن أي خسارة أو ضرر نتعرض له نتيجة لانتهاكك لهذه الشروط (بما في ذلك الضمانات التي تقدمها لنا بموجب هذه الشروط)، أو أي سلوك متعمد، أو أفعال غير قانونية، أو إهمال في استخدامك أو إساءة استخدامك للخدمة.",
            exclusionOfLiability: "إلى أقصى حد يسمح به القانون، ومع مراعاة الفقرات 7(5) و7(6) من هذه الشروط، نستبعد أي مسؤولية عن جميع المطالبات، والنفقات، والخسائر، والأضرار، والتكاليف المقدمة ضدك أو التي تكبدتها مباشرة أو غير مباشرة نتيجة لاستخدامك للخدمة أو عدم قدرتك على استخدام الخدمة، بما في ذلك فيما يتعلق بالخسائر الاقتصادية، وفقدان البيانات، وانقطاع الأعمال، أو أي أضرار تبعية أو عرضية.",
            totalLiabilityLimit: "إلى أقصى حد يسمح به القانون، ومع مراعاة الفقرات 7(5) و7(6) من هذه الشروط، تقتصر مسؤوليتنا الإجمالية تجاهك عن خرق العقد بموجب هذه الشروط، أو عن الأضرار (بما في ذلك الإهمال)، أو لأي سبب آخر على مبلغ يساوي إجمالي الرسوم المدفوعة أو المستحقة الدفع من قبلك للخدمة عن فترة شهر واحد تسبق مباشرة اليوم الذي نشأت فيه مسؤوليتنا.",
            exclusionOfTerms: "إلى أقصى حد يسمح به القانون، ومع مراعاة الفقرات 7(6) و7(7) من هذه الشروط، نستبعد جميع الشروط، والبيانات، والضمانات، والشروط، والضمانات أو الالتزامات (سواء كانت صريحة أو ضمنية) بخلاف تلك المنصوص عليها صراحة في هذه الشروط.",
            statutoryObligations: "في بعض الولايات القضائية، قد تتطلب التشريعات أن يتم تضمين بعض الضمانات، والشروط، والضمانات أو الالتزامات المتعلقة بالخدمة في هذه الشروط أو تفرض على تقديمنا للخدمة ('الالتزامات القانونية'). علاوة على ذلك، قد تحظر التشريعات أو تلغي شروطًا أخرى لها تأثير استبعاد، أو تقييد، أو تعديل الشروط المفروضة، أو ممارسة الحقوق والسبل القانونية، أو استرداد التعويضات، التي قد تكون متاحة لك عندما نخرق شرطًا مفروضًا ('الحظر القانوني').",
            statuteProhibition: "إذا كانت التشريعات المشار إليها في الفقرة 7(6) تنطبق على هذه الشروط كما تم قبولها من قبلك، أو على الخدمة المقدمة لك، فلا شيء في هذه الشروط يهدف إلى أن يكون أو يعمل كحظر قانوني. على وجه الخصوص، لا يُقصد بأي جزء من هذه الشروط تقييد مسؤوليتنا حيث سيكون هذا الجزء حظرًا قانونيًا.",
            termination: "إنهاء",
            terminationAutomatic: "تنتهي هذه الشروط تلقائيًا إذا توقفنا عن تشغيل الخدمة لأي سبب.",
            terminationNotice: "يمكننا أيضًا إنهاء أو تعليق وصولك إلى الخدمة على الفور، مع إشعارك، إذا اعتقدنا بشكل معقول أنك انتهكت هذه الشروط بأي شكل من الأشكال.",
            cancelService: "يمكنك إلغاء الخدمة في أي وقت عن طريق إبلاغنا، ويمكنك الاستمرار في الوصول إلى الخدمة حتى نهاية فترة الفوترة الحالية.",
            terminationRights: "تنتهي جميع الحقوق الممنوحة لك بموجب هذه الشروط عند إنهائها.",
            assignmentRestriction: "لا يجب عليك التنازل عن حقوقك أو منح تراخيص فرعية أو التصرف بأي شكل آخر في حقوقك بموجب هذه الشروط.",
            invalidProvision: "إذا كانت أي من أحكام هذه الشروط غير صالحة أو غير قابلة للتنفيذ، فيجب قراءتها أو فصلها بالقدر اللازم دون التأثير على صلاحية أو قابلية تنفيذ الأحكام المتبقية.",
            expenseResponsibility: "يجب على كل طرف، على نفقته الخاصة، القيام بكل ما هو ضروري بشكل معقول لإعطاء تأثير كامل لهذا الاتفاق والأحداث التي تم تصورها من خلاله.",
            governingLaw: "تخضع هذه الشروط لقوانين تركيا، ويخضع كل طرف لسلطة محاكم تركيا.",
            privacyPolicyTab: "سياسة الخصوصية",
            termsAndConditionsTab: "شروط وأحكام",
            placeholders: "نقاط الحجز",
            deleteOperation: "عملية الحذف",
            deleteConfirmationMessage: "هل أنت متأكد أنك تريد حذف هذا الفلتر؟",
            deleteSuccess: "تم حذف الفلتر بنجاح",
            filterSavedSuccessfully: "تم حفظ الفلتر بنجاح",
            filterCreatedMessage: "تم إنشاء {filterName} بنجاح والآن يمكن استخدامه في أي وقت.",
            copyImage: "نسخ الصورة",
            copyText: "نسخ النص",
            replyMessage: "الرد",
            downloading: "جارٍ تحميل الملف...",
            downloadSuccess: "تم تحميل الملف بنجاح",
            downloadFailed: "فشل تحميل الملف",
            translateVisitorMessage: "ترجمة الرسالة",
            filterName: "اسم الفلتر",
            enterFilterName: "أدخل اسم الفلتر",
            selectVisibility: "حدد مستوى الرؤية",
            public: "عام",
            private: "خاص",
            includeExistingFilters: "تضمين الفلاتر الحالية",
            includeSearchTerm: "تضمين مصطلح البحث",
            includeSortOrder: "تضمين ترتيب الفرز",
            includeGroupingSelection: "تضمين اختيار التجميع",
            saveFilter: "احفظ الفلتر",
            ban: "حظر",
            chatbotTickets: "تذاكر الدردشة الآلية",
            ticketSettings: "إعدادات التذاكر",
            offlineTickets: "تذاكر غير متصلة بالإنترنت",
            forwardToDepartmentAndAssign: "إعادة توجيه إلى القسم وتعيين",
            storageSpace: "مساحة التخزين",
            cancelled: "ملغى",
            running: "قيد التشغيل",
            paused: "معلق",
            queued: "في قائمة الانتظار",
            scheduled: "مجدول",
            metaLead: "العميل الميتا",
            agent: "وكيل",
            invoice: "فاتورة",
            whatsapp: "واتساب",
            chatbot: "روبوت الدردشة",
            webhook: "Webhook",
            table: "جدول",
            tag: "علامة",
            low: "منخفض",
            lowest: "الأدنى",
            medium: "متوسط",
            high: "مرتفع",
            highest: "الأعلى",
            createDepartment: "إنشاء قسم",
            goToLink: " انتقل إلى الرابط",
            emailAddressYouProvide: "يوجد بالفعل حساب باستخدام عنوان البريد الإلكتروني الذي قدمته. يرجى محاولة تسجيل الدخول أو إعادة تعيين كلمة المرور الخاصة بك.",
            channelPrivacyPolicyNotMet: "سياسة الخصوصية للقناة غير مستوفية",
            userIsNotInDepartment: "المستخدم غير موجود في هذا القسم",
            currentDepartment: "القسم الحالي",
            validDepartment: "القسم الصالح",
            youCanForwardToThisDepartment: "يمكنك توجيه المحادثة إلى هذا القسم",
            goToSettings: "الذهاب إلى الإعدادات",
            changeDepartmentAndForward: "تغيير القسم والتوجيه",
            selectDepartmentToForwardAgent: "يرجى تحديد القسم الذي ترغب في توجيه المحادثة من خلاله للوكيل المسمى {selectAgentName}.",
            selectDepartmentToForward: "يرجى اختيار القسم للإرسال",
            packageConfirmationMessage: "هل أنت متأكد من أنك تريد شراء الباقة؟ الباقة التي تشتريها خاضعة للرسوم الفورية. يمكنك الاستمرار في استخدامها لمدة عام بعد الإلغاء. سعر هذا المنتج هو السعر قبل إضافة ضريبة القيمة المضافة 20%.",
            packagePurchaseConfirmation: "هل أنت متأكد من أنك تريد شراء الباقة؟ سيتم خصم الباقات الشهرية في بداية كل شهر. سينتهي استخدام الباقة بعد تاريخ الإلغاء. سعر هذا المنتج هو السعر قبل إضافة ضريبة القيمة المضافة 20%.",
            annualPurchaseDiscount: "استفد من عرض خصم 30٪ على المشتريات السنوية!",
            customerTables: "جدول العملاء",
            formIntegration: "تكامل النموذج",
            automationIntegration: "تكامل الأتمتة",
            remainingAutomationTask: "مهمة الأتمتة المتبقية",
            createUserError: "حدث خطأ أثناء إنشاء المستخدم",
            sendTemplateMessage: "إرسال رسالة قالب",
            startChatWithDifferentChannel: "بدء محادثة مع قناة مختلفة",
            whatsappChatStarter: "بادئ محادثة واتساب",
            pressEnterToJoin: "اضغط Enter للانضمام إلى المحادثة",
            pressEnterToStartChat: "اضغط Enter لبدء المحادثة",
            cannotSendMessage: "لا يمكنك إرسال رسالة لهذا الشخص",
            cannotSendSessionMessage: "لا يمكنك إرسال رسالة جلسة لهذا الشخص",
            conversationNotInYourDepartments: "هذه المحادثة لا تنتمي إلى أي من أقسامك",
            customizeImage: "إذا كنت تريد تخصيص الصورة",
            clickToUpload: "انقر هنا لتحميل صورة",
            uploadNote: "فيما يلي تنسيقات الملفات وأحجامها المقبولة للتحميل",
            imageSize: "لا يمكن تحميل الصورة لأنها أكبر من 2 ميجابايت",
            videoSize: "لا يمكن تحميل الفيديو لأنه أكبر من 20 ميجابايت",
            documentSize: "لا يمكن تحميل المستند لأنه أكبر من 2 ميجابايت",
            uploading: "جاري تحميل الصورة، يرجى الانتظار...",
            uploadSuccess: "تم تحميل الصورة بنجاح",
            note: "ملاحظة",
            gridView: "نظرة عامة",
            completedTasks: "المهام المنجزة",
            system: "النظام",
            destroyedBy: "تم إنشاء القناة بنجاح",
            brand: "العلامة التجارية",
            channelCreatedSuccess: "تم إنشاء القناة بنجاح",
            channelCreatedError: "فشل في إنشاء القناة",
            plans: {
                types: {
                    supsis: "حزم الممثلين",
                    chatbot: "روبوت الدردشة",
                    automation: "أتمتة",
                    customer_tables: "جدول العملاء",
                    mail: "البريد الإلكتروني",
                    tasks: "المهام",
                    form: "نموذج",
                    whatsapp: "واتساب ويب (QR)",
                    whatsapp_business: "واجهة برمجة تطبيقات واتساب للأعمال",
                    instagram: "إنستغرام",
                    messenger: "مسنجر",
                    meta_lead: "ميتا ليد",
                    trendyol: "ترينديول",
                    artificial_intelligence: "الذكاء الاصطناعي",
                    webhook: "الويب هوك",
                    telegram: "تليجرام",
                    webphone: "Web Phone"
                }
            },
            vipCustomerDescription: "تحديد هذه الشخص كعميل VIP ينقله إلى أعلى قائمة الانتظار ويضمن حصوله على خدمة ذات أولوية.",
            switchOn: "تشغيل",
            switchOff: "إيقاف",
            ownerDescription: "توضح هذه الميزة مالك الدردشة. بغض النظر عن حالة المالك (متصل أو غير متصل)، يتم دائمًا تعيين الدردشات للمالك. يمكن فقط للمالك المعني عرض الدردشات المملوكة ولا يمكن الرد عليها بواسطة الروبوت.",
            permissionError: "ليس لديك إذن لتنفيذ هذا الإجراء!",
            copySuccess: "تم نسخ المحتوى بنجاح!",
            unowned: "بدون مالك",
            add: "أضف",
            copy: "ينسخ",
            cancel: "يلغي",
            edit: "يحرر",
            update: "تحديث",
            search: "ابدأ البحث",
            save: "يحفظ",
            jsonPreview: "معاينة JSON",
            enterNewValue: "أدخل قيمة جديدة",
            updatePreferredLanguage: "تحديث اللغة المفضلة",
            updateTags: "تحديث العلامات",
            updateEmail: "تحديث البريد الإلكتروني",
            enterNewEmail: "أدخل بريدًا إلكترونيًا جديدًا",
            deleteConfirmation: "تأكيد الحذف",
            confirmDelete: "هل أنت متأكد أنك تريد حذف هذه الميزة؟",
            yesDelete: "نعم، احذف",
            vipCustomer: "★ عميل VIP",
            takeControlFromChatbot: "إختيار المسؤول الخاص بك",
            enterJoin: "يمكنك الدخول إلى الدردشة بالضغط على مفتاح Enter",
            watchChat: "مشاهدة الدردشة",
            untitledAutomation: "👉 ملف تعريف غير معنون انقر فوق التشغيل الآلي",
            event: "حدث",
            chatbotSettings: "إعدادات توجيه الروبوت",
            chatbotScenarioNotFound: "لم يتم العثور على سيناريو الروبوت",
            noChatbotScenario: "لم يتم العثور على سيناريو روبوت في النظام.",
            scenarioNotFound: "لم يتم العثور على السيناريو",
            descNotAvailable: "الوصف غير متوفر",
            lastRegulation: "آخر تنظيم",
            taskCreator: "منشئ المهمة",
            noPermission: "ليس لديك إذن لإنشاء مهام.",
            notAppointed: "لم يتم تعيينه",
            changeStage: "تغيير المرحلة",
            selectedCandidates: "1 مرشح(مرشحة) مختار(ة)",
            coverPhotoRemove: "إزالة صورة الغلاف",
            coverPhotoSet: "تعيين كصورة غلاف",
            autoTransfer: "نقل جهات الاتصال الخاصة بك إلى زوهو تلقائيًا",
            autoTransferDescription: "يتم نقل جهات الاتصال التي تصل إلى هذه القناة تلقائيًا إلى وحدة جهات الاتصال في Zoho CRM. أولئك الذين تم نقلهم إلى Zoho ينشطون أدوات Zoho.",
            zohoChannelRequiredTitle: "قناة Zoho CRM مطلوبة",
            zohoChannelRequiredContent: "ليس لديك قناة Zoho CRM. انقر هنا لإضافة واحدة على الفور.",
            okText: "إضافة قناة Zoho CRM",
            cancelText: "إلغاء",
            forceQueueForNoOwnerContacts: "إجبار جهات الاتصال بدون مالك على الانتظار في الطابور",
            forceQueueDescription: "فقط جهات الاتصال المملوكة يتم تعيينها تلقائيًا، مما يجبر جهات الاتصال بدون مالك على الانتظار في الطابور.",
            showNoOwnerContactsToAdmins: "عرض جهات الاتصال بدون مالك فقط للمسؤولين",
            showNoOwnerContactsDescription: "جهات الاتصال بدون مالك مرئية فقط للمسؤولين.",
            autoAssignOwner: "تعيين مالك الاتصال تلقائيًا",
            autoAssignOwnerDescription: "عندما يتم تعيين الدردشة تلقائيًا لممثل، يتم تعيينها أيضًا كمالك.",
            creator: "المنشئ",
            hideShow: "إخفاء / عرض",
            url: "URL",
            cannedMessages: "رسائل جاهزة",
            templateMessages: "رسائل نموذجية",
            chatbots: "الدردشة الآلية",
            noCannedMessages: "لم يتم العثور على رسائل جاهزة",
            filterToFindMore: "يمكنك العثور على المزيد من الرسائل الجاهزة عن طريق تغيير الفلاتر الخاصة بك.",
            runPrompt: "تشغيل الموجه",
            noLeadsFound: "لم يتم العثور على أي عملاء محتملين لهذا الشخص",
            deals: "صفقات",
            noDealsFound: "لم يتم العثور على أي صفقات لهذا الشخص",
            loadingDeals: "جارٍ تحميل الصفقات",
            zohoCRM: "Zoho CRM",
            viewContact: "عرض الاتصال",
            noNotesAdded: "لم يتم إضافة أي ملاحظات بعد",
            attachments: "مرفقات",
            addNewNote: "إضافة ملاحظة جديدة",
            savingg: "جارٍ الحفظ...",
            warningFillFields: "يرجى ملء حقول العنوان والمحتوى.",
            successNoteAdded: "تمت إضافة الملاحظة بنجاح.",
            errorAddingNote: "حدث خطأ أثناء إضافة الملاحظة.",
            noteTitle: "عنوان الملاحظة",
            noteContent: "محتوى الملاحظة",
            selectPreferredAgent: "اختر الوكيل المفضل الذي تريد تعيينه للزائر.",
            postOperations: "عمليات النشر",
            loadingPostOperations: "جارٍ تحميل عمليات النشر",
            noPostOperations: "لم يتم العثور على عمليات نشر لهذا الشخص",
            postOperationDetails: "تفاصيل عملية النشر",
            noMediaDocuments: "لا توجد وسائط أو مستندات متاحة لهذه الشخص.",
            selectionLimitError: "يمكنك اختيار حد أقصى 30 عنصرًا.",
            showNote: "إظهار الملاحظة للجميع",
            hideNote: "إخفاء الملاحظة",
            updateNote: "تحديث الملاحظة",
            addUserNote: "أضف ملاحظة حول المستخدم",
            privateNote: "ملاحظة خاصة",
            metaReferrals: "إحالات ميتا",
            noMetaReferrals: "لم يتم العثور على تفاعلات إعلانات ميتا.",
            searchPrompt: "ابحث عن شيء.",
            noRecentResults: "لم يتم العثور على نتائج حديثة.",
            contactInfo: "معلومات الاتصال",
            noPropertiesAdded: "لم يتم إضافة أي خصائص بعد.",
            propertyAddedUpdated: "تمت إضافة/تحديث الخاصية بنجاح.",
            propertyError: "حدث خطأ أثناء إضافة/تحديث الخاصية.",
            propertyDeleted: "تم حذف الخاصية بنجاح.",
            propertyDeleteError: "حدث خطأ أثناء حذف الخاصية.",
            zohoSynchronization: "مزامنة زوهو",
            zohoSyncConfirmation: "هل تريد إجراء تغييرات على الشخص في زوهو أيضًا؟",
            hideOtherInfo: "إخفاء معلومات أخرى",
            showOtherInfo: "عرض معلومات أخرى",
            whatsappChatStart: "بدء دردشة واتساب",
            ownership: "ملكية العميل",
            countryAndLanguage: "البلد، اللغة",
            calendarEvent: "حدث تقويم",
            reservation: "حجز",
            contact: "اتصال",
            user: "مستخدم",
            customerOwnership: "ملكية العميل",
            ownerless: "بدون مالك",
            preferredDepartment: "القسم المفضل",
            flowluTransfer: "نقل إلى Flowlu",
            mergeSuccess: "تمت عملية الدمج بنجاح.",
            visitorOwnershipWarning: "هذا الزائر مملوك من قبل مستخدم آخر.",
            newAutomation: "أتمتة جديدة",
            automations: "الأتمتة",
            createProfileAutomation: "إنشاء أتمتة الملف الشخصي",
            profileButtonClicked: "تم النقر على زر الملف الشخصي",
            profileButtonDescription: "سيتم تفعيل هذه الأتمتة عند النقر على زر الملف الشخصي.",
            automationName: "اسم الأتمتة",
            create: "إنشاء",
            dayRange: "نطاق الأيام",
            hourRange: "نطاق الساعات",
            last24Hours: "آخر 24 ساعة",
            today: "اليوم",
            yesterday: "أمس",
            thisWeek: "هذا الأسبوع",
            lastWeek: "الأسبوع الماضي",
            last7Days: "آخر 7 أيام",
            last30Days: "آخر 30 يومًا",
            thisMonth: "هذا الشهر",
            lastMonth: "الشهر الماضي",
            startDateTime: "تاريخ ووقت البدء",
            endDateTime: "تاريخ ووقت الانتهاء",
            complaint: "شكوى",
            opens: "فتح",
            clicks: "نقرات",
            mockData: "(بيانات وهمية)",
            preferredRepresentative: "اختيار الوكيل المفضل",
            forwardToDepartment: "إرسال إلى القسم",
            toMobileAgents: "الوكلاء المحمولين",
            noMediaAndDocuments: "لا يوجد ميديا وملفات لهذا المستخدم",
            reportBug: "إبلاغ عن خطأ",
            waitingForReply: "في انتظار الرد",
            memorySize: "حجم الذاكرة",
            usedMemory: "الذاكرة المستخدمة",
            availableMemory: "الذاكرة المتاحة",
            memoryLimit: "الحد الأقصى للذاكرة",
            memoryLimitPrice: "التكلفة للذاكرة الإضافية",
            telegramBotIsReachable: "يمكن الوصول إلى خدمة روبوت تيليجرام",
            telegramBotIsHealthy: "خدمة روبوت تيليجرام صحية",
            telegramBotIsUnhealthy: "يوجد خطأ في خدمة روبوت تيليجرام",
            pieView: "عرض دائري",
            chartView: "عرض الرسم البياني",
            tableView: "عرض الجدول",
            lastUpdate: "آخر تحديث",
            task: "مهمة",
            filterBy: "حسب الفلتر",
            watchAllLive: "مشاهدة جميع البث المباشر",
            sessionsUnique: "الجلسات (المستخدمون الفريدون)",
            sessionsAll: "الجلسات (جميع المستخدمين)",
            moreFeaturesDesc: "المزيد من الميزات، والمزيد من عمليات التكامل، والمزيد من الوكلاء! اتخذ إجراءً الآن لإدارة فريقك بشكل أفضل وتنمية أعمالك إلى أقصى إمكاناتها!",
            metaLeadForms: "نماذج MetaLeads",
            metaLeadsConnectedSucs: "تم توصيل MetaLeads بنجاح",
            failedToConnectMetaLeads: "فشل الاتصال بنماذج MetaLeads",
            forbiddenChannel: "قناة محظورة",
            forbiddenChannelDesc: "غير مسموح لك بعرض هذه القناة",
            firstContact: "جهة الاتصال الأولى",
            needsAnalysis: "تحليل الاحتياجات",
            offerSent: "العرض المرسل",
            offerReview: "مراجعة العرض",
            decisionPhase: "مرحلة القرار",
            personDeleted: "الشخص المحذوف",
            metaLeadsIntegration: "تكامل العروض الوصفية",
            phoneNumberIsInvalid: "رقم الهاتف غير صالح",
            owner: "المالك",
            addAnItem: "إضافة عنصر",
            saveItem: "حفظ عنصر",
            customItem: "عنصر مخصص",
            backgroundPhoto: "صورة الخلفية",
            whenYouActivateFeature: "عند تفعيل هذه الميزة، لن تظهر في صفحة الحجز",
            logo: "الشعار",
            noLogo: "لا يوجد شعار",
            addTeamMember: "إضافة عضو فريق",
            timezone: "المنطقة الزمنية",
            selectDayys: "تحديد يوم (أيام)",
            selectStartHour: "تحديد وقت البدء",
            selectEndHour: "تحديد وقت الانتهاء",
            moveLeft: "تحريك لليمين",
            moveRight: "تحريك لليسار",
            address: "العنوان",
            reply: "الرد",
            replyToAll: "الرد على الكل",
            deleteThreadMessage: "حذف رسالة الموضوع",
            totalEmailsBounced: "إجمالي رسائل البريد الإلكتروني المرتجعة",
            totalEmailsComplained: "إجمالي رسائل البريد الإلكتروني المشكو منها",
            untilNowTotalEmailOpens: "إجمالي رسائل البريد الإلكتروني التي تم فتحها حتى الآن",
            untilNowTotalEmailLinkClicks: "إجمالي نقرات رابط البريد الإلكتروني حتى الآن",
            uniqueClicks: "إجمالي النقرات الفريدة",
            untilNowTotalUniqueEmail: "إجمالي النقرات الفريدة على رابط البريد الإلكتروني حتى الآن (لكل مستلم)",
            emailCampaignTimeline: "المخطط الزمني لحملة البريد الإلكتروني",
            receivedBroadcasts: "عمليات البث المستلمة",
            groupDeletedSuccessfully: "تم حذف المجموعة بنجاح",
            verify: "تم التحقق",
            done: "تم",
            pleaseSelectAnEmailAddress: "الرجاء تحديد عنوان بريد إلكتروني",
            goBack: "رجوع",
            show: "إظهار",
            vueEmailEditor: "محرر البريد الإلكتروني فيو (تجريبي)",
            saveDesign: "حفظ التصميم",
            exportHTML: "تصدير HTML",
            saveAsAsEmailCustomerGroup: "الحفظ كمجموعة عملاء البريد الإلكتروني",
            saveAsAsWhatsAppCustomerGroup: "حفظ كمجموعة عملاء واتساب",
            deleteModalModalFormDesc: "إذا قمت بحذف هذا النموذج، فسيتم حذف جميع بيانات النموذج نهائيًا. هل أنت متأكد من رغبتك في المتابعة؟",
            todo: "أشياء يجب القيام بها",
            inProgress: "قيد التنفيذ",
            approval: "موافقة",
            completed: "مكتمل",
            transactionType: "نوع المعاملة",
            previousBalance: "الرصيد السابق",
            nextBalance: "الرصيد التالي",
            amount: "المبلغ",
            wpIntegrationChannelRequired: "مطلوب قناة تكامل الويب الخاصة بـ Whatsapp",
            wpIntegrationChannelRequiredDesc: "يتطلب تكامل واتساب + Whatsapp Web قناة Whatsapp Web. يُرجى إنشاء قناة جديدة.",
            wabaIntegrationChannelRequired: "مطلوب قناة تكامل واتساب للأعمال.",
            wabaIntegrationChannelRequiredDesc: "يتطلب تكامل واجهة برمجة تطبيقات واتساب للأعمال تكامل Whatsapp Business API قناة الويب الخاصة بـ Whatsapp. يُرجى إنشاء قناة جديدة.",
            instaIntegrationChannelRequired: "مطلوب قناة تكامل Instagram.",
            instaIntegrationChannelRequiredDesc: "يتطلب تكامل chatbot + Instagram قناة Instagram. يُرجى إنشاء قناة جديدة.",
            createWpChannel: "إنشاء قناة واتساب على الويب",
            createWabaChannel: "إنشاء قناة Whatsapp Business API",
            createInstaChannel: "إنشاء قناة Instagram",
            failToDeleteGroup: "فشل حذف المجموعة",
            failToDeleteGroups: "فشل في حذف المجموعات",
            failToFetchGroupContacts: "فشل في جلب جهات اتصال المجموعة",
            mailAddressDeletedSuccessfully: "تم حذف عنوان البريد بنجاح",
            defaultMailAddressChangedSuccessfully: "تم تغيير عنوان البريد الافتراضي بنجاح",
            mailAddressAlreadyRegistered: "لا يمكن أن يكون عنوان البريد مسجلاً بالفعل أو فارغاً.",
            pleaseVerifyByClicking: "الرجاء التحقق بالنقر على الرابط المرسل إلى عنوان بريدك الإلكتروني.",
            signSucsRegistered: "تم تسجيل التوقيع بنجاح",
            myContacts: "جهات الاتصال الخاصة بي",
            unanswered: "لم يتم الرد",
            emailBroadcasts: "عمليات البث عبر البريد الإلكتروني",
            monthlyLimit: "الحد الشهري",
            totalShipments: "إجمالي الشحنات",
            shippingStatus: "حالة الشحن",
            lastAction: "آخر إجراء",
            receiver: "المستلم",
            delivered: "تم التسليم",
            opened: "تم الفتح",
            clicked: "تم النقر",
            bounced: "عاد",
            clickedLinks: "تم النقر فوق الروابط",
            reason: "السبب",
            timer: "مؤقت",
            implemented: "تم التنفيذ؟",
            module: "الوحدة النمطية",
            excelDownload: "تنزيل Excel",
            serviceFeatures: "ميزات الخدمة",
            mailAddressDeletedSucs: "تم حذف عنوان البريد بنجاح",
            inputSearchText: "إدخال نص البحث",
            createRecord: "إنشاء سجل",
            separatorCharacter: "حرف فاصل",
            exampleResultPreview: "مثال على معاينة النتيجة",
            importRecords: "استيراد السجلات",
            equals: "يساوي",
            notEquals: "غير متساوٍ",
            startsWith: "يبدأ ب",
            endsWith: "ينتهي ب",
            greaterThan: "أكبر من",
            lessThan: "أقل من",
            before: "قبل",
            after: "بعد",
            is: "يكون",
            isNot: "ليس",
            empty: "فارغ",
            notEmpty: "غير فارغ",
            isOneOff: "مرة واحدة",
            field: "حقل",
            records: "سجل",
            addIntegration: "إضافة تكامل",
            chatbotScenarioReleased: "تم إصدار سيناريو روبوت المحادثة",
            chatbotScenarioHasBeenCancelled: "تم إلغاء سيناريو روبوت الدردشة الآلية",
            titleAndDesc: "العنوان والوصف",
            templateAndMailSelection: "اختيار القالب والبريد",
            peopleToSend: "الأشخاص المراد الإرسال إليهم",
            submissionPlans: "خطة التقديم",
            summary: "الملخص",
            broadcastTitle: "عنوان البث",
            sentByEmail: "البريد الإلكتروني المرسل",
            emailTemplate: "قالب البريد الإلكتروني",
            onlyPeopleWithEmail: "فقط الأشخاص الذين لديهم عنوان بريد إلكتروني صالح للإرسال",
            sendNow: "إرسال الآن",
            plan: "الخطة",
            senderEmail: "البريد الإلكتروني للمرسل",
            totalBuyer: "إجمالي المشتري",
            estimatedDuration: "المدة المقدرة",
            person: "الشخص",
            shippingIsNowComplete: "اكتمل الشحن!",
            back: "رجوع",
            customerName: "اسم العميل",
            customerEmail: "البريد الإلكتروني للعميل",
            customValue: "قيمة مخصصة",
            selectMailTemplate: "يجب عليك تحديد قالب بريد",
            youMustSelectSendingMailAddress: "يجب تحديد عنوان البريد المرسل.",
            youMustSelectCustomerGroupSend: "يجب تحديد مجموعة العملاء المراد الإرسال إليها.",
            createBroadcast: "إنشاء بث",
            broadcastDetails: "تفاصيل البث",
            youCanCheckYourEmailStatus: "يمكنك التحقق من حالة بريدك الإلكتروني عن طريق ترقية خطتك. يمكنك التحقق من حالة بريدك الإلكتروني عن طريق ترقية خطتك.",
            sentDetails: "التفاصيل المرسلة",
            failed: "فشل",
            total: "إجمالي",
            totalEmailsProcessed: "إجمالي رسائل البريد الإلكتروني التي تمت معالجتها",
            totalEmailsDelivered: "إجمالي رسائل البريد الإلكتروني المرسلة",
            toAvailableAgents: "للوكلاء المتاحين",
            toAvailableDepartments: "للأقسام المتاحة",
            toWithAgentAndDepartment: "للوكلاء والأقسام المتاحة",
            toMobilAgents: "للوكلاء المتنقلين",
            toPreferredAgents: "للوكلاء المفضلين",
            searchAgent: "وكيل البحث",
            searchDepartment: "قسم البحث",
            searchMobileAgent: "وكيل البحث المتنقل",
            searchAgentOrDepartment: "وكيل البحث أو القسم",
            searchPreferredAgent: "البحث عن الوكيل المفضل",
            noAgentsAvailableToForward: "لا يوجد وكلاء متاحين لإعادة التوجيه",
            noDepartmentsAvailableToForward: "لا توجد أقسام متاحة لإعادة التوجيه",
            checkChannelVisibilityTitle: "تحقق من إعدادات خصوصية القناة",
            checkChannelVisibilityDescription: "إذا لم تتمكن من رؤية بعض الأقسام، تحقق من إعدادات خصوصية القناة",
            goToChannelSettings: "الذهاب إلى إعدادات القناة",
            noMobileAgentsAvailableToForward: "لا يوجد وكلاء متنقلون متاحون لإعادة التوجيه",
            noPreferredAgentsAvailableToForward: "لا يوجد وكلاء مفضلون متاحون لإعادة التوجيه",
            ifYouSendThisConversationToTheQueue: "إذا قمت بإرسال هذه المحادثة إلى قائمة الانتظار، فسيتم إزالتك من الدردشة ووضع المحادثة في قائمة الانتظار. إذا تم تمكين التخصيص التلقائي للمحادثة، فسيتم تعيين المحادثة إلى وكيل مناسب وقد يتم تحويلها إليك.",
            ifAutomaticChatAssignmentIsDisabled: "إذا تم تعطيل التخصيص التلقائي للمحادثة فستبقى المكالمة في قائمة الانتظار. يمكن للموظفين المصرح لهم استلام المكالمة من قائمة الانتظار.",
            sendQueue: "إرسال إلى قائمة الانتظار",
            agentName: "اسم الوكيل",
            departmentName: "اسم القسم",
            toQueue: "قائمة الانتظار",
            mobile: "موبايل",
            noGrouping: "بدون تجميع",
            groupByThis: "تجميع حسب هذا",
            selectGroupingCriteria: "تحديد معايير التجميع",
            activeUsers: "المستخدمون النشطون",
            passiveUsers: "المستخدمون السلبيون",
            noPlatform: "لا توجد منصة محددة",
            noRole: "دور غير محدد",
            noDepartment: "لا يوجد قسم محدد",
            noLanguage: "لا توجد لغة محددة",
            group2: "مجموعة",
            groupedByStatus: "مجمعة حسب الحالة",
            grouping: "تجميع",
            activeSubjects: "الموضوعات النشطة",
            passiveSubjects: "الموضوعات المنفعلة",
            groupSubjects: "مواضيع المجموعة",
            showAll: "إظهار الكل",
            onlyActive: "نشط فقط",
            onlyPassive: "السلبي فقط",
            selectTimezone: "تحديد المنطقة الزمنية",
            userFilter: "عامل تصفية المستخدم",
            confidenceScore: "درجة الثقة",
            chatbotLanguage: "لغة روبوت المحادثة",
            botScenerio: "سيناريو الروبوت",
            selectTemplate: "تحديد القالب",
            ImportFromReadyTemplates: "الاستيراد من القوالب الجاهزة",
            classification: "تصنيف",
            addClassification: "إضافة تصنيف",
            expressionClassified: "التعبير المراد تصنيفه",
            zohoModuleName: "اسم وحدة Zoho",
            selectModule: "تحديد الوحدة النمطية",
            standardFields: "الحقول القياسية",
            selectStandardField: "تحديد حقل قياسي",
            customFields: "الحقول المخصصة",
            selectCustomFields: "تحديد حقل مخصص",
            aiFunction: "وظيفة الذكاء الاصطناعي",
            aiFunctionDesc: "إدارة دالة الذكاء الاصطناعي لتنفيذ إجراءات بناءً على مدخلات المستخدم",
            functionName: "اسم الدالة",
            functionDesc: "وصف الدالة",
            addParameter: "إضافة معلمة",
            chooseAiStory: "اختيار قصة ذكاء اصطناعي",
            chatbotAiPromptDesc: "الذكاء الاصطناعي يتعلم ويحدد كيف يجب أن يتصرف من خلال إعطائه تعليمات حول مهمة أو مشكلة معينة باستخدام ميزة 'المطالبة'.",
            enterPrompt: "أدخل الموجه",
            aiParameterTunings: "ضبط معلمة الذكاء الاصطناعي",
            aiParameterTuningsDesc: "يمكنك ضبط معلمات الذكاء الاصطناعي لجعل الذكاء الاصطناعي أكثر استجابة ودقة. تُستخدم هذه المعلمات للتحكم في سلوك الذكاء الاصطناعي وكيفية استجابته لمدخلات المستخدم.",
            temperature: "درجة الحرارة",
            temperatureDesc: "درجة حرارة أخذ العينات التي يجب استخدامها، بين 0 و 2. القيم الأعلى مثل 0.8 ستجعل الإخراج أكثر عشوائية، بينما القيم الأقل مثل 0.2 ستجعله أكثر تركيزًا وحتمية.",
            topDesc: "كبديل لأخذ العينات حسب درجة الحرارة، ما يسمى بأخذ العينات النواة (kernel sampling)، يأخذ النموذج في الاعتبار نتائج الرموز ذات الكتلة الاحتمالية الأعلى_p. لذا فإن 0.1 يعني أن الرموز ذات الكتلة الاحتمالية الأعلى بنسبة 10% فقط هي التي تؤخذ بعين الاعتبار. نوصي عادةً بتغيير هذا أو درجة الحرارة، ولكن ليس كليهما.",
            toolChoices: "خيارات الأداة",
            noneDesc: "لا شيء يعني أن النموذج لن يستدعي أي أداة وبدلاً من ذلك سينشئ رسالة.",
            autoDesc: "الوضع التلقائي هو القيمة الافتراضية ويعني أن النموذج يمكنه الاختيار بين توليد رسالة أو استدعاء عامل أو أكثر.",
            requiredDesc: "الوضع المطلوب يعني أن النموذج يجب أن يستدعي وكيلًا واحدًا أو أكثر قبل الاستجابة للمستخدم.",
            createArticles: "إنشاء مقالة",
            createArticlesDesc: "إنشاء مقالات لمساعدة المستخدمين في العثور على إجابات لأسئلتهم.",
            articlesTitle: "عنوان المقالة",
            articlesContent: "محتوى المقالة",
            createFaq: "إنشاء أسئلة متكررة (FAQ)",
            createFaqDesc: "إنشاء أسئلة متكررة جديدة لروبوت الدردشة الخاص بك. سيساعد هذا روبوت الدردشة الآلي في الإجابة عن أسئلة المستخدم.",
            question: "سؤال",
            saveAndClose: "حفظ وإغلاق",
            contentPreview: "معاينة المحتوى",
            upgradePackageTitle: "قم بترقية باقتك وتجنب القيود",
            upgradePackageDescription: "المزيد من الميزات، والمزيد من عمليات التكامل، والمزيد من الوكلاء! اتخذ إجراءً الآن لإدارة فريقك بشكل أفضل وزيادة إمكانات عملك إلى أقصى حد!",
            upgradePackage: "الترقية",
            deleteSelected: "حذف الملفات المحددة",
            newFolder: "مجلد جديد",
            newFile: "ملف جديد",
            noFilesFound: "لم يتم العثور على ملفات في هذا المجلد",
            uploadFile: "تحميل ملف",
            enterFolderName: "الرجاء إدخال اسم المجلد",
            folderName: "اسم المجلد",
            dropFileHere: "إسقاط الملفات هنا",
            createFolder: "إنشاء مجلد",
            fileUploadingError: "حدث خطأ أثناء تحميل ملف",
            fileUploadingSucs: "تم إنشاء المجلد بنجاح",
            folderNameNotEmpty: "لا يمكن أن يكون اسم المجلد فارغًا",
            deleteFolder: "حذف مجلد",
            sureDeleteFolder: "هل تريد بالتأكيد حذف هذا المجلد وجميع الملفات الموجودة فيه؟",
            deletionSucs: "تم الحذف بنجاح",
            deleteFile: "حذف ملف",
            sureDeleteFile: "هل أنت متأكد من أنك تريد حذف هذا الملف؟",
            deletionError: "حدث خطأ أثناء عملية الحذف",
            selectFile: "تحديد ملف",
            moreThanOneSelect: "يمكنك تحديد أكثر من ملف واحد",
            selectAnFile: "تحديد ملف",
            removeZohoLinkbulkSms: "إرسال رسائل نصية قصيرة مجمعة",
            sendBulkBulkSmsCustomers: "إرسال رسائل نصية قصيرة مجمعة إلى عملائك",
            writeYourMessage: "اكتب رسالتك هنا",
            sendSms: "إرسال رسائل نصية قصيرة",
            sendSmsYourCustomers: "إرسال رسائل قصيرة إلى عملائك",
            manageChannelDetail: "إدارة معلومات القناة",
            details: "التفاصيل",
            teamGramChannels: "قنوات TeamGram",
            newTeamGramIntegration: "تكامل TeamGram الجديد",
            teamGramIntegration: "تكامل TeamGram",
            notMoreThanOneTeamGramChannels: "لا يمكنك إنشاء أكثر من قناة TeamGram واحدة",
            teamGramDetail: "تفاصيل TeamGram",
            manageYourYourTeamGramIntegration: "إدارة تكامل TeamGram الخاص بك",
            trendyolChannels: "قنوات ترينديول",
            trendyolStoreIntegration: "تكامل متجر ترينديول",
            trenyolStoreConnection: "توصيل متجر ترينديول الخاص بك",
            deleteTrendyolIntegration: "حذف تكامل ترينديول",
            sureDeleteTrendyolIntegration: "هل أنت متأكد من رغبتك في حذف تكامل Trendyol؟ هذا الإجراء لا رجعة فيه.",
            trendyolStoreChannel: "قناة متجر ترينديول",
            deleteTrendyolChannel: "حذف قناة ترينديول",
            channelUpdatedSucs: "تم تحديث القناة بنجاح",
            failedUpdateChannel: "فشل تحديث القناة.",
            trendyolStoreIntegrationDetail: "تفاصيل تكامل متجر ترينديول",
            configureTrendyolStoreStoreIntegrationDetail: "تكوين تكامل متجر ترينديول الخاص بك",
            trenyolStoreProductQuestManage: "Trendyol Store - إدارة مهام المنتج",
            trendyolStoreDesc: "يمكنك استخدام الإعدادات التالية لإدارة الاستفسارات الخاصة بمنتجات متجر ترينديول.",
            zohoCrmChannels: "قنوات Zoho CRM",
            zohoPersonalChannel: "قنوات زوهو الشخصية",
            connectZohoZoho: "الاتصال بـ Zoho CRM",
            updateChannelDesc5: "تحديث قناة Zoho CRM",
            zohoCrmIntegration: "تكامل Zoho CRM",
            sureDeleteDeleteZohoChannel: "هل أنت متأكد من رغبتك في حذف قناة Zoho CRM؟",
            createNotMoreThanOneZohoChannels: "لا يمكنك إنشاء أكثر من قناة Zoho واحدة",
            removeZohoLink: "إزالة رابط Zoho",
            connectToZoho: "الاتصال ب Zoho",
            chatClosed: "تم إغلاق الدردشة",
            scoreChat: "تم تسجيل الدردشة",
            createdTicket: "تم إنشاء تذكرة",
            updatedTicket: "تم تحديث التذكرة",
            newUserCreated: "تم إنشاء مستخدم جديد",
            updateUser: "مستخدم محدث",
            deleteUsers: "تم حذف مستخدم",
            changeStatusRepresent: "تم تغيير حالة الممثل",
            incomingMessage: "رسالة واردة",
            outgoingMessage: "رسالة صادرة",
            createdNewTicket: "تم إنشاء تذكرة جديدة",
            bitrix24Channels: "قنوات Bitrix24",
            sureDeleteBitrixChannel: "هل أنت متأكد أنك تريد حذف قناة Bitrix24؟",
            bitrix24Integrations: "تكامل Bitrix24",
            notCreateMoreThanOneChannel: "لا يمكنك إنشاء أكثر من قناة واحدة من قنوات Ideasoft",
            connectToBitrix24: "الاتصال بـ Bitrix24",
            connectToBitrix24Api: "الاتصال ب Bitrix24 Api",
            updateChannel: "تحديث القناة",
            updateChannelDesc: "تحديث قناة Bitrix24 Api",
            yourBitrix24Domain: "اسم مجال Bitrix24 الخاص بك",
            bitrix24ConnectedSucs: "تم توصيل Bitrix24 بنجاح",
            failedToConnectBitrix24: "فشل الاتصال بـ Bitrix24",
            channelCreatedSuccessfully: "تم إنشاء القناة بنجاح",
            failedToCreateChannel: "فشل إنشاء قناة",
            holidayPlusChannels: "قنوات Holiday+Channels",
            newHolidayPlusIntegration: "تكامل جديد لـ Holiday+",
            holidayPlusIntegrations: "تكامل Holiday+",
            notCreateMoreThanOneHolidayChannel: "لا يمكنك إنشاء أكثر من قناة عطلة+ واحدة",
            holidayPlusDetail: "تفاصيل العطلة+",
            manageHolidayPlusIntegration: "إدارة تكامل Holiday+ الخاص بك",
            ideasoftChannels: "قنوات Ideasoft",
            connectToIdeasoft: "الاتصال بـ Ideasoft",
            connectToIdeasoftApi: "الاتصال بواجهة برمجة تطبيقات Ideasoft",
            updateChannelDesc2: "تحديث قناة واتس آب للأعمال",
            ideasoftIntegration: "تكامل Ideasoft",
            sureDeleteIdeasoftChannel: "هل تريد بالتأكيد حذف قناة Ideasoft؟",
            moreThanOneChannelError: "لا يمكنك إنشاء أكثر من قناة Ideasoft واحدة",
            websiteAddress: "عنوان موقع الويب",
            ideasoftConnectedSucs: "تم توصيل Ideasoft بنجاح",
            failedToConnectIdeasoft: "فشل الاتصال بـ Ideasoft",
            redirectURLcopiedToClipboard: "إعادة توجيه عنوان URL المنسوخ إلى الحافظة",
            openAIChannels: "فتح قنوات الذكاء الاصطناعي",
            newOpenAiChannel: "قناة OpenAI جديدة",
            createNewChannelOpenAi: "إنشاء قناة جديدة ل OpenAI",
            updateChannelDesc3: "تحديث قناة واتساب لـ Whatsapp business api",
            openAiIntegration: "تكامل OpenAI",
            sureDeleteOpenAiChannel: "هل أنت متأكد من رغبتك في حذف قناة OpenAI؟",
            createMoreThanOneOpenAiChannel: "لا يمكنك إنشاء أكثر من قناة OpenAI واحدة",
            postaCellChannels: "قنوات PostaCell",
            newPostaCellChannel: "قنوات PostaCell الجديدة",
            createNewPostaCellChannel: "إنشاء قناة جديدة لمزود خدمة الرسائل القصيرة لـ PostaCell",
            updateChannelDesc4: "تحديث قناة Whatsapp business api",
            accessControl: "التحكم في الوصول",
            leads: "الرصاص",
            ensureFacebookAccount: "تأكد من وجود حساب وصفحة على فيسبوك",
            ensureAdAccount: "تأكد من وجود حساب إعلاني",
            page: "الصفحة",
            leadCount: "عدد العملاء المحتملين",
            showLeads: "إظهار العملاء المحتملين",
            syncLeeds: "مزامنة ليدز",
            wpStartChat: "مشغل دردشة واتساب",
            archivedIn: "مؤرشف؟",
            makeSelect: "إجراء التحديد",
            newLead: "Leed الجديد",
            initialContact: "جهة الاتصال الأولى",
            needsAssessment: "تحليل الاحتياجات",
            proposalSent: "إرسال العرض",
            proposalReview: "مراجعة العرض",
            negotiation: "التفاوض",
            decisionStage: "مرحلة القرار",
            closure: "إغلاق",
            followUp: "متابعة",
            campaign: "حملة",
            adSet: "مجموعة الإعلانات",
            ad: "إعلان",
            inArchived: "مؤرشف",
            deletedSelectedPerson: "حذف الأشخاص المحددين",
            sureDelSelectedPerson: "هل أنت متأكد من رغبتك في حذف الأشخاص المحددين؟",
            deletePerson: "حذف الأشخاص المحددين",
            sureDeletePerson: "هل أنت متأكد من رغبتك في حذف الشخص؟",
            phoneNumberNotAvailable: "رقم الهاتف غير متوفر",
            statusSucsUpdated: "تم تحديث الحالة بنجاح",
            statusUpdatedFailed: "حدث خطأ أثناء تحديث الحالة",
            archivedContact: "أرشفة جهة الاتصال",
            sureWantArchivePerson: "هل أنت متأكد أنك تريد أرشفة هذا الشخص؟",
            personArchived: "شخص مؤرشف",
            personArchivedHead: "فشلت عملية الأرشفة",
            metaLeadChannels: "قنوات ميتا ليد",
            wpStartSpeech: "بادئ خطاب واتساب",
            pleaseSelectStartChat: "الرجاء تحديد القناة التي تريد بدء الدردشة عليها:",
            phoneNumber: "رقم الهاتف",
            phoneNumberDesc: "رمز البلد مع أرقام فقط بدون مسافات",
            channelDesc: "القناة التي تريد بدء الدردشة عليها",
            pleaseSelectStartChatOn: "يرجى تحديد القناة التي تريد بدء الدردشة عليها",
            notAuthorisedChannel: "أنت غير مصرح لك بالوصول إلى هذه القناة.",
            phoneNumberError: "رقم الهاتف غير صحيح",
            chatStartError: "حدث خطأ في بدء الدردشة. يرجى المحاولة مرة أخرى.",
            noRecordFailed: "لم يتم العثور على سجل",
            metaLeadsChannel: "قناة MetaLeads Leads",
            mlChannelDetails: "تفاصيل قناة Meta Leads",
            manageMlChannel: "إدارة قناة العروض الوصفية",
            deleteMetaLeadsChannelInfo: "هل أنت متأكد من أنك تريد حذف قناة Meta Leads؟",
            contactPage: "صفحة الاتصال",
            addRouted: "إضافة موجه",
            otherEmailProviders: "موفرو البريد الإلكتروني الآخرون",
            visitorScreenLabel: "تسمية شاشة الزائر",
            enterCatalogTitle: "أدخل عنوان الكتالوج...",
            passwordUpdate: "تحديث كلمة المرور",
            showCenterScreen: "العرض في منتصف الشاشة",
            skipNow: "تخطى الآن",
            confirm: "تأكيد",
            newTable: "جدول جديد",
            actions: "معاملات",
            integrationsTrendyol: "اربط متجرك على Trendyol ورد على استفسارات عملائك تلقائيًا",
            integrationsHoliday: "قم بدمج Holiday+ لتوفير الفنادق والغرف عبر الدردشة الآلية",
            integrationsTeamgram: "انقل عملائك من Supsis إلى Teamgram لتبسيط إدارة العملاء لديك",
            integrationsTicimax: "أرسل رسالة آلية إلى الأعضاء المجزئين في Ticimax",
            integrationsBitrix24: "قم بتفعيل API Bitrix24 لتحسين تجربة الدردشة الآلية لعملائك",
            integrationsIdeasoft: " قم بتفعيل API Ideasoft لتحسين تجربة الدردشة الآلية لعملائك",
            integrationsOpenAI: "تفعيل خدمات OpenAI استجابة الذكاء الاصطناعي للدردشة, مساعد الذكاء الاصطناعي CoPilot قاعدة معلومات الذكاء الاصطناعي للدردشة",
            integrationsSMSPostacell: "قم بتفعيل إرسال الرسائل النصية عبر مزود خدمة الرسائل النصية PostaCELL",
            integrationsMetaLeads: "قم بإدارة عملاء Meta المحتملين عبر Supsis اربط العملاء المحتملين بالتذاكر أو روبوت الدردشة أو الدعم المباشر",
            integrationsZoho: "ادمج عملياتك التجارية في Zoho CRM مع Supsis.",
            forward: "إلى الأمام",
            packUpRequired: "مطلوب ترقية الحزمة",
            upgradePack: "باقة الترقية",
            supsisMobilApp: "تطبيق SUPSIS MOBİL",
            supsisMobilAppDesc: "تطبيق IOS و Android في السوق!",
            sendEmail: "إرسال بريد إلكتروني",
            jumpToMessage: "انقر للانتقال إلى الرسالة",
            doesntMatter: "لا يهم",
            events: "أحداث التقويم",
            reservations: "الحجوزات",
            designer: "مصمم",
            targetContacts: "جهات الاتصال المستهدفة",
            scheduler: "المجدول",
            planAndTask: "الخطة والمهام",
            insights: "رؤى",
            createRole: "إنشاء دور",
            createSubject: "إنشاء موضوع",
            createUser: "إنشاء مستخدم",
            blockManuel: "بلوك مانويل",
            showHide: "إظهار/إخفاء",
            contactSearch: "البحث عن جهة الاتصال",
            favorites: "المفضلة",
            downloadAllData: "تنزيل جميع البيانات",
            downloadThePage: "تنزيل الصفحة",
            choosePoints: "اختر النقاط",
            createdAt: "تم إنشاؤها في",
            action: "الإجراء",
            searchChannel: "قنوات البحث",
            activeChannels: "القنوات النشطة",
            deleteChannels: "القنوات المحذوفة",
            selectChannel: "اختر القناة",
            channelFilter: "تصفية القناة",
            noConversationDesc: "هنا يمكنك رؤية الدردشات النشطة والدردشات المخصصة لك.",
            forMe: "بالنسبة لي",
            unAssigned: "غير معين",
            agentDetails: "تفاصيل الوكيل",
            contactProperties: "خصائص الاتصال",
            goToProfile: "اذهب إلى الملف الشخصي",
            addNote: "أضف ملاحظة",
            noPreferredAgent: "لا يوجد وكيل مفضل بعد",
            toPrefer: "تفضيل",
            inChat: "في الدردشة",
            watching: "يشاهد",
            chatsTitle: "المحادثات",
            dealyTimeMaxValueError: "يمكن أن يكون وقت التأخير 15 كحد أقصى",
            dealyTimeTypeError: "يجب أن تكون قيمة وقت التأخير رقما",
            passedTimeHm: "{hour} ساعات {min} دقائق",
            passedTimeMs: "{min} دقائق {sec} ثانية",
            passedTimeSc: "{sec} ثانية",
            translateMessage: "تمت ترجمة رسالتك بواسطة الذكاء الاصطناعي.",
            toneChanged: "تم تغيير نبرة الرسالة إلى {tone}",
            aiResponseAdded: "تمت إضافة استجابة الذكاء الاصطناعي إلى الرسالة",
            messageLonger: "تم جعل الرسالة أطول",
            grammarFixed: "تم تصحيح القواعد",
            aiTranslate: "ترجمة",
            other: "آخر",
            yourLanguage: "لغتك",
            contactLanguage: "لغة العملاء",
            myLanguage: "لغتي",
            forwardToChatbot: "إرسال إلى الروبوت",
            friendly: "ودود",
            confident: "واثق",
            straightForward: "بسيط",
            casual: "غير رسمي",
            professional: "مهني",
            longSentence: "جملة طويلة",
            changeTone: "تغيير النبرة",
            fixGrammar: "تصحيح القواعد",
            aiResponse: "استجابة الذكاء الاصطناعي",
            templateButtonNote: "لحظر الاتصال، تأكد من استخدام النصوص التالية على زر الحظر. بغض النظر عن الأحرف الكبيرة أو الصغيرة",
            templateButtonTags: "#إلغاء الاشتراك# | #حظر# | #منع# | #إلغاء الاشتراك#",
            dashboard: "لوحة القيادة",
            calendarModule: "وحدة التقويم",
            taskModule: "وحدة إدارة المهام",
            maxUrlButtonMessage: "You can add a maximum of 2 URL buttons.",
            noPreferredDepartment: "لا يوجد قسم مفضل",
            searchForDepartment: "البحث عن القسم",
            departmentAssignedToTheVisitor: "حدد القسم الذي ترغب في تعيينه للزائر.",
            assignPreferredDepartment: "تعيين القسم المفضل",
            smsChannel: "قناة الرسائل القصيرة",
            whatsappv2Channel: "قناة واتساب V2",
            whatsappv1Channel: "قناة واتساب V1",
            wBChannel: "قناة واتساب للأعمال",
            messengerChannel: "قناة المراسل",
            instagramChannel: "قناة Instagram",
            allPlatforms: "جميع المنصات",
            cbStartMessage: "رسالة بدء الدردشة الآلية",
            cbStartMessageDesc: "تتم معالجة الرسالة الأولى التي يدخلها المستخدم تلقائيًا بواسطة الدردشة الآلية وتوجيهها إلى العنوان المناسب.",
            messengerUserProfile: "ملف تعريف مستخدم Messenger",
            instagramUserProfile: "ملف تعريف مستخدم Instagram",
            noEventFound: "لم يتم العثور على أحداث",
            visitorMails: "رسائل الزوار",
            visitorActions: "إجراءات الزائرين",
            notVerified: "غير مُتحقق",
            visitorEvents: "أحداث الزوار",
            assignedTasks: "المهام المعينة",
            mails: "رسائل البريد",
            prefferedAgents: "الوكلاء المفضلين",
            createEvent: "إنشاء حدث",
            blockManagement: "إدارة الحظر",
            deleteUser: "حذف المستخدم",
            blocked: "محظور",
            profiles: "الملفات الشخصية",
            similiarProfiles: "تم العثور على ملفات مماثلة",
            ReplyAsAPm: "الرد كرسالة خاصة والإغلاق",
            replyAsAComment: "الرد كتعليق والإغلاق",
            messengerAddDesc: "انقر على الزر الاتصال أدناه وقم بتسجيل الدخول إلى حساب الفيسبوك الخاص بك.",
            instaAddPrivacyCheckDesc: "لقد قرأت وأوافق على {Terms and Conditions} و {Privacy}",
            instaAddDesc5: "انقر على الزر الاتصال أدناه وقم بتسجيل الدخول إلى حساب الفيسبوك الخاص بك.",
            instaAddDesc4: "التسجيل كمطور فيسبوك",
            instaAddDesc3: "تأكد من تفعيل مفتاح <b>'السماح بالوصول إلى الرسائل'</b>",
            instaAddDesc2: "تأكد من أن حسابك المهني في Instagram متصل بصفحتك على الفيسبوك",
            instaAddDesc1: "تأكد من أن حسابك على Instagram هو حساب مهني (حساب تجاري) في Instagram.",
            selectedDepartment: "القسم المحدد",
            departmentForwardEnable: "تم تمكين قاعدة إعادة توجيه القسم",
            departmentForwardRule: "قاعدة إعادة توجيه القسم",
            departmentForwardDesc: "حدد القسم الذي ستُحيل إليه المحادثات الواردة إلى القناة.",
            channelName: "اسم القناة",
            forwardToLiveAgents: "إعادة توجيه إلى الوكلاء الحيين👉 ",
            manageIgChannel: "إدارة قناتك على Instagram",
            igDetail: "تفاصيل إنستجرام",
            manageVisibilityDesc: "إدارة من يمكن أن يرى هذه القناة",
            selectAnIgAccount: "اختر حساب Instagram",
            connectToInsta: "الاتصال بـ Instagram",
            connectToMetaLeads: "Connect to Meta Leads",
            deleteInstaChannelInfo: "هل أنت متأكد أنك تريد حذف قناة Instagram؟",
            instagramChannels: "قنوات إنستجرام",
            suspendedDescription: "لقد تم تعليق حسابك بسبب الفواتير غير المدفوعة.",
            onlyChatbot: "الدردشة فقط",
            onlyAgents: "الوكلاء فقط",
            checkboxWarning: "يجب تحديد هذا الحقل",
            sendingAllow: "إرسال",
            receiving: "استقبال",
            platform: "منصة",
            banModalTitle: "النافذة المنبثقة لحظر الزائر",
            selectDepartmentDesc: "حدد الأقسام التي ترغب في تغيير رؤيتها",
            selectAgentDesc: "حدد الوكلاء الذين ترغب في تغيير رؤيتهم",
            selectDepartment: "حدد القسم",
            selectAgent: "حدد الوكيل",
            visibleDepartments: "الأقسام المرئية",
            visibleAgents: "الوكلاء المرئيين",
            visibilityInfoCont: "يمكن لجميع الوكلاء والإدارات رؤية هذه القناة",
            editDepartmentVisibility: "تحرير أذونات القسم",
            editAgentVisibility: "تحرير أذونات الوكيل",
            typeSTToSearch: "اكتب شيئًا للبحث عن المستخدمين",
            exportToCSV: "تصدير إلى CSV",
            clear: "مسح",
            usedSessionCount: "عدد الجلسات المستخدمة",
            maxSessionCount: "الحد الأقصى لعدد الجلسات",
            leftSessionCount: "عدد الجلسات المتبقية",
            planManagement: "إدارة الخطط",
            maxAutomationTask: "الحد الأقصى لمهام الأتمتة",
            teamChat: "دردشة الفريق",
            templateNameIsNotValid: "اسم القالب غير صالح",
            relatedAdvertisement: "إعلان ذو صلة",
            whatsappNumber: "رقم واتس اب",
            integrationsWhatsappV1: "يتطلب خطة واتساب لتحقيق تواصل سلس بين Supsis و WhatsApp.",
            integrationsWhatsappV2: "يمكنك نقل معلومات الدردشة بسهولة بين Supsis و WhatsApp.",
            integrationsWhatsappBusiness: "يمكنك نقل معلومات الدردشة بسرعة وبشكل ملائم بين Supsis و WhatsApp.",
            selectDays: "اختر الأيام",
            addTime: "اختر الوقت",
            instagramContactList: "قائمة جهات الاتصال على Instagram",
            archiveAllRated: "احصل على جميع المحادثات التي تم فيها إجراء تقييم.",
            allChannels: "جميع القنوات",
            comment: "تعليق",
            news: "ما الاخبار",
            conversation: "حديث الفريق",
            speechTermination: "إنهاء المحادثة",
            noSystemMessage: "لا توجد رسائل في النظام حتى الآن!",
            supsisCustomerService: "خدمات العملاء التي تقدمها Supsis ،",
            supsisClickExperience: "يمكنك تجربة التجربة من خلال النقر.",
            customerPage: "انتقل إلى صفحة العملاء",
            buttonTitle: "عنوان الزر",
            buttonType: "نوع الزر",
            buttonSendMessage: "ارسل رسالة",
            buttonGoToBlock: "اذهب إلى المدونة",
            buttonOpenUrl: "رابط مفتوح",
            buttonPhoneCall: "مكالمة هاتفية",
            buttonOpenMoment: "افتح لحظة",
            buttonCloseChat: "إغلاق الدردشة",
            buttonTransferChat: "نقل الدردشة",
            buttonCreateTicket: "إنشاء تذكرة",
            deleteVisitor: "هل أنت متأكد أنك تريد حذف المستخدم؟ لا يمكن التراجع عن هذا الإجراء.",
            userProfile: "الملف الشخصي",
            addCalendarEvent: "إضافة +",
            you: "أنت",
            and: "و",
            apiIntegration: "مطور",
            generateToken: "إنشاء رمز مميز",
            copyToken: "نسخ الرمز المميز",
            dndBlocked: "تم إيقاف تشغيل إعدادات إرسال الملف.",
            labels: "تسميات",
            noData: "لايوجد بيانات",
            color: "لون",
            titleColor: "لون العنوان",
            secondTitleColor: "لون العنوان الثاني",
            tag_name_indicator: "اسم العلامة",
            sendMessage: "إرسال رسالة",
            removeFromG: "إزالة من المجموعة",
            delChannel: "هل أنت متأكد أنك تريد حذف هذه القناة؟",
            new_name: "اسم جديد",
            set_group_info: "تحرير معلومات المجموعة",
            shortcut_desc_num: "التبديل بين المحادثات النشطة باستخدام الأرقام الرقمية",
            copilot_desc_num: "يسمح لك بفتح Copilot على شاشة الدردشة",
            typing_w_chat: "يكتب...",
            edit_group_info: "تحرير معلومات المجموعة",
            notif_sound: "قم بتشغيل أصوات الإشعارات",
            notif_mute: "كتم الإشعارات",
            leave: "انصرف",
            group: "مجموعة",
            updateTag: "تحديث العلامة",
            ordered_desc: "تخصيص الدردشات للممثلين بالترتيب.",
            random_desc: "تخصيص الدردشات للممثلين بشكل عشوائي.",
            Rrobin_desc: "تخصيص الدردشات للممثلين بأسلوب دوري دائري. (يعطي الأولوية للممثلين الأقل انشغالًا)",
            RrobinRev_desc: "تخصيص الدردشات للممثلين بأسلوب دوري دائري عكسي. (يعطي الأولوية للممثلين الأكثر انشغالًا)",
            algo_desc: "اختر الخوارزمية لتوزيع الدردشات تلقائيًا",
            algorithm: "خوارزمية",
            os_browser: "نظام التشغيل ومتصفح الويب",
            CHAT: "محادثة",
            addTag: "إضافة علامة",
            tags: "العلامات",
            searchRepresentative: "البحث عن مندوب",
            voting: "التصويت",
            chatWidget: "supsis دردشة القطعة",
            webhooks: "Webhooks",
            selectHooks: "حدد خطاف الويب",
            planRequired: "{integratable} الخطة المطلوبة",
            allIntegrations: "جميع التكامل",
            disableAgentSystemMessages: "إخفاء رسائل نظام الوكيل",
            disableAgentSystemMessagesDesc: "إخفاء رسائل نظام الوكيل.",
            disableAutoTranslate: "الترجمة التلقائية",
            disableAutoTranslateDesc: "يترجم الرسائل تلقائياً من اللغات المختلفة. وبالتالي يمكنك التواصل مع عملائك بسهولة أكبر.",
            shouldAddMethod: "يجب عليك ملء طريقة الدفع وعنوان الفواتير!",
            approveSelection: "الموافقة على الاختيار",
            trialDaysEndSelectPlan: "تأكيد اختيار الخطة",
            trialDaysEndSelectPlanDesc: "لقد انتهى نسختك التجريبية. تحتاج إلى التأكيد من خلال اختيار الخطة أدناه.",
            infoAboutAnnouncement: "معلومات موجزة حول الإعلان",
            announcement: "إعلان",
            newAnnouncementForm: "نموذج إعلان جديد",
            newAnnouncement: "إعلان جديد",
            announcements: "الإعلانات",
            newTicketSound: "تذكرة جديدة",
            vtippyDepartmentNotification: "إعدادات الإشعار لرسائل محادثة القسم",
            vtippyGroupNotification: "إعدادات الإشعار لرسائل المجموعات التي تم إنشاؤها",
            vtippyTicketNotification: "إعدادات الإشعار لكل تذكرة جديدة تتلقاها",
            vtippyAnnouncemenNotification: "إعدادات الإشعار للإعلانات الجديدة",
            languageSelection: "اختيار اللغة",
            announcementTitle: "عنوان الإعلان",
            infinitePlay: "العب بشكل مستمر",
            hideBubbleOnMobile: "يختبئ على الهاتف المحمول",
            vtippyHideBubbleOnMobile: "يتم إخفاء فقاعة الدردشة من مستخدمي الأجهزة المحمولة.",
            deleteSystemLanguage: "حذف {code} لغة من النظام",
            assignedChat: "دردشة مخصصة",
            check: "خانة الاختيار",
            systemStatus: "حالة النظام",
            chatAssignedToUser: "محادثة جديدة مخصصة",
            inactiveThresholdTime: "وقت الدردشة غير النشط (دقيقة)",
            tippyInactiveThresholdTime: "إذا لم يتم إرسال أي رسالة خلال الوقت المحدد ، فإن المحادثة تعتبر غير نشطة. أدخل القيمة (الدقائق). يجب أن يكون المدى في 1 دقيقة - 120 دقيقة.",
            inactiveTerminateTime: "إنهاء الدردشة غير النشطة المدة (دقيقة)",
            tippyInactiveTerminateTime: "سيتم إنهاء الدردشة غير النشطة إذا لم يتم تحويلها إلى الوضع النشط خلال فترة زمنية معينة. أدخل القيمة (الدقائق). يجب أن يكون المدى في 1 دقيقة - 120 دقيقة.",
            removePendingMessage: "إلغاء إرسال الرسالة",
            disconnected: "انقطع الاتصال",
            visitorWriteEmptyChatTippy: "يمكن للعميل الكتابة إلى محادثة قبل اتصال الوكيل.",
            visitorWriteEmptyChat: "يمكن للعميل الكتابة بدون وكيل متصل.",
            visitorConnectionEventSystemMessageEnabled: "تمكين رسائل نظام حالة اتصال الزوار",
            visitorConnectionEventSystemMessageEnabledTippy: "غادر الزائر ورسائل نظام عودة الزوار تمكين",
            openBubble: "فقاعة مفتوحة",
            showHeaderImage: "عرض صورة الرأس",
            askQuestion: "طرح سؤال",
            locationPermsNeeded: "هناك حاجة إلى أذونات الموقع لاستخدام هذه الميزة",
            useMyLocation: "استخدم موقعي",
            acceptingChat: "قبول الدردشات",
            notAcceptingChat: "عدم قبول الدردشات",
            blockBy: "محظور من قبل",
            languageRemovalQuestion: "أنت على وشك حذف لغة {code} من النظام!",
            loggedOut: "تسجيل الخروج",
            vtippyNewVisitorNotification: "إشعار مسموع لكل زائر جديد إلى موقع الويب الخاص بك",
            vtippySelectnotification: "يمكنك اختيار صوت الإخطار.",
            vtippyVoiceLevel: "يمكنك ضبط مستوى الصوت",
            vtippyStartVoice: "يستمع",
            vtippyInfiniteNotification: "إذا لم تكن نشطًا في لوحة الدردشات الجديدة ، فستستمر في اللعب. يمكنك تحرير النقر النشط بالنقر.",
            vtippyTranslateButton: "يترجم اللغة المحددة إلى لغات أخرى",
            vtippyTranslateClearButton: "ينظف المحتوى بلغات أخرى.",
            vtippyNewChatNotification: "يمكنك تحديد إشعار الصوت للمحادثات الجديدة القادمة إلى النظام وضبط مستوى الصوت.",
            vtippyNewConversationNotification: "يمكنك اختيار إشعار الصوت وضبط مستوى الصوت عندما يتم تعيين محادثات واردة جديدة لك.",
            vtippyNewMessageNotification: "يمكنك تحديد إشعارات للرسائل الواردة لمحادثاتك وضبط مستوى الصوت.",
            vtippyPrivateMessageNotification: "يمكنك تحديد إشعار للرسالة الواردة إلى Talk Talk.",
            hideInactiveAgents: "إخفاء العوامل غير النشطة",
            hideMinorValues: "إخفاء القيم البسيطة",
            hashHintMessage: "يمكنك إدخال اختصارات الهاشتاج بسرعة مع #hash",
            pmHintMessage: "هل تعلم أنه يمكنك إرسال رسالة خاصة للكلمة الرئيسية؟ على سبيل المثال PM: مرحبًا",
            shortcutHintMessage: "هل تعلم أنه يمكنك إرسال رسائل بشكل أسرع مع الرسائل المختصرة؟",
            switchBetweenConversations: "هل تعلم أنه يمكنك التبديل بسرعة بين المحادثات مع اختصارات ABC؟",
            atNameHintMessage: "هل تعلم أنه يمكنك إدخال اسم الزائر بسرعة مع name؟",
            dndHintMessage: "يمكنك تحميل الملفات باستخدام السحب والإفلات.",
            pasteFile: "يمكنك إرسال الملفات.",
            atEmailHintMessage: "هل تعلم أنه يمكنك إدخال بريد الزائر بسرعة مع @mail؟",
            pastePlainText: "اللصق من الحافظة كنص عادي",
            pressAndTalk: "Press and talk",
            agentActivities: "أنشطة الوكيل",
            listStatuses: "الحالات",
            newHASHContent: "#add التجزئة",
            hash: "الوسم",
            hashText: "نص التجزئة",
            exampleHash: "تتبع الطلب",
            notValidHash: "يجب ألا تحتوي على مسافات.",
            websiteChatWidgetIntegration: "تكامل أداة الدردشة على الموقع",
            videoCallEnabledDesc: "تنشيط لتمكين ميزة مكالمة الفيديو.",
            videoCallEnabled: "ميزة مكالمة الفيديو",
            audioCallDesc: "تنشيط لتمكين ميزة البحث الصوتي.",
            audioCallEnabled: "ميزة البحث الصوتي",
            assignPreferredAgent: "تعيين وكيل مفضل",
            representativeAssignedToTheVisitor: "حدد الوكيل المفضل الذي تريد تعيينه للزائر.",
            agentFileSendEnabledDesc: "يتيح القدرة على إرسال الملفات إلى المندوبين",
            agentFileSendEnabled: "يمكن للممثلين إرسال الملفات",
            visitorFileSendEnabledDesc: "يتيح لك تشغيل ميزة إرسال ملف الزوار أو إيقاف تشغيلها",
            visitorFileSendEnabled: "يمكن للزوار إرسال الملفات",
            visitorAutoLogin: "زائر تسجيل الدخول للسيارات",
            visitorAutoLoginDesc: "بدء المحادثة التلقائية عندما انقر فوق الزائر على فقاعة الدردشة",
            agentVoiceRecordEnabledDesc: "يمكّن الوكلاء من تسجيل الصوت",
            agentVoiceRecordEnabled: "يمكن للوكلاء تسجيل الصوت",
            visitorVoiceRecordEnabledDesc: "يمكّن الزائرين من تسجيل الصوت",
            visitorVoiceRecordEnabled: "يمكن للزوار تسجيل الصوت",
            startVideoCall: "مكالمة فيديو",
            startAudioCall: "مكالمة صوتية",
            visitorGDPRDeleteEnabledDesc: "يتيح لك تبديل القدرة على حذف جميع معلومات الزوار",
            visitorGDPRDeleteEnabled: "يمكن للزوار حذف جميع معلوماتهم",
            visitorLocationEnabled: "يمكن للزوار مشاركة الموقع",
            visitorLocationEnabledDesc: "يسمح للزائرين بتشغيل مشاركة الموقع أو إيقاف تشغيله",
            customerLocationEnabled: "يمكن للممثلين مشاركة الموقع",
            customerAutoMergeEnabled: "يدمج تلقائيا نفس الأفراد",
            customerAutoMergeEnabledDesc: "تقوم هذه الميزة بتنفيذ عملية الدمج التلقائي لجمع بيانات تخص نفس الأفراد بفعالية. وبهذه الطريقة، يتم تمثيل المستخدمين ذوي الملامح المماثلة بشكل أكثر انتظاما وترتيبا في مجموعات البيانات.",
            chatAiCopilot: "مساعد الدردشة الذكية",
            chatAiCopilotDesc: "الرد التلقائي على أسئلة عملائك باستخدام مساعد الدردشة الذكية",
            customerLocationEnabledDesc: "يسمح للممثلين بتشغيل مشاركة الموقع أو إيقاف تشغيله",
            thoesNotOwners: "إبقاء غير المالكين في قائمة الانتظار",
            thoesNotOwnersDesc: "يمكنك تمكين هذه الميزة لإبقاء الأشخاص الذين لا يملكون المحادثة في قائمة الانتظار.",
            hideContactInfo: "إخفاء معلومات الاتصال",
            hideContactInfoDesc: "عند تمكين هذه الميزة، سيتم إخفاء أرقام العملاء ورسائل البريد الإلكتروني الخاصة بهم عن الوكلاء.",
            triggerAlreadyExists: "الزناد موجود بالفعل",
            ticketStatusForm: "نموذج حالة التذكرة",
            statusFormTitle: "عنوان حالة التذكرة",
            allStatus: "جميع الحالات",
            triggers: "محفزات",
            trigger: "مشغل",
            noTrigger: "لم تضيف أي مشغلات بعد",
            triggerSkipLoginForm: "نموذج تسجيل الدخول",
            triggerSkipLoginFormTrue: "إظهار نموذج تسجيل الدخول",
            triggerSkipLoginFormFalse: "تخطي نموذج تسجيل الدخول والانتقال مباشرة إلى الرسالة",
            noContent: "لا يوجد محتوى",
            toCreate: "لنصنع او لنبتكر",
            clickTheButton: "انقر فوق الزر",
            triggerContent: "اكتب الوصف الذي تريد ظهوره في الوسيط الذي يفتح. ما عليك سوى الكتابة بلغة واحدة ويتم الترجمة إلى لغات أخرى تلقائيًا.",
            triggerDrag: "يمكنك ضبط مدة الرسالة عن طريق سحب الشريط أو النقر عليه.",
            triggerNewCondition: "يمكنك إضافة حالة جديدة مع الزر.",
            triggerNoConditionDescription1: "يمكنك إنشاء الشروط التي تريدها من الخيارات. إذا لم تنشئ أي شروط لأي مشغل ، فسيكون المشغل الأول نشطًا.",
            triggerNoConditionDescription2: "يظهر واحد فقط من المشغلات مع نفس الشروط على صفحة الزوار.",
            triggerShowAndHide: "يمكنك إظهار أو إخفاء المشغلات وقتما تشاء.",
            countryLanguage: "لغة البلد",
            addTrigger: "إضافة الزناد",
            yesPlease: "نعم من فضلك!",
            noThanks: "ًلا شكرا.",
            firstAnswer: "تأكيد حوار السؤال الجواب",
            secondAnswer: "اسأل حوار استبعاد الإجابة",
            noTitle: "لا يوجد حاضر",
            sumChat_MediaFile: "الوسائط والوثائق",
            importantWarning: "تحذير مهم!",
            images: "الصور",
            URLS: "روابط",
            files: "دوسيلار",
            noCondition: "بدون شرط! يمكنك إضافة شروط بالنقر فوق أيقونة Plus.",
            showTriggers: "انقر لإظهار المشغلات",
            showThisTrigger: "انقر لإظهار هذا الزناد",
            hideTriggers: "انقر لإخفاء المشغلات",
            hideThisTrigger: "انقر لإخفاء هذا الزناد",
            updateTrigger: "تحديث الزناد",
            conditions: "شروط",
            messageDurationPerRow: "مدة الرسالة لكل صف",
            updateCompleted: "تحديث الانتهاء",
            CatalogUpdatedSuccessfully: "تم تحديث الكتالوج بنجاح",
            integrateSupsiswithIntegratable: "تمرير معلومات الدردشة بين supsis و {integratable} بسهولة.",
            installationOK: "المثبتة",
            dayTime: "ساعة",
            weekDay: "يوم من الأسبوع",
            spendTimePage: "قضيت الوقت على الصفحة",
            spendTimeSite: "قضيت الوقت في الموقع",
            pageUrl: "رابط الصفحة",
            pageTitle: "عنوان الصفحة",
            equal: "متساوي",
            not_equal: "غير متساوي",
            less_than: "أقل من",
            greater_than: "أكثر من",
            less_than_or_equal: "اصغر من او يساوي",
            greater_than_or_equal: "أكبر من أو يساوي",
            visitorName: "اسم الزائر",
            seconds10: "10 ثواني",
            seconds30: "30 ثانية",
            minute1: "1 دقيقة",
            minutes5: "5 دقائق",
            minutes10: "10 دقائق",
            minutes30: "30 دقيقة",
            hour1: "1 ساعة",
            hours2: "ساعاتين",
            hours4: "4 ساعات",
            hours8: "8 ساعات",
            hours12: "12 ساعة",
            hours24: "24 ساعة",
            maxCondition: "كحد أقصى",
            doYouWishToDeleteTrigger: "هل ترغب في حذف الزناد",
            contains: "يتضمن",
            not_contains: "لا يحتوي",
            chatLanguage: "لغة الدردشة",
            translating: "جار الترجمة",
            buyWhatsapp: "شراء تكامل WhatsApp",
            liveSupportStartingWait: "بدء الدعم المباشر ، يرجى الانتظار",
            noConnection: "لا يوجد اتصال!",
            integrations: "التكامل",
            refundInvoiceSure: "هل أنت متأكد من أنك تريد إعادة الفاتورة؟",
            invoiceMarkedAsPaidSuccess: "تم وضع علامة على الفاتورة بنجاح",
            invoiceMarkedAsPaidError: "خطأ ، لم يتم وضع علامة على الفاتورة",
            deleteConfirm: "هل تريد حذف هذا {object}؟",
            markPaidConfirm: "هل أنت متأكد من مارك مثل هذه الفاتورة؟",
            addLink: "وصلة",
            startChatDesc: "ابدأ المحادثة",
            selectStep: "حدد خطوة:",
            addGOTO: "اذهب إلى",
            sendFastLink: "إرسال رابط سريع",
            or: "أو",
            allTags: "جميع العلامات",
            showDetail: "أظهر تفاصيل",
            hideDetail: "إخفاء التفاصيل",
            weLlSendPhone: "سنرسل إلى هاتفك",
            weLlSendEmail: "سنرسل إلى بريدك الإلكتروني",
            linkSentToPhone: "تم إرسال الرابط كرسائل نصية",
            offerlinkSendToPhone: "سنرسل لك رابط تنزيل تطبيقنا عبر الرسائل القصيرة.",
            offerlinkSendToMail: "سنرسل لك رابط تنزيل تطبيقنا عبر البريد الإلكتروني.",
            theEmail: "بريدي الإلكتروني المسجل",
            differentEmail: "بريد إلكتروني آخر مختلف",
            linkSentToMailBox: "تم إرسال الرابط إلى Adress بريدك",
            errorOccurred: "حدث خطأ !",
            clickStoreIcon: "يمكنك الوصول إلى تطبيق الهاتف المحمول من خلال النقر على الرمز المناسب لهاتفك.",
            meetWithSupsis: "هل ترغب في مقابلة تطبيق Supsis Mobile الخاص بنا؟",
            downloadMobileApps: "قم بتنزيل تطبيق الجوال",
            getApps: "احصل على التطبيقات",
            info: "معلومة",
            conversationHistory: "تاريخ المحادثة",
            planInfoHeader: "تخطيط المعلومات",
            planInformation: "خطتك هي {selectedPlan} ({detailMaxAgentCount} Agent) ({freeAgent} Free Agent)",
            creditAvailable: "ائتمان وكيلك المتاح في خطتك:",
            upDownGradePlan: "إذا كنت ترغب في الترقية/خفض خطتك ، من فضلك",
            click: "انقر",
            autoStartChat: "بداية الدردشة التلقائية",
            bubbleColor: "لون فقاعة الدردشة",
            openFolder: "افتح المجلد",
            preDefined: "موضوعات",
            customIcon: "تثبيت من جهاز الكمبيوتر الخاص بك",
            theme: "سمة",
            themeSettings: "إعدادات الموضوع",
            chatThemeSettings: "إعدادات موضوع الدردشة",
            bubbleSettings: "إعدادات فقاعة الدردشة",
            inputHeightOfBubble: "حجم الفقاعة",
            inputPixelsOfChatBubble: "انقر لتحرير مسافات فقاعة الدردشة إلى الحواف",
            modalTitleIsMarginAsPixelInfo: "مسافات فقاعة الدردشة إلى الحواف:",
            inputPxOfXaxis: "الموقف الأفقي",
            inputPxOfYaxis: "الوضع الرأسي",
            inputPxOfMobileXaxis: "(موبيل) الموقف الأفقي",
            inputPxOfMobileYaxis: "(موبيل) الموقف الرأسي",
            animations: "الرسوم المتحركة",
            preferredAnimation: "الرسوم المتحركة المفضلة",
            selectAnAnimation: "حدد الرسوم المتحركة",
            inputOfBubbleMessage: " {contentOfChatBubble}\n{ أضف محتوى إلى فقاعات الدردشة الضخمة",
            showChatBubbleOnlyLoggedUserToolTip: "إنه الإعداد لإخفاء فقاعة الدردشة بناءً على حالة تسجيل الدخول.",
            showChatBubbleOnlyLoggedUser: "أظهر فقاعة لتسجيلها فقط في المستخدم. (Ideasoft)",
            helloDoUNeedHelp: "مرحبا هل تحتاج إلى مساعدة؟",
            bubbleIcon: "صورة فقاعة الدردشة",
            overrideMargins: "تخصيص الهوامش",
            autoHideBubble: "إخفاء فقاعة الدردشة",
            vtippyAutoHideBubble: "يخفيون فقاعة الدردشة عندما يكون الوكلاء في وضع عدم الاتصال",
            hideBubble: "تعطيل فقاعة الدردشة",
            vtippyHideBubble: "قم بإيقاف فقاعة الدردشة.",
            overrideMobileMargin: "تخصيص الهوامش للجوال",
            vtippyMobileMargin: "تخصيص الهوامش للجوال",
            isFabsActive: "إظهار زر الإجراء العائم",
            isAlwaysActive: "القائمة مفتوحة دائمًا",
            isAlwaysActiveDesc: "هل ترغب في أن تظل قائمة فقاعة الدردشة مفتوحة دائمًا في عرض الويب؟",
            bubbleOpenableMenu: "دردشة فقاعة المنسدلة",
            vtippyIsFabsActive: "إعداد زر العرض / إخفاء الإجراء العائم",
            vtippyIsFabsAsIcon: "إنه إعداد ما إذا كانت الرموز ستظهر في القائمة المنسدلة.",
            isFabsAsIcon: "عرض أيقونات القائمة.",
            setMarginAsPixel: "تعيين بكسل",
            returnDefaultMargins: "إعدادات الهامش الافتراضية",
            deleteSite: "هل تريد حذف الموقع \"{siteName}\"؟",
            deleteThisSite: "حذف الموقع",
            assetOversizeWithExt: "يجب أن يكون حجم الملف أقل من 10 ميغابايت وفي تنسيق JPG.",
            closeChat: "نهاية المراسلة",
            ticket: "تذكرة",
            formStep: "خطوة الشكل",
            menuStep: "خطوة القائمة",
            contentStep: "خطوة المحتوى",
            menuTitle: "عنوان القائمة",
            messageContent: "محتوى الرسالة",
            goToLive: "نقل إلى التمثيلي",
            prevStep: "العودة إلى الخطوة السابقة",
            button: "زر",
            addImage: "صورة",
            addText: "نص",
            stepTitle: "عنوان الخطوة",
            addTicket: "تذكرة",
            formDescription: "سؤال",
            addInput: "سؤال",
            addRandomText: "نص عشوائي",
            calendarPassedTimeMinSec: "{min} دقيقة {sec} الثانية {name}",
            calendarPassedTimeSec: "{ساعة} ساعة {min} دقيقة {sec} الثانية {name}",
            updateUserName: "تحديث اسم المستخدم",
            forgotPassword: "هل نسيت كلمة السر",
            osrFromMessageSaved: "تم حفظ الرسالة دون اتصال.",
            requiredField: "هذه الخانة مطلوبه.",
            nightModeOn: "وضع الليل على",
            catalogMenu: "قائمة طعام",
            catalogContent: "محتوى",
            all: "الجميع",
            allDepartments: "جميع الإدارات",
            preferredLanguage: "اللغة المفضلة",
            kmkAutoDepartmentBind: "اكتشاف kmk auto deparment",
            kmkAutoDepartmentBindDesc: "بحث بائع على مواقع عملاء KMK وقم بتعيين صفحة تسجيل الدخول كقسم",
            visitorEmailUpdated: "تم تحديث البريد الإلكتروني للزائر",
            visitorEmailIsNotValid: "البريد الإلكتروني للزوار غير صالح",
            visitorNameUpdated: "اسم الزائر تم تحديثه",
            clickToEdit: "إضغط للتعديل",
            addEmail: "+ إضافة بريد إلكتروني",
            addFullname: "+ إضافة fullname",
            partner: "المرجع؟",
            isIntegrated: "اندماج؟",
            agentCount: "عدد الوكيل",
            closePreviewColors: "إغلاق معاينة الموضوع",
            previewColors: "معاينة موضوع مفتوح",
            videoCalls: "مكالمات فيديو",
            filterLost: "الدردشات المفقودة",
            vtipyCustomLogin: "يمكنك تخصيص المعلومات التي سيتم طلبها في نموذج تسجيل الدخول عندما يتصل زوارك بالنظام.",
            vtipyLoginlessChat: "سيتم إخفاء نموذج تسجيل الدخول للزوار. يمكن للزائر الاتصال بالدردشة مباشرة.",
            loginlessChat: "نموذج تسجيل الدخول للزوار",
            imageUrl: "رابط الصورة",
            replied: "رد",
            solved: "تم حلها",
            openImage: "صورة مفتوحة",
            writeFeedback: "يمكنك كتابة ملاحظاتك حول supsis هنا.",
            feedbackFailed: "حدث خطأ أثناء إرسال الملاحظات.",
            feedbackSuccessful: "ردود الفعل تقديم ناجحة.",
            sendFeedback: "ارسل رأيك",
            errorReport: "يمكنك أن تعطينا ملاحظات حول المشكلات التي تواجهها حول supsis.",
            sendErrorFeedBack: "أعطنا ملاحظات حول القضية التي تواجهها.",
            successImgUpload: "تم تحميل صورتك بنجاح.",
            successImgDelete: "تم حذف الصورة بنجاح.",
            errorImgUpload: "حدث خطأ أثناء تحميل صورتك.",
            errorImgDelete: "حدث خطأ أثناء حذف الصورة",
            chatBotEndStatics: "معدل نجاح محادثة chatbot",
            videoCallDist: "توزيع مكالمات الفيديو",
            departmentInfo: "معلومات القسم",
            infoAboutDepartment: "قدم معلومات موجزة عن القسم",
            deleteDepartmentQuestion: "هل تريد حقًا حذف هذا القسم؟",
            departmentDeleted: "حذف القسم",
            departmentTitle: "لقب القسم",
            updateDepartmentForm: "نموذج تحديث القسم",
            newDepartmentForm: "نموذج قسم جديد",
            department: "قسم",
            newDepartment: "قسم جديد",
            departmentSaved: "أنقذ القسم",
            selectAll: "اختر الكل",
            collapseAll: "انهيار جميع",
            expandAll: "توسيع الكل",
            addUsersToDepartment: "إضافة مستخدمين إلى القسم",
            removeFromDepartment: "إزالة من القسم",
            moveToDepartment: "نقل إلى قسم آخر",
            noUsersInDepartment: "لا يوجد مستخدمون في هذا القسم",
            selectAtLeastOneUser: "اختر مستخدمًا واحدًا على الأقل",
            departmentUsersUpdated: "تم تحديث المستخدمين",
            copyToDepartment: "أضف أيضًا إلى القسم",
            userAlreadyInDepartment: "المستخدم موجود بالفعل في هذا القسم",
            removeUserFromDepartmentConfirm: "هل أنت متأكد أنك تريد إزالة هذا المستخدم من القسم؟",
            bulkUpdateProgress: "تحديث جماعي",
            usersUpdated: "تم التحديث",
            moveToAllDepartments: "نقل إلى جميع الأقسام",
            copyToAllDepartments: "أضف أيضًا إلى جميع الأقسام",
            deselectAll: "إلغاء تحديد الكل",
            sameDepartment: "هناك قسم بنفس الاسم",
            sameValue: "هناك قيمة بنفس الاسم!",
            sameTag: "هناك وسم بهذا الاسم!",
            departments: "الإدارات",
            chatTimingSettings: "إعدادات توقيت الدردشة",
            assetOversize: "يجب ألا يتجاوز حجم الملف الذي تريد إرساله 2 ميجابايت.",
            assetOversizeMB: "لا يجب أن يتجاوز حجم الملف الذي تريد إرساله {mb} ميجابايت.",
            messageDeleted: "تم حذف هذه الرسالة",
            filterLostChat: "تصفية الدردشات المفقودة",
            filterClosedByAgent: "مرشح مغلق من قبل الوكيل",
            filterVideoCall: "مرشح مكالمة الفيديو",
            notificationText: "يحتاج Supsis إلى إذن لـ",
            notificationTitle: "الإخطارات معطلة",
            deniedText: "إن إشعاراتك مغلقة ، فأنت بحاجة إلى تشغيل إشعاراتك حتى لا تفوتك عملائك.",
            deniedTitle: "انقر لفتح الإخطارات الخاصة بك!",
            deniedHeader: "حتى لا تفوت عملائك ، تحتاج إلى تشغيل إشعاراتك!",
            showNotificationGuide: "انقر للاطلاع على التفاصيل",
            howToEnableNotification: "كيف يمكنني تمكين الإخطارات",
            notificationOK: "نعم",
            notificationUnderstood: "تم فهمه!",
            notificationCancel: "يلغي",
            howToEnableNotificationInstruction1: "انقر على أيقونة القفل في شريط العناوين للمتصفح",
            howToEnableNotificationInstruction2: "إذا تم تعطيل \"الإخطارات\" في قسم الأذونات ، فقم بتمكينه",
            howToEnableNotificationInstruction3: "إذا لم تظهر \"الإشعارات\" في قسم الأذونات ، فانقر فوق \"إعدادات الموقع",
            howToEnableNotificationInstruction4: "قم بتشغيل إذن \"الإخطارات\" من قسم \"الأذونات\" في صفحة إعدادات الموقع",
            checkPaymentMethod: "يرجى التحقق من طريقة الدفع الخاصة بك",
            pushNotificationEnabled: "تم تمكين إشعار الدفع الرائع",
            pushNotificationDenied: "لقد أنكرت إذن الإخطار",
            suspendedMessage: "تم تعليق حسابك",
            enableNotification: "تمكين إخطارات سطح المكتب.",
            languageSettings: "لغة مختارة",
            problemsSound: "إذا كانت لديك مشاكل في الإشعارات ، فيمكنك النقر فوق قفل صورة من مربع بحث المتصفح (الموضح في الصورة) انقر فوق \"إعدادات الموقع\" وتغيير \"الصوت\" للسماح",
            betweenRepresentative: "هناك رسالة جديدة من ممثل",
            desktopNotifications: "إخطارات سطح المكتب",
            notificationEnabled: "يتم تمكين إخطارات سطح المكتب Supsis.",
            newMessageAlert: "لديك رسالة جديدة.",
            notificationDisable: "يمكنك تعطيل الإخطار من الإعدادات التمثيلية",
            newConversationAlert: "لديك زائر جديد.",
            chatBot: "روبوت الدردشة",
            ticketResponse: "Temsilcinin Yanıtı:",
            archived: "أرشيف",
            chatbotChatCount: "روبوت الدردشة",
            changeTitle: "غير العنوان",
            changeVisitorTitle: "تغيير عنوان الزائر",
            catalog: "عنوان الكتالوج",
            openTheCatalog: "كتالوج مفتوح",
            catalogNotOpen: "تم تعطيل ميزة الكتالوج. يمكنك تشغيل ميزة الكتالوج لدعم عملائك بمحتوى مستعد مسبقًا.",
            showCatalogCategories: "اضبط ما إذا كانت قائمة الكتالوج ستظهر على فقاعة الدردشة",
            showChatBot: "اضبط ما إذا كان chatbot سيظهر على فقاعة الدردشة",
            openCatalog: "الرؤية كتالوج",
            unreadMessages: "رسائل غير مقروءة",
            personalFirstMsg: "الوكيل المتوسط ​​وقت الاستجابة (SEC)",
            personalRating: "نقاط الموظفين AVG",
            soundSettings: "إعدادات الإشعار",
            newPrivateMessage: "رسالة خاصة",
            addNewGroup: "إنشاء مجموعة جديدة",
            newMessage: "رسالة جديدة",
            newConversation: "دردشة جديدة",
            newVisitor: "زائر جديد",
            chatPosition: "موقف الدردشة",
            bottomLeftCorner: "الزاوية اليسرى السفلية",
            leftDocked: "رست على اليسار",
            bottomRightCorner: "الزاوية اليمنى السفلى",
            rightDocked: "رست الحق",
            chatPositionSelect: "اختر الموقف",
            teamChatGroup: "رسائل المجموعة",
            teamChatDepartment: "رسائل القسم",
            teamChatTeam: "رسائل الفريق",
            teamChatDm: "رسائل البريد المباشر",
            bottomLeft: "أسفل اليسار",
            left: "غادر",
            bottomRight: "أسفل اليمين",
            right: "يمين",
            mailorname: "البريد الإلكتروني أو الاسم",
            fieldName: "الاسم الرئيسي",
            value: "قيمة",
            addSetting: "إضافة إعدادات",
            globalSettings: "الاعدادات العامة",
            breaksByTime: "عداد الكسر حسب الوقت",
            clPlaceholder: "الاسم الذي سيظهر في نموذج العميل",
            target: "تحميل عنوان اختبار",
            duration: "مدة اختبار التحميل (ثانية)",
            arrivalCount: "عدد الدردشة",
            bootMaxLife: "دردشة أقصى وقت الحياة (SEC)",
            startLoadTest: "ابدأ اختبار التحميل",
            noClusterInstanceFound: "لا يوجد خادم",
            stopLoadTest: "توقف اختبار التحميل",
            integrationDesc: "فقط أضف رمز السطر الواحد أدناه إلى موقعك.",
            integrationDemoCode: "رمز تجريبي للتكامل البسيط",
            integrationWindow: "كيف يمكنني الاندماج في موقعي؟",
            notIntegrated: "اندماج",
            help: "يساعد",
            notIntegratedDesc: "لاحظنا أنك لم تضيف نظام الدردشة إلى موقعك. عندما تقوم بدمجه في موقعك وابدأ الدردشة الأولى ، ستقوم بإكمال التكامل. انقر للحصول على البرنامج النصي للتكامل",
            backToLogin: "ارجع إلى شاشة تسجيل الدخول",
            passwordlessLoginUnsuccessful: "تسجيل الدخول غير ناجح. يمكن انتهاء صلاحية أو استخدامها من قبل",
            passwordlessLogin: "تسجيل الدخول بدون كلمة مرور",
            loginWithEmail: "تسجيل الدخول مع البريد الإلكتروني",
            loginWithPassword: "تسجيل الدخول مع كلمة المرور",
            enteringPasswordless: "تسجيل الدخول بدون كلمة مرور ...",
            toMainPath: "إعادة التوجيه إلى الصفحة الرئيسية",
            userRoleChanged: "تغيرت أذوناتك. سيتم إعادة توجيهك إلى الصفحة الرئيسية.",
            passwordChangeSuccess: "تغيرت كلمة المرور الخاصة بك بنجاح",
            feedback: "إظهار ردود الفعل",
            showFeedbackHistory: "إظهار الرسائل التي تم إرسال ملاحظات",
            newSelfServiceSite: "موقع خدمة الذات الجديد",
            subdomain: "نطاق فرعي",
            rootUserEmail: "بريد إلكتروني",
            rootUserName: "اسم",
            newVersion: "نسخة جديدة متاحة",
            closeLiveSupport: "وثيق الدعم المباشر",
            newVersionShort: "نسخة جديدة",
            bannedWordRestrict: "حظر الكلمة المحظورة",
            ticketShow: "السماح للعملاء بإنشاء تذاكر",
            ticketShowDesc: "تمكين خيار إنشاء التذاكر في قائمة الدردشة",
            autoLoadIframe: "حركة المرور الحية",
            autoLoadIframeDesc: "تحميل التلقائي iframe ، مرر جميع حركة الزوار",
            bannedWordRestrictDesc: "عندما يتم تشغيل حظر الكلمة المحظورة ، يتم منع الممثلين من كتابة الكلمات المحظورة المحددة في النظام للزوار.",
            agentDown: "وكيل أسفل",
            delayChat: "دردشة تأخر",
            tableSettingTippy: "يمكنك تغيير المعلومات التي ستظهر في الجدول.",
            tableSettings: "إعدادات الجدول",
            tableSettingsInfo: "يمكنك تغيير المعلومات التي ستظهر في الجدول. يمكنك تحديد عمود 7 على الأكثر",
            privateParametry: "معلمات المستخدم المخصصة",
            systemOperetor: "معلومات النظام",
            cityAndDistrict: "مقاطعه المدينه",
            general: "عام",
            availability: "توافر",
            home: "بيت",
            successful: "نجح",
            forgetPasswordSent: "تم إرسال البريد الإلكتروني لإعادة تعيين البريد الإلكتروني ، تحقق من صندوق الوارد الخاص بك",
            saturday: "السبت",
            friday: "جمعة",
            thursday: "يوم الخميس",
            wednesday: "الأربعاء",
            tuesday: "يوم الثلاثاء",
            monday: "الاثنين",
            sunday: "الأحد",
            download: "تحميل الملف",
            calendarPassedTimeHour: "{name} لـ {hour} ساعة",
            calendarPassedTime: "{name} لـ {hour} ساعة {min} دقيقة",
            calendarPassedTimeMin: "{name} لـ {value} min",
            workScheduleOneDay: "جدول العمل {name} على {sDate}",
            workSchedule: "جدول العمل {name} بين {sDate} - {eDate}",
            calendar: "تقويم",
            noRating: "لا يوجد تصنيف للعرض",
            rateDist: "توزيع الأسعار",
            distConversation: "توزيع الكلام من قبل الممثلين",
            distributionConversa: "توزيع النقاط",
            distChatbotAgent: "قنوات الاتصال",
            distAgent: "وكيل شات بوت",
            distFugitive: "الكلام الفائت والكلام المستلم",
            distLive: "دردشة مباشرة",
            distChatbot: "الشات بوت",
            distComplex: "دردشة مباشرة & الشات بوت",
            distHandled: "أجاب الدردشة",
            distMissed: "دردشة غير مجاب عنها",
            distWeb: "موقع إلكتروني",
            distWhatsapp: "واتس اب",
            distTelegram: "برقية",
            distInstagram: "الانستغرام",
            totalWhatsappChatCount: "عدد دردشة Whatsapp",
            statsByTime: "عدد الدردشة حسب الوقت",
            selectRep: "حدد ممثل",
            allRepresentatives: "جميع الممثلين",
            avgRating: "درجة التقييم ({point}) ({count} تصنيف)",
            avgFirstMessageTime: "متوسط وقت الاستجابة",
            totalBreakTime: "وقت كسر النظام",
            totalBreakNum: "عداد الكسر",
            averageConTime: "متوسط وقت المحادثة",
            multiWpReportTitle: "رقم محادثة واتس اب متعدد",
            multiWpReport: "عدد محادثات الواتساب المتعددة",
            multiWpReportExplanation: "يمكنك رؤية مقدار الدردشة لقنوات Whatsapp المتعددة الخاصة بك.",
            longestConTime: "أطول وقت محادثة",
            shortestConTime: "أقصر وقت محادثة",
            refresh: "ينعش",
            waitingReply: "الرسائل المعلقة",
            organizationName: "اسم المنظمة",
            companySlogan: "الاسم الطويل للمنظمة",
            messageSentErr: "الرسالة لا ترسل ، حاول مرة أخرى.",
            messageSent: "تم الارسال.",
            openPrivateChat: "فتح الدردشة التمثيلية",
            escKey: "يخفي محادثة نشطة",
            archiveChatKey: "يسمح لك بالانضمام إلى الدردشة في أسفل صفحة الأرشيف.",
            chatCopilot: "يقوم بتشغيل برنامج Chat CoPilot",
            privateChat: "لوحة محادثة بين العوامل",
            multiModeAlertDesc: "Supsis مفتوح في نافذة أخرى. انقر فوق \"استخدم هنا\" لاستخدام supsis في هذه النافذة.",
            useHereText: "استخدم هنا",
            brandVisibility: "تسمية العلامة التجارية Supsis تظهر على فقاعة الدردشة",
            focusInput: "حقل إدخال الدردشة النشطة للمؤشر",
            send: "يرسل",
            notYet: "ليس بعد",
            sending: "إرسال",
            onlyRepresentative: "لا يمكن أن يرى رسالتك إلا من قبل الممثلين",
            yourMessage: "رسالتك",
            liveFabListDescription: "الدعم المباشر",
            messengerIntegrationDesc: "تحدث مع عملائك عبر صفحة الفيسبوك، وأرسل رسائل آلية باستخدام الدردشة الآلية.",
            checkDepartmentToAgent: "التحقق من القسم للوكيل عبر الإنترنت",
            ifAllOfflineStory: "القصة لتوجيه إذا كان الجميع غير متصلين",
            AssignMessagesToAgents: "تعيين جميع الرسائل للوكلاء",
            firstChatbotAndAssign: "يُجيب Chatbot أولاً ثم يُسند إلى وكيل",
            hybridAssign: "يتحقق النظام من القسم لمعرفة ما إذا كان هناك وكيل عبر الإنترنت ، وإذا لم يكن هناك وكيل عبر الإنترنت ، فإنه يعينه إلى الشاتبوت.",
            ticketFabListDescription: "تذكرة",
            whatsappFabListDescription: "ال WhatsApp",
            phoneFabListDescription: "هاتف",
            emailFabListDescription: "بريد إلكتروني",
            facebookFabListDescription: "فيسبوك",
            twitterFabListDescription: "تويتر",
            instagramFabListDescription: "Instagram",
            youtubeFabListDescription: "موقع YouTube",
            linkedinFabListDescription: "Linkedin",
            telegramFabListDescription: "Telegram",
            typeYourChannelLink: "اكتب رابط قناة {channelLink} في هذا الحقل.",
            typeYourAccountLink: "اكتب رابط حساب {accountLink} في هذا الحقل.",
            typeYourMessage: "اكتب رسالتك هنا",
            typeYourMessageMail: "سيتم إرسال الرسالة التي تم إدخالها في هذا الحقل من قبل العميل إلى عنوان البريد أعلاه كرسالة أولى.",
            typeYourMessageDesc: "سيتم إرسال الرسالة التي تم إدخالها في هذا الحقل من قبل العميل إلى رقم الهاتف أعلاه كرسالة أولى.",
            sendNumber: "رقم الهاتف لإرسال الرسالة إلى: {path}",
            callNumber: "رقم الهاتف لعميلك للاتصال: {phoneNumber}",
            numberIsNotCorrect: "تم إدخال الرقم المفقود !!",
            emailIsNotCorrect: "البريد الإلكتروني غير صحيح!",
            selectFab: "حدد FAB",
            notValid: "يمكنك فقط إدخال الحروف. (حرف واحد) .e ، d ، f ، z ، a ، x ، c ، v ، w ، t ، n الحروف غير صالحة",
            forMacUsers: "يمكن لمستخدمي MAC استخدام اختصار التحكم (⌃)",
            basePriceValue: "السعر الأساسي",
            basePriceDiscount: "تخفيض",
            basePriceCurrency: "عملة",
            customerDBEnabled: "اختيار قاعدة البيانات: استخدم خادم قاعدة بيانات العملاء",
            customerDBDisabled: "اختيار قاعدة البيانات: استخدم SUPSIS Server",
            mongoConnectionString: "اتصال Mongo",
            whatsappBasePriceValue: "سعر قاعدة WhatsApp",
            whatsappPlusBasePriceValue: "WhatsApp Plus سعر الأساس",
            instagramBasePriceValue: "سعر قاعدة Instagram",
            instagramPlusBasePriceValue: "السعر الأساسي Instagram Plus",
            clientAddress: "عنوان العميل",
            customerClientAddress: "عنوان عميل العميل",
            apiAddress: "عنوان API",
            socketAddress: "عنوان المقبس",
            backendAddress: "عنوان الخلفية",
            panelLogoUrl: "عنوان شعار لوحة URL",
            panelCustomCssUrl: "لوحة عنوان URL المخصص CSS",
            customerLogoUrl: "عنوان URL شعار العميل",
            customerCssUrl: "عميل CSS URL",
            siteAlias: "الملقب الموقع",
            language: "لغة",
            features: "سمات",
            interactionPopularity: "شيوع التفاعلات",
            interactionCount: "عدد التفاعل",
            uniqueUserCount: "عدد المستخدم الفريد",
            allUserPercentage: "(٪) النسبة المئوية لكل المستخدمين",
            represantativeSettings: "الإعدادات التمثيلية",
            documentTitle: "نموذج مستند Supsis",
            supsisDocument: "وثيقة Supsis",
            ApiDoc: "وثائق الواجهة البرمجية للتطبيق",
            chatBalloonTehemeSettings: "إعدادات بالون وموضوع الدردشة",
            customLoginFormSettingsTitle: "تخصيص نموذج تسجيل الدخول للزوار",
            addNewField: "أضف حقلًا جديدًا",
            editField: "تحرير الحقل",
            typeHere: "اكتب المحتوى هنا!",
            pco: "cur",
            perPage: "/صفحة",
            perPageInFilter: "قطعة",
            noUserInfoFound: "لم يتم العثور على معلومات المستخدم",
            startFilter: "بدء مرشح",
            showMyChats: "أظهر الدردشات الخاصة بي",
            showOnlineAgents: "إظهار الوكلاء عبر الإنترنت فقط",
            showWaitingChats: "عرض الدردشات الانتظار",
            addNewStatus: "أضف الحالة",
            newTitleContent: "عنوان جديد",
            newCTRLContent: "محتوى CTRL جديد",
            newALTContent: "محتوى ALT جديد",
            newTABContent: "محتوى علامة تبويب جديدة",
            roleName: "اسم الدور",
            error: "خطأ",
            contentTitle: "عنوان المحتوى",
            contentType: "نوع المحتوى",
            cannotMoveFullParent: "لا يمكن تحريك هذا العنصر",
            newSiteForm: "نموذج تسجيل موقع جديد",
            updateSiteForm: "نموذج تحديث الموقع",
            newBannedWordForm: "نموذج تسجيل الكلمات المحظور الجديد",
            updateBannedWordForm: "نموذج تحديث الكلمات المحظور",
            newWelcomeMessageForm: "نموذج تسجيل رسالة ترحيب جديد",
            updateWelcomeMessageForm: "نموذج تحديث رسالة النظام",
            newDefaultContentForm: "نموذج تسجيل المحتوى الافتراضي الجديد",
            updateDefaultContentForm: "نموذج تحديث المحتوى الافتراضي",
            newSubjectForm: "نموذج تسجيل الموضوع الجديد",
            updateSubjectForm: "نموذج تحديث الموضوع",
            showChatColorMeaning: "ألوان الدردشة",
            showIntro: "عرض مقدمة",
            options: "خيارات",
            resetPassword: "إعادة تعيين كلمة المرور",
            audioLevel: "حجم تنبيه الصوت",
            privateChatNotificationSound: "صوت الإشعار",
            continue: "يكمل",
            newRoleForm: "نموذج تسجيل الدور الجديد",
            updateRoleForm: "نموذج تحديث الدور",
            newRolePlaceHolder: "انقر لدور جديد",
            newUserForm: "نموذج تسجيل مستخدم جديد",
            updateUserForm: "نموذج تحديث المستخدم",
            changeOSRForm: "رسالة تغيير في وضع عدم الاتصال",
            tooltipOSRForm: "يمكنك تغيير الرسالة دون اتصال.",
            newOSRForm: "نموذج الدعم في وضع عدم الاتصال",
            newOSRMessages: "أضف رسالة غير متصلة بالإنترنت",
            updateOSRForm: "نموذج التحديث في وضع عدم الاتصال",
            osrTitle: "عنوان",
            osrTitleDescription: "يمكنك إضافة عنوان نموذج الدعم في وضع عدم الاتصال",
            osrContent: "محتوى",
            osrContentDescription: "يمكنك إضافة محتوى نموذج الدعم في وضع عدم الاتصال",
            hello: "مرحبا بالعالم",
            date: "تاريخ",
            startDate: "تاريخ البدء",
            finish: "ينهي",
            start: "يبدأ",
            endDate: "تاريخ الانتهاء",
            representative: "مندوب",
            representative_: "ممثل",
            star: "نجمة",
            filter: "منقي",
            reset: "إعادة ضبط",
            dailyChatList: "قائمة الدردشة اليومية",
            dailyChatDuration: "مدة الدردشة اليومية",
            chatDuration: "مدة الدردشة",
            dailyChatGraph: "الرسم البياني للدردشة اليومية",
            ok: "نعم",
            chatCount: "عدد الدردشة",
            shortest: "أقصر",
            longest: "أطول",
            average: "متوسط",
            count: "عدد",
            averagePoint: "متوسط ​​النقطة",
            pointDist: "توزيع النقطة",
            point: "نقطة",
            filters: "المرشحات",
            totalCustomer: "إجمالي العميل",
            avResponseTime: "متوسط ​​وقت الاستجابة",
            breakDuration: "مدة كسر",
            breakCount: "عداد الكسر",
            lastLoginPlatform: "منصة",
            active: "نشيط",
            passive: "سلبي",
            userForm: "المستخدم",
            sender: "المُرسِل",
            profile: "حساب تعريفي",
            name: "اسم",
            number: "رقم",
            username: "اسم المستخدم",
            email: "بريد إلكتروني",
            password: "كلمة المرور",
            oldPassword: "كلمة المرور القديمة",
            newPassword: "كلمة المرور الجديدة",
            passwordAtLeast: "كلمة المرور (على الأقل {num})",
            passwordRepeat: "اعد كلمة السر",
            changePassword: "تغيير كلمة المرور",
            status: "حالة",
            enableState: "نشيط؟",
            douYouWishToDeleteUser: "دو ترغب في حذف هذا المستخدم؟",
            userDeleted: "تم حذف المستخدم",
            userSaved: "تم حفظ المستخدم.",
            oldPasswordError: "كلمة المرور القديمة غير صحيحة ، يرجى التحقق.",
            chooseAnOption: "الرجاء تحديد صوت الإخطار.",
            userVolumeUpdated: "تحديث إعدادات الصوت.",
            addNewMenu: "أضف قائمة جديدة",
            addNewContent: "أضف محتوى جديد",
            pleaseTitleEnter: "الرجاء العنوان إدخال",
            like: "يحب",
            disLike: "لم يعجبنى",
            users: "المستخدمون",
            visitor: "الزائرين",
            allContacts: "كل الاتصالات",
            allUsers: "جميع الممثلين",
            allSites: "جميع المجالات",
            newUser: "مستخدم جديد",
            noNewUser: "لا يوجد مستخدم بعد.",
            noNewAdminUser: "لا يوجد مستخدم مسؤول حتى الآن.",
            noRoleFound: "لا يوجد دور حتى الآن.",
            noBannedWordFound: "لا توجد كلمة محظورة حتى الآن.",
            noWelcomeMessageFound: "لا توجد رسالة نظام حتى الآن.",
            noSubjectFound: "لا يوجد موضوع حتى الآن.",
            noVisitorFound: "لا يوجد زائر.",
            noContactFound: "لا يوجد اتصال.",
            sendResponse: "اكتب رد",
            delete: "يمسح",
            noLiveSupportFound: "لا يوجد زائر متصل بالدعم المباشر",
            noLiveSupportFoundWithDepartment: "لا يوجد خطاب ينتمي إلى القسم",
            duplicate: "ينسخ",
            makeDefault: "جعل الافتراضي",
            checkMore: "تحقق أكثر",
            useReadyTemplates: "استخدم قوالب جاهزة",
            noRePresentativeFound: "لا يوجد ممثل",
            noBannedVisitorFound: "لا يوجد زائر محظور حتى الآن.",
            removeBanDescription: "إزالة الحظر",
            editThisItem: "قم بتحديث هذا العنصر",
            removeThisItem: "أزل هذا البند",
            role: "دور",
            autoChatAssignLimit: "محادثة تلقائية تعيين الحد",
            chatAssignInfo: "-1 = افتراضي النظام ، 0 = لا يوجد تعيين ،> 0 = تعيين كقيمة معينة.",
            relatedDepartments: "الإدارات ذات الصلة",
            subjectInfo: "إذا لم يكن هناك موضوع محدد ، يُسمح بجميع الموضوعات.",
            archive: "أرشيف",
            offlineSupportRequests: "الدعم في وضع عدم الاتصال",
            first: "أولاً",
            last: "آخر",
            query: "بدء البحث",
            clean: "ينظف",
            loading: "تحميل",
            loadMore: "تحميل المزيد",
            noMessage: "ليست أي رسالة",
            selectChat: "اختر الدردشة",
            noMessageInChat: "لا توجد رسالة في هذه الدردشة",
            noMediaToShow: "لا توجد وسائط لعرضها",
            firstSeen: "ظهور أول مرة",
            userInfo: "معلومات المستخدم",
            chatId: "معرف الدردشة",
            visitorId: "معرف الزائر",
            visitingPage: "صفحة زيارة",
            osAndBrowser: "نظام التشغيل والمتصفح",
            customerClientVersion: "إصدار عميل العميل",
            visitorFeedback: "ردود الفعل الزائر",
            notes: "ملاحظات",
            nameSurname: "اسم اللقب",
            chats: "الدردشات",
            bannedVisitors: "الزوار المحظورون",
            country: "دولة",
            city: "مدينة",
            cityDistrict: "مقاطعه المدينه",
            browser: "متصفح",
            os: "نظام التشغيل",
            ipAddress: "عنوان IP",
            connectionDate: "تاريخ الاتصال",
            transaction: "عملية",
            banRemoved: "حظر إزالة.",
            bannedWords: "الكلمات المحظورة",
            newBannedWord: "كلمة محظورة جديدة",
            noBannedWord: "لا كلمة محظورة حتى الآن.",
            bannedWordForm: "نموذج العمل المحظور",
            word: "كلمة",
            bannedWordAndWordGroup: "مجموعة الكلمة / العمل المحظورة",
            doYouWishToDeleteBannedWord: "دو هل ترغب حقًا في حذف هذه الكلمة المحظورة؟",
            doYouWishToOfflineSupportRequest: "دو هل ترغب حقًا في حذف هذه الرسالة؟",
            bannedWordSaved: "الكلمة المحظورة المحفوظة",
            deletedSuccessfully: "حذف بنجاح",
            deleteErrorMsg: "خطأ: لم يتم حذفه ، حاول مرة أخرى",
            socketError: "خطأ في اتصال المقبس. الرجاء تحديث الصفحة وحاول مرة أخرى.",
            socketConnecting: "الاتصال بالخادم",
            offlineModeDescription: "النظام لأسفل ، لن يتمكن العملاء من الوصول إلى الدعم المباشر.",
            offlineModeSettingsDescription: "تحقق من ميزة الوضع غير المتصلة في قائمة الإعدادات.",
            offlineModeUser: "يجب أن يكون هناك ممثل واحد على الأقل عبر الإنترنت في النظام.",
            offlineModeMessage: "رسالة دون اتصال",
            offlineMode: "وضع غير متصل بالشبكة",
            adminCannotConnectSocket: "لا يمكن للمسؤول الاتصال بالمقبس.",
            liveSupport: "الدعم المباشر",
            siteVisitors: "زوار الموقع",
            visitors: "الزائرين",
            thoseConnectedToLiveSupport: "أولئك الذين يتصلون بدعم مباشر",
            visitorHistory: "تاريخ الزوار",
            visitorHistoryDescription: "يمكنك عرض وتحميل سجل دردشة الزائر.",
            privateMessage: "رسالة خاصة",
            addRepresentative: "إضافة ممثل",
            forwardRepresentative: "ممثل إلى الأمام",
            keyboardShortcuts: "اختصارات لوحة المفاتيح",
            chatColorMeanings: "معاني ألوان الدردشة",
            connLostCheckInternet: "الاتصال المفقود ، يرجى التحقق من اتصال الإنترنت الخاص بك.",
            wishToEndThisChat: "دو ترغب في إنهاء هذه الدردشة؟",
            defaultContents: "المحتوى الافتراضي",
            contents: "محتويات",
            newDefaultContent: "محتوى افتراضي جديد",
            title: "عنوان",
            shortcutChar: "الطابع الاختصار",
            pickOne: "إختر واحدة",
            writeSomething: "اكتب حرفًا (A-Z | 0-9)",
            letterSequence: "تسلسل الرسالة",
            exampleText: "مثال: SOC -> كرة القدم",
            anyChar: "أي شخصية",
            shorcutKey: "مفتاح الاختصار",
            content: "محتوى",
            shortcutName: "اسم الاختصار",
            type: "يكتب",
            shortcut: "الاختصار",
            defaultContentForm: "نموذج المحتوى الافتراضي",
            deleteContentQuestion: "هل ترغب حقًا في حذف هذا المحتوى الافتراضي؟",
            titleContentForm: "رأس المحتوى الجاهز",
            defaultContentDeleted: "المحتوى الافتراضي المحذوف",
            defaultContentSaved: "المحتوى الافتراضي المحفوظ.",
            contentMoved: "تحرك المحتوى.",
            yourEmail: "عنوان البريد الإلكتروني",
            yourName: "اسمك ولقبك",
            login: "تسجيل الدخول",
            lostPassword: "هل نسيت كلمة السر",
            multipleSession: "لقد وقعت في مكان آخر.",
            notAuthorizedToDisplayPage: "أنت غير مخول لرؤية هذه الصفحة!",
            permissions: "أذونات",
            newPermission: "إذن جديد",
            permissionForm: "شكل إذن",
            displayTitle: "عنوان العرض",
            key: "مفتاح",
            keyToUseInSystem: "القيمة الرئيسية للاستخدام في النظام",
            deletePermissionQuestion: "هل ترغب حقًا في حذف هذا الإذن؟",
            permissionDeleted: "تم حذف إذن.",
            permissionSaved: "إذن تم حفظه.",
            newRole: "دور جديد",
            selectARole: "حدد دورًا",
            yes: "نعم",
            no: "لا",
            fullAuth: "إذن كامل",
            roleDeleted: "دور تم حذفه.",
            roleForm: "شكل الدور",
            roles: "أدوار",
            settings: "إعدادات",
            selectTopic: "حدد قسم",
            autoCallTransfer: "نقل المكالمات التلقائية",
            customerTyping: "كتابة العملاء",
            typing: "الكتابة",
            agentTyping: "الكتابة التمثيلية",
            disconnectTime: "وقت إعادة الاتصال ماكس (ثانية)",
            tippyDissconnectTime: "عندما تكون الدردشة غير نشطة بعد عدد الثواني ستنتهي محادثة.",
            queueNumberVisibleFeature: "عرض رقم قائمة الانتظار للزائر",
            privateChatEnabled: "إظهار الدردشة بين الممثلين",
            delayedTalkTime: "وقت التأخير (ثانية)",
            employeeAverageChatCount: "متوسط ​​رقم الدردشة لمعدل دردشة الموظف",
            customerDownTimeWhenRepExit: "توقف العميل عندما يترك التمثيلي (SN.)",
            autoAssignLimit: "الحد الأقصى التلقائي التلقائي",
            wasted: "محادثة فقدت الوقت (ثانية)",
            settingFormWrong: "بيانات النموذج خاطئة ، حاول مرة أخرى بعد التحقق من ذلك",
            settingsSaved: "تم حفظ الإعدادات.",
            settingsCannotSaved: "لا يمكن حفظ الإعدادات",
            noAuthorization: "لا تخويل",
            warningBadInput: "يوصى بإدخال رقم بين 0 و 70.",
            warning: "تحذير!",
            warningBadInputMarginY: "تحذير من إدخال الهامش العمودي ⚠",
            warningBadInputMarginX: "تحذير من إدخال الهامش الأفقي ⚠",
            warningBadInputBubbleSize: "تحذير من إدخال فقاعة الدردشة ⚠",
            delayTime: "وقت التأخير (ثانية)",
            sites: "المواقع",
            newSite: "موقع جديد",
            noSiteYet: "لا يوجد موقع حتى الآن.",
            siteAddress: "عنوان الموقع",
            turnBack: "رجوع",
            customerRepLimit: "حد ممثل العميل",
            siteSaved: "تم حفظ الموقع.",
            siteSaveError: "حدث خطأ أثناء إنشاء الموقع",
            subjects: "المواضيع",
            newSubject: "موضوع جديد",
            noSubject: "لا موضوع حتى الآن.",
            subject: "موضوع",
            subjectTitle: "عنوان الموضوع",
            infoAboutSubject: "معلومات حول الموضوع",
            deleteSubjectQuestion: "هل ترغب حقًا في حذف هذا الموضوع؟",
            subjectDeleted: "موضوع تم حذفه.",
            subjectSaved: "موضوع حفظ.",
            welcomeMessages: "رسائل النظام",
            newWelcomeMessages: "رسالة ترحيب جديدة",
            noWelcomeMessage: "لا توجد رسالة نظام.",
            welcomeMessageContent: "محتوى رسالة النظام",
            makeChoice: "أختار...",
            welcomeMessage: "ترحيب رسالة",
            repLoggedIn: "قام ممثل بتسجيل الدخول",
            loginMessage: "تسجيل الدخول",
            message: "رسالة",
            deleteWelcomeMessageQuestion: "هل ترغب حقًا في حذف رسالة النظام هذه؟",
            welcomeMessageDeleted: "تم حذف رسالة النظام",
            welcomeMessageSaved: "تم حفظ رسالة النظام.",
            welcomeMessageForm: "نموذج رسالة النظام",
            noRep: "لا يوجد ممثل حتى الآن.",
            addChat: "أضف الدردشة",
            forwardChat: "الدردشة إلى الأمام",
            ago: "منذ",
            repName: "اسم الممثل",
            lastOnline: "آخر اتصال/وقت عبر الإنترنت",
            lastStatusChange: "تغيير الحالة الأخيرة",
            activeChat: "دردشة نشطة",
            userMaxCapacity: "سعة الدردشة القصوى",
            noActiveChat: "لا دردشة نشطة",
            watch: "يشاهد",
            join: "ينضم",
            open: "فتح محادثة",
            directMessage: "رسالة خاصة",
            block: "حاجز",
            transactions: "المعاملات",
            informations: "المعلومات",
            visitStart: "قم بزيارة البداية",
            fullName: "الاسم الكامل",
            waitChatTime: "وقت الانتظار/الدردشة",
            blockUserConfirm: "هل تريد منع هذا المستخدم؟",
            messaging: "المراسلة",
            hideChat: "إخفاء الدردشة",
            block_: "حاجز",
            privateMessage_: "رسالة خاصة",
            assignRep: "تعيين ممثل",
            forwardRep: "إلى الأمام",
            leaveChat: "اترك الدردشة",
            endChat: "نهاية المحادثة",
            translatedTextDescription: "ترجم Amazon هذه الرسالة {from} -> {to}.",
            autoTranslate: "ترجمة السيارات",
            translateThisMessage: "ترجمة هذه الرسالة",
            autoTranslateDetectedDesc: "لغة الزائر هي {visitorLanguage}. انقر هنا لتفعيل الترجمة التلقائية",
            on: "على",
            off: "عن",
            prevChats: "الدردشات السابقة",
            noShortCut: "لا اختصار",
            leaveChartConfirm: "دو هل ترغب حقًا في مغادرة الدردشة؟",
            endChatConfirm: "دو ترغب في إنهاء الدردشة؟",
            endConversation: "نهاية المحادثة",
            onlyOneRep: "أنت الممثل الوحيد في هذه المحادثة!",
            chatList: "قائمة الدردشة",
            chatBar: "شريط الدردشة",
            unreadTitle: "غير مقروء",
            visitorLeftTitle: "غادر الزائر",
            activeChatTitle: "دردشة نشطة",
            autoAssignedTitle: "دردشة مخصصة تلقائية",
            watchModeTitle: "وضع الساعة",
            lostChat: "الاتصال التمثيلي فقد",
            chatWidthDelay: "الدردشة مع التأخير",
            repChatWidthDelay: "عندما لا يكون هناك ممثل نشط في النظام أو جميع ممثلينا ممتلئين بسبب ارتفاع حركة المرور ، ستكون خلفية الدردشة خضراء",
            repLostConn: "إذا فقد ممثل العميل الاتصال ، فستكون خلفية الدردشة وردية.",
            unreadMsg: "إذا كانت هناك رسائل غير مقروءة ، فستكون الخلفية زرقاء فاتحة.",
            visitorLeftChat: "إذا غادر الزائر المحادثة ، تصبح الخلفية رمادية داكنة.",
            activeChatMsg: "الخلفية خضراء إذا كانت الدردشة نشطة",
            autoAssignMsg: "تصبح الخلفية خردلًا إذا تم تعيينها عن طريق المهمة التلقائية ولم يتم النظر إلى المحادثة أبعد من ذلك",
            watchModeMsg: "إذا تم تشغيله في وضع التشغيل ، تصبح الخلفية حمراء",
            online: "متصل",
            beRightBack: "بعيد",
            away: "بعيد",
            busy: "مشغول",
            offline: "غير متصل على الانترنت",
            logout: "تسجيل خروج",
            forWindows: "للنوافذ",
            forMac: "لل ماك",
            nextChatFromActive: "التبديل من النشط إلى المحادثة التالية",
            previousChatFromActive: "التبديل من النشط إلى السابق",
            hideActiveChat: "إخفاء المحادثة النشطة",
            closeActiveChat: "إغلاق محادثة نشطة",
            firsthiddenChat: "انضم إلى أكثر دردشة العميل التي انتظرها",
            firstChatWaiting: "قم بالتبديل إلى المحادثة الانتظار",
            previousOpenedChat: "بغض النظر عن الترتيب ، انتقل إلى المحادثة التي تم فتحها مسبقًا",
            historyDetails: "تفاصيل التاريخ",
            chat: "محادثة",
            chatNotFound: "لم يتم العثور على كلام",
            dataNotFound: "لم يتم العثور على بيانات.",
            visitorInfo: "معلومات الزائر",
            timeSpent: "قضاء الوقت",
            noActiveVisitors: "لا زوار نشطين",
            totalConnected: "عدد المحادثة",
            missedChat: "عدد الدردشة الفائتة",
            workTime: "وقت العمل",
            closedChatCount: "دردشة مغلقة",
            activeConvo: "محادثة نشطة",
            notAnswered: "لم يرد بعد",
            delayedConvo: "تأخير",
            leavingRep: "ترك ممثل",
            staffRate: "معدل عمل الموظفين",
            select: "القائمة المنسدلة",
            fullname: "الاسم الكامل",
            text: "نص",
            numeric: "رقم",
            phone: "هاتف",
            optionsPlaceholder: "قيمة الخيار",
            selectField: "انقر إذا كنت تريد إضافة قائمة منسدلة",
            fullnameField: "انقر إذا كنت تريد إضافة حقل اسم كامل.",
            textField: "انقر إذا كنت تريد إضافة حقل نص.",
            labelField: "انقر إذا كنت تريد إضافة حقل وصف.",
            numericField: "انقر إذا كنت تريد إضافة حقل رقمي.",
            phoneField: "انقر إذا كنت ترغب في إضافة حقل هاتف.",
            departmentField: "انقر إذا كنت ترغب في إضافة حقل قسم.",
            emailField: "انقر إذا كنت ترغب في إضافة حقل بريد إلكتروني.",
            visible: "مرئي",
            required: "مطلوب",
            label: "تعليق",
            customLoginAlert: "يجب أن يحتوي نموذج تسجيل الدخول الخاص بك على حقل مرئي واحد على الأقل.",
            atLeastOneLanguage: "يجب أن تشعر بلغة واحدة على الأقل",
            requiredFieldField: "هذه الخانة مطلوبه",
            notRequiredField: "لا يشترط هذا المجال",
            visibleField: "هذا المجال مرئي",
            notVisibleField: "هذا الحقل لا يظهر في النموذج.",
            connectServer: "أنت متصل بالخادم",
            disconnectServer: "أنت غير متصل بالخادم",
            liveChatOff: "الدردشة الحية متوقفة",
            visitorScreen: "شاشة الزوار",
            viewOnTheSite: "عرض على الصفحة",
            viewOnTheSiteTippy: "انقر هنا لترى كيف تصمد التغييرات الخاصة بك.",
            showHint: "اظهر التلميح",
            dontShowHint: "لا تظهر تلميحًا",
            liveChatOn: "الدردشة الحية قيد التشغيل",
            nightModeOff: "وضع الليل قبالة",
            doubleClickEdit: "انقر نقرًا مزدوجًا أو اضغط على زر التحرير لتحريره.",
            deleteField: "يمسح",
            arrow_upward: "السهم لأعلى",
            arrow_downward: "السهم لأسفل",
            newCatalogCategory: "فئة الكتالوج الجديدة",
            childCreate: "انقر نقرًا مزدوجًا لإنشاء طفل جديد",
            updateCatalogCategoryFrom: "تحديث نموذج فئة الكتالوج",
            newCatalogCategoryFrom: "نموذج فئة الكتالوج الجديدة",
            catalogCategoryMenu: "إضافة قائمة فئة الكتالوج",
            catalogCategoryLeaf: "إضافة القائمة الفرعية فئة الكتالوج",
            catalogCategoryName: "فئة الكتالوج اسم",
            newCatalogContentFrom: "نموذج محتوى الكتالوج الجديد",
            catalogContentName: "اسم محتوى الكتالوج",
            catalogCategorySaved: "فئة الكتالوج المحفوظة",
            catalogCategoryDeleted: "فئة الكتالوج المحذوفة",
            catalogCategoryRate: "معدل المحتوى",
            catalogContentFeature: "ميزة محتوى الكتالوج",
            vtipyAudioLevel: "تستخدم لكتم الصوت أو إلغاء كتم الأصوات.",
            vtipyOrganizationName: "يمكنك تغيير اسم المؤسسة وتحديثه.",
            vtipyBrandVisibility: "Supsis هو الإعداد ما إذا كان يمكن عرض العلامة في فقاعة الدردشة.",
            vtipyBrandVisibilityForced: "يمكن لمستخدمي بروبان فقط التغيير !!",
            vtipyClientDefault: "يمكنك تغيير لغة صفحة الوكيل هنا.",
            vtipyCustomerClientDefault: "يمكنك تغيير لغة صفحة العميل (الدردشة) هنا.",
            vtipyVisitorPreferredLang: "يمكن للعميل تحديد اللغة المنطوقة على صفحة (الدردشة).",
            vtipyCustomerClientLanguageDetect: "يمكنك تغيير لغة صفحة العميل (الدردشة) هنا.",
            vtipySelectTopic: "تحدث المهام التلقائية للممثلين الحاليين في القسم المحدد.",
            vtipyAutoCallTransfer: "يعين تلقائيا مكالمات الانتظار إلى الوكلاء المتاحين.",
            vtipyCustomerTyping: "يتيح لك معرفة ما كتبه العميل على شاشة الدردشة على شاشة الدردشة التمثيلية.",
            vtipyAgentTyping: "إنها تعطي معلومات عند كتابة التمثيلية للعميل في الدردشة bobble",
            vtipyQueueNumberVisibleFeature: "عندما يكون الممثلون مشغولين ، فإنه يوضح العملاء الذين يرغبون في الاتصال ، في أي ترتيب هم.",
            vtipyPrivateChatEnabled: "يظهر لوحة المحادثة بين العوامل.",
            vtipyDelayedTalkTime: "إذا لم يتم توصيل أي مندوبين بالمحادثة خلال هذا الوقت ، فسيتم تسميته \\ \"الدردشة المتأخرة \\",
            vtipyOfflineMode: "يتيح لك وضع النظام في وضع عدم الاتصال.",
            vtipyAutoAssignLimit: "يحدد عدد العملاء (الدردشة) سيتم تعيينهم للممثل تلقائيًا.",
            vtipyCustomerDownTimeWhenRepExit: "وقت الخمول العميل عندما يخرج الممثل (ثانية)",
            tippyDisconnectTime: "إغلاق الدردشة بعد فصل العميل (SEC).",
            changeSettings: "تغيير الإعدادات العالمية",
            totalBg: "مجموع الدردشات",
            activeBg: "الدردشات النشطة",
            watchBg: "يشاهد",
            waitingBg: "محادثات عابرة",
            lateBg: "محادثات عابرة",
            freeBg: "حر",
            maxCapacityBg: "السعة القصوى",
            addNewSettings: "أضف إعدادات عالمية جديدة",
            darkMode: "الوضع المظلم",
            clientDefault: "لوحة الافتراضية اللوحة",
            customerClientDefault: "لغة العميل الافتراضية",
            customerClientLanguageDetect: "لغة العميل لاكتشاف تلقائي",
            visitorPreferredLang: "دع العميل يختار اللغة المنطوقة",
            preferredThemeColor: "لون السمة المفضل لشاشة دردشة العميل",
            detail: "التفاصيل",
            supportUs: "اتصل بنا (الدعم المباشر)",
            langSetting: "إعدادات اللغة",
            changeLang: "تغيير اللغة",
            fontSizeSetting: "إعداد تكبير الشاشة",
            changeLangDesc: "يغير لغة التطبيق إلى {code}",
            trLang: "اللغة التركية",
            enLang: "إنجليزي",
            fieldRequired: "{الحقل} مطلوب حقل",
            selectALanguage: "اختر لغة",
            selectATheme: "حدد موضوع",
            responseForm: "نموذج الاستجابة",
            clientRequestInfo: "معلومات طلب العميل",
            createdDate: "تاريخ الإنشاء",
            descMessage: "رسائل",
            new: "جديد",
            selectAllPermission: "اختر الكل",
            catalogCategories: "فهرس",
            copiedClipboard: "نسخ إلى الحافظة",
            changeLogo: "تغيير الشعار",
            changePhoto: "غير الصوره",
            addPhoto: "إضافة صورة",
            seePhoto: "انظر الصورة",
            deletePhoto: "احذف الصورة",
            organizationLogo: "شعار المنظمة",
            changePlan: "خطة التغيير",
            close: "يغلق",
            vtipyUploadLogo: "من خلال تحميل شعار شركتك من هذا المجال ، يمكنك استخدام شعارك الخاص في رسائل البريد الإلكتروني وصفحات العملاء.",
            tagName: "اسم العلامة",
            tagDescription: "وصف التسمية",
            tagColor: "لون التسمية",
            userInformations: "معلومات المستخدم",
            incomingChat: "محادثة واردة",
            support: "يدعم",
            team: "تعيين",
            groups: "مجموعات",
            newConversationStarted: "بدأت محادثة جديدة",
            allHistoryLoaded: "تم تحميل كل التاريخ",
            chatCreator: "منشئ الدردشة",
            enterGroupTitle: "أدخل عنوان المجموعة",
            requiredTitle: "لا يمكنك ترك حقل العنوان فارغًا",
            requiredChannel: "لا يمكن ترك اسم القناة فارغًا",
            next: "يتأكد",
            selectPeople: "حدد الأشخاص",
            textLimitAlertMessage: "الحد الأقصى لعدد الأحرف في WhatsApp هو 19 حرفًا ولن يتم عرضه بعد هذا الحد. ومع ذلك، على الويب، يتم نقل النصوص التي تتجاوز الحد المسموح به وهو 19 حرفًا تلقائيًا إلى السطر التالي ويتم عرضها.",
            artificialIntelligence: "الذكاء الاصطناعي",
            channelSettings: "إعدادات القناة",
            apiKeyMode: "وضع مفتاح API",
            byokTitle: "استخدام مفتاح API الخاص بي (BYOK)",
            byokDesc: "استخدم مفتاح API من حساب OpenRouter الخاص بك",
            supsisKeyTitle: "دع Supsis AI يوفر مفتاح API",
            supsisKeyDesc: "استخدم مفتاح API المقدم من Supsis",
            openrouterApiKey: "مفتاح OpenRouter API",
            openrouterApiKeyHint: "يمكنك الحصول على مفتاح API من لوحة OpenRouter.",
            noChannels: "لا توجد قنوات بعد",
            createFirstChannel: "انقر على \"إضافة قناة\" لإنشاء قناتك الأولى.",
            createChannel: "إنشاء قناة",
            providerInfo: "معلومات المزود",
            channels: "القنوات",
            channelUpdatedSuccessfully: "تم تحديث القناة بنجاح",
            channelDeletedSuccessfully: "تم حذف القناة بنجاح",
            failedToSaveChannel: "فشل حفظ القناة",
            failedToDeleteChannel: "فشل حذف القناة",
            apiKeyRequired: "مفتاح API مطلوب",
            deleteChannelConfirm: "هل أنت متأكد من حذف هذه القناة؟",
            copiedToClipboard: "تم النسخ إلى الحافظة",
            showMore: "عرض المزيد",
            showLess: "عرض أقل",
            dropdown: "قابل للتحديد",
            selectRepresentativeChatbot: "اختيار الممثل/روبوت الدردشة",
            selectDomain: "اختيار النطاق",
            salesOrders: "طلبات المبيعات",
            noSalesOrdersFound: "لا توجد طلبات مبيعات لهذا الشخص",
            loadingSalesOrders: "جاري تحميل طلبات المبيعات",
            contacts: "جهات الاتصال",
            noContactsFound: "لم يتم العثور على جهات اتصال لهذا الرقم",
            loadingContacts: "جاري تحميل جهات الاتصال",
            saveAsEmailCustomerGroup: "الحفظ كمجموعة عملاء بريد",
            saveAsWhatsappCustomerGroup: "الحفظ كمجموعة عملاء واتساب",
            deleteModalFormDesc: "إذا حذفت هذا النموذج، سيتم حذف جميع بيانات النموذج نهائياً. هل أنت متأكد من المتابعة؟",
            failedToDeleteGroup: "فشل حذف المجموعة",
            failedToDeleteGroups: "فشل حذف المجموعات",
            failedToFetchGroupContacts: "فشل جلب جهات اتصال المجموعة",
            isOneOf: "واحد من",
            between: "بين",
            chatbotScenarioHasBeenCanceled: "تم إلغاء سيناريو روبوت الدردشة",
            importFromReadyTemplates: "استيراد من القوالب الجاهزة",
            aiClassificationTextMode: "تصنيف النص",
            aiClassificationImageMode: "تصنيف الصورة",
            aiClassificationImageUrlLabel: "الصورة المراد تصنيفها (رابط)",
            aiClassificationImageUrlPlaceholder: "أدخل رابط صورة بصيغة https://...",
            updateChannelDesc6: "تحديث قناة واتساب للأعمال",
            newWabaChannel: "قناة واتساب للأعمال الجديدة",
            newWabaChannelDesc: "إنشاء قناة جديدة لواتساب للأعمال",
            deleteFiles: "حذف الملفات",
            sureDeleteMultipleFiles: "هل أنت متأكد من حذف الملفات المحددة؟",
            cancelSelection: "إلغاء التحديد",
            bulkSms: "رسائل SMS جماعية",
            sendBulkSmsCustomers: "إرسال رسائل SMS جماعية لعملائك",
            manageYourTeamGramIntegration: "إدارة تكامل TeamGram",
            configureTrendyolStoreIntegrationDetail: "تكوين تكامل متجر Trendyol",
            connectZoho: "الاتصال بـ Zoho CRM",
            sureDeleteZohoChannel: "هل أنت متأكد من حذف قناة Zoho CRM؟",
            notCreateMoreThenOneChannel: "لا يمكنك إنشاء أكثر من قناة Ideasoft واحدة",
            createMoreThenOneOpenAiChannel: "لا يمكنك إنشاء أكثر من قناة OpenAI واحدة",
            questions: "الأسئلة",
            initalContact: "أول اتصال",
            needsAssessnment: "تحليل الاحتياجات",
            campagin: "الحملة",
            notAuthorizedChannel: "غير مصرح لك بالوصول إلى هذه القناة.",
            visitorScreenNaming: "تسمية شاشة الزائر",
            integrationsYouTubeComments: "Manage YouTube comments from a single panel and engage with your customers.",
            integrationsGoogleBusinessReviews: "Manage Google Business reviews from a single panel and engage with your customers.",
            integrationsGooglePlayReviews: "Manage Google Play Store app reviews from a single panel and engage with your users.",
            integrationsAppStoreReviews: "Manage App Store app reviews from a single panel and engage with your users.",
            integrationsGoogleDrive: "Manage your Google Drive files within Supsis and share them in conversations.",
            integrationsPage: {
                compare: "قارن",
                dead: "غير متاح",
                whatsappV2Web: "WhatsApp V2 (Web)",
                whatsappV3QR: "WhatsApp V3 (QR Code)",
                whatsappBusinessAPI: "WhatsApp Business API",
                whatsappBusinessAPIv2: "WhatsApp Business API v2",
                instagram: "Instagram",
                instagramV2: "Instagram V2",
                instagramV2Desc: "اتصال مباشر عبر Instagram Login. لا حاجة لحساب فيسبوك.",
                messenger: "Messenger",
                linkedin: "LinkedIn",
                telegramQR: "Telegram (QR Code)",
                telegramBotFather: "Telegram (Bot Father)",
                youtubeComments: "تعليقات YouTube",
                googleBusinessReviews: "مراجعات Google Business",
                googlePlayReviews: "مراجعات Google Play",
                appStoreReviews: "مراجعات App Store",
                googleDrive: "Google Drive",
                webTabs: "علامات ويب",
                webTabsDesc: "افتح التطبيقات الخارجية داخل Supsis بإضافة علامات مخصصة لقائمة الشريط الجانبي",
                webApps: "تطبيقات الويب",
                webAppsDesc: "قم بتحميل وإدارة تطبيقات الويب الخاصة بك",
                mail: "البريد",
                smsPostacell: "SMS - Postacell",
                zohoCRM: "Zoho CRM",
                teamgram: "Teamgram",
                ideasoft: "Ideasoft",
                ticimax: "Ticimax",
                ticimaxV2: "Ticimax-V2",
                ticimaxV2Desc: "إدارة متجر Ticimax والرد على العملاء في الوقت الفعلي عبر Supsis.",
                tsoft: "T-SOFT",
                tsoftDesc: "إدارة طلبات T-SOFT والشحن بسهولة مع SUPSIS AI.",
                ikas: "IKAS",
                ikasDesc: "إدارة طلبات متجر Ikas والشحن بسهولة مع SUPSIS AI.",
                cacheManager: "مدير التخزين المؤقت",
                cacheManagerDesc: "إدارة التخزين المؤقت لتبادل البيانات بين الأتمتة والروبوتات",
                openai: "OpenAI",
                slack: "Slack",
                pushover: "Pushover",
                metaLeads: "Meta Leads",
                voice: "صوت",
                webphoneRedsantral: "Webphone (Red Central)",
                webphoneRedsantralDesc: "تكامل نظام الهاتف عبر الويب",
                webphoneTelnyx: "Webphone (Telnyx)",
                webphoneTelnyxDesc: "تكامل Telnyx للمكالمات العالمية",
                webphoneNetgsm: "Webphone (NetGSM)",
                webphoneNetgsmDesc: "تكامل الهاتف عبر الويب مع سنترال NetGSM",
                aiVoiceAgent: "وكيل الصوت بالذكاء الاصطناعي",
                aiVoiceAgentDesc: "إدارة هواتفك بمساعد الصوت الذكي. يمكنك أيضًا دمج المساعد الصوتي في موقعك.",
                artificialIntelligenceFallback: "الذكاء الاصطناعي",
                openRouter: "OpenRouter",
                openRouterDesc: "الوصول إلى جميع نماذج LLM عبر واجهة API واحدة",
                openAIDesc: "نماذج GPT-4 و GPT-4o و ChatGPT",
                googleAIStudio: "Google AI Studio",
                googleAIStudioDesc: "نماذج Gemini",
                anthropic: "Anthropic",
                anthropicDesc: "نماذج Claude 3.5 Sonnet و Claude",
                mistral: "Mistral",
                mistralDesc: "Mistral Large ونماذج أخرى",
                microsoftAzure: "Microsoft Azure",
                microsoftAzureDesc: "خدمات Azure OpenAI",
                amazonBedrock: "Amazon Bedrock",
                amazonBedrockDesc: "منصة AWS LLM",
                cohere: "Cohere",
                cohereDesc: "نماذج Command R+ و NLP",
                xai: "xAI",
                xaiDesc: "نماذج Grok",
                deepInfra: "DeepInfra",
                deepInfraDesc: "بنية استدلال LLM",
                together: "Together",
                togetherDesc: "خدمات LLM مفتوحة المصدر",
                fireworks: "Fireworks",
                fireworksDesc: "استدلال LLM سريع",
                siliconFlow: "SiliconFlow",
                siliconFlowDesc: "منصة نماذج الذكاء الاصطناعي",
                parasail: "Parasail",
                parasailDesc: "خدمة LLM API",
                nebius: "Nebius",
                nebiusDesc: "بنية الذكاء الاصطناعي السحابية",
                alibabaCloud: "Alibaba Cloud",
                alibabaCloudDesc: "نماذج Qwen",
                xiaomi: "Xiaomi",
                xiaomiDesc: "نماذج MiLM",
                sambaNova: "SambaNova",
                sambaNovaDesc: "أجهزة وبرامج الذكاء الاصطناعي",
                moonshotAI: "Moonshot AI",
                moonshotAIDesc: "نماذج Kimi",
                minimax: "Minimax",
                minimaxDesc: "نماذج Abab",
                nvidia: "NVIDIA",
                nvidiaDesc: "نماذج NVIDIA NIM",
                whatsappComparisonTitle: "مقارنة حلول WhatsApp",
            },
            trendyol: "Trendyol",
            addUserToRole: "إضافة مستخدم إلى الدور",
            moveToRole: "نقل إلى الدور",
            noUsersInRole: "لا يوجد مستخدمون في هذا الدور",
            removeUserFromRole: "إزالة المستخدم من الدور",
            removeUserFromRoleConfirm: "هل أنت متأكد من إزالة هذا المستخدم من الدور؟",
            selectNewRole: "اختيار دور جديد",
            selectRole: "اختيار الدور",
            roleUsersUpdated: "تم تحديث المستخدمين",
            userNotFound: "المستخدم غير موجود",
            unnamed: "بدون اسم",
            adminReports: "تقارير المسؤول",
            whatsappv3Channel: "قناة واتساب V3: ",
            linkedinChannel: "قناة لينكدإن: ",
            telegramChannel: "قناة تيليجرام: ",
            linkedinUserProfile: "ملف مستخدم لينكدإن",
            telegramUserProfile: "ملف مستخدم تيليجرام",
            createTask: "إنشاء مهمة",
            integrationsInstagram: "أدر رسائل إنستغرام من لوحة واحدة ووفر تواصلاً متواصلاً مع العملاء على وسائل التواصل.",
            integrationsLinkedin: "أدر رسائل وتعليقات لينكدإن ووفر تفاعلاً سريعاً مع العملاء بالردود التلقائية.",
            integrationsTelegram: "أدر قناة تيليجرام من منصة واحدة وتحكم بجميع الرسائل بسهولة.",
            integrationsWebchat: "زِد التحويلات بروبوت دردشة يعمل 24/7 على موقعك مع ردود على الأسئلة الشائعة ومتابعة العملاء المحتملين.",
            deleteThread: "هل أنت متأكد من حذف جميع الرسائل؟ لا يمكن التراجع عن هذا الإجراء.",
            deleteMail: "هل أنت متأكد من حذف البريد؟ لا يمكن التراجع عن هذا الإجراء.",
            tokenCopied: "تم نسخ رمز الوصول.",
            cardInfos: "معلومات البطاقة",
            saveSystemCardInfo: "يتم حفظ بطاقتك في نظامنا وستُخصم تلقائياً عند حلول تاريخ الدفع.",
            cardNumber: "رقم البطاقة",
            cardType: "نوع البطاقة",
            skt: "تاريخ الانتهاء",
            cvv: "CVV",
            saveCard: "حفظ البطاقة",
            cardNameSurname: "اسم حامل البطاقة ولقبه",
            confidentialityAgreementCheck: "أوافق على اتفاقية Confidentiality",
            confidentialityAgreement: "اتفاقية Confidentiality",
            announcementInfo: "معلومات الإعلان",
            deleteAnnouncementQuestion: "هل أنت متأكد من حذف هذا الإعلان؟",
            announcementDeleted: "تم حذف الإعلان",
            updateAnnouncementForm: "نموذج تحديث الإعلان",
            announcementSaved: "تم حفظ الإعلان.",
            newOsrMessageTitle: "عنوان رسالة عدم الاتصال",
            startChat: "بدء الدردشة",
            douYouWishToDeleteAnnouncement: "هل أنت متأكد من حذف هذا الإعلان؟",
            noNewAnnouncement: "لا يوجد إعلان بعد.",
            useAITemplates: "استخدام قوالب GPT-4 الجاهزة للذكاء الاصطناعي",
            mail: "البريد",
            sameRole: "يوجد دور بنفس الاسم!",
            messageTitle: "العنوان",
            joinChat: "انضم إلى الدردشة",
            billingAddress: "عنوان الفواتير",
            addNewAddress: "إضافة عنوان جديد",
            adressTitle: "عنوان العنوان",
            contactUs: "اتصل بنا",
            Aufgabe: "المهمة",
            FromName: "اسم المرسل",
            KeepUsingFeatures: "لمواصلة استخدام ميزاتك",
            anWarteschlange: "قائمة الانتظار",
            aprobado: "موافق عليه",
            beginsWith: "يبدأ بـ",
            cantProceedPayment: "لم نتمكن من إتمام الدفع",
            completado: "مكتمل",
            deleteZohoLinkbulkSms: "رسائل SMS جماعية",
            favorite: "المفضلة",
            featureIsNotAvailable: "الميزة غير متاحة.",
            ifYouSendThisConversationToTheQue: "إذا أرسلت هذه المحادثة إلى قائمة الانتظار، سيتم إخراجك من المحادثة ووضعها في الطابور. إذا كان التعيين التلقائي للمحادثة مفعّلاً، ستُعيَّن المحادثة للوكيل المناسب وقد تُعاد إليك.",
            payNow: "ادفع الآن",
            saving: "جاري الحفظ...",
            supprimerZohoLinkbulkSms: "رسائل SMS جماعية",
            suspendedPlan: "الميزات معلقة",
            temperatura: "درجة الحرارة",
            trendyolStoreConnection: "ربط متجر Trendyol الخاص بك",
            usageLimitExceeded: "تم تجاوز حد الاستخدام",
            utoForwardToOwnerForce: "إعادة توجيه تلقائية إلى المالك (حتى مع روبوت الدردشة النشط)"
        },
        shouldAddMethod: "يجب عليك ملء حقل طريقة الدفع وعنوان الفواتير!\nلن يتم سحب أي أموال من حسابك..\nفي نهاية الشهر ، سيتم إنشاء فاتورة وفقًا لمبلغ استخدامك.",
        telegram: {
            typeInTelegramToken: "اكتب رمز برقية",
            token: "رمز",
            telegramTokenTitle: "تكامل Telegram Supsis",
            telegramAlertForm: "يمكنك الحصول على Telegram bot token منz",
            telegramAlertTitle: "هل تريد حقًا حذف الرمز المميز؟",
            telegramAlertText: "الرمز المميز سوف يختفي بشكل دائم!",
            telegram: "Telegram"
        },
        wp: {
            sendingStatus: "قيد الإرسال",
            sent: "تم الإرسال",
            allErrors: "جميع الأخطاء",
            inProcess: "قيد المعالجة",
            sendingStatuses: "حالات الإرسال",
            downloadCSV: "تحميل CSV",
            errorMessage: "رسالة خطأ",
            noNumbersAdded: "لم تتم إضافة أرقام",
            downloadDetails: "تحميل التفاصيل",
            broadcastFound: "تم العثور على {count} إرسالية",
            resendForFailedNumbersTooltip: "بدء إعادة الإرسال للمتبقين",
            date: "التاريخ",
            walletBalanceInsufficient: "رصيد المحفظة غير كافٍ.",
            broadcastCreatedSuccess: "تم إنشاء البث بنجاح.",
            broadcastCreateFailed: "تعذر إنشاء البث.",
            resendTitlePrefix: "إعادة إرسال ({count} مستلم): ",
            duplicateTitlePrefix: "نسخة: ",
            broadcastClonedSuccess: "تم استنساخ البث بنجاح.",
            broadcastCloneFailed: "تعذر استنساخ البث.",
            broadcastCancelRequestSent: "تم إرسال طلب إلغاء البث. يرجى الانتظار...",
            broadcastCancelledSuccess: "تم إلغاء البث بنجاح.",
            downloadError: "حدث خطأ أثناء التحميل!",
            progressTooltipFormat: "{percent}% ({sent} مرسل/{total} جهة اتصال)",
            successRatioTooltipFormat: "إجمالي الرسائل المرسلة = {total} \n رسائل ناجحة = {success} \n رسائل فاشلة = {failed}",
            notAvailable: "غير متاح",
            fieldRequired: "حقل {field} مطلوب.",
            defaultBroadcastMessageText: "مرحباً {{name}}، شكراً لاختيارك لنا.",
            sendAgain: "إعادة الإرسال",
            shippingDetails: "تفاصيل الشحن",
            importContactsFromFile: "استيراد جهات الاتصال من ملف",
            chatStarted: "بدأت الدردشة",
            chatNotStarted: "الدردشة لم تبدأ",
            contactSelected: "الاتصال المحدد",
            startChatWithAnyNo: "ابدأ الدردشة مع أي رقم",
            toLittleChar: "رقم مفقود !",
            typeInANumberDesc: "اكتب الرقم لبدء الدردشة مع:",
            wpPlusAndLicenceRequired: "WhatsApp Plus خطة وترخيص مطلوب.",
            wpPlusAndLicenceRequiredDesc: "قبل أن تتمكن من بدء الدردشات بأرقام غير مسجلة في جهات الاتصال الخاصة بك ، يجب عليك ترقية خطة WhatsApp والحصول على ترخيص ..",
            chatStartingWait: "بدء المحادثة ، يرجى الانتظار",
            whatsapp: "ال WhatsApp",
            agreement: "اتفاق",
            purchase: "شراء",
            activating: "تنشيط خدمة WhatsApp",
            authenticating: "مصادقة رمز الاستجابة السريعة",
            ready: "مستعد",
            enableFeature: "تمكين ميزة WhatsApp",
            readAndAgree: "لقد قرأت وأوافق",
            subscribe: "يشترك",
            subscribed: "مشترك",
            toEnableWpDescription: "لتمكين ميزات WhatsApp ، انقر فوق الزر أدناه.",
            waitForWpActivationDescription: "يتم تنشيط خدمة حساب WhatsApp الخاصة بك. يرجى الانتظار لبعض الوقت. يستغرق حوالي 10-30 ثانية.",
            greatWpActivatedDescription: "رائع ، يتم تنشيط خدمة حساب WhatsApp الخاصة بك!",
            unsubscribe: "إلغاء الاشتراك",
            planDetails: "سمات",
            sendReceiveMessage: "إرسال واستقبال الرسائل النصية",
            sendReceiveImage: "إرسال وتلقي ملفات الصور",
            sendReceiveAudio: "إرسال واستقبال ملفات الصوت",
            sendReceiveGif: "إرسال وتلقي ملفات GIF",
            startChat: "ابدأ الدردشة على supsis",
            supsisFunctionality: "وظائف دردشة Supsis مفيدة",
            onePhoneMultiAgent: "هاتف واحد ووكلاء متعددين",
            basicIntegration: "التكامل الأساسي وتكوين الصفر",
            activationTitle: "لتفعيل تكامل WhatsApp على supsis:",
            wpIntegrationInstruction1: "افتح WhatsApp على هاتفك",
            wpIntegrationInstruction2: "اضغط على القائمة أو الإعداد. انقر فوق الأجهزة المرتبطة",
            wpIntegrationInstruction3: "أشر هاتفك إلى هذه الشاشة لالتقاط الرمز",
            qrGeneratingWait: "توليد رمز الاستجابة السريعة من فضلك انتظر ...",
            pleaseContinueToWaitUntilCompleted: "بعد التحقق من رمز الاستجابة السريعة ، سيتم التبديل تلقائيًا إلى الحقل المكتمل. انتظر من فضلك...",
            authenticatingWait: "المصادقة ، من فضلك انتظر ...",
            unsubscribeWpInetgration: "إلغاء الاشتراك في تكامل WhatsApp",
            unsubscribeIGIntegration: "إلغاء الاشتراك في تكامل Instagram",
            wpBack: "خلف",
            terminatelWpInetgration: "عند النقر فوق الزر \"إلغاء الاشتراك\" ، سيتم إنهاء تكامل WhatsApp الخاص بك",
            cancelWpInetgration: "هل تريد إلغاء تكامل WhatsApp؟",
            terminatelIGIntegration: "عند النقر فوق الزر \"إلغاء الاشتراك\" ، سينتهي تكامل Instagram الخاص بك",
            cancelIGIntegration: "هل تريد إلغاء تكامل Instagram؟",
            startChatWp: "ابدأ الدردشة",
            purchaseHeader: "شراء تكامل supsis-whatsapp",
            wpServices: "خدمة WhatsApp",
            wpServicesIntegrationCompleted: "اكتمل تكامل WhatsApp الخاص بك. يمكنك الآن استخدام الخدمة.",
            purchasePaymentDescription: "ميزة WhatsApp التي تم إصدارها من شهر إلى شهر. سيتم تنشيط خدمة WhatsApp الخاصة بك بعد قبول الاشتراك.",
            wpIntegrationFeatures: "ميزات تكامل WhatsApp",
            saveChanges: "حفظ التغييرات",
            contactList: "قائمة الإتصال",
            broadcast: {
                broadcast: "إذاعة",
                detail: "تفاصيل البث",
                customer: "عميل",
                phoneNumbers: "ارقام التواصل",
                showMore: "أظهر المزيد",
                groupName: "أسم المجموعة",
                messages: "رسائل",
                status: "حالة",
                usageCost: "تكلفة الاستخدام",
                sendingTime: "إرسال الوقت",
                progress: "تقدم",
                groupDetail: "تفاصيل المجموعة",
                messagesPerContact: "رسائل لكل جهة اتصال",
                successRatio: "نسبة النجاح",
                showLess: "عرض أقل",
                message: "الرسالة"
            },
            messages: "رسائل",
            broadcastRequests: "طلبات البث",
            customerGroups: "مجموعات العملاء",
            messageTemplates: "قوالب الرسائل",
            plans: "خطط",
            wpIntegrationRequired: "تكامل WhatsApp مطلوب",
            wpRequiredIntegrationDescription: "آسف ، سيتم تنشيط الصفحة التي قمت بزيارتها عند دمج WhatsApp الخاص بك.",
            integrateWp: "دعنا نذهب ، دمج whatsapp",
            active: "نشيط",
            archived: "أرشفة",
            createBroadcastMessage: "إنشاء رسالة بث",
            title: "عنوان",
            description: "وصف",
            createdAt: "أنشئت في",
            numbers: "أعداد",
            actions: "أجراءات",
            action: "فعل",
            createCustomerGroup: "إنشاء مجموعة عملاء مخصصة",
            search: "يبحث",
            name: "اسم",
            contacts: "جهات الاتصال",
            noContactFound: "لم يتم العثور على اتصال",
            broadcastTitle: "إعطاء عنوان البث الخاص بك.",
            recipients: "المستلمين",
            selectRecipients: "حدد المستلمين",
            writeYourMessage: "اكتب رسالتك.",
            schedule: "جدول",
            scheduleNowOrLater: "الجدول الزمني الآن أو بعد ذلك",
            summary: "ملخص",
            cancel: "يلغي",
            send: "يرسل",
            sending: "إرسال",
            deleteCustomerGroup: "هل أنت متأكد من حذف مجموعة العملاء هذه؟ {name}",
            customerGroupDeleting: "حذف مجموعة العملاء ...",
            customerGroupDeletingSuccess: "تم حذف مجموعة العملاء بنجاح",
            customerGroupDeletingError: "خطأ أثناء حذف مجموعة العملاء",
            wpPlusRequired: "الخطة WhatsApp Plus المطلوبة.",
            broadcastMessageArchived: "رسالة البث أرشفة",
            broadcastMessageNotArchived: "رسالة البث غير مؤرشفة",
            groupNameSearch: "اكتب اسم مجموعة العملاء",
            groupNameDesc: "اسم مجموعة العميل حدد مجموعات العملاء الخاصة بك",
            save: "يحفظ",
            number: "رقم",
            addColumn: "إضافة العمود",
            addColumnDesc: "أضف عمودًا إلى الجدول",
            addNewContact: "إضافة جهة اتصال جديدة",
            addNewContactDesc: "أضف جهة اتصال إلى الجدول",
            importFile: "استيراد من الملف",
            importFileDesc: "استيراد جهات الاتصال من ملف Excel أو CSV",
            contactAdded: "الاتصال المضافة",
            updateCustomerGroup: "تحديث مجموعة العملاء ...",
            updateCustomerGroupSuccess: "تم تحديث مجموعة العملاء بنجاح",
            sendBroadcastMessage: "إرسال رسالة البث",
            columnName: "اسم العمود",
            columnType: "نوع العمود",
            defaultValue: "القيمة الافتراضية",
            setDefaultValue: "اضبط القيمة الافتراضية على جهات الاتصال",
            age: "عمر",
            location: "موقع",
            gender: "جنس",
            selectContactFile: "حدد ملف الاتصال",
            selectContactCsvOrExcel: "حدد ملف CSV أو Excel.",
            importConfiguration: "تكوين استيراد",
            customizeFile: "تخصيص تكوين الاستيراد الخاص بك.",
            sendMessageTo: "من تريد إرسال الرسالة إلى؟",
            allContact: "كل الاتصال",
            messageTypes: "أنواع الرسائل",
            whenSendMessage: "متى تريد إرسال الرسالة إلى؟",
            instantlyRightNow: "على الفور الآن",
            completed: "مكتمل",
            scheduleFuture: "جدول زمني لتاريخ المستقبل",
            messageDesc: "سيتم إرسال رسالتك على الفور إلى جميع المستلمين",
            messageSendAt: "سيتم إرسال رسالتك إلى جميع المستفيدين في",
            estimatedPrice: "السعر المقدر",
            estimatedTime: "الوقت المقدر",
            now: "الآن",
            tenMinute: "10 دقائق",
            cancelled: "ألغيت",
            failed: "فشل",
            running: "جري",
            queued: "قائمة الانتظار",
            scheduled: "المقرر",
            noNumberAdded: "لم تتم إضافة أرقام",
            csvOrExcelFile: "ملف CSV أو Excel",
            broadcastMessagesToContactFile: "رسائل البث إلى قائمة الاتصال",
            broadcastMessageTemplates: "قوالب الرسائل البث",
            messageFlow: "تدفق الرسالة",
            textMessageSupport: "دعم الرسائل النصية",
            imageMessageSupport: "دعم رسالة الصورة",
            spamPreventions: "الوقاية من البريد العشوائي",
            includesAllBasicPlans: "يشمل كل شيء في الخطة الأساسية",
            chatbotIntegration: "تكامل chatbot",
            messageToNewNumbers: "رسالة إلى أرقام جديدة",
            broadcastMessageToEveryone: "بث رسائل للجميع",
            personalizedBroadcastMessage: "رسائل البث الشخصية",
            customerGroupSegmentation: "تجزئة مجموعة العملاء",
            scheduleBroadcastMessage: "جدولة رسالة البث",
            locationMessageSupport: "دعم رسالة الموقع",
            advancedSpamPreventions: "الوقاية من البريد العشوائي المتقدمة",
            whatsappPlans: "خطط WhatsApp",
            selectBestPlan: "اختر الخطة التي تناسبك",
            comingSoon: "قريباً...",
            selectFile: "حدد ملف",
            created: "مخلوق",
            message: "رسالة",
            cancelIGIntgeration: "هل تريد إلغاء تكامل إنستغرام؟",
            uploadFromComputer: "الرفع من الجهاز"
        },
        ig: {
            instagram: "Instagram"
        },
        ticket: {
            trendyolQandA: "أسئلة وأجوبة ترينديول",
            chatbotTickets: "تذاكر الدردشة الآلية",
            ticketSettings: "إعدادات التذاكر",
            instagramComments: "تعليقات انستغرام",
            messengerComments: "تعليقات ماسنجر",
            trendyolComments: "تعليقات تريندول",
            facebookComments: "تعليقات فيسبوك",
            ticketSelection: "تم تحديد التذكرة",
            bulkClose: "إغلاق جماعي",
            igComment: "تعليق على إنستغرام",
            igMentioned: "إشارات إنستغرام",
            incomingReqChatbot: "الطلبات الواردة مع روبوت المحادثة",
            incomingReqWebForm: "الطلبات الواردة من نموذج الويب",
            incomingReqAutomation: "الطلبات من الأتمتة",
            thisPersonEmailAnswered: "هذا الشخص يريد الرد عبر البريد الإلكتروني",
            thisPersonWpAnswered: "هذا الشخص ينتظر إجابة عبر واتساب",
            clickStartWpChat: "انقر لبدء دردشة واتساب",
            requestProgress: "تقدم الطلب",
            requestMessage: "طلب رسالة",
            clickAddMailAddress: "انقر لإضافة عنوان بريد",
            sendReplyCloseTicket: "إرسال الرد وإغلاق التذكرة",
            closeTicket: "إغلاق التذكرة",
            selectEmailSender: "تحديد مرسل البريد الإلكتروني",
            withEmailWillNotRecievice: "لن تتمكن من تلقي الردود على البريد عند الإرسال باستخدام عنوان البريد هذا!",
            deleteCommentAndClose: "حذف وإغلاق التعليق",
            sendReplyAndClose: "إرسال رد وإغلاق",
            startChatWp: "بدء دردشة واتساب",
            sureWantToDeleteTicket: "هل أنت متأكد من رغبتك في حذف تذكرة؟",
            bulkDeleteConfirmation: "تأكيد الحذف الجماعي للتذكرة",
            selectedTicketSucsDelete: "تم حذف التذاكر المحددة بنجاح.",
            thereErrorDeletingTicket: "حدث خطأ أثناء حذف التذاكر.",
            deleteConfirm: "تأكيد الحذف",
            sureDeleteTicket: "هل أنت متأكد من رغبتك في حذف هذه التذكرة؟",
            ticketSucsDelete: "تم حذف التذكرة بنجاح.",
            represantiveSucsAppoint: "تم تعيين الوكيل بنجاح.",
            ticketClosedSucs: "تم إغلاق التذكرة بنجاح.",
            ticketCloureFailed: "فشل إغلاق التذكرة.",
            unprocessed: "غير معالج",
            pleaseSelectValidStatus: "الرجاء تحديد حالة صالحة.",
            ticketStatusBeenUpdatd: "تم تحديث حالة التذكرة.",
            doYouWantCloseTicket: "هل تريد إغلاق التذكرة؟",
            ticketWillMarkedClosed: "سيتم وضع علامة على التذكرة على أنها مغلقة وأرشفتها.",
            errorUpdatingTicketFailed: "حدث خطأ أثناء تحديث حالة التذكرة.",
            igCommentDeleteIgPost: "تم حذف تعليق Instagram من منشور IG الخاص بك.",
            igCommentHideChange: "تم تغيير حالة إخفاء التعليق على إنستغرام.",
            pleaseChooseRepresent: "الرجاء اختيار ممثل.",
            selectedTicketSucsDelegated: "تم تفويض التذاكر المحددة بنجاح.",
            errorOccuredDuringDelegation: "حدث خطأ أثناء عملية التفويض.",
            bulkTicketClosing: "إغلاق تذاكر مجمعة",
            sureWantCloseTicket: "هل أنت متأكد من رغبتك في إغلاق التذكرة؟",
            selectedTicketSucsClosed: "تم إغلاق التذاكر المحددة بنجاح.",
            thereErrorClosingTicket: "حدث خطأ أثناء إغلاق التذاكر.",
            changeFilterTicketPage: "تغيير عوامل التصفية في صفحة التذاكر",
            nameOfFilter: "اسم المرشح",
            filterValue: "قيمة عامل التصفية",
            deletesSelectedTickets: "حذف التذاكر المحددة",
            idTicketBeDelete: "معرفات التذاكر المراد حذفها. (معرفات التذاكر المحددة أو جميع معرفات التذاكر المدرجة)",
            assignsAgentSelectedTickets: "يخصص ممثلاً للتذاكر المحددة",
            idTicketBeAssigned: "معرفات التذاكر المراد تخصيصها. (معرفات التذاكر المحددة أو جميع معرفات التذاكر المدرجة)",
            idAgentAssigned: "معرف الممثل المخصص",
            changesStatusSelectedTicket: "يغير حالة التذاكر المحددة",
            idTicketWhoseStatus: "معرفات التذاكر التي ستتغير حالتها. (معرفات التذاكر المحددة أو جميع معرفات التذاكر المدرجة)",
            newStatus: "حالة جديدة",
            selectedTicketsSucsUpdated: "تم تحديث حالة التذاكر المحددة بنجاح.",
            errorWhileChangingStatus: "حدث خطأ أثناء تغيير حالة التذاكر.",
            thisPageVoiceAssistant: "تحتوي هذه الصفحة على مساعد صوتي",
            hello: "مرحباً!",
            voiceAssistantContent: "هل كنت تعلم أن هناك <strong>مساعد ذكاء صناعي</strong> يمكنه مساعدتك في هذه الصفحة؟\nيمكنك تجربة استخدام المساعد بطرق التالية:",
            commandHoldingDownTheKey: "يمكنك الضغط على مجموعة المفاتيح والاستمرار في التحدث لإعطاء الأوامر.",
            topRightContent: "في الزاوية العليا اليمنى",
            clickOnTheIcon: "يمكنك بدء المساعد بالنقر على الرمز.",
            sampleVoiceCommands: "نموذج الأوامر الصوتية:",
            showMyTickets: "إظهار تذاكري",
            showMeZeynepsOpenTicket: "إظهار تذاكر زينب المفتوحة اليوم",
            deleteTicketsScreen: "حذف التذاكر على الشاشة",
            assigntLastTicketAli: "تعيين التذكرة الأخيرة لعلي",
            changeStatusAllTicket: "تغيير حالة جميع التذاكر إلى تم.",
            setStatusTicketsScreen: "تعيين حالة التذاكر على الشاشة إلى .......",
            assigntUserTicketScreen: "تعيين التذاكر على الشاشة إلى المستخدم .....",
            assigntFirstTicket: "تعيين التذكرة الأولى لي",
            showIgTickets: "عرض تذاكر الشهر الماضي على الشاشة",
            makeChoice: "إجراء الاختيار",
            makeAssignment: "إجراء التعيين",
            tickets: "تذاكر",
            instagramTickets: "تذاكر انستجرام",
            facebookTickets: "تذاكر فيسبوك",
            trendyolTickets: "تذاكر ترينديول",
            automationTickets: "تذاكر الأتمتة",
            supsisFormTickets: "تذاكر نموذج سوبسيس",
            columnSettings: "إعدادات العمود",
            ticketField: "منطقة التذاكر",
            contactPropertyFields: "الوصول إلى مناطق الملكية",
            ticketFilterList: {
                archivedRequests: "الطلبات المؤرشفة",
                comingFromFacebook: "قادم من فيسبوك",
                comingFromInstagram: "قادم من إنستغرام",
                unassignedOpenRequests: "الطلبات المفتوحة غير المخصصة",
                openRequests: "الطلبات المفتوحة",
                requestsOpenedThisWeek: "الطلبات المفتوحة هذا الأسبوع",
                specialList: "قائمة خاصة",
                creationDate: "تاريخ الإنشاء",
                supsisFromTheForm: "سوبسيس من ذا فورم",
                fromTrendyol: "من ترينديول",
                comesWithAutomation: "يأتي من الأتمتة",
                label: "التسمية",
                status: "الحالة",
                subject: "الموضوع",
                email: "البريد الإلكتروني",
                name: "الاسم",
                phone: "الهاتف",
                type: "النوع",
                assignedUser: "المستخدم المعين"
            },
            appointingRepresentative: "عيّن ممثلًا",
            ticketTagFilter: "علامة تصفية التذاكر",
            ticketEmails: "قائمة البريد الإلكتروني لإعادة توجيه التذاكر",
            save: "يحفظ",
            delete: "يمسح",
            transactions: "خيارات",
            noEmailTicketNotifications: "ليس هنالك معلومات",
            emailIsNotValid: "البريد الإلكتروني غير صالح",
            emailNotificationDeleted: "تم حذف العنصر بنجاح",
            emailNotificationDeleteError: "حدث خطأ",
            tagFilterRequired: "علامة مرشح التذاكر المطلوبة ، استخدم *(Wildcard) علامة لجميع التذاكر",
            emailsRequired: "يجب ألا يكون إعادة توجيه رسائل البريد الإلكتروني لاغية",
            emailNotificationCreated: "تم إنشاء قاعدة التذاكر",
            emailNotificationCreateError: "حدث خطأ",
            ticketForwarding: "إعادة توجيه البريد الإلكتروني التذاكر",
            ticketTagFilterDesc: "يستخدم موضوعات التذاكر التي استخدمتها في تصميم chatbot لتصفية التذاكر. يمكنك كتابة علامة مختلفة واضغط على Enter لإضافتها. إذا قمت بتحديد علامة \"*\" ، فسيتم تحديد جميع التذاكر",
            ticketEmailsDesc: "قائمة البريد الإلكتروني التي سيتم إعادة توجيه التذاكر إليها. يمكنك إضافة عناوين الممثلين في النظام عن طريق اختيارها. يمكنك أيضًا إضافة بريد إلكتروني غير نظام/ق.",
            ticketList: "قواعد إعادة توجيه التذاكر",
            ticketTagFilterPlaceHolder: "مرشح التذاكر ، حدد \"*\" للجميع",
            ticketEmailsPlaceHolder: "إعادة توجيه قائمة البريد الإلكتروني",
            offlineTickets: "تذاكر عدم الاتصال",
            assignFirstTicket: "تعيين التذكرة الأولى لي.",
            assignLastTicketAli: "تعيين التذكرة الأخيرة لعلي.",
            assignUserTicketScreen: "تعيين التذاكر على الشاشة للمستخدم .....",
            placeholders: "العناصر النائبة",
            ticketStatusBeenUpdated: "تم تحديث حالة التذكرة."
        },
        theme: {
            opacity: "العتامة",
            headerColor1: "لون قسم هادر 1",
            headerColor1A: "قسم هادر عتامة 1",
            headerColor2: "رأس قسم الرأس 2",
            headerColor2A: "رأس قسم العتامة 2",
            backgroundColor: "لون الخلفية 1",
            backgroundColorA: "عتامة الخلفية 1",
            backgroundColor2: "لون الخلفية 2",
            backgroundColor2A: "عتامة الخلفية 2",
            textColor: "لون الخط",
            errorTheme: "لون الخطأ",
            bubbleBackground: "تمثيلي لون الفقاعة",
            bubbleVisitorBackground: "لون فقاعة العملاء",
            bubbleBackgroundA: "تمثيلية الفقاعة العتامة",
            bubbleVisitorBackgroundA: "عتامة فقاعة العملاء",
            bubbleText: "لون النص التمثيلي",
            bubbleVisitorText: "لون نص العميل",
            textFormColor: "شكل اللون",
            selectCustom: "حدد موضوع مخصص",
            headerColorSecond: "رأس اللون العلوي",
            headerColorFirst: "لون أسفل العنوان",
            backgroundColorFirst: "لون الخلفية العلوي",
            formColor: "لون نص النموذج",
            buttonColor: "لون الزر",
            backgroundColorSecond: "لون الخلفية السفلي",
            chatBotButtonText: "لون زر Chatbot",
            chatBotButtonColor: "لون زر Chatbot",
            font: "الخط"
        },
        billing: {
            paymentId: "معرف الدفع",
            billType: "نوع الفاتورة",
            invoiceId: "معرف الفاتورة",
            invoiceAmount: "مبلغ الفاتورة",
            invoiceDate: "تاريخ الفاتورة",
            invalidBill: "فاتورة غير صالحة",
            invalidBillNotPossible: "لم يتم إنشاء هذه الفاتورة بعد، لذلك لا يمكن تحديدها على أنها غير صالحة.",
            myInvoices: "تذاكري",
            allInvoices: "جميع الفواتير",
            manualInvoices: "فواتير يدوية",
            endOfPeriodInvoices: "فواتير نهاية الفترة",
            purchaseInvoices: "فواتير الشراء",
            paidInvoices: "فواتير مدفوعة",
            unpaidInvoices: "فواتير غير مدفوعة",
            walletDeposit: "إيداع المحفظة",
            updateBillingInfo: "تحديث معلومات الفاتورة",
            notFoundSavedBillingAddress: "لا يوجد عنوان فاتورة محفوظ",
            notFoundSavedCard: "لا يوجد بطاقة ائتمانية محفوظة",
            cardInfoIsStoredSecurelyByIyzico: "يتم تخزين معلومات البطاقة بأمان بواسطة Iyzico",
            paymentMethodAndInvoiceAddress: "طريقة الدفع وعنوان الفاتورة",
            unpaidInvoiceBannerMessage: "لديك فاتورة غير مدفوعة. يرجى دفع فاتورتك لتجنب انقطاع الخدمة.",
            unpaidInvoiceBannerMessageWithDate: "لديك فاتورة غير مدفوعة. إذا لم تدفع قبل {date}، سيتم تعليق حسابك.",
            unpaidInvoiceBannerSuspendedMessage:
                "تم تعليق حسابك بسبب فواتير غير مدفوعة. يُرجى إتمام الدفع لاستعادة الخدمة.",
            clickToPay: "انتقل إلى صفحة الدفع",
            packageDescriptions: {
                whatsapp: "قم بدمج حساب WhatsApp العادي الخاص بك للرد على العملاء عبر جميع القنوات.",
                whatsappBusiness: "قم بدمج حساب WhatsApp Business الخاص بك للرد على العملاء عبر جميع القنوات.",
                supsis: "مع وجود عدد أكبر من الممثلين، يمكنك الرد على عملائك بسرعة وكفاءة أكبر.",
                chatbot: "يتيح لك تكامل روبوت الدردشة تقديم الدعم لعملائك على مدار الساعة طوال أيام الأسبوع.",
                instagram: "قم بدمج حساب Instagram الخاص بك للرد على العملاء عبر جميع القنوات.",
                telegram: "قم بدمج حساب Telegram الخاص بك للرد على العملاء عبر جميع القنوات.",
                custom: "اختر إحدى خططنا المخصصة للحصول على حلول تناسب احتياجات عملك.",
                messenger: "قم بدمج حساب Messenger الخاص بك للرد على العملاء عبر جميع القنوات.",
                trendyol: "قم بدمج حساب Trendyol الخاص بك للرد بسرعة على استفسارات العملاء.",
                metaLead: "قم بدمج حساب Meta Lead الخاص بك لإدارة العملاء المحتملين مباشرة من لوحة التحكم.",
                customerTables: "قم بإنشاء جداول ديناميكية لإدارة معلومات العملاء والطلبات وغير ذلك الكثير.",
                form: "قم بإنشاء نماذج لجمع المعلومات من عملائك وتحليل البيانات.",
                automation: "قم بإعداد الأتمتة لتسريع العمليات وتحسين الخدمة.",
                mail: "يتيح لك تكامل البريد الإلكتروني إرسال واستقبال الرسائل من عملائك.",
                tasks: "قم بإنشاء المهام لتخطيط وإدارة سير العمل لديك.",
                artificialIntelligence: "يساعدك تكامل الذكاء الاصطناعي على الرد على العملاء بسرعة وكفاءة أكبر.",
                webhook: "قم بدمج تطبيقاتك مع Supsis باستخدام Webhooks.",
                default: "استكشف باقاتنا لمزيد من التفاصيل."
            },
            autoRenew: "تلقائي تجديد",
            purchased: "مشترى",
            currentPlans: "الخطط الحالية",
            individual: "فرد",
            expirationDate: "ت.ا",
            yourNameSurname: "اسمك واسم عائلتك",
            editCardInformation: "تعديل معلومات البطاقة",
            billingContactInfo: "تم تحديث معلومات جهة اتصال الفوترة بنجاح.",
            defaultRootEmail: "افتراضي: البريد الإلكتروني الأساسي",
            invoiceEmailAddress: "عنوان البريد الإلكتروني للفاتورة",
            invoiceSettings: "إعدادات الفاتورة",
            updateChannelDesc6: "تحديث قناة واتساب للأعمال",
            newWabaChannel: "قناة واتساب للأعمال الجديدة",
            newWabaChannelDesc: "إنشاء قناة جديدة لواجهة برمجة تطبيقات واتساب للأعمال",
            popular: "مشهور",
            selectedPlan: "الخطة المحددة",
            editPlan: "تحرير الخطة",
            removePlan: "إزالة خطة",
            showPlan: "إظهار الخطة",
            hiddenPlan: "إخفاء الخطة",
            contactSales: "الاتصال بالمبيعات",
            showLess: "إظهار أقل",
            more: "المزيد",
            selectTransactionType: "نوع المعاملة",
            walletLogs: "سجلات المحفظة",
            addBalance: "إضافة رصيد",
            availableBalance: "الرصيد المتاح",
            walletTransactions: "معاملات المحفظة",
            autoReload: "إعادة التحميل التلقائي",
            transactionTypes: "أنواع المعاملات:",
            transactionTypesHint: "(انقر للاختيار الفردي، Ctrl+انقر للاختيار المتعدد)",
            importantInfo: "معلومات مهمة",
            walletImportantPoint1: "إذا تعذر تحصيل الدفع من بطاقتك، سيتوقف النظام تلقائياً؛ يجب عليك تفعيله بنفسك.",
            walletImportantPoint2: "تحميل واحد فقط كل 10 دقائق. حافظ على الرصيد المستهدف مرتفعاً للاستخدام المكثف.",
            walletImportantPoint3: "يمكنك تفعيل المزيد من الإشعارات من إعدادات الإشعارات.",
            walletImportantPoint3Before: "يمكنك تفعيل المزيد من الإشعارات من ",
            walletImportantPoint3After: ".",
            walletImportantPoint4: "يمكنك عرض إعادة التحميل التلقائية في تبويب \"معاملات المحفظة\".",
            walletImportantPoint5: "لا يوجد حد لعدد أو مبلغ إعادة التحميل؛ تأكد من إدخال الإعدادات الصحيحة.",
            autoBalanceReload: "إعادة تحميل الرصيد التلقائي",
            autoBalanceReloadDesc: "يقوم بتحميل الرصيد تلقائياً عندما ينخفض رصيد محفظتك عن الحد الذي تحدده.",
            autoReloadToggle: "إعادة التحميل التلقائي",
            autoReloadToggleDesc: "يمكنك تفعيل/إلغاء تفعيل هذه الميزة",
            disabledDueToFailure: "معطل بسبب الفشل",
            thresholdValue: "قيمة الحد (TL)",
            thresholdValueDesc: "يتم إعادة التحميل التلقائي عندما ينخفض الرصيد عن هذه القيمة",
            reloadMode: "وضع إعادة التحميل",
            reloadModeDesc: "ماذا يحدث عندما ينخفض الرصيد عن الحد؟",
            addFixedAmount: "إضافة مبلغ ثابت",
            fixBalance: "تثبيت الرصيد",
            modeAddDesc: "عندما ينخفض الرصيد عن الحد، يتم إضافة المبلغ المحدد. مثال: الحد 50 TL، الرصيد 30 TL → إضافة 200 TL → الرصيد يصبح 230 TL.",
            modeFixedDesc: "عندما ينخفض الرصيد عن الحد، يتم إكمال الرصيد إلى المبلغ المحدد. مثال: الحد 50 TL، الرصيد 30 TL → إضافة 170 TL → الرصيد يصبح 200 TL.",
            amountToAdd: "المبلغ المضاف (TL)",
            targetBalance: "الرصيد المستهدف (TL)",
            amountToAddDesc: "سيتم إضافة هذا المبلغ عندما ينخفض الرصيد عن الحد",
            targetBalanceDesc: "سيتم إكمال الرصيد إلى هذا المبلغ عندما ينخفض عن الحد (يجب أن يكون أكبر من الحد)",
            panelNotifications: "إشعارات اللوحة",
            panelNotificationsDesc: "في أي الحالات تريد استلام الإشعارات؟",
            notifyOnRecharge: "إشعار التحميل الناجح",
            notifyOnFailure: "إشعار الفشل",
            notifyOnDisabled: "إشعار التعطيل",
            emailNotifications: "إشعارات البريد الإلكتروني",
            emailNotificationsDesc: "من يجب أن يستلم إشعارات البريد (اختياري)",
            emailPlaceholder: "أدخل عناوين البريد (افصل بفاصلة)",
            emailHint: "إذا تركت فارغاً، سيتم إرسال البريد فقط لمالك الموقع",
            lastTrigger: "آخر تفعيل:",
            neverTriggered: "لم يتم التفعيل بعد",
            failedAttempt: "المحاولة الفاشلة:",
            saveSettings: "حفظ الإعدادات",
            tabAll: "الكل",
            tabAiUsage: "استخدام الذكاء الاصطناعي",
            tabVoiceAgent: "وكيل الصوت",
            tabAutomation: "الأتمتة",
            balanceAddedSuccess: "تم إضافة {price}TL إلى رصيد حساب واتساب الخاص بك",
            balanceAddFailed: "تعذر إضافة الرصيد إلى حسابك.",
            autoRebalanceLoadError: "تعذر تحميل إعدادات إعادة التحميل التلقائي",
            thresholdMinError: "يجب أن تكون قيمة الحد 0 أو أكبر",
            targetBalanceMinError: "يجب أن يكون الرصيد المستهدف أكبر من 0",
            targetBalanceThresholdError: "يجب أن يكون الرصيد المستهدف أكبر من الحد",
            autoRebalanceSaveSuccess: "تم حفظ إعدادات إعادة التحميل التلقائي بنجاح",
            settingsSaveFailed: "تعذر حفظ الإعدادات",
            testFailed: "فشل الاختبار",
            creditCardRequiredForAutoReload: "يجب إضافة معلومات بطاقة الائتمان أولاً لإعادة التحميل التلقائي",
            notificationSettings: "إعدادات الإشعارات",
            appsumoPack: "حزمة أبسومو",
            updatePlan: "تحديث الخطة",
            createPlan: "إنشاء خطة",
            freePack: "حزمة مجانية",
            instantFee: "سيتم فرض رسوم فورية",
            planSequence: "تسلسل الخطة",
            requiredCodes: "عدد الرموز المطلوبة",
            subHeading: "العنوان الفرعي",
            featureKey: "مفتاح الميزة",
            customerKey: "مفتاح العميل",
            monthlyPrice: "السعر الشهري",
            monthlyNonDiscounted: "السعر الشهري غير المخصوم (عرض غير وظيفي)",
            twoYearDiscount: "خصم سنتين",
            yearDiscount: "خصم سنوي",
            sixMonthDiscount: "خصم ستة أشهر",
            threeMonthDiscount: "خصم ثلاثة أشهر",
            areYouSoreRefundInvoice: "هل أنت متأكد من رغبتك في استرداد قيمة هذه الفاتورة؟",
            copied: "تم النسخ",
            copiedToClipboard: "تم نسخ المحتوى إلى الحافظة.",
            copyFailed: "فشلت عملية النسخ.",
            invoiceGenerated: "تم إنشاء الفاتورة",
            invoiceNotGenerated: "لم يتم إنشاء الفاتورة",
            notAvailable: "غير متوفر",
            estimated: "تقديري",
            dueDate: "تاريخ الاستحقاق",
            markAsPaid: "تحديد كمدفوع",
            refundPayment: "معالجة الاسترداد",
            editInvoice: "تعديل الفاتورة",
            deleteInvoice: "حذف الفاتورة",
            adminGroup: "المسؤول",
            billTypeNone: "لا شيء",
            billTypeManual: "يدوي",
            billTypeMonthly3: "3 أشهر",
            billTypeMonthly6: "6 أشهر",
            billTypeAnnual: "سنوي",
            billTypeAnnual2: "سنتان",
            billTypeEducation: "تعليم",
            billTypeConsultancy: "استشارة",
            billTypeInstallation: "تركيب",
            billTypeOther: "أخرى",
            paymentNotPossible: "الدفع غير ممكن",
            saveCardFirst: "يرجى حفظ بطاقة الائتمان أولاً لإجراء الدفع.",
            features: "خصائص",
            sessionCount: "عدد الجلسات",
            subType: "نوع الاشتراك",
            skipTrialVersion: "تخطي الإصدار التجريبي",
            skipTrialVersionDesc: "يمكنك تخطي الإصدار التجريبي والمتابعة عن طريق تحديد الحزمة المناسبة لنشاطك التجاري. إذا قمت بتخطي الإصدار التجريبي، لا يمكن التراجع عن هذا الإجراء.",
            skipStep: "تخطي هذه الخطوة",
            switchToPay: "التبديل إلى الدفع",
            forward: "إلى الأمام",
            pleaseFillInCard: "الرجاء ملء تفاصيل البطاقة!",
            fillInTheBillingAddress: "الرجاء ملء معلومات عنوان الفوترة!",
            cardNumberWrong: "رقم البطاقة خاطئ!",
            pleaseConfirmTheUser: "الرجاء تأكيد اتفاقية المستخدم!",
            pleaseCheckYourCard: "يرجى التحقق من بطاقتك وتفاصيلك.",
            site: "الموقع",
            period: "الفترة",
            billStatus: "حالة الفاتورة",
            totalPrice: "السعر الإجمالي + ضريبة القيمة المضافة",
            depotMoneyWallet: "الإيداع في المحفظة",
            threeMonthly: "٣ شهرياً",
            sixMonthly: "٦ شهرياً",
            twoYearly: "٢ سنة",
            forever: "إلى الأبد",
            extraPackage: "الحزمة الإضافية",
            teamPackage: "حزم الفريق",
            adventPackage: "الحزم المميزة",
            cupponError: "رمز القسيمة غير صحيح أو منتهي الصلاحية",
            enterYourCard: "الرجاء إدخال بطاقتك الائتمانية",
            invalidCard: "بطاقة ائتمان غير صالحة، لم يتم استلام الدفع",
            calculateThis: "احسب لـ:",
            adventageousPackage: "خصومات الباقة المميزة!",
            cupponApplied: "تم تطبيق القسيمة بنجاح",
            subStart: "تم بدء الاشتراك",
            subSuccessStart: "بدأ اشتراكك بنجاح",
            success: "ناجح",
            succesDesc: "تم إنشاء الاشتراك بنجاح",
            successDesc: "تم تفعيل الميزة الخاصة بك بنجاح.",
            maxNumber: "الحد الأقصى لعدد الممثلين الذين سيتحدثون",
            currentAmountDetails: "تفاصيل المبلغ الحالي",
            endOfMonthForecastDetails: "تفاصيل توقعات نهاية الشهر",
            totalAmount: "إجمالي المبلغ",
            vatAmount: "مبلغ ضريبة القيمة المضافة (20%)",
            totalAmountIncludingVAT: "إجمالي المبلغ شاملاً ضريبة القيمة المضافة",
            hideDetails: "إخفاء التفاصيل",
            createInvoice: "إنشاء فاتورة",
            reimbursementMade: "تم السداد",
            invalidInvoice: "فاتورة غير صالحة",
            balanceTopUp: "تعبئة رصيد واتساب",
            paidSuccesfully: "تم دفع الفاتورة بنجاح",
            paymentFailed: "فشلت عملية دفع الفاتورة.",
            areYouSurePaid: "هل تريد بالتأكيد وضع علامة مدفوعة على هذه الفاتورة؟",
            invoiceMarkedPaid: "تم وضع علامة على الفاتورة على أنها مدفوعة.",
            invoiceMarkedFailed: "حدث خطأ وتعذر وضع علامة مدفوعة على الفاتورة.",
            areYouSureRefundInvoice: "هل أنت متأكد من أنك تريد معالجة استرداد الأموال لهذه الفاتورة؟",
            youMustFillInEmpty: "يجب عليك ملء جميع المساحات الفارغة.",
            createdNewInvoice: "تم إنشاء فاتورة جديدة بنجاح.",
            createdNewInvoiceFailed: "حدث خطأ أثناء إنشاء الفاتورة.",
            invoiceUpdated: "تم تحديث مبلغ الفاتورة بنجاح...",
            invoiceUpdatedFailed: "حدثت مشكلة أثناء تحديث الفاتورة.",
            plans: "الخطط",
            companyName: "اسم الشركة",
            compony: "شركة",
            person: "شخص",
            invoiceAddressInfo: "معلومات عنوان الفاتورة",
            idNo: "معرف تركي",
            taxOffice: "مكتب الضرائب",
            taxNumber: "رقم الضريبة",
            packageCanNotDownSupsis: "لا يمكن تخفيض رتبة الحزمة الخاصة بك. يُرجى إزالة أو تعطيل العديد من وكلائك لخفض ترقية الحزمة الخاصة بك.",
            packageCanNotDownWp: "لا يمكن تخفيض رتبة الحزمة الخاصة بك. يُرجى حذف العديد من قنوات الواتس آب الخاصة بك لتخفيض رتبة الحزمة الخاصة بك.",
            packageCanNotDownWPBussiness: "لا يمكن تخفيض رتبة الحزمة الخاصة بك. يُرجى حذف العديد من قنوات واتساب التجارية الخاصة بك لخفض رتبة باقتك.",
            chooseYourPlan: "اختر خطتك.",
            numberOfRepresentatives: "عدد الممثلين",
            numberOfChannels: "عدد القنوات",
            wpNumberOfChannels: "عدد قنوات الواتساب",
            igNumberOfChannels: "عدد قنوات الإنستغرام",
            msNumberOfChannels: "عدد قنوات المسنجر",
            cancelIt: "إلغاء",
            activePlan: "خطة نشطة",
            activate: "تنشيط",
            noTransition: "لا انتقال",
            daysLater: "اليوم التالي",
            payBack: "إعادة الدفع",
            paid: "مدفوع",
            unPaid: "غير مدفوعة",
            editPrice: "تحرير السعر",
            payNow: "ادفع الآن",
            youAreCurrentlyOnTrial: "أنت حاليًا قيد التجربة. يمكنك تخطي الفترة التجريبية الآن لمشاهدة الباقات الحصرية.",
            youAreCurrentlyLimited: "أنت مقيد حاليًا من قبل النظام لأن باقاتك لا تستوفي الشروط.",
            youHaveOneRepresentative: "لديك ممثل واحد.",
            deactivateOrDeleteYourPiece: "قم بإلغاء تنشيط أو حذف ممثل قطعتك أو شراء ممثل.",
            youHaveOneWhatsAppQRChannel: "لديك قناة واتساب QR واحدة.",
            deleteYourWhatsAppQR: "احذف قناة واتساب QR الخاصة بك أو اشترِ قناة.",
            youHaveAWhatsAppBusiness: "لديك قناة واتساب واحدة للأعمال.",
            deleteYourWhatsApp: "احذف قناة واتساب للأعمال أو اشترِ قناة.",
            youHaveAnInstagram: "لديك قناة على Instagram.",
            deleteYourInstagram: "احذف قناتك على Instagram أو اشترِ قناة.",
            youHaveAMessenger: "لديك قناة على الماسنجر.",
            deleteYourMessenger: "احذف قناتك على الماسنجر أو اشترِ قناة.",
            additionalPackages: "حزم إضافية",
            availablePackages: "الباقات المتاحة",
            buyNow: "شراء الآن",
            invoiceInformation: "معلومات الفاتورة",
            invoiceAddress: "عنوان الفاتورة",
            invoiceType: "نوع الفاتورة",
            review: "مراجعة",
            viewDetails: "عرض التفاصيل",
            addNewAddress: "إضافة عنوان جديد",
            enterYourBillingAddress: "أدخل عنوان الفاتورة الخاص بك",
            selectPlan: "اختر الخطة",
            paymentStatus: "حالة الدفع",
            amount: "المبلغ",
            invoiceID: "معرف الفاتورة",
            expected: "متوقع...",
            currentAmount: "المبلغ الحالي",
            monthlyEstimatedAmount: "المبلغ التقديري الشهري",
            creationDate: "تاريخ الإنشاء",
            invoiceStatus: "حالة الفاتورة",
            invoicePeriod: "فترة الفاتورة",
            newPaymentMethod: "طريقة دفع جديدة",
            channelCount: "عدد القنوات",
            remainingTime: "الوقت المتبقي",
            chatbotLimit: "حد الدردشة الآلية",
            free: "مجاني",
            maxChatbotSession: "الحد الأقصى لجلسات الدردشة الآلية",
            buyIt: "اشترِ",
            renewalDate: "تاريخ التجديد",
            monthly: "شهرياً",
            yearly: "سنوياً",
            packagePeriod: "فترة الحزمة",
            packageType: "نوع الحزمة",
            packageManagement: "إدارة الحزم",
            invoiceManagement: "إدارة الفواتير",
            futureInvoice: "الفاتورة المستقبلية",
            pastInvoices: "الفواتير السابقة",
            creditCard: "بطاقة الائتمان",
            invoice: "فاتورة",
            mustBeUpgradePlanForChatBot: "لتفعيل ميزة chatbot ، يجب عليك التبديل إلى خطة Pro!",
            cardInfo: "معلومات البطاقة",
            billingDetails: "تفاصيل الفاتورة",
            addCardIyzico: "ليس لديك بطاقة مسجلة. من أجل دفع رسوم الاستخدام الشهرية ، تحتاج إلى إضافة بطاقة. يتم توفير نظام الدفع بواسطة Iyzico.",
            billingPlanSettings: "فاتورة الفواتير",
            startWith: "{cardFamily} تبدأ بطاقة {binNumber}",
            paymentMethod: "طريقة الدفع او السداد",
            billingDate: "تاريخ الفواتير",
            isPaid: "مدفوع؟",
            markPaid: "مارك كما دفعت",
            paymentDate: "تاريخ الدفع",
            pay: "يدفع",
            newInvoice: "إنشاء فاتورة",
            updateBilling: "تحديث تفاصيل الفواتير",
            updateCard: "تغيير بطاقة الائتمان",
            paymentBilling: "طريقة الدفع وتفاصيل الفواتير",
            price: "سعر",
            billingAddress: "عنوان وصول الفواتير",
            billingCity: "مدينة",
            billingCountry: "دولة",
            contactName: "اسم الاتصال الفواتير",
            expireMonth: "تنتهي صلاحية الشهر",
            expireYear: "تنتهي صلاحيتها",
            expireDate: "تاريخ الانتهاء",
            cardNumber: "رقم البطاقة",
            cardHolderName: "إسم صاحب البطاقة",
            cardAlias: "اسم الاسم المستعار",
            identityNumber: "رقم الهوية",
            name: "اسم",
            surname: "اسم العائلة",
            email: "بريد إلكتروني",
            addCard: "إضافة بطاقة",
            update: "تحديث",
            cancel: "يلغي",
            save: "يحفظ",
            saving: "إنقاذ",
            noInvoiceFound: "لا توجد فاتورة",
            year: "سنة",
            updating: "تحديث ...",
            newInvoiceForm: "فاتورة جديدة إنشاء نموذج",
            error: "خطأ",
            transactions: "خيارات",
            paymentMethodAdded: "تمت إضافة طريقة الدفع بنجاح",
            paymentMethodAddError: "لم يتم إضافة طريقة الدفع ، حدث خطأ",
            creditCardChanged: "لقد تغيرت بطاقة الائتمان بنجاح",
            errorOccurred: "حدث خطأ ، حاول مرة أخرى",
            billingDetailUpdated: "تم تحديث تفاصيل الفواتير بنجاح",
            invoiceCreated: "تم إنشاء الفاتورة بنجاح",
            paymentSuccess: "الدفع بنجاح ، شكرا لك",
            paymentFail: "فشل الدفع ، حاول مرة أخرى",
            billingAddressChanged: "لقد تغير عنوان الفواتير بنجاح",
            hidePlan: "إخفاء الخطة",
            informationShopping: "يتم التحكم في معلومات الدفع الخاصة بك ومعلومات الفواتير ومعلومات بطاقة الائتمان بواسطة Shopify.",
            trialTimeInformation: "تنتهي المحاكمة {dayCount} بعد أيام. إذا لم تقم بإدخال طريقة الدفع حتى انتهاء هذه الفترة ، فسيتم تبديلك تلقائيًا إلى الخطة المجانية من قبل النظام.",
            trialTimeInformationShort: "التجربة: يوم آخر {dayCount}",
            currentPlanLabel: "الخطة الحالية: {planName} ({agentCount} Agent)",
            changeCancelPlan: "خطة تغيير/إلغاء",
            oneAgent: "عامل",
            agent: "عامل",
            yourCurrentPlan: "الخطة الحالية",
            month: "شهر",
            billedMonthToMonth: "(فواتير من شهر إلى شهر)",
            selectAgentCount: "حدد عدد الوكيل",
            selectFreePlan: "حدد خطة مجانية",
            planDetails: "تخطيط التفاصيل",
            multiAgent: "(وكيل متعدد)",
            selectProPlan: "حدد خطة Pro",
            foreverFree: "مجاني للابد",
            websiteIntegration: "تكامل الموقع",
            websiteIntegrationUnlimited: "تكامل الموقع",
            ChatBotUnlimited: "chatbot",
            videoCallUnlimited: "مكالمة فيديو",
            multiAgentUpTo: "وكيل متعدد (تصل إلى {agentCount} Agent)",
            audioCallUnlimited: "مكالمة صوتية",
            screenSharingUnlimited: "مشاركة الشاشة",
            fileTransferUnlimited: "نقل الملف",
            autoChatAssignerUnlimited: "محال الدردشة التلقائي",
            multiLanguageTranslationUnlimited: "ترجمة السيارات",
            detailedReporting: "الإبلاغ",
            days30TrialsAvailable: "30 يوم تجارب متاحة",
            limitedArchiveLookupLastMo: "البحث المحدود أرشيف (آخر {monthCount} -mo)",
            fullCustomizationUnlimited: "التخصيص",
            planUpdated: "رائع ، تم تحديث خطتك.",
            planUpdating: "خطتك يتم تحديث ...",
            planUpdatingDescription: "يرجى الانتظار أثناء تحديث خطتك",
            done: "منتهي",
            freePlanUpdated: "تم تحديث خطتك كخطة مجانية. (Max Agent Credit: 1)",
            proPlanUpdated: "تم تحديث خطتك كخطة محترفة. (Max Agent Credit: {AgentCount})",
            canNotDwnGrade: "لا يمكن تخفيض خطتك من Pro {agentCountSecond} Agent (s) إلى {valNewPlnToUppr} {agentCountFirst}. ائتمانات وكيلك قيد الاستخدام.",
            deleteWarning: "يجب عليك حذف أو تعطيل {valDif} الوكيل (s)",
            warnMessage: "يجب أن تكون الخطة المحددة مختلفة عن الخطة الحالية",
            add: "يضيف",
            cancelYourPlan: "إلغاء خطتك",
            upgradeYourPlan: "ترقية خطتك",
            downgradeYourPlan: "خفض خطتك",
            agree: "يوافق",
            disagree: "تعارض",
            invoices: "فواتير",
            priceIntervals: "الفاصل الزمني للسعر",
            selectSiteAlias: "حدد أو أدخل اسم الموقع",
            selectPriceInterval: "حدد أو أدخل الفاصل الزمني للسعر",
            isRefunded: "هل يتم استرداده؟",
            siteId: "الموقع لا",
            createdDate: "تاريخ الإنشاء",
            failCount: "عدد محاولات جلب الدفع الفاشلة",
            failDate: "تاريخ الدفع الفاشل",
            Dashboard: "لوحة القيادة",
            Agents: "عملاء",
            Integration: "اندماج",
            Settings: "إعدادات",
            Contacts: "جهات الاتصال",
            Domain: "اِختِصاص",
            lastActivity: "النشاط الاخير",
            basePrice: "السعر الأساسي",
            packagePrice: "سعر الطرد",
            whatsappPrice: "سعر whatsapp",
            realtimeVisitorCount: "زائر الوقت الحقيقي",
            suspend: "تعليق",
            partner: "شريك",
            plan: "يخطط",
            trialDay: "أيام المحاكمة",
            mobile: "متحرك",
            webSite: "موقع إلكتروني",
            websiteOrigins: "أصل موقع الويب",
            ownerName: "اسم المالك",
            ownerEmailAddress: "البريد الإلكتروني للمالك",
            discount: "تخفيض",
            daysLeft: "ايام متبقية",
            newTrialPopUp: "كم يوما يجب أن تكون الفترة التجريبية الجديدة؟",
            newWpPricePopUp: "كم هي رسوم WhatsApp الجديدة؟",
            newIGPricePopUp: "كم هي رسوم Instagram الجديدة؟",
            newBasePricePopUp: "كم هو سعر الأساس الجديد؟",
            siteInfoUpdated: "معلومات الموقع المحدثة",
            siteInfoNotUpdated: "معلومات الموقع لم يتم تحديثها",
            siteInfoNotUpdatedErr: "حدث خطأ! معلومات الموقع لم يتم تحديثها.",
            yearDisccount: "Annual Discount",
            depositMoneyWallet: "Cüzdana Para Yatır",
            couponError: "Kupon kodu yanlış veya süresi dolmuş.",
            paidSuccessfully: "Fatura başarıyla ödendi.",
            company: "Şirket",
            youHaveOneWhatsappQRChannel: "You have one Whatsapp QR channel.",
            youHaveAWhatsappBusiness: "You have one Whatsapp Business channel.",
            deleteYourWhatsapp: "Delete your Whatsapp Business channel or buy a channel.",
            incorrect: "Incorrect",
            firstPreferredCard: "Set as Primary Card",
            primary: "Primary",
            billingHistory: "Invoice History",
            cuponApplied: "Coupon erfolgreich angewendet",
            packageCanotDownSupsis: "Votre paquet ne peut pas être déclassé. Veuillez supprimer ou désactiver plusieurs de vos agents pour rétrograder votre paquet.",
            packageCanotDownWPBussiness: "Votre forfait ne peut pas être déclassé. Veuillez supprimer plusieurs de vos canaux professionnels Whatsapp pour rétrograder le statut de votre forfait.",
            packageCanotDownWp: "Votre forfait ne peut pas être déclassé. Veuillez supprimer plusieurs de vos canaux Whatsapp pour rétrograder votre forfait.",
            planes: "Planes",
            sito: "Sito"
        },
        tour: {
            closeChat: "وثيق الدردشة",
            ticket: "تذكرة",
            formStep: "خطوة الشكل",
            menuStep: "خطوة القائمة",
            contentStep: "خطوة المحتوى",
            menuTitle: "عنوان القائمة",
            messageContent: "محتوى الرسالة",
            goToLive: "Connect stistative",
            stats: "لوحة الإحصاء",
            settings: "إعدادات",
            status: "حالة",
            prevStep: "خطوة سابقة",
            nextStep: "الخطوة التالية",
            finish: "ينهي",
            skip: "يتخطى",
            skip2: "تخطي ، أعرف النظام",
            startTour: "بدء جولة",
            firstTimeIntro: "أنت تدخل النظام لأول مرة ، أريد تقديم التطبيق إذا سمحت",
            hi: "أهلاً",
            welcomeTo: "مرحبًا بك في دعم Supsis Live",
            statsPanel: "إنه شريط الحالة الذي يوضح أرقام الدردشة الكلية والنشطة التي تنتظر على الفور مع النظام ..",
            sidebarMenu: "قائمة طعام",
            sidebarMenuContent: "يمكنك التبديل بين الصفحات هنا.",
            representativePrivateMessage: "لوحة محادثة بين التمثيل",
            representativePrivateMessageContent: "يمكنك رؤية المحادثات الخاصة بين الوكلاء هنا.",
            helpMenu: "قائمة المساعدة",
            helpMenuContent: "يمكنك العثور على معلومات مساعدة حول النظام هنا ..",
            settingsMenu: "قائمة الإعدادات",
            settingsMenuContent: "يمكنك القيام باللغة والوضع الليلي وخطوات تكبير الشاشة هنا ..",
            startChat: "ابدأ الدردشة",
            profileMenu: "قائمة ملف التعريف",
            profileMenuContent: "يمكنك تغيير توافرك وتعيين إعدادات الوكيل هنا ..",
            visitorsTab: "الزائرين",
            visitorsTabContent: "يمكنك رؤية الزوار هنا.",
            visitorTabHistory: "تاريخ الزوار",
            visitorTabHistoryContent: "يمكنك رؤية تاريخ الزائر هنا.",
            representativeTab: "مندوب",
            representativeTabContent: "يمكنك رؤية الممثلين هنا.",
            liveSupport: "الدعم المباشر",
            liveSupportContent: "يمكنك رؤية عدد العملاء الذين يتلقون الدعم المباشر هنا ..",
            siteVisitors: "زوار الموقع",
            siteVisitorsContent: "يمكنك رؤية عدد زوار الموقع هنا.",
            tableSettings: "إعدادات الجدول",
            tableSettingsContent: "يمكنك إظهار أو إخفاء الأعمدة في الجدول هنا.",
            watchModeButton: "زر العارض",
            watchModeContent: "يمكنك الانضمام هنا كوضع للعارض ويمكنك فقط عرض ما يتم نشره.",
            popoverInfo: "تفاصيل الزائر",
            popoverInfoContent: "يعطي معلومات حول الزائر.",
            popoverButton: "إعدادات الدردشة المتقدمة",
            popoverButtonContent: "يمكنك فتح المحادثة ، وإرسال رسالة مباشرة إلى الممثل أو حظر الزائر.",
            openChat: "انضم إلى زر المحادثة",
            openChatContent: "يمكنك فتح المحادثة هنا",
            pagination: "قائمة الترحيل.",
            paginationContent: "يمكنك زيادة عدد الصفحات هنا.",
            changeLang: "يمكن تغيير لغة النظام",
            changeTheme: "يمكن تبديل المظلمة والخفيفة",
            changeStatus: "يمكن أن تغير حالة توافرك",
            logout: "يمكن نظام تسجيل الدخول من هنا",
            chatwindow: {
                chatWindowActionButtons: "أزرار عمل نافذة الدردشة",
                chatPanelActions: "إجراءات لوحة الدردشة",
                otherPanels: "لوحات أخرى",
                chatColorButton: "إظهار معنى ألوان شريط الدردشة",
                keyboardShortcutButton: "إظهار وظائف اختصارات KeyBpard",
                hideButton: "قلل من الدردشة الحالية دون خروج",
                closeButton: "إغلاق القوة والخروج من الدردشة الحالية",
                ellipsisButton: "المزيد من إجراءات الدردشة. تقليل ، إغلاق ، حظر الزائر ، إرسال رسالة خاصة ، تعيين ممثل",
                userInfoWidget: "إظهار تفاصيل زائر المالك لمستخدم الدردشة الحالي",
                preparedContentWidget: "عنصر واجهة مستخدمة رسائل معدّة ، يمكنك تحديد إدخال قالب رسالة إلى الدردشة الحالية",
                chatHistoryWidget: "إذا كان هناك بعض تاريخ الدردشة للزوار الحالي ، فبإمكانه مشاهدتها",
                chatWindowSettingsButtons: "زر إعدادات نافذة الحديث",
                settingsButton: "يمكنك حظر المحادثة ، والتقدم ، والرسالة السرية وتعيين المندوبين.",
                chatBarButton: "هنا يمكنك منع محادثة نشطة ، وإرسال رسالة خاصة إلى الوكيل وترك المحادثة .."
            },
            chats: "CHAT PANELİ",
            representativ_eTab: "Temsilciler",
            selectColumnsToDisplay: "Select columns to display",
            selectAll: "Select All",
            deselectAll: "Deselect All",
            resetToDefault: "Reset to Default",
            settingsSaved: "Settings saved"
        },
        adminUser: {
            newAdminUserForm: "نموذج تسجيل مستخدم المسؤول الجديد",
            updateAdminUserForm: "نموذج تحديث مستخدم المسؤول",
            adminUsers: "مستخدمي المسؤول",
            newAdminUser: "مستخدم مسؤول جديد",
            noAdminUser: "لا يوجد مستخدمين للمسؤول حتى الآن",
            adminUserName: "اسم مستخدم المسؤول"
        },
        report: {
            channel: "قناة",
            channelType: "نوع القناة",
            contactCount: "عدد جهات الاتصال",
            tag: "علامة",
            owner: "مالك",
            email: "البريد الإلكتروني",
            language: "لغة",
            approvalCount: "عدد الموافقات",
            adTitle: "عنوان الإعلان",
            sourceType: "نوع المصدر",
            contactDistributions: "توزيعات جهات الاتصال",
            mostUsedTag: "العلامة الأكثر استخداماً",
            leastUsedTag: "العلامة الأقل استخداماً",
            timeDistribution: "توزيع جهات الاتصال حسب الوقت",
            channelDistribution: "توزيع جهات الاتصال حسب القناة",
            tagDistribution: "توزيع جهات الاتصال حسب العلامات",
            platformDistribution: "توزيع جهات الاتصال حسب المنصة",
            ownerDistribution: "توزيع جهات الاتصال حسب المالك",
            languageDistribution: "توزيع جهات الاتصال حسب اللغة",
            adsDistribution: "توزيع جهات الاتصال حسب الإعلانات",
            contactPropertyDistribution: "توزيع جهات الاتصال حسب خصائص الاتصال",
            totalPersonCount: "العدد الإجمالي لجهات الاتصال",
            averagePersonCount: "متوسط عدد جهات الاتصال",
            personCount: "عدد جهات الاتصال",
            person: "جهة اتصال",
            mostEffectiveAd: "الإعلان الأكثر فعالية",
            leastEffectiveAd: "الإعلان الأقل فعالية",
            mostUsedChannel: "القناة الأكثر استخداماً",
            leastUsedChannel: "القناة الأقل استخداماً",
            columnChart: "مخطط عمودي",
            pieChart: "مخطط دائري",
            mostUsed: "الأكثر استخداماً",
            leastUsed: "الأقل استخداماً",
            mostUsedLanguage: "اللغة الأكثر استخداماً",
            leastUsedLanguage: "اللغة الأقل استخداماً",
            mostAssigned: "الأكثر تعييناً",
            leastAssigned: "الأقل تعييناً",
            mostUsedPlatform: "المنصة الأكثر استخداماً",
            leastUsedPlatform: "المنصة الأقل استخداماً",
            commentAnalysis: "تحليل التعليقات",
            whatsappChannelDistribution: "توزيع المحادثات حسب قنوات واتساب",
            instagramChannelDistribution: "توزيع المحادثات حسب قنوات انستغرام",
            messengerChannelDistribution: "توزيع المحادثات حسب قنوات ماسنجر",
            trendyolChannelDistribution: "توزيع المحادثات حسب قنوات تريندول",
            metaLeadsChannelDistribution: "توزيع المحادثات حسب قنوات ميتا ليدز",
            chatDistributionByTelegramChannels: "توزيع الدردشة حسب قنوات تيليجرام",
            chatDistributionByLinkedinChannels: "توزيع الدردشة حسب قنوات لينكد إن",
            channelTimeseries: "الجدول الزمني للقنوات",
            channelPies2: "توزيع القنوات",
            date: "التاريخ",
            incomingMessages: "الرسائل الواردة",
            outgoingMessages: "الرسائل الصادرة",
            customerCount: "عدد العملاء",
            mailCount: "عدد البريد",
            answered: "تمت الإجابة",
            unanswered: "لم يتم الرد عليها",
            selectaChannel: "تحديد قناة",
            sentMails: "الرسائل المرسلة",
            sentMailCount: "عدد الرسائل المرسلة",
            eventCount: "عدد الأحداث",
            ticketDistribution: "توزيع التذاكر",
            selectWorkflow: "تحديد سير العمل الخاص بك",
            distributionOfTasks: "توزيع المهام",
            mostMissioned: "أكثر المهام",
            leastTask: "أقل المهام",
            totalNumberTasks: "إجمالي عدد المهام",
            erorFetchingTask: "خطأ في تلقي بيانات المهمة:",
            pipelinePhase: "مرحلة خط الأنابيب",
            status: "الحالة",
            numberOfTasks: "عدد المهام",
            insufficientData: "بيانات غير كافية",
            hourly: "(ساعيا)",
            hourlyAverage: "متوسط ساعي",
            hourlyMax: "الحد الأقصى الساعي",
            hourlyMin: "الحد الأدنى الساعي",
            totalAmount: "المبلغ الإجمالي",
            averageAmount: "المبلغ المتوسط",
            minAmount: "المبلغ الأدنى",
            maxAmount: "المبلغ الأقصى",
            siteCount: "site Count",
            agentCount: "Agent Count",
            channelsTimeSeries: "سلاسل زمنية للقنوات",
            channelPies: "فطائر القنوات",
            pieView: "رسم بياني دائري",
            topVisitorCountry: "البلد الذي يأتي منه أكبر عدد من الزوار",
            websiteTrafficByCountry: "حركة مرور الموقع حسب البلد",
            visitorCount: "عدد الزوار",
            websiteVisitorTraffic: "حركة زوار الموقع",
            websiteTraffic: "حركة مرور الموقع",
            author: "المؤلف",
            topWorstComments: "أسوأ التعليقات",
            topBestComments: "أفضل التعليقات",
            topComments: "أفضل التعليقات",
            noComment: "لا توجد تعليقات بعد",
            minWaitingTime: "أقل وقت انتظار",
            maxWaitingTime: "أقصى وقت انتظار",
            averageWaitTime: "متوسط ​​وقت الانتظار",
            waitTime: "وقت الانتظار (ثواني)",
            agentWaitDurationTitle: "رسم بياني لمدة انتظار الوكيل",
            incomingMessage: "رسالة (رسائل) واردة",
            outgoingMessage: "رسالة (رسائل) صادرة",
            totalSpent: "إجمالي الإنفاق",
            avgSpent: "متوسط الإنفاق",
            totalPayment: "إجمالي الدفع",
            walletStatus: "حالة المحفظة",
            walletBalanceStatus: "حالة رصيد المحفظة",
            messageTraffic: "حركة الرسائل",
            breakCount: "عدد الفترات",
            agentBreakTime: "عدد فترات استراحة الوكلاء ☕",
            agentStatusHour: "ساعة حالة الوكيل",
            agentWorkTimeCalendar: "تقويم وقت عمل الوكيل",
            agentActivity: "نشاط الوكيل",
            noEnoughtData: "لا توجد بيانات كافية",
            averageFirstResponse: "متوسط ​​زمن الاستجابة الأولى",
            slowestResponser: "الأبطأ في الرد",
            fastestResponder: "الأسرع في الرد",
            firstAnswerTimeSec: "وقت الرسالة الأولى (بالثواني)",
            firstAnswerByAgent: "وقت الرسالة الأولى بواسطة الوكيل",
            averageSolutionTime: "متوسط ​​وقت الحل",
            slowestSolver: "أبطأ محلل",
            fastestSolver: "أسرع محلل",
            averageChat: "متوسط الدردشة",
            leastChatReceiver: "أقل مستقبل للدردشة",
            mostChatRecipients: "أكبر عدد من المستقبلين للدردشة",
            averageTicket: "Average Ticket",
            leastTicketReceiver: "Least Ticket Least",
            mostTicketRecipients: "Most Ticket Recipients",
            resolveTime: "وقت الحل (دق)",
            resolveTimeByUser: "وقت حل الدردشة من قبل المستخدم (بالدقائق)",
            chatResolveTimeByAgent: "وقت حل الدردشة من قبل الوكلاء",
            chatDistByHandleType: "توزيع الدردشات حسب المعالج",
            chatDistByHandDesc: "كم عدد الدردشات التي تم التعامل معها من قبل الوكلاء والروبوتات الدردشة والهجينة؟",
            chatCountsByHandleType: "عدد الدردشات حسب نوع المعالجة",
            missed: "تم التفويت",
            chatDistByAnsDesc: "كم عدد المحادثات التي تم الرد عليها أو تم تفويتها؟",
            chatCountsByAns: "عدد الدردشات حسب الإجابة",
            chatCountByPlatform: "عدد الدردشات حسب المنصة",
            chatDistByPDesc: "كم دردشة وصلت إلى أي منصة؟",
            chatDistByPlatform: "توزيع الدردشة حسب المنصة",
            ticketCountByUser: "عدد التذاكر حسب الوكلاء",
            ticketCountByStatus: "عدد التذاكر حسب حالة الاستجابة",
            user: "مستخدم",
            saveAsImage: "حفظ كصورة",
            fullScreen: "ملء الشاشة",
            download: "تحميل",
            tableView: "عرض الجدول",
            chartView: "عرض الرسم البياني",
            chatDistByUsers: "توزيع المحادثات حسب المستخدمين",
            chatCountsByUsers: "عدد المحادثات حسب المستخدمين",
            minDuration: "الحد الأدنى من المدة",
            maxDuration: "الحد الأقصى للمدة",
            totalDurationByAgent: "إجمالي مدة الجلسة حسب الوكيل",
            averageDurationByAgent: "المدة المتوسطة للجلسة حسب الوكيل",
            totalDurationByCB: "إجمالي مدة الجلسة حسب الدردشة الآلية",
            averageDurationByCB: "المدة المتوسطة للجلسة حسب الدردشة الآلية",
            viewUnitAs: "عرض الوحدة كـ",
            hybrid: "هجين",
            handledBy: "تمت المعالجة بواسطة",
            sessionDurationOverall: "مدة الجلسة الإجمالية",
            allChannels: "جميع القنوات",
            sessionsDurationOverall: "مدة الجلسات الإجمالية",
            sessionsOverall: "جلسات بشكل عام",
            sessionsOverallDesc: "Total chat session count in the selected period",
            ratingOverallDesc: "Distribution of customer satisfaction scores",
            sessionDurationOverallDesc: "Average and total session durations",
            totalSessionCountDesc: "Total number of sessions in the selected period",
            averageSessionCountDesc: "Average session count per time unit",
            maxSessionCountDesc: "Highest session count in a single time unit",
            minSessionCountDesc: "Lowest session count in a single time unit",
            totalSessionDurationDesc: "Sum of all session durations",
            averageSessionDurationDesc: "Average duration per session",
            totalDurationByCBDesc: "Total duration handled by chatbot",
            averageDurationByCBDesc: "Average chatbot session duration",
            totalDurationByAgentDesc: "Total duration handled by agents",
            averageDurationByAgentDesc: "Average agent session duration",
            maxDurationDesc: "Longest session in the selected period",
            minDurationDesc: "Shortest session in the selected period",
            totalRatingCountDesc: "Total number of ratings received",
            averageRatingDesc: "Average score of all ratings",
            weightedAverageRatingDesc: "Weighted average based on score distribution",
            chatDistByUsersDesc: "Chat session distribution by agent",
            chatDistByAnsDesc: "Ratio of answered vs missed sessions",
            chatDistByPlatformDesc: "Chat sessions by platform source",
            chatDistByHandleTypeDesc: "Session distribution between chatbot and live agent",
            resolveTimeByUserDesc: "Average resolve time per agent",
            firstAnswerByAgentDesc: "Average first response time per agent",
            agentWaitDurationDesc: "Customer wait time for agent response",
            topCommentsDesc: "Best and worst customer feedback comments",
            websiteTrafficDesc: "Website visitor traffic over time",
            websiteTrafficByCountryDesc: "Website visitor distribution by country",
            channelBreakdownDesc: "Session counts and distribution by channel",
            wabaMessageTrafficDesc: "WhatsApp message traffic (incoming/outgoing)",
            walletStatusDesc: "Balance transactions and wallet status",
            calendarEventsDesc: "Calendar event count time series",
            reservationEventsDesc: "Reservation event count time series",
            mailInboxDesc: "Incoming email count time series",
            mailSendDesc: "Sent email count time series",
            ticketTimeSeriesDesc: "Support ticket time series",
            ticketByStatusDesc: "Support ticket distribution by status",
            ticketByUserDesc: "Support ticket distribution by agent",
            taskOverallDesc: "Task status and pipeline stage distribution",
            contactTimeDistDesc: "Contact distribution over time",
            contactChannelDistDesc: "Contact distribution by channel",
            contactTagDistDesc: "Contact distribution by tag",
            contactPlatformDistDesc: "Contact distribution by platform",
            contactOwnerDistDesc: "Contact distribution by agent",
            contactLanguageDistDesc: "Contact distribution by language",
            contactAdDistDesc: "Contact distribution by advertisement",
            contactPropertyDistDesc: "Contact distribution by contact properties",
            agentActivitiesDesc: "Daily agent activity summary",
            agentPerformanceDesc: "Agent performance metrics",
            agentWorktimeDesc: "Agent work and break durations",
            breakCountDesc: "Break count and duration distribution",
            calendarEvents: "أحداث التقويم",
            reservationEvents: "أحداث الحجز",
            incomingMails: "رسائل البريد الواردة",
            incomingMailCount: "عدد رسائل البريد الواردة",
            reservation: "حجز",
            event: "حدث",
            reservationEventCount: "عدد أحداث الحجز",
            channelBreakdown: "توزيع القنوات",
            websiteAnalysis: "تحليل الموقع الإلكتروني",
            customerSatisfaction: "رضا العملاء",
            teamBreakAnalysis: "تحليل فواصل الفريق",
            dailyAgentActivity: "نشاط الوكيل اليومي",
            agentPerformance: "أداء الوكيل",
            chatDistributions: "توزيع المحادثات",
            users: "المستخدمين",
            segmentTimeseries: "سلسلة زمنية للقطاع",
            segmentsOverall: "القطاعات بشكل عام",
            unmatchRatio: "نسبة عدم التطابق",
            totalMatchCount: "إجمالي عدد التطابقات",
            totalUnmatchCount: "إجمالي عدم التطابق",
            matchRatio: "نسبة التطابق",
            matched: "مطابق",
            trainingOverall: "التدريب الشامل",
            trainingStatusTimeseries: "سلسلة زمنية لحالة التدريب",
            duration: "المدة",
            totalSessionDuration: "مدة الجلسة الإجمالية",
            averageSessionDuration: "متوسط مدة الجلسة",
            second: "ثانية",
            minute: "دقيقة",
            hour: "ساعة",
            aggregateAs: "تجميع كـ",
            chatbotSessionDurationOverall: "مدة جلسة الدردشة الآلية بشكل عام",
            ratingTimeSeries: "رسم بياني زمني للتقييمات",
            chatCountTimeseries: "سلسلة زمنية لعدد الدردشات",
            notRated: "غير مقيّم",
            totalRatingCount: "إجمالي عدد التقييمات",
            averageRating: "متوسط التقييم",
            weightedAverageRating: "متوسط التقييم المرجح",
            rate: "تقييم",
            ratingOverall: "تقييمات العملاء بشكل عام",
            session: "جلسة",
            total: "المجموع",
            average: "متوسط",
            max: "الحد الأقصى",
            min: "الحد الأدنى",
            sessionCount: "عدد الجلسات",
            uniqueUsers: "مستخدمون فريدون",
            viewAs: "عرض كـ",
            overall: "عام",
            detailReport: "تقرير مفصل",
            dailyReports: "التقارير اليومية",
            pointBasedReports: "التقارير القائمة على نقطة",
            personDateBasedPointReport: "تقرير النقطة القائمة على الشخص والتاريخ",
            personDateBasedReport: "التقرير القائم على الشخص والتاريخ",
            personBasedReport: "التقارير القائمة على الشخص",
            personAndDateBasedGraph: "الرسم البياني القائم على الشخص والتاريخ",
            noReport: "لايوجد تقرير",
            reports: "التقارير",
            totalBar: "المجموع",
            ticketCount: "Ticket Count",
            adNameDistribution: "Contact Distribution by Ad Name",
            adsetDistribution: "Contact Distribution by Ad Set Name",
            campaignDistribution: "Contact Distribution by Campaign Name",
            selectChannel: "Bir Kanal Seçin",
            leastTasked: "Least Tasked",
            errorFetchingTask: "Error receiving task data:",
            dailyAverage: "Günlük Ortalama",
            dailyMax: "Günlük Maksimum",
            dalyMin: "Günlük Minimum",
            topBestWorstComments: "En İyi/Kötü Yorumlar"
        },
        stats: {
            total: "عدد جميع الدردشات المفتوحة",
            active: "عدد الدردشة النشطة المعينة لك",
            waiting: "عدد الزوار في انتظار دخول ممثل",
            late: "عدد الزوار ينتظرون أكثر من فترة معينة",
            free: "عدد الزوار المجانيين الذين ينتظرون للممثل الجديد للدخول",
            pco: "[معدل استخدام السعة] معدل حمل العمل في قدرة الدردشة التمثيلية النشطة",
            maxCapacity: "الحد الأقصى لعدد الدردشة التي يمكن للنظام تعيين ممثلين دون الانتظار",
            chatbot: "عدد الدردشة النشطة مع Chatbot"
        },
        time: {
            lastYear: "العام الماضي",
            thisYear: "هذا العام",
            last3Months: "آخر 3 أشهر",
            last7: "آخر 7 أيام",
            today: "اليوم",
            yesterday: "أمس",
            lastWeek: "الأسبوع الماضي",
            currentWeek: "هذا الاسبوع",
            currentMonth: "هذا الشهر",
            lastMonth: "الشهر الماضي",
            last30Day: "آخر 30 يومًا",
            allTime: "كل الأوقات",
            custom: "موعد مخصص"
        },
        fastWizard: {
            generalColors: "الألوان العامة",
            tellUsMore: "أخبرنا أكثر ، حتى نتمكن من تخصيص تجربتك",
            moreInfo: "مزيد من المعلومات",
            display: "عرض",
            availability: "توافر",
            preview: "معاينة",
            installCode: "تثبيت رمز",
            previous: "سابق",
            setupSupsisLiveChat: "الإعداد Supsis الدردشة المباشرة",
            continue: "الخطوة التالية",
            completeInitialize: "الإعداد الكامل",
            completedMessage: "Supsis Live Chat Setup قد اكتمل بنجاح.",
            websiteIntegration: "عنوان موقع الويب الخاص بك لدمج الدردشة المباشرة Supsis",
            customizeLiveChat: "تخصيص الدردشة المباشرة الخاصة بك",
            createBrandedExperience: "قم بإنشاء تجربة دردشة ذات علامة تجارية لزوارك.",
            chatColor: "لون الدردشة",
            chooseChatColor: "اختر لون لهجة.",
            chatBubble: "فقاعة الدردشة",
            selectBubble: "حدد فقاعة الدردشة",
            chatBubbleColor: "لون فقاعة الدردشة",
            selectChatBubbleColor: "حدد لون فقاعة الدردشة",
            customSelection: "الاختيار المخصص:",
            chatAvailability: "توافر الدردشة",
            onlineSupportVisitorTime: "متى تكون على الإنترنت لدعم زوارك؟",
            channelAvailability: "توافر القناة",
            availability724: "الدردشة متوفرة 7/24",
            basedOnTeam: "بناءً على حالة عضو الفريق",
            basedOnTeamExplanation: "ستظهر الدردشة عبر الإنترنت عندما يتم تعيين عضو واحد على الأقل إلى متاح",
            customHours: "ساعات عمل مخصصة",
            customHoursExplanation: "تكوين ساعات عملك",
            customHoursTimezone: "وحدة زمنية:",
            customHoursFrom: "من:",
            customHoursTo: "ل:",
            customHoursAddHours: "+إضافة ساعات",
            previewDesktop: "سطح المكتب",
            previewIpad: "اى باد",
            installationAndInstructions: "تعليمات التحميل",
            installationTrackingCode: "قم بتثبيت رمز التتبع على موقع الويب الخاص بك",
            installationTrackingCodePlease: "يرجى لصق الرمز وفقًا للتعليمات أدناه ، قبل نهاية علامة {bodyTag} في أي صفحة تريد تمكين الدردشة المباشرة Supsis.",
            installationInstructionsJavascript: "الصق رمز التكامل الوارد أعلاه في علامة {bodyTag} قبل الإغلاق مباشرة.",
            installationInstructionsCopy: "ينسخ",
            installationInstructionsCoppyMessage: "تم نسخ البرنامج النصي للتكامل إلى الحافظة",
            installationInstructionsShopify1: "1. تسجيل الدخول إلى لوحة Shopify الخاصة بك",
            installationInstructionsShopify2: "2. انتقل إلى المتجر عبر الإنترنت> الموضوعات> القائمة المنسدلة الإجراءات ضمن السمة الحالية> تحرير الرمز> السمة. liquid",
            installationInstructionsShopify3: "3. ضع لصق رمز التكامل المذكور أعلاه قبل علامة {bodyTag} مباشرة في نهاية البرنامج النصي.",
            installationInstructionsIdeaSoft1: "1. تسجيل الدخول إلى لوحة الوكيل الخاصة بك.",
            installationInstructionsIdeaSoft2: "2. انتقل إلى الإعدادات -> SEO -> خدمات محرك البحث.",
            installationInstructionsIdeaSoft3: "3. حدد \"التحقق من الموقع باستخدام علامة التعريف\" من قسم رمز التتبع.",
            installationInstructionsIdeaSoft4: "4. نسخ ولصق رمز التكامل أعلاه في المربع المفتوح وحفظ.",
            installationInstructionsIdeaSoft5: "5. داخل الإعدادات -> ، انقر على زر \"مسح ذاكرة التخزين المؤقت\". وبالتالي اكتمل التكامل.",
            installationInstructionsWordPress1: "1. تسجيل الدخول إلى لوحة مسؤول WordPress الخاص بك",
            installationInstructionsWordPress2: "2. اذهب إلى المظهر> محرر السمة",
            installationInstructionsWordPress3: "3. ضمن ملفات السمة (أقصى اليمين) ، ابحث عن تذييل السمة (footer.php) وحدده",
            installationInstructionsWordPress4: "4. قم بتعبير رمز التكامل أعلاه قبل علامة {bodyTag} في الأسفل.",
            installationInstructionsWordPress5: "5. انقر فوق تحديث الملف لحفظ التغييرات",
            installationInstructionsOpenCart1: "1. تسجيل الدخول إلى لوحة مسؤول OpenCart",
            installationInstructionsOpenCart2: "2. انتقل إلى التصميم> محرر السمة",
            installationInstructionsOpenCart3: "3. حدد ملف \"مشترك\" وفتح \"ملف Header.twig\".",
            installationInstructionsOpenCart4: "4. قم بتعبئة رمز التكامل أعلاه قبل علامة {headTag} في الأسفل.",
            installationInstructionsOpenCart5: "5. انقر فوق زر حفظ.",
            installationInstructionsTicimax1: "1. تسجيل الدخول إلى لوحة إدارة Ticimax الخاصة بك",
            installationInstructionsTicimax2: "2. تصميم مفتوح> تصميم> إعدادات تصميم تذييل الرأس",
            installationInstructionsTicimax3: "3. انقر فوق الزر \"المصدر\" في قسم تصميم الشعار.",
            installationInstructionsTicimax4: "4. الصق رمز التكامل أعلاه أسفل رمز HTML.",
            installationInstructionsEticaretteyim1: "1. تسجيل الدخول إلى لوحة إدارة التجارة الإلكترونية الخاصة بك",
            installationInstructionsEticaretteyim2: "2. قم ببساطة بتسمية SUPSIS من الإضافات> إنشاء HTML> وانسخ الكود.",
            installationInstructions: "تعليمات",
            installationVerify: "تحقق من تثبيت موقع الويب الخاص بك من supsis",
            installationVerifyChecking: "تدقيق",
            installationVerifyCheck: "يفحص",
            installationVerifyCheckingStatus: "التحقق من حالة تكامل SUPSIS على {website}",
            installationCheckingStatusMessageYes: "رائع ، تم دمج supsis في موقع {website} !!",
            installationCheckingStatusMessageNo: "SUPSIS غير مدمج حاليًا مع موقع الويب {website}. يمكنك إكمال عملية الاندماج الخاصة بك الآن أو في وقت لاحق.",
            vtippyPreferredLanguage: "اللغة المفضلة"
        },
        akinon: {
            typeOrSelectSKU: "اكتب أو حدد SKU",
            akinonUserId: "معرف المستخدم AKINON",
            userEmail: "البريد الالكتروني للمستخدم",
            userEmailDesc: "اكتب أو حدد بريد إلكتروني المستخدم ...",
            send: "يرسل",
            selectCity: "اختر مدينة",
            city: "مدينة",
            selectState: "اختر ولايه",
            state: "ولاية",
            useMap: "استخدم الخريطة",
            chooseAddress: "اختر العنوان",
            selectCountry: "حدد الدولة",
            country: "دولة",
            productIdDesc: "اكتب أو حدد المنتج ...",
            productId: "معرف المنتج",
            userIdDesc: "اكتب معرف المستخدم Akinon ...",
            productSKU: "منتج SKU",
            latitudeDesc: "اكتب أو حدد خط عرض الموقع الهدف ...",
            longitudeDesc: "اكتب أو حدد خط الطول المستهدف ...",
            orderNumber: "رقم طلبك",
            orderDesc: "اكتب رقم الطلب ...",
            longitude: "خط الطول",
            latitude: "خط العرض"
        },
        headBar: {
            source: "المصدر",
            label: "التسمية",
            completed: "اكتمل؟",
            email: "بريد إلكتروني",
            phone: "هاتف",
            name: "اسم",
            date: "تاريخ",
            subject: "موضوع",
            situation: "حالة",
            representative: "ممثل",
            transactions: "المعاملات",
            channel: "قناة الاتصال",
            Email: "E-mail"
        },
        login: {
            loginTitle1: "Supsis AI",
            loginTitle2: "مرحبا بكم في",
            email: "عنوان البريد الإلكتروني الخاص بك",
            emailPlaceholder: "الرجاء إدخال عنوان البريد الإلكتروني الخاص بك.",
            emailError: "الرجاء إدخال بريد إلكتروني صحيح",
            password: "كلمة السر خاصتك",
            passwordLogin: "كلمة مرور مجانية تسجيل الدخول",
            passwordAndLogin: "تسجيل الدخول باستخدام كلمة المرور",
            passwordNew: "إعادة تعيين كلمة المرور الخاصة بي",
            loginAnd: "أو",
            passwordPlaceholder: "من فضلك أدخل رقمك السري.",
            loginMemory: "تذكر هذا الجهاز",
            passwordForget: "لقد نسيت كلمة المرور",
            passwordNewAgain: "كلمة سر جديدة",
            passwordNewAgainTwo: "كرر كلمة المرور الجديدة",
            passwordNewAgainPlaceholder: "الرجاء إدخال كلمة المرور الجديدة الخاصة بك.",
            passwordNewAgainPlaceholderTwo: "الرجاء إعادة إدخال كلمة المرور الجديدة الخاصة بك.",
            login: "تسجيل الدخول",
            loginFooter: "أو قم بتسجيل الدخول باستخدام البريد الإلكتروني",
            emailLogin: "تسجيل الدخول باستخدام البريد الإلكتروني",
            welcomeTitle: "مرحباً",
            welcomeMorning: "صباح الخير",
            welcomeAfternoon: "مساء الخير",
            welcomeEvening: "مساء الخير",
            welcomeNight: "تصبح على خير"
        },
        settings: {
            ipWhitelist: "قائمة الوصول IP",
            loadMore: "تحميل المزيد...",
            detectIpAddress: "اكتشاف عنوان IP الخاص بي",
            addWighteListAddress: "إضافة عنوان IP إلى القائمة البيضاء",
            accessControlSubTitles: "توفر المراقبة في الوصول طبقة أمان إضافية تسمح فقط لعناوين IP المصرح بها بالوصول إلى النظام.",
            companyInformation: "معلومات الشركة",
            ipAddress: "عنوان IP الخاص بي",
            whiteList: "قائمة عناوين IP الآمنة",
            whiteListAdd: "إضافة عنوان IP آمن",
            whiteListDeletedSuccessfully: "تم حذف قائمة الوصول بنجاح",
            whiteListDeletedFailed: "فشل حذف قائمة الوصول",
            whiteListAddedSuccessfully: "تمت إضافة قائمة الوصول بنجاح",
            whiteListAddedFailed: "فشل إضافة قائمة الوصول",
            deleteWhiteListTitle: "هل أنت متأكد أنك تريد حذف هذا القائمة البيضاء؟",
            talkSettings: "إعدادات الكلام",
            talkSubtitles: "إدارة إعدادات الكلام الخاصة بك",
            changeSettings: "تغيير إعدادات تعيين الدردشة التلقائية",
            dateAndTime: "التاريخ والوقت",
            actor: "الممثل",
            event: "حدث",
            accessControl: "التحكم في الوصول",
            rulesGroup: "القواعد",
            organizationLongName: "الاسم الطويل للمؤسسة",
            visitorNewDesc: "يمكنك استخدام الإصدار الجديد من سمة الزائر",
            transactionType: "نوع المعاملة",
            priorBalance: "الرصيد السابق",
            nextBalance: "الرصيد التالي",
            amount: "المبلغ",
            phoneNumber: "رقم الهاتف",
            profileInfoRemoved: "تمت إزالة معلومات الملف الشخصي",
            newValueUpdated: "تم تحديث القيمة الجديدة",
            ballanceToTransferred: "الرصيد المراد تحويله",
            availableBalance: "الرصيد المتاح",
            balanceReceived: "الرصيد المستلم",
            totalBalance: "إجمالي الرصيد",
            paymentCard: "بطاقة الدفع",
            wpPhoneNumber: "رقم هاتف واتساب",
            wpSendingMessage: "إرسال رسالة واتساب الأولى",
            auditlogs: "سجلات التدقيق",
            myaccount: "حسابي",
            notifications: "الإشعارات",
            company: "شركة",
            features: "الميزات",
            general: "جنرال لواء",
            chat: "دردشة",
            timings: "توقيت",
            wallet: "محفظة",
            language: "لغة",
            "bubble-settings": "إعدادات الفقاعة",
            "bubble-actions": "إجراءات الفقاعة",
            "theme-settings": "إعدادات الموضوع",
            visitorLoginForm: "نموذج تسجيل الدخول للزائر",
            visitorAttribute: "معلومات ملف تعريف الزائر",
            timing_settings: "إعدادات التوقيت",
            auto_assign: "تعيية التلقائية",
            availability: "توفر",
            "website-integration": "تكامل الموقع",
            General: "جنرال لواء",
            Chat: "دردشة",
            Timings: "توقيت",
            Integration: "تكامل",
            developer: "مطور",
            visitorNew: "زائر جديد",
            companySubtitles: "إدارة شركتك.",
            featuresSubtitles: "إدارة ميزات شركتك.",
            languageSubtitles: "حدِّد اللغة والمنطقة الزمنية المفضلة لنشاطك التجاري.",
            bubbleSettings: "إعدادات الفقاعة",
            bubbleSettingsSubtitles: "إدارة إعدادات الفقاعة الخاصة بشركتك.",
            bubbleActionsSubtitles: "إدارة إجراءات الفقاعة الخاصة بشركتك.",
            chatThemeSettingsSubtitles: "إدارة إعدادات موضوع الدردشة الخاصة بشركتك.",
            visitorLoginFormSubtitles: "إدارة نموذج تسجيل الدخول للزائر الخاص بشركتك.",
            chatTimingSettingsSubtitles: "إدارة إعدادات توقيت الدردشة الخاصة بشركتك.",
            webSiteIntegrationSubtitles: "إدارة إعدادات تكامل موقع الويب الخاصة بشركتك.",
            apiAccessTitle: "وصول API",
            apiAccessSubtitles: "إدارة وصول API الخاص بشركتك.",
            youTubeActionForm: "أضف قناتك على YouTube",
            linkedinActionForm: "أضف حساب لينكد إن الخاص بك",
            telegramActionForm: "أضف حساب Telegram",
            facebookActionForm: "أضف صفحتك على Facebook",
            tiwitterActionForm: "أضف صفحتك على Twitter",
            instagramActionForm: "أضف صفحتك على Instagram",
            liveSupportDescription: "دعم العملاء على موقع الويب الخاص بك",
            ticketDescription: "إدارة تذاكر العملاء",
            whatsappDescription: "دعم العملاء على WhatsApp",
            phoneDescription: "دعم العملاء على الهاتف",
            emailDescription: "دعم العملاء عبر البريد الإلكتروني",
            facebookDescription: "دعم العملاء على Facebook",
            twitterDescription: "دعم العملاء على Twitter",
            instagramDescription: "دعم العملاء على Instagram",
            youtubeDescription: "دعم العملاء على YouTube",
            linkedinDescription: "اسمح لعملائك بالوصول إليك عبر LinkedIn",
            telegramDescription: "اسمح لعملائك بالوصول إلى الحجم باستخدام Telegram",
            whatsappModalTitle: "نموذج إجراء WhatsApp",
            whatsappModalDescription: "يرجى ملء النموذج أدناه لإضافة رقم WhatsApp الخاص بك.",
            phoneModalTitle: "نموذج إجراء الهاتف",
            phoneModalDescription: "يرجى ملء النموذج أدناه لإضافة رقم هاتفك.",
            emailModalTitle: "نموذج إجراء البريد الإلكتروني",
            emailModalDescription: "يرجى ملء النموذج أدناه لإضافة عنوان بريدك الإلكتروني.",
            facebookModalTitle: "نموذج إجراء Facebook",
            facebookModalDescription: "يرجى ملء النموذج أدناه لإضافة صفحة Facebook الخاصة بك.",
            twitterModalTitle: "نموذج إجراء Twitter",
            twitterModalDescription: "يرجى ملء النموذج أدناه لإضافة صفحة Twitter الخاصة بك.",
            instagramModalTitle: "نموذج إجراء Instagram",
            instagramModalDescription: "يرجى ملء النموذج أدناه لإضافة صفحة Instagram الخاصة بك.",
            youtubeModalTitle: "نموذج إجراء YouTube",
            youtubeModalDescription: "يرجى ملء النموذج أدناه لإضافة قناة YouTube الخاصة بك.",
            linkedinModalTitle: "نموذج معاملة LinkeIn",
            linkedinModalDescription: "يرجى ملء النموذج أدناه لربط حسابك على LinkedIn.",
            telegramModalTitle: "نموذج معاملة Telegram",
            telegramModalDescription: "أدخل رابط ملف تعريف Telegram الخاص بك في النموذج أدناه لربط حساب Telegram الخاص بك",
            instagramAlertTitle: "التكامل مع Instagram مطلوب",
            instagramAlertDesc: "عذرًا، سيتم تنشيط الصفحة التي زرتها عند تكامل Instagram الخاص بك.",
            instagramActivateText: "لنذهب، دمج Instagram",
            remove: "إزالة",
            edit: "تصحيح",
            connected: "متصل",
            add: "أضف",
            themeDescription: "إدارة موضوع شركتك.",
            fontDescription: "إدارة الخط الخاص بشركتك.",
            isFabsAsIcon: "إظهار نصوص رمز القائمة.",
            chatBubbleTextSetting: "إعداد نص فقاعة الدردشة",
            textOnChatBubble: "يمكنك ضبط إعدادات النص التي ستظهر في فقاعة الدردشة.",
            textToAppearOnChatBubble: "نص للظهور في فقاعة الدردشة",
            newVisitorProfileInformation: "معلومات ملف تعريف الزائر الجديد",
            newVisitorProfileInformationDescription: "يضيف قيمة جديدة لمعلومات ملف تعريف الزائر",
            create: "يخلق",
            newAdd: "اضف جديد",
            toInform: "لكي يعلم",
            toInformDescription: "يمكنك مطابقة القيم التي تضيفها في هذه الصفحة مع نموذج تسجيل دخول الزائر..",
            showVisitor: "إظهار الزائر",
            label: "تذكرة",
            text: "كتابة",
            email: "بريد إلكتروني",
            phone: "هاتف",
            number: "رقم",
            url: "URL",
            date: "وقت",
            dropdown: "اختيار",
            languageTimeZone: "اللغة والمنطقة",
            timeZoneTitle: "المنطقة والمنطقة الزمنية",
            timeZoneDescription: "إعدادات المنطقة الزمنية والمنطقة الزمنية",
            integration: "Entegrasyon",
            emailTitle: "E-Posta Adresinizi Giriniz",
            emailMessage: "E-posta İlk Gönderim Mesajı",
            advertising: "Pubblicità",
            balanceToTransferred: "Balance to be transferred",
            ballanceToTransfer: "Solde à transférer",
            crm: "CRM",
            ecommerce: "E-commerce",
            sms: "SMS",
            socialMedia: "Social Media",
            utilities: "Utilità",
            web: "Web"
        },
        sessions: {
            mySessions: "جلساتي",
            mySessionsDesc: "عرض وإدارة جلساتك النشطة المتصلة بحسابك.",
            allSessions: "جميع الجلسات",
            sessionManagement: "إدارة الجلسات",
            allSessionsDesc: "عرض وإدارة جميع الجلسات النشطة في النظام.",
            noActiveSessions: "لم يتم العثور على جلسات نشطة",
            currentSession: "الجلسة الحالية",
            lastAccess: "آخر وصول",
            createdAt: "تم الإنشاء",
            revoke: "إلغاء",
            revokeConfirm: "هل أنت متأكد أنك تريد إلغاء هذه الجلسة؟",
            revokeAllConfirm: "هل أنت متأكد أنك تريد إلغاء جميع الجلسات الأخرى؟",
            revokeSuccess: "تم إلغاء الجلسة بنجاح",
            revokeAllSuccess: "تم إلغاء جميع الجلسات بنجاح",
            revokeFailed: "فشل إلغاء الجلسة",
            revokeAllOther: "إلغاء جميع الجلسات الأخرى",
            unknownLocation: "موقع غير معروف",
            unknownDevice: "جهاز غير معروف",
            filterByUser: "تصفية حسب المستخدم",
            mobile: "جوال",
            supsisMobileApp: "تطبيق Supsis للجوال",
            httpClient: "عميل HTTP",
            unknown: "غير معروف",
            ios: "iOS",
            android: "أندرويد"
        },
        contactModuleRules: {
            title: "قواعد وحدة جهة الاتصال",
            description: "تحديد الإجراءات التلقائية عند إنشاء بطاقة العميل أو فتح الدردشة",
            active: "نشط",
            passive: "غير نشط",
            when: "متى:",
            conditions: "الشروط:",
            actions: "الإجراءات:",
            elseTitle: "وإلا (عند عدم تطابق أي قاعدة)",
            noActionsDefined: "لم يتم تحديد إجراءات",
            addNewRule: "إضافة قاعدة جديدة",
            rulesDisabled: "قواعد وحدة جهة الاتصال معطلة",
            enableHint: "قم بتشغيل المفتاح أعلاه لتفعيل الإجراءات التلقائية",
            rulesEnabledSuccess: "تم تفعيل قواعد وحدة جهة الاتصال",
            rulesDisabledSuccess: "تم تعطيل قواعد وحدة جهة الاتصال",
            ruleEnabledSuccess: "تم تفعيل القاعدة",
            ruleDisabledSuccess: "تم تعطيل القاعدة",
            ruleUpdateError: "خطأ أثناء تحديث القاعدة",
            orderUpdatedSuccess: "تم تحديث ترتيب القواعد",
            orderUpdateError: "خطأ أثناء تحديث الترتيب",
            ruleNameTemplate: "القاعدة {n}",
            ruleSavedSuccess: "تم حفظ القاعدة",
            ruleSaveError: "خطأ أثناء حفظ القاعدة",
            deleteRuleTitle: "حذف القاعدة",
            deleteRuleConfirm: "هل أنت متأكد أنك تريد حذف القاعدة \"{name}\"؟",
            delete: "حذف",
            ruleDeletedSuccess: "تم حذف القاعدة",
            ruleDeleteError: "خطأ أثناء حذف القاعدة",
            elseActionsSavedSuccess: "تم حفظ إجراءات Else",
            actionsSaveError: "خطأ أثناء حفظ الإجراءات",
            whenContactCreated: "عند إنشاء بطاقة العميل",
            whenChatOpened: "عند فتح الدردشة",
            noCondition: "لا شرط",
            and: "و",
            or: "أو",
            AND: "و",
            OR: "أو",
            fieldNotSelected: "لم يتم تحديد الحقل",
            noAction: "لا إجراء",
            doNothing: "لا تفعل شيئاً",
            assignToOwnerless: "غير معين",
            assignOwnerlessAction: "تعيين كـ <strong>{ownerless}</strong>",
            assignTo: "تعيين إلى",
            assignToUser: "تعيين إلى <strong>{name}</strong>",
            unknown: "غير معروف",
            leastContact: "الأقل محادثات",
            roundRobin: "التوزيع الدائري",
            today: "اليوم",
            last7Days: "آخر 7 أيام",
            last30Days: "آخر 30 يوماً",
            channelAccessUsers: "المستخدمون ذوو صلاحية القناة",
            usersCount: "{n} مستخدم",
            allUsers: "جميع المستخدمين",
            random: "عشوائي",
            algorithmic: "خوارزمي",
            addTagNotSelected: "إضافة علامة (غير محددة)",
            tagsLabel: "علامات",
            tagLabel: "علامة",
            addDepartmentNotSelected: "إضافة قسم (غير محدد)",
            addDepartmentTo: "قسم",
            applyToConversation: "(تطبيق على المحادثة أيضاً)",
            updatePropertyNotSelected: "تحديث الخاصية (غير محددة)",
            changeOwner: "تغيير المالك",
            addTag: "إضافة علامة",
            addDepartment: "إضافة قسم",
            updateProperty: "تحديث الخاصية",
            yes: "نعم",
            no: "لا",
            fields: {
                fullname: "الاسم",
                email: "البريد",
                phone: "الهاتف",
                whatsappNumber: "واتساب",
                whatsappCountry: "بلد واتساب",
                platform: "المنصة",
                ownerExists: "المالك",
                ownerIsOnline: "المالك متصل",
                ownerStatus: "حالة المالك",
                uptime: "العمر (د)",
                tags: "العلامات",
                channel: "القناة",
                preferredDepartment: "القسم",
                hour: "الساعة",
                day: "اليوم",
                conversationStatus: "حالة الدردشة",
                conversationSubject: "قسم الدردشة"
            },
            operators: {
                equals: "يساوي",
                not_equals: "لا يساوي",
                contains: "يحتوي",
                not_contains: "لا يحتوي",
                gt: "أكبر من",
                gte: "≥",
                lt: "أصغر من",
                lte: "≤",
                in: "يحتوي",
                not_in: "لا يحتوي",
                exists: "موجود",
                not_exists: "غير موجود"
            },
            ruleEditor: {
                editTitle: "تعديل القاعدة",
                createTitle: "إنشاء قاعدة جديدة",
                stepWhen: "متى؟",
                stepConditions: "الشروط",
                stepActions: "الإجراءات",
                whenQuestion: "متى يجب أن تعمل القاعدة؟",
                ruleName: "اسم القاعدة",
                ruleNamePlaceholder: "أدخل اسماً للقاعدة",
                contactCreatedTitle: "عند إنشاء بطاقة العميل",
                contactCreatedDesc: "تعمل عند إنشاء سجل عميل جديد",
                chatOpenedTitle: "عند فتح الدردشة",
                chatOpenedDesc: "تعمل عند بدء العميل محادثة جديدة",
                conditionsQuestion: "ما الشروط التي يجب استيفاؤها؟",
                actionsQuestion: "ما الإجراءات التي يجب أن تعمل؟",
                back: "رجوع",
                cancel: "إلغاء",
                next: "التالي",
                save: "حفظ",
                newRule: "قاعدة جديدة"
            },
            elseEditor: {
                title: "تعديل إجراءات Else",
                description: "تحديد الإجراءات الافتراضية عند عدم تطابق أي قاعدة"
            },
            ruleTester: {
                title: "اختبار القاعدة",
                description: "يمكنك اختبار عدد جهات الاتصال التي ستطابقها قاعدتك",
                selectRule: "اختر القاعدة",
                selectRulePlaceholder: "اختر القاعدة للاختبار",
                test: "اختبار",
                ruleInfo: "معلومات القاعدة",
                conditionCount: "عدد الشروط:",
                actionCount: "عدد الإجراءات:",
                ruleNotFound: "القاعدة غير موجودة",
                testComingSoon: "ميزة الاختبار قادمة قريباً.",
                testError: "خطأ أثناء الاختبار"
            },
            filterBuilder: {
                noConditions: "لم تتم إضافة شروط بعد",
                addFirstCondition: "إضافة أول شرط",
                groupTitle: "المجموعة {n}",
                deleteGroup: "حذف المجموعة",
                if: "إذا",
                selectField: "اختر الحقل",
                operator: "العامل",
                select: "اختر",
                selectValue: "اختر القيمة",
                enterValue: "أدخل القيمة",
                addCondition: "إضافة شرط",
                addFilterGroup: "إضافة مجموعة فلتر",
                andOption: "و",
                orOption: "أو",
                fieldLabels: {
                    fullname: "اسم جهة الاتصال",
                    email: "بريد جهة الاتصال",
                    phone: "هاتف جهة الاتصال",
                    whatsappNumber: "رقم واتساب",
                    whatsappCountry: "بلد واتساب",
                    platform: "منصة جهة الاتصال",
                    ownerExists: "جهة الاتصال لها مالك",
                    ownerIsOnline: "مالك جهة الاتصال متصل",
                    ownerStatus: "حالة المالك",
                    uptime: "عمر جهة الاتصال (دقيقة)",
                    tags: "علامات جهة الاتصال",
                    channel: "قناة جهة الاتصال",
                    preferredDepartment: "القسم المفضل",
                    hour: "الساعة الحالية",
                    day: "اليوم الحالي",
                    conversationStatus: "حالة المحادثة",
                    conversationSubject: "قسم المحادثة"
                },
                operators: {
                    equals: "يساوي",
                    not_equals: "لا يساوي",
                    contains: "يحتوي",
                    not_contains: "لا يحتوي",
                    gt: "أكبر من",
                    gte: "أكبر أو يساوي",
                    lt: "أصغر من",
                    lte: "أصغر أو يساوي",
                    between: "بين",
                    exists: "موجود",
                    not_exists: "غير موجود",
                    in: "يحتوي",
                    not_in: "لا يحتوي"
                }
            },
            actionsEditor: {
                noActions: "لم تتم إضافة إجراءات بعد",
                addFirstAction: "إضافة أول إجراء",
                actionNumber: "الإجراء {n}",
                actionType: "نوع الإجراء",
                addAction: "إضافة إجراء"
            },
            changeOwnerConfig: {
                method: "طريقة التعيين",
                static: "ثابت",
                algorithmic: "خوارزمي",
                random: "عشوائي",
                userSelect: "اختيار المستخدم",
                assignOwnerless: "تعيين كغير معين",
                selectUser: "اختر مستخدماً",
                userList: "قائمة المستخدمين",
                channelAccessUsers: "جميع المستخدمين ذوي صلاحية القناة",
                selectUsers: "اختر المستخدمين",
                algorithm: "الخوارزمية",
                leastContact: "الأقل محادثات",
                roundRobin: "التوزيع الدائري",
                dateRange: "نطاق التاريخ",
                today: "اليوم",
                last7Days: "آخر 7 أيام",
                last30Days: "آخر 30 يوماً",
                onlyOnline: "تضمين المستخدمين المتصلين فقط"
            },
            addTagConfig: {
                tagsToAdd: "العلامات للإضافة",
                selectTag: "اختر علامة",
                selectedTagsHint: "ستُضاف العلامات المحددة إلى جهة الاتصال"
            },
            addDepartmentConfig: {
                departmentSelect: "اختيار القسم",
                selectDepartment: "اختر القسم",
                departmentHint: "سيُضاف القسم المحدد إلى قائمة أقسام جهة الاتصال",
                applyToConversation: "تطبيق على المحادثة أيضاً",
                applyToConversationHint: "إذا تم التفعيل، سيتم تعيين قسم المحادثة المفتوحة أيضاً"
            },
            upsertContactPropertyConfig: {
                propertySelect: "اختيار الخاصية",
                selectProperty: "اختر الخاصية",
                propertyHint: "الخاصية للتحديث أو الإنشاء",
                value: "القيمة",
                valuePlaceholder: "أدخل قيمة الخاصية",
                valueHint: "سيتم تعيين هذه القيمة للخاصية"
            }
        },
        taskModuleRules: {
            title: "قواعد وحدة المهام",
            description: "تحديد الإجراءات التلقائية عند إنشاء أو تحديث مهمة أو إضافة تعليق",
            settingsTitle: "قواعد وحدة المهام",
            settingsDescription: "تحديد قواعد المهام التلقائية لكل سير عمل",
            selectWorkflow: "اختر سير العمل",
            selectWorkflowPlaceholder: "اختر سير العمل",
            selectWorkflowHint: "اختر سير عمل لتحرير قواعد وحدة المهام",
            active: "نشط",
            passive: "غير نشط",
            when: "متى:",
            conditions: "الشروط:",
            actions: "الإجراءات:",
            elseTitle: "وإلا (عند عدم تطابق أي قاعدة)",
            noActionsDefined: "لم يتم تحديد إجراءات",
            addNewRule: "إضافة قاعدة جديدة",
            rulesDisabled: "قواعد وحدة المهام معطلة",
            enableHint: "قم بتشغيل المفتاح أعلاه لتفعيل الإجراءات التلقائية",
            rulesEnabledSuccess: "تم تفعيل قواعد وحدة المهام",
            rulesDisabledSuccess: "تم تعطيل قواعد وحدة المهام",
            ruleEnabledSuccess: "تم تفعيل القاعدة",
            ruleDisabledSuccess: "تم تعطيل القاعدة",
            ruleUpdateError: "خطأ أثناء العملية",
            orderUpdatedSuccess: "تم تحديث ترتيب القواعد",
            orderUpdateError: "خطأ أثناء تحديث الترتيب",
            ruleNameTemplate: "القاعدة {n}",
            ruleSavedSuccess: "تم حفظ القاعدة",
            ruleSaveError: "خطأ أثناء حفظ القاعدة",
            deleteRuleTitle: "حذف القاعدة",
            deleteRuleConfirm: "هل أنت متأكد أنك تريد حذف القاعدة \"{name}\"؟",
            delete: "حذف",
            ruleDeletedSuccess: "تم حذف القاعدة",
            ruleDeleteError: "خطأ أثناء حذف القاعدة",
            elseActionsSavedSuccess: "تم حفظ إجراءات Else",
            actionsSaveError: "خطأ أثناء حفظ الإجراءات",
            noCondition: "لا شرط",
            and: "و",
            or: "أو",
            AND: "و",
            OR: "أو",
            fieldNotSelected: "لم يتم تحديد الحقل",
            noAction: "لا إجراء",
            chainBadge: "التسلسل",
            chainBadgeTooltip: "يمكن لهذه القاعدة تفعيل قواعد أخرى",
            automationOffBadge: "الأتمتة مغلقة",
            automationOffTooltip: "لا يتم الإبلاغ عنها لـ Supsis Automations",
            yes: "نعم",
            no: "لا",
            unknown: "غير معروف",
            cancel: "إلغاء"
        },
        userInfoWidget: {
            zohoInfo: "معلومات زوهو",
            messageSearch: "بحث الرسائل",
            userInformation: "معلومات المستخدم",
            fullName: "الاسم الكنية",
            newValue: "قيمة جديدة",
            newProfileInfo: "معلومات الملف الشخصي الجديدة",
            affiliatedRepresentatives: "مندوب",
            preferredAgents: "الوكيل (الوكلاء) المفضل",
            labels: "تسميات",
            agentNotes: "ملاحظات الوكيل",
            newNote: "ملاحظة جديدة",
            note: "ملحوظة",
            available: "هناك ملاحظات متوفرة.",
            systemInformation: "معلومات النظام",
            speechID: "معرف الكلام",
            customerVersion: "معرف الكلام",
            IPAddress: "عنوان IP",
            pageVisited: "تمت زيارة الصفحة",
            systemAndBrowser: "نظام التشغيل والمتصفح",
            countryAndLanguage: "البلد واللغة",
            clickToEdit: "تحرير انقر داخل المنشور",
            adsYouAreInterestedIn: "الإعلانات التي تهتم بها",
            detail: "التفاصيل",
            adsTitle: "العنوان",
            adUrl: "رابط الإعلان",
            sourceID: "معرّف المصدر",
            resourceType: "نوع المصدر",
            adsBody: "المحتوى",
            adsCreateDate: "تاريخ الإنشاء",
            adsUpdateDate: "تاريخ التحديث"
        },
        newWizartV2: {
            generalSettings: "الاعدادات العامة",
            themeSettings: "إعدادات الموضوع",
            representativeWorkingHours: "ساعات عمل الممثل",
            preview: "معاينة",
            setup: "يثبت",
            formStepTitle: "قدم لنا المزيد من المعلومات حتى نتمكن من تخصيص تجربتك",
            supsisEntergation: "أين ستستخدم Supsis على موقع الويب الخاص بك؟",
            goToNextStep: "خذ الخطوة التالية",
            readytemplate: "استخدم قالب ألوان جاهز",
            customSettings: "إعدادات مخصصة",
            customerMessageView: "عرض رسالة العميل",
            backcgroundColor: "لون الخلفية",
            textColor: "لون الخط",
            agentMessageView: "عرض رسالة الوكيل",
            workingHours: "ما الفترات الزمنية التي تقدم فيها الخدمات للزائرين؟",
            continuousService: "الخدمة المستمرة",
            continuousServiceDescription: "فقاعة الدردشة نشطة دائمًا. حتى لو لم تكن في النظام.",
            vote: "قم باختيارك",
            representativeWorking: "ساعات عمل الممثل",
            representativeWorkingDescription: "تظهر الدردشة على الإنترنت عندما يكون هناك وكيل واحد على الأقل متصلاً بالإنترنت. إذا لم يكن هناك ممثل عبر الإنترنت ، فسيظهر على أنه غير متصل.",
            computer: "حاسوب",
            tablet: "لوح",
            uploadTrackingCodeToYourWebsite: "تحميل رمز التتبع على موقع الويب الخاص بك",
            password: "تعيين كلمة مرور جديدة"
        },
        whatsappChannel: {
            whatsappTitleV1: "قنوات Whatsapp V1 (QR)",
            whatsappTitleV2: "قنوات Whatsapp V2 (QR)",
            channelName: "اسم القناة",
            phoneNumber: "رقم الهاتف",
            forwardToChatbot: "إعادة توجيه إلى الروبوت الدردشة",
            forwardingChatbotOrLiveAgent: "إعادة توجيه (روبوت الدردشة أو وكيل مباشر)",
            addChannel: "إضافة قناة",
            newWhatsappChannel: "قناة جديدة على واتساب",
            newWhatsappChannelDescription: "أنشئ قناة واتساب جديدة عن طريق مسح رمز الاستجابة السريعة (QR)",
            editWhatsappChannel: "تحرير قناة واتساب",
            editWhatsappChannelDescription: "تحرير قناة واتساب",
            whatsappChannel: "قناة واتساب",
            deleteWhatsappChannelDescription: "هل أنت متأكد أنك تريد حذف هذه القناة؟",
            whatsappIntegration: "تكامل واتساب",
            deleteChannel: "حذف القناة",
            restartChannel: "إعادة تشغيل القناة",
            wantRestartChannel: "هل ترغب في إعادة تشغيل القناة؟",
            deleteSMSChannelDescription: "هل أنت متأكد أنك تريد حذف قناة الرسائل القصيرة؟",
            smsChannel: "قناة الرسائل القصيرة",
            maxChannelCount: "لا يمكنك إنشاء أكثر من قناة رسائل نصية واحدة!",
            smsModalText: "إن تكاملنا مع حلول الاتصالات الحديثة يمنحك الفرصة لإرسال الرسائل القصيرة بسهولة وفعالية. قم بإزالة الحدود في التواصل، وتواصل مباشرة مع عملائك!",
            smsModalBtn: "انقر لفتح قناة الرسائل القصيرة...",
            postaCellDetail: "تفاصيل قناة PostaCell",
            phoneNummer: "Telefon Numarası"
        },
        noPermission: "ليس لديك إذن لأداء هذه العملية.",
        mail_integration_detail: {
            title: "تفاصيل البريد",
            integration: "التكامل",
            sender: "بريد المرسل",
            signature: "توقيع",
            inbox: "صندوق الوارد",
            medias: "وسائط",
            visibility: "الرؤية",
            settings_group: "الإعدادات",
            contacts: "جهات الاتصال"
        },
        whatsapp_business_api: {
            userVisibility: "رؤية المستخدم",
            userVisibilityDesc: "تعتمد القنوات التي يمكن للمستخدمين الوصول إليها على دورهم وإعدادات الرؤية الخاصة بالقناة. يمكن للمستخدمين الذين لديهم دور المسؤول الكامل أو الدور الجذر رؤية جميع القنوات. إذا كانت إعدادات رؤية القناة فارغة، تكون القناة عامة. ومع ذلك، إذا كانت القناة محددة لمستخدمين أو أقسام محددة، فيمكن لهؤلاء المستخدمين أو أعضاء الأقسام فقط رؤية القناة.",
            searchTemplate: "قالب البحث...",
            forwardToChatbot: "إعادة التوجيه إلى روبوت المحادثة",
            forwarding: "إعادة التوجيه (إلى روبوت المحادثة أو الوكيل المباشر)",
            forwardLiveAgents: "إعادة التوجيه إلى الدعم المباشر",
            forwardingToDepartment: "إعادة التوجيه إلى القسم",
            selectDepartment: "تحديد قسم",
            createWbChannel: "لإنشاء قناة واتساب للأعمال، يجب عليك شراء باقة واتساب للأعمال. يمكنك الوصول إلى باقات بأسعار معقولة على الفور.",
            wbCreateChannelMax: "لقد وصلت إلى الحد الأقصى لإنشاء قنوات واتساب للأعمال. الحد الأقصى",
            wbContinue: "يمكنك إنشاء قناة واتساب للأعمال. للمتابعة، قم بترقية باقتك أو احذف بعض قنوات واتساب للأعمال الخاصة بك.",
            chatInitiatorTemplate: "قالب بادئ الدردشة",
            selectChatInitiatorTemplate: "حدد قالب بادئ الدردشة الخاص بك.",
            dailyUsageReport: "تقرير الاستخدام اليومي",
            metaInsightsTitle: "رؤى Meta",
            metaInsightsSubtitle: "عرض إحصائيات واتساب Business API",
            metaInsightsDateRange: "نطاق التاريخ",
            metaInsightsDateStart: "البداية",
            metaInsightsDateEnd: "النهاية",
            metaInsightsGranularity: "الدقة",
            metaInsightsGranularityDay: "يومي",
            metaInsightsGranularityMonth: "شهري",
            metaInsightsGranularityHalfHour: "نصف ساعة",
            metaInsightsRefresh: "تحديث",
            metaInsightsTabMessaging: "تحليلات المراسلة",
            metaInsightsTabConversation: "تحليلات المحادثة",
            metaInsightsTabPricing: "تحليلات التسعير",
            metaInsightsTabTemplate: "تحليلات القالب",
            metaInsightsTabTemplateGroup: "تحليلات مجموعة القوالب",
            metaInsightsErrorMessaging: "فشل تحميل بيانات تحليلات المراسلة",
            metaInsightsErrorConversation: "فشل تحميل بيانات تحليلات المحادثة",
            metaInsightsErrorPricing: "فشل تحميل بيانات تحليلات التسعير",
            metaInsightsErrorTemplate: "فشل تحميل بيانات تحليلات القالب",
            metaInsightsErrorTemplateGroup: "فشل تحميل بيانات تحليلات مجموعة القوالب",
            metaInsightsViewChart: "عرض الرسم البياني",
            metaInsightsViewTable: "عرض الجدول",
            metaInsightsDownloadExcel: "تحميل Excel",
            metaInsightsTotalSent: "إجمالي المرسل",
            metaInsightsTotalDelivered: "إجمالي المُسَلّم",
            metaInsightsDeliveryRate: "معدل التسليم",
            metaInsightsUnitMessage: "رسائل",
            metaInsightsMessageStats: "إحصائيات الرسائل",
            metaInsightsSent: "مرسل",
            metaInsightsDelivered: "مُسَلّم",
            metaInsightsDateColumn: "التاريخ",
            metaInsightsCountryBreakdown: "التوزيع حسب البلد",
            metaInsightsNoData: "لم يتم العثور على بيانات. يرجى التحقق من نطاق التاريخ.",
            metaInsightsPieChart: "رسم دائري",
            metaInsightsTotalConversations: "إجمالي المحادثات",
            metaInsightsTotalCost: "إجمالي التكلفة",
            metaInsightsAvgCost: "متوسط التكلفة",
            metaInsightsUnitConversation: "محادثات",
            metaInsightsCostPerConversation: "$/محادثة",
            metaInsightsCategoryBreakdown: "التوزيع حسب الفئة",
            metaInsightsConversationStats: "إحصائيات المحادثات",
            metaInsightsCategoryDistribution: "توزيع الفئات",
            metaInsightsConversationCount: "عدد المحادثات",
            metaInsightsCost: "التكلفة",
            metaInsightsCategory: "الفئة",
            metaInsightsType: "النوع",
            metaInsightsConversationCategoryAuth: "المصادقة",
            metaInsightsConversationCategoryMarketing: "التسويق",
            metaInsightsConversationCategoryService: "الخدمة",
            metaInsightsConversationCategoryUtility: "الأدوات",
            metaInsightsConversationCategoryOther: "أخرى",
            metaInsightsConversationDistribution: "توزيع المحادثات",
            metaInsightsTotalVolume: "إجمالي الحجم",
            metaInsightsAvgUnitCost: "متوسط تكلفة الوحدة",
            metaInsightsCostPerMessage: "$/رسالة",
            metaInsightsPricingCategoryBreakdown: "توزيع فئة التسعير",
            metaInsightsPricingTypeBreakdown: "توزيع نوع التسعير",
            metaInsightsPricingStats: "إحصائيات التسعير",
            metaInsightsCostDistribution: "توزيع التكلفة",
            metaInsightsCountry: "البلد",
            metaInsightsVolume: "الحجم",
            metaInsightsTier: "المستوى",
            metaInsightsPricingCategoryAuth: "المصادقة",
            metaInsightsPricingCategoryAuthInternational: "المصادقة الدولية",
            metaInsightsPricingCategoryMarketing: "التسويق",
            metaInsightsPricingCategoryService: "الخدمة",
            metaInsightsPricingCategoryUtility: "الأدوات",
            metaInsightsPricingCategoryReferral: "تحويل الإحالة",
            metaInsightsPricingTypeRegular: "عادي",
            metaInsightsPricingTypeFreeCustomerService: "خدمة عملاء مجانية",
            metaInsightsPricingTypeFreeEntryPoint: "نقطة دخول مجانية",
            metaInsightsTemplateAboutTitle: "حول تحليلات القوالب",
            metaInsightsTemplateAboutDesc: "يجب عليك اختيار قوالب لتحليلات القوالب. يمكنك اختيار حتى 10 قوالب. يتم إرجاع بيانات التحليلات بدقة يومية ويمكنك الوصول إلى 90 يوماً من البيانات التاريخية.",
            metaInsightsTemplateSelectLabel: "اختر القوالب (الحد الأقصى 10)",
            metaInsightsTemplateSelectPlaceholder: "اختر القوالب...",
            metaInsightsFetchData: "جلب البيانات",
            metaInsightsTotalRead: "إجمالي المقروء",
            metaInsightsReadRate: "معدل القراءة",
            metaInsightsRead: "مقروء",
            metaInsightsTemplatePerformance: "أداء القالب",
            metaInsightsCostInfo: "معلومات التكلفة",
            metaInsightsTotalSpent: "إجمالي المصروف",
            metaInsightsCostPerDelivered: "التكلفة لكل تسليم",
            metaInsightsClickInfo: "معلومات النقر",
            metaInsightsClickInfoDesc: "نقرات أزرار URL والرد السريع متاحة فقط للقوالب في فئات التسويق والأدوات.",
            metaInsightsTemplateNoData: "لم يتم العثور على بيانات تحليلات القوالب. يمكنك جلب البيانات بتحديد معرفات القوالب.",
            metaInsightsTemplateId: "معرف القالب",
            metaInsightsTemplateGroupAboutTitle: "حول تحليلات مجموعة القوالب",
            metaInsightsTemplateGroupAboutDesc: "يجب عليك إدخال معرفات مجموعات القوالب المُنشأة في Meta لتحليلات مجموعة القوالب. يمكنك إدخال حتى 10 مجموعات. يتم إرجاع بيانات التحليلات بدقة يومية ويمكنك الوصول إلى 90 يوماً من البيانات التاريخية.",
            metaInsightsTemplateGroupIdsLabel: "معرفات مجموعة القوالب (مفصولة بفاصلة، الحد الأقصى 10)",
            metaInsightsTemplateGroupIdsPlaceholder: "مثال: 1044106240855852, 1044106240855853",
            metaInsightsTemplateGroupPerformance: "أداء مجموعة القوالب",
            metaInsightsGroupBreakdownTitle: "الأداء حسب المجموعة",
            metaInsightsGroupLabel: "المجموعة",
            metaInsightsTemplateGroupNoData: "لم يتم العثور على بيانات تحليلات مجموعة القوالب. يمكنك جلب البيانات بإدخال معرفات مجموعة القوالب.",
            metaInsightsGroupId: "معرف المجموعة",
            capiStatus: "حالة CAPI",
            capiActive: "نشط",
            capiPassive: "غير نشط",
            capiConnectionMethod: "طريقة الاتصال",
            capiConnectThroughMeta: "الاتصال عبر Meta",
            capiWithDatasetAndToken: "باستخدام Dataset والرمز",
            capiOauthInfoDesc: "تحتاج إلى إعادة التفويض للاتصال عبر Meta. هذا لا يعطل قناتك الحالية، بل يضيف أذونات إضافية فقط.",
            capiConnecting: "جاري الاتصال...",
            capiConnectWithMeta: "الاتصال بـ Meta",
            capiDatasetSelection: "اختيار مجموعة البيانات",
            capiSelectDataset: "اختر مجموعة بيانات",
            capiCreating: "جاري الإنشاء...",
            capiCreateNewDataset: "إنشاء مجموعة بيانات جديدة",
            capiDatasetId: "معرف مجموعة البيانات",
            capiEnterDatasetId: "أدخل معرف مجموعة البيانات",
            capiAccessToken: "رمز الوصول",
            capiEnterAccessToken: "أدخل رمز الوصول",
            capiTesting: "جاري الاختبار...",
            capiTestConnection: "اختبار الاتصال",
            capiConnectionSuccess: "الاتصال ناجح",
            capiConnectionFailed: "فشل الاتصال",
            capiAutoEventSend: "إرسال الأحداث التلقائي",
            capiEventInitiateCheckout: "بدء الدردشة",
            capiEventInitiateCheckoutDesc: "عند إنشاء محادثة جديدة",
            capiEventPurchase: "الشراء",
            capiEventPurchaseDesc: "عند اكتمال الشراء",
            capiEventAppointmentBooked: "تم حجز الموعد",
            capiEventAppointmentBookedDesc: "عند حجز موعد",
            capiEventAddToCart: "أضيف إلى السلة",
            capiEventAddToCartDesc: "عند إضافة منتج إلى السلة",
            capiEventViewContent: "تم عرض المحتوى",
            capiEventViewContentDesc: "عند عرض صفحة أو منتج",
            capiEventOrderCreated: "تم إنشاء الطلب",
            capiEventOrderCreatedDesc: "عند إنشاء الطلب بنجاح",
            capiEventOrderShipped: "تم شحن الطلب",
            capiEventOrderShippedDesc: "عند شحن الطلب",
            capiMetaConnectionSuccess: "اتصال Meta ناجح",
            capiMetaConnectionFailed: "فشل اتصال Meta",
            capiDatasetsLoadError: "فشل تحميل مجموعات البيانات",
            capiDatasetCreated: "تم إنشاء مجموعة بيانات جديدة",
            capiDatasetCreateError: "فشل إنشاء مجموعة البيانات",
            capiConnectionTestSuccess: "اتصال CAPI ناجح!",
            capiConnectionTestFailed: "فشل اتصال CAPI",
            capiConnectionTestError: "تعذر إجراء اختبار الاتصال",
            wabaMovementsTitle: "أنشطة Webhook",
            wabaMovementsSubtitle: "تتبع أنشطة قناة WhatsApp Business API",
            wabaMovementsTotalActivity: "إجمالي الأنشطة",
            wabaMovementsEmailNotifications: "إشعارات البريد الإلكتروني",
            wabaMovementsActive: "نشط",
            wabaMovementsOff: "إيقاف",
            wabaMovementsEmailSettingTitle: "استلام إشعارات الحساب عبر البريد الإلكتروني",
            wabaMovementsEmailSettingDesc: "إرسال إشعارات بالبريد الإلكتروني لأنشطة Webhook",
            wabaMovementsEmailListHeader: "عناوين البريد الإلكتروني لإرسال الإشعارات إليها",
            wabaMovementsEmailPlaceholder: "أدخل عنوان البريد الإلكتروني",
            wabaMovementsNoEmailsYet: "لم تتم إضافة عناوين بريد إلكتروني بعد",
            wabaMovementsActivityLoadError: "حدث خطأ أثناء تحميل سجلات النشاط",
            wabaMovementsNotificationsOn: "تم تفعيل إشعارات البريد الإلكتروني",
            wabaMovementsNotificationsOff: "تم إيقاف إشعارات البريد الإلكتروني",
            wabaMovementsUpdateError: "حدث خطأ أثناء التحديث",
            wabaMovementsEmailAlreadyAdded: "عنوان البريد الإلكتروني مضاف مسبقاً",
            wabaMovementsEmailAdded: "تمت إضافة عنوان البريد الإلكتروني",
            wabaMovementsEmailAddError: "حدث خطأ أثناء إضافة البريد الإلكتروني",
            wabaMovementsEmailRemoved: "تمت إزالة عنوان البريد الإلكتروني",
            wabaMovementsEmailRemoveError: "حدث خطأ أثناء إزالة البريد الإلكتروني",
            freeChat: "دردشة مجانية",
            paidChat: "دردشة مدفوعة",
            templateMessage: "قالب الرسالة",
            outgoingSession: "الجلسة الصادرة",
            incomingSession: "الجلسة الواردة",
            totalCost: "التكلفة الإجمالية",
            allOptNumbers: "جميع أرقام الاشتراك",
            startChat: "بدء الدردشة",
            lastMessageDate: "تاريخ آخر رسالة",
            sureDeleteTemplate: "هل أنت متأكد أنك تريد حذف هذا القالب؟",
            manageWhoChannelChat: "إدارة من يمكنه رؤية دردشات القناة هذه",
            profileImageDesc: "ستكون هذه لقطة شاشة واتساب لنشاطك التجاري.",
            businessDescription: "وصف نشاطك التجاري.",
            descOfWork: "وصف نشاطك التجاري ببضع كلمات (بحد أقصى 512 حرفًا).",
            accountStatus: "حالة الحساب.",
            dockerStatus: "حالة الإرساء.",
            phoneQuality: "جودة الهاتف.",
            customersOrDay: "يوم العملاء.",
            messagingLimit: "حد المراسلة.",
            canSendMessage: "يمكن إرسال رسالة.",
            officialDetails: "التفاصيل الرسمية.",
            officialDetailsDesc: "ستظهر هذه العناوين دائمًا في قسم الملف الشخصي للمستخدمين الذين يدردشون معك على واتساب. بعد التعديل، سنرسلها إلى واتساب للموافقة عليها.",
            addressLine: "سطر العنوان.",
            stateIfApplic: "الولاية (إن وجدت).",
            zipCodeOrPostCode: "الرمز البريدي/ الرمز البريدي.",
            selectCountry: "تحديد البلد.",
            selectBussVertical: "تحديد منطقة العمل.",
            saveInfo: "حفظ المعلومات.",
            active: "نشط.",
            banned: "محظور.",
            low: "منخفض.",
            medium: "متوسط.",
            high: "مرتفع.",
            connected: "متصل.",
            disConnected: "غير متصل.",
            flagged: "تم وضع علامة.",
            pending: "معلق.",
            restricted: "مقيد.",
            unknown: "غير معروف.",
            available: "متاح.",
            limited: "محدود.",
            blocked: "محظور.",
            loadingProfile: "جاري تحميل معلومات الملف الشخصي...",
            businessProfileTitle: "الملف الشخصي للأعمال",
            lastUpdate: "آخر تحديث:",
            updateFromMeta: "تحديث من ميتا",
            waitSeconds: "انتظر {n} ثانية",
            wabaInfoTitle: "معلومات حساب WhatsApp Business",
            phoneInfo: "معلومات الهاتف",
            verifiedNameLabel: "الاسم الموثق:",
            phoneNumberLabel: "رقم الهاتف:",
            codeVerificationLabel: "التحقق من الرمز:",
            platformSettings: "إعدادات المنصة",
            platformTypeLabel: "نوع المنصة:",
            throughputLevelLabel: "مستوى الإنتاجية:",
            twoFaPinLabel: "رمز 2FA:",
            enabled: "مفعّل",
            disabled: "معطّل",
            dailyLimit: "الحد اليومي",
            messageSending: "إرسال الرسائل",
            businessInfoTitle: "معلومات الأعمال",
            profilePhoto: "صورة الملف الشخصي",
            change: "تغيير",
            profilePhotoNote: "JPG أو PNG (بحد أقصى 5 ميجابايت، موصى به: 640x640 بكسل)",
            aboutText: "نص حول",
            aboutPlaceholder: "اكتب وصفاً قصيراً عن عملك...",
            aboutHint: "وصف قصير سيظهر في ملفك الشخصي على واتساب (139 حرفاً كحد أقصى)",
            businessDescriptionLabel: "وصف الأعمال",
            businessDescriptionPlaceholder: "اكتب الوصف التفصيلي لعملك...",
            descriptionHint: "الوصف التفصيلي لعملك",
            contactEmail: "البريد الإلكتروني للاتصال",
            emailPlaceholder: "example@company.com",
            businessAddress: "عنوان الأعمال",
            addressPlaceholder: "العنوان الكامل",
            website1: "الموقع 1",
            website2: "الموقع 2",
            website1Placeholder: "https://www.company.com",
            website2Placeholder: "https://www.facebook.com/company",
            businessCategory: "فئة الأعمال",
            selectBusinessCategory: "اختر فئة الأعمال",
            categoryHint: "اختر مجال نشاطك التجاري",
            revertChanges: "تراجع عن التغييرات",
            updateButton: "تحديث",
            accountModeLabel: "وضع الحساب:",
            na: "غير متاح",
            verticalOther: "أخرى",
            verticalAuto: "السيارات",
            verticalBeauty: "التجميل والسبا وصالون",
            verticalApparel: "الملابس والملبوسات",
            verticalEdu: "التعليم",
            verticalEntertain: "الترفيه",
            verticalEventPlan: "تخطيط الخدمات والفعاليات",
            verticalFinance: "المالية والمصرفية",
            verticalGrocery: "المواد الغذائية والبقالة",
            verticalGovt: "الخدمة العامة",
            verticalHotel: "الفنادق والإقامة",
            verticalHealth: "الطبية والصحة",
            verticalNonprofit: "غير ربحية",
            verticalProfServices: "الخدمات المهنية",
            verticalRetail: "التسوق والتجزئة",
            verticalTravel: "السفر والنقل",
            verticalRestaurant: "المطعم",
            verticalAlcohol: "الكحول",
            verticalOnlineGambling: "المقامرة عبر الإنترنت",
            verticalPhysicalGambling: "المقامرة الفعلية",
            verticalOtcDrugs: "الأدوية بدون وصفة",
            verticalMatrimonyService: "خدمة الزواج",
            success: "نجاح.",
            successDesc: "تم تحديث معلومات ملفك الشخصي بنجاح.",
            wabaOverview: "نظرة عامة على صحة WABA.",
            manageChannelDetail: "إدارة معلومات قناتك.",
            wpBussChannelDetail: "تفاصيل قناة واتساب للأعمال.",
            manageWpBussChannel: "إدارة قناة واتساب للأعمال الخاصة بك.",
            channelName: "اسم القناة.",
            phoneNumberE164: "رقم الهاتف",
            phoneNumberE164Place: "رقم الهاتف على سبيل المثال 908501234455.",
            channelUpdatedSucs: "تم تحديث القناة بنجاح.",
            faieldUpdateChannel: "فشل تحديث القناة.",
            completeSetup: "إكمال الإعداد",
            completeSetupDescription:
                "لإكمال إعداد واتساب Business API، يرجى النقر على الزر أدناه للانتقال إلى صفحة الاتصال.",
            connectWhatsAppBusinessAccount: "ربط حساب واتساب Business",
            infoLabel: "معلومات",
            onboardingInfoDescription:
                "يجب أن يكون حساب Facebook Business ورقم واتساب جاهزين لإعداد واتساب Business API.",
            businessId: "معرف الأعمال",
            phoneNumberId: "معرف رقم الهاتف",
            wabaId: "معرف WABA",
            verifiedNameLabel: "الاسم الموثق",
            userAccessibility: "إمكانية وصول المستخدم",
            userAccessibilityDesc:
                "يمكن للأشخاص المحددين أدناه رؤية جهات الاتصال والدردشات في هذه القناة (لا يمكن الوصول إذا تم تعيين الملكية). يُستخدم هذا الإعداد في: <ul><li><strong>تعيين الدردشة التلقائي:</strong> يتم تعيين العملاء الوافدين إلى هذه القناة وفقًا للرؤية؛ لا يتم تعيين الدردشات لمن ليس لديهم حق الوصول</li><li><strong>إعادة التوجيه:</strong> يجب أن تتطابق إعادة توجيه الدردشة من مكان آخر أو إضافة وكيل آخر مع هذه الإعدادات؛ لا يُسمح بالإعادة للمستخدمين غير المصرح لهم</li><li><strong>قوائم جهات الاتصال/العملاء:</strong> القوائم التي تراها تعتمد على هذا الإعداد؛ إذا لم تتمكن من رؤية بعض جهات الاتصال، فقد يكون ذلك مرتبطًا بهذا</li><li><strong>الملكية:</strong> يمكنك تعيين عميل لوكيل ضمن هذا الإعداد</li></ul>",
            makePublicButton: "جعله عامًا",
            channelOwners: "مالكو القناة",
            channelOwnersDesc:
                "يتمتع مالكو القناة بالإذن لعرض جميع المحادثات في هذه القناة. يمكنهم قراءة جميع الرسائل بغض النظر عن إعدادات الرؤية.",
            editChannelOwners: "تحرير مالكي القناة",
            selectChannelOwner: "اختر مالك القناة",
            selectChannelOwnerDesc: "حدد الوكلاء الذين سيملكون هذه القناة",
            makePublicConfirmTitle: "هل أنت متأكد أنك تريد جعل هذه القناة عامة؟",
            makePublicConfirmContent: "بعد هذا الإجراء، سيتمكن جميع الوكلاء من رؤية المحادثات في هذه القناة.",
            makePublicConfirmOk: "نعم، اجعلها عامة",
            makePublicSuccessMessage: "تم جعل القناة عامة",
            stepSetupTemplate: "إعداد القالب",
            stepEditTemplate: "تحرير القالب",
            stepSubmitReview: "إرسال للمراجعة",
            templateNameAndLanguage: "اسم القالب واللغة",
            editModeNoticeText: "في وضع التحرير، لا يمكن تغيير اسم القالب واللغة. يمكن تحرير الفئة فقط (إن لم تتم الموافقة)، والمكونات، ومدة الصلاحية.",
            nameYourTemplate: "اسم قالبك",
            enterTemplateNamePlaceholder: "أدخل اسم القالب",
            selectLanguage: "اختر اللغة",
            content: "المحتوى",
            footerOptional: "التذييل • اختياري",
            enterTextPlaceholder: "أدخل النص",
            bodyLabel: "الجسم",
            bodyPlaceholder: "أدخل نص جسم رسالتك",
            bold: "عريض",
            italic: "مائل",
            strikethrough: "يتوسطه خط",
            headerLabelRecommended: "موصى به",
            headerLabelOptionalTextOnly: "اختياري (نص فقط)",
            headerLabelRequiredProduct: "مطلوب (منتج)",
            headerLabelOptional: "اختياري",
            headerNone: "بدون",
            headerTextOption: "نص",
            headerDocument: "مستند",
            headerProduct: "منتج",
            productHeaderAutoSet: "يتم تعيين رأس المنتج تلقائياً عند استخدام قوالب المنتج.",
            headerTextPlaceholder: "أضف سطراً قصيراً من النص إلى رأس رسالتك",
            mediaHintNote: "ملاحظة:",
            mediaHintIntro: "تنسيقات وأحجام الملفات المقبولة:",
            mediaHintImage: "صورة: JPEG, PNG (حد أقصى 5 ميجابايت)",
            mediaHintVideo: "فيديو: MP4 (حد أقصى 16 ميجابايت)",
            mediaHintDocument: "مستند: PDF (حد أقصى 100 ميجابايت)",
            productHeaderAutoInfo: "يتم إضافة رأس المنتج تلقائياً من كتالوجك. لا حاجة لإعداد يدوي.",
            carouselContentDescription: "أنشئ رسالتين منفصلتين: أولاً رسالة النص العامة (الجسم). ثانياً بطاقات الكاروسيل مع صورة/فيديو. كل بطاقة يمكن أن يكون لها نص جسم (اختياري) وأزرار (مطلوب، واحد على الأقل). رسالة الجسم الرئيسية لا يمكن أن تحتوي أزراراً؛ فقط بطاقات الكاروسيل.",
            contentDescriptionProduct: "أضف نص الجسم لقالب رسالة المنتج. يتم إضافة رأس المنتج تلقائياً من كتالوجك.",
            contentDescriptionLTO: "أضف الرأس والجسم لقالب العرض محدود الوقت. التذييل غير مدعوم لهذا النوع.",
            contentDescriptionCarousel: "أضف نص الجسم العام وبطاقات الكاروسيل. كل بطاقة لها رأسها ونص جسم اختياري وأزرار. رسالة الجسم الرئيسية لا يمكن أن تحتوي أزراراً.",
            contentDescriptionDefault: "أضف الرأس والجسم والتذييل لقالبك.",
            readyToSubmit: "جاهز للإرسال",
            submitReviewDescription: "سيتم إرسال قالبك لمراجعة ميتا. عادة يستغرق دقائق وقد يصل إلى 24 ساعة.",
            bodyContentAdded: "تم إضافة محتوى الجسم",
            buttonsAddedCount: "تم إضافة {count} أزرار",
            previous: "السابق",
            discard: "إلغاء",
            next: "التالي",
            submitForReview: "إرسال للمراجعة",
            updateTemplate: "تحديث القالب",
            cannotProceed: "لا يمكن المتابعة",
            noChangesReason: "لم يتم إجراء أي تغييرات على القالب. يرجى إجراء تغيير واحد على الأقل.",
            categoryCannotChangeWarning: "لا يمكن تغيير الفئة للقوالب المعتمدة.",
            setupYourTemplate: "قم بإعداد قالبك",
            setupDescription: "اختر الفئة التي تصف قالب رسالتك. ثم اختر نوع الرسالة التي تريد إرسالها.",
            learnMoreCategories: "اعرف المزيد عن الفئات.",
            marketing: "التسويق",
            utility: "مساعد",
            authentication: "المصادقة",
            categoryCannotChangeApproved: "لا يمكن تغيير الفئة للقوالب المعتمدة",
            categoryCannotEditApproved: "لا يمكن تحرير الفئة للقوالب المعتمدة. يمكن تحرير المكونات ومدة الصلاحية فقط.",
            notSupported: "غير مدعوم",
            selectProductMessageType: "اختر نوع رسالة المنتج",
            selectOtpAutofillType: "اختر نوع الملء التلقائي OTP",
            templatePreview: "معاينة القالب",
            previewAlt: "معاينة",
            previewAltCallPermission: "طلب إذن المكالمة",
            previewSampleCard: "بطاقة نموذجية",
            previewCardPreview: "معاينة البطاقة",
            previewBodyMarketingDefault: "مرحباً! تصفح منتجاتنا الطازجة الآن! استخدم الكود HEALTH للحصول على خصم 10% إضافي.",
            previewBodyCarouselStep0: "تصفح منتجاتنا المميزة! اسحب لاستكشاف العروض الرائعة.",
            previewSpecialOffer: "عرض خاص",
            previewEndsIn2Days: "ينتهي خلال يومين",
            previewExpiresLabel: "ينتهي: ",
            previewSeeAllOptions: "عرض كل الخيارات",
            previewBodyLto: "ابدأ الآن! اشترِ اثنين واحصل على واحد مجاناً في مجموعة الصابون الجديدة. اجعل الجمعة السوداء لا تُنسى.",
            previewWinterSaleHeader: "تخفيضات الشتاء بدأت!",
            previewBodyCoupon: "تسوق حتى نهاية ديسمبر واستخدم الكود WINTER25 لخصم 25% على طلبك!",
            previewViewBizCatalog: "عرض كتالوج {BIZ_NAME} على واتساب",
            previewBrowseCatalogueDetails: "تصفح الصور وتفاصيل العروض.",
            previewBodyCatalogue: "تسوق منتجاتك المفضلة هنا على واتساب! تصفح كتالوجنا الكامل.",
            previewBodyCatalogueSingle: "اكتشف هذا المنتج الرائع! مثالي لاحتياجاتك.",
            previewBodyCatalogueMulti: "نسيت شيئاً؟ يبدو أنك تركت هذه المنتجات في سلتك.",
            previewBodyCatalogueCarousel: "اكتشف أحدث منتجاتنا! تصفح الكتالوج واعثر على ما تبحث عنه.",
            previewBodyUtility: "أخبار سارة! تم شحن طلبك 23KFEJJ2312! معلومات التتبع في الرابط أدناه.",
            previewBodyAuth: "123456 هو رمز التحقق الخاص بك. لسلامتك، لا تشارك هذا الرمز.",
            previewBodyPlaceholder: "سيظهر نص رسالتك هنا",
            previewBodyCarouselPlaceholder: "سيظهر نص رسالة الكاروسيل هنا",
            previewButtonN: "زر {n}",
            previewProductNDescription: "وصف المنتج {n}",
            previewTemplateGoodFor: "هذا القالب مناسب لـ",
            previewTemplateAreasCustomise: "مناطق القالب التي يمكنك تخصيصها",
            previewDescCatalogue: "اكتشاف المنتجات/الخدمات، المبيعات، العروض، التسويق المستهدف",
            previewDescCoupon: "إرسال رموز ترويجية مع زر نسخ. محدود بزر نسخ واحد.",
            previewDescCarousel: "عرض منتجات أو خدمات متعددة في عرض قابل للتمرير. كل بطاقة يمكن أن تحتوي صورة ووصف وأزرار.",
            previewDescMarketing: "رسائل ترحيب، عروض، كوبونات، نشرات، إعلانات",
            previewDescUtility: "تأكيد الطلبات، تحديث الحساب، إيصالات، تذكيرات المواعيد",
            previewDescAuth: "كلمة مرور لمرة واحدة، استرداد الحساب، التحقق، التحديات",
            previewCustomisableCallPermission: "الرأس، الجسم، التذييل",
            previewCustomisableCoupon: "الرأس (نص)، الجسم، الزر (ما عدا نص نسخ الكود)",
            previewCustomisableCarousel: "نص الجسم العام، بطاقات الكاروسيل",
            previewCustomisableMarketing: "الوسائط، الرأس، الجسم، التذييل، الزر",
            previewCustomisableUtility: "الرأس، الجسم، التذييل",
            previewCustomisableAuth: "الجسم",
            productMessage: "رسالة المنتج",
            callUs: "اتصل بنا",
            unsubscribe: "إلغاء الاشتراك",
            trackShipment: "تتبع الشحن",
            choosePreference: "اختر التفضيل",
            autoVerify: "التحقق التلقائي",
            yourTemplateNamePlaceholder: "اسم_القالب",
            templateNameLabel: "اسم القالب",
            categoryLabel: "الفئة",
            languageLabel: "اللغة",
            templateCreatedSuccess: "تم إنشاء القالب وإرساله للمراجعة بنجاح!",
            templateUpdatedSuccess: "تم تحديث القالب بنجاح!",
            mediaUploadedSuccess: "تم رفع الوسائط بنجاح",
            mediaUploadFailedPrefix: "فشل رفع الوسائط: ",
            nameRequired: "اسم القالب مطلوب",
            nameInvalidChars: "مسموح فقط بالأحرف الصغيرة والأرقام والشرطة السفلية",
            nameMaxLength: "يجب ألا يتجاوز اسم القالب 512 حرفاً",
            bodyRequired: "محتوى الجسم مطلوب",
            ltoRequiresOneButton: "العرض محدود الوقت يتطلب زراً واحداً على الأقل",
            ltoRequiresUrlButton: "العرض محدود الوقت يتطلب زر رابط",
            carouselRequiresOneCard: "قالب الكاروسيل يتطلب بطاقة واحدة على الأقل",
            cardMustHaveButton: "يجب أن تحتوي البطاقة {index} على زر واحد على الأقل",
            cardMustHaveHeaderMedia: "يجب أن تحتوي البطاقة {index} على صورة أو فيديو للرأس",
            ltoUrlButtonCannotRemove: "العرض محدود الوقت يتطلب زر رابط واحداً على الأقل ولا يمكن إزالته",
            ltoRequiresOneButtonWarning: "العرض محدود الوقت يتطلب زراً واحداً على الأقل",
            copyCodeButtonRequired: "زر نسخ الرمز مطلوب لقالب كوبون ولا يمكن إزالته",
            carouselCardMustHaveButton: "كل بطاقة كاروسيل يجب أن تحتوي على زر واحد على الأقل",
            imageMaxSize: "يجب أن تكون الصورة أقل من 5 ميجابايت",
            videoMaxSize: "يجب أن يكون الفيديو أقل من 16 ميجابايت",
            documentMaxSize: "يجب أن يكون المستند أقل من 100 ميجابايت",
            fileUploadFailed: "فشل رفع الملف",
            uploadFileLoading: "جاري رفع الملف...",
            templateTypeDefault: "افتراضي",
            templateTypeDefaultDesc: "أرسل رسائل مع وسائط وأزرار مخصصة للتفاعل مع عملائك.",
            templateTypeLimitedTimeOffer: "عرض محدود الوقت",
            templateTypeLimitedTimeOfferDesc: "أنشئ إلحاحاً مع عروض ترويجية حساسة للوقت ورموز العرض.",
            templateTypeCarousel: "كاروسيل",
            templateTypeCarouselDesc: "أرسل كاروسيل بطاقات مع صور وأزرار لعرض منتجات أو عروض متعددة.",
            templateTypeProductMessage: "رسالة منتج",
            templateTypeProductMessageDesc: "أرسل رسائل تدفع المبيعات من خلال ربط كتالوج المنتجات.",
            templateTypeCallPermission: "طلب إذن الاتصال",
            templateTypeCallPermissionDesc: "اسأل العملاء إذا كان بإمكانك الاتصال بهم على واتساب.",
            templateTypeCouponCode: "رمز القسيمة",
            templateTypeCouponCodeDesc: "أرسل رموزاً ترويجية مع زر نسخ للاسترداد السهل.",
            templateTypeUtilityDefault: "افتراضي",
            templateTypeUtilityDefaultDesc: "أرسل رسائل حول طلب أو حساب موجود.",
            templateTypeOtp: "رمز مرور لمرة واحدة",
            templateTypeOtpDesc: "أرسل رموزاً للتحقق من معاملة أو تسجيل دخول.",
            catalogueSubtypeCatalogue: "رسالة الكتالوج",
            catalogueSubtypeCatalogueDesc: "اعرض كتالوج المنتجات الكامل مع زر عرض الكتالوج.",
            catalogueSubtypeMultiProduct: "رسالة منتجات متعددة",
            catalogueSubtypeMultiProductDesc: "اعرض حتى 30 منتجاً من كتالوجك في رسالة واحدة.",
            catalogueSubtypeSingleProduct: "رسالة منتج واحد",
            catalogueSubtypeSingleProductDesc: "سلط الضوء على منتج واحد بالتفاصيل وزر الحث على العمل.",
            catalogueSubtypeProductCardCarousel: "كاروسيل بطاقة المنتج",
            catalogueSubtypeProductCardCarouselDesc: "اعرض حتى 10 بطاقات منتج في عرض كاروسيل.",
            catalogueSubtypeDisabledReason: "غير مدعوم حالياً. يتطلب نوع القالب هذا تكاملاً مع كتالوج المنتجات.",
            authSubtypeCopyCode: "نسخ الرمز",
            authSubtypeCopyCodeDesc: "المستخدم ينسخ الرمز يدوياً (OTP قياسي).",
            authSubtypeOneTap: "لمسة واحدة",
            authSubtypeOneTapDesc: "ملء الرمز تلقائياً بلمسة واحدة على أجهزة أندرويد المدعومة.",
            authSubtypeZeroTap: "صفر لمسة",
            authSubtypeZeroTapDesc: "ملء الرمز تلقائياً دون تفاعل المستخدم (يتطلب موافقة المستخدم).",
            viewCatalog: "عرض الكتالوج",
            viewProduct: "عرض المنتج",
            viewProducts: "عرض المنتجات",
            view: "عرض",
            copyOfferCode: "نسخ رمز العرض",
            oneTapAutofill: "ملء تلقائي بلمسة واحدة",
            zeroTapAutofill: "ملء تلقائي بصفر لمسة",
            shopNow: "تسوق الآن",
            viewItems: "عرض العناصر",
            autofill: "ملء تلقائي",
            messageTtlOptional: "مدة صلاحية الرسالة (TTL) • اختياري",
            selectTtlPlaceholder: "اختر TTL أو اترك الافتراضي",
            ttlDescMarketing: "إن لم نستطع توصيل رسالتك التسويقية، سنعيد المحاولة للمدة المحددة.",
            ttlDescUtility: "حدد مدة توصيل الرسائل المساعدة كتأكيدات الطلب.",
            ttlDescAuthentication: "حدد مدة صلاحية رموز المصادقة للتوصيل.",
            ttlInfoMarketing: "قوالب التسويق: 12 ساعة إلى 30 يوماً. الافتراضي يحدده النظام.",
            ttlInfoUtility: "قوالب المساعد: 30 ثانية إلى 12 ساعة أو -1 لـ 30 يوماً. الافتراضي يحدده النظام.",
            ttlInfoAuthentication: "قوالب المصادقة: 30 ثانية إلى 15 دقيقة أو -1 لـ 30 يوماً. الافتراضي يحدده النظام.",
            ttlOption12Hours: "12 ساعة (43,200 ثانية)",
            ttlOption1Day: "يوم واحد (86,400 ثانية)",
            ttlOption3Days: "3 أيام (259,200 ثانية)",
            ttlOption7Days: "7 أيام (604,800 ثانية)",
            ttlOption15Days: "15 يوماً (1,296,000 ثانية)",
            ttlOption30Days: "30 يوماً (2,592,000 ثانية)",
            ttlOption30Seconds: "30 ثانية",
            ttlOption1Minute: "دقيقة واحدة (60 ثانية)",
            ttlOption2Minutes: "دقيقتان (120 ثانية)",
            ttlOption3Minutes: "3 دقائق (180 ثانية)",
            ttlOption5Minutes: "5 دقائق (300 ثانية)",
            ttlOption10Minutes: "10 دقائق (600 ثانية)",
            ttlOption15Minutes: "15 دقيقة (900 ثانية)",
            ttlOption30Minutes: "30 دقيقة (1,800 ثانية)",
            ttlOption1Hour: "ساعة واحدة (3,600 ثانية)",
            ttlOption2Hours: "ساعتان (7,200 ثانية)",
            ttlOption4Hours: "4 ساعات (14,400 ثانية)",
            ttlOption6Hours: "6 ساعات (21,600 ثانية)",
            ttlOption30DaysSpecial: "30 يوماً (قيمة خاصة: -1)",
            authSettings: "إعدادات المصادقة",
            addSecurityRecommendation: "إضافة توصية أمان",
            securityRecommendationHint: "يضيف الرسالة \"لأمانك، لا تشارك هذا الرمز\".",
            authMessageTtlHint: "الحد الزمني لتوصيل الرسالة (60-600 ثانية). اتركه فارغاً للافتراضي.",
            authTtlPlaceholder: "60-600",
            authCodeExpPlaceholder: "1-90",
            authPackagePlaceholder: "com.example.app",
            authSignatureHash: "توقيع الهاش",
            messageTtlSecondsOptional: "TTL الرسالة (ثوانٍ) • اختياري",
            codeExpirationOptional: "انتهاء صلاحية الرمز (دقائق) • اختياري",
            codeExpirationHint: "مدة صلاحية رمز OTP. تظهر في التذييل.",
            zeroTapTerms: "أقبل شروط Zero Tap",
            zeroTapTermsHint: "مطلوب لعمل الملء التلقائي Zero Tap.",
            supportedAndroidAppsOptional: "تطبيقات أندرويد المدعومة • اختياري",
            addApp: "إضافة تطبيق",
            limitedTimeOfferLabel: "عرض محدود الوقت",
            ltoDescription: "أضف نصاً يخلق إلحاحاً لعرضك. وقت الانتهاء يُحدد عند الإرسال.",
            ltoPlaceholder: "مثال: عرض منتهٍ! تخفيض!",
            showExpirationTimer: "إظهار مؤقت الانتهاء",
            ltoExpirationHint: "عند التفعيل، واتساب سيعرض عداً تنازلياً حسب وقت الإرسال.",
            carouselCards: "بطاقات الكاروسيل",
            carouselCardsDescription: "ستظهر هذه البطاقات كرسالة ثانية بعد نص الجسم العام. كل بطاقة تحتاج رأس صورة/فيديو وزر واحد على الأقل (حتى 2). نص جسم البطاقة اختياري ويدعم المتغيرات. حتى 10 بطاقات.",
            carouselCardN: "البطاقة {n}",
            carouselButtonsLabel: "الأزرار * (واحد على الأقل، حتى 2)",
            cardHeaderRequired: "رأس البطاقة",
            cardBodyOptional: "جسم البطاقة • اختياري",
            cardBodyPlaceholder: "أدخل نص جسم البطاقة (اختياري)",
            image: "صورة",
            video: "فيديو",
            moveUp: "تحريك لأعلى",
            moveDown: "تحريك لأسفل",
            remove: "إزالة",
            dragDropUpload: "اسحب وأفلت للرفع",
            orChooseFiles: "أو اختر ملفات من جهازك",
            uploadingToMeta: "جاري الرفع إلى ميتا...",
            uploadedSuccessfully: "تم الرفع بنجاح",
            addQuickReplyButton: "إضافة زر رد سريع",
            addCtaButton: "إضافة زر CTA",
            urlButtonRequiredLto: "زر الرابط مطلوب للعرض محدود الوقت",
            copyCodeButtonFixed: "نص زر نسخ الرمز لا يمكن تخصيصه في قوالب كوبون",
            copyCode: "نسخ الرمز",
            fixed: "ثابت",
            buttonsHeading: "الأزرار",
            buttonLabelAutoAdded: "يُضاف تلقائياً",
            buttonLabelRequiredCopyCode: "مطلوب (1 نسخ رمز + اختياري)",
            buttonLabelRequiredUrl: "مطلوب (1 رابط + اختياري)",
            buttonLabelOptional: "اختياري",
            buttonDescCatalogue: "يُضاف زر المنتج تلقائياً. يمكنك تخصيص نص الزر.",
            buttonDescCallPermission: "يُضاف زر إذن الاتصال تلقائياً. لا يمكن إضافة أزرار إضافية.",
            buttonDescAuth: "يُضاف زر التحقق تلقائياً. يمكنك تخصيص نص الزر.",
            buttonDescCoupon: "زر نسخ الرمز مطلوب ولا يمكن تخصيص نصه. يمكنك إضافة أزرار رد سريع أو CTA حتى 10 إجمالاً.",
            buttonDescLto: "العروض محدودة الوقت تتطلب زر رابط واحداً على الأقل. يمكنك إضافة أزرار CTA أو رد سريع إضافية.",
            buttonDescDefault: "أضف أزرار رد سريع أو أزرار CTA. بحد أقصى 10 أزرار.",
            buttonPlaceholderText: "نص الزر",
            buttonMax10Warning: "الحد الأقصى 10 أزرار مسموح",
            buttonCopyCodeAutoAddedWarning: "زر نسخ الرمز يُضاف تلقائياً ولا يمكن إضافته يدوياً",
            exampleValuePlaceholder: "قيمة_مثال",
            copyCodeExamplePlaceholder: "SUMMER20",
            quickReply: "رد سريع",
            visitWebsite: "زيارة الموقع",
            callPhone: "الاتصال",
            addCard: "إضافة بطاقة",
            addButton: "إضافة زر",
            title: "قنوات واتساب Business API",
            integration: "التكامل",
            detail: "تفاصيل",
            visibility: "رؤية",
            templates: "جميع رسائل القوالب",
            settings_group: "إعدادات",
            template_message_group: "رسائل القوالب",
            chat_initiator_template: "قالب بدء الدردشة",
            contacts: "جهات الاتصال",
            numbers: "الأرقام",
            all_contacts: "كل الاتصالات",
            new_template: "إنشاء قالب جديد",
            broadcast_group: "بث",
            broadcast_requests: "طلبات البث",
            customer_groups: "مجموعات العملاء",
            businessChannelDetail: "تفاصيل قناة واتساب الأعمال",
            wallet: "Wallet",
            postacellMessage: "إرسال رسالة نصية",
            postacellAllMessage: "إرسال رسائل نصية جماعية",
            message_group: "رسالة",
            createNewTemplate: "إنشاء رسالة قالب جديدة",
            templateName: "اسم القالب",
            templateNameDesc: "قدم اسمًا لقالب الرسالة الخاص بك.",
            templateInfo: "معلومات القالب",
            viewTemplates: "عرض القوالب",
            templateListTitle: "قوالب الرسائل",
            templateListShownTotal: "{shown} قوالب معروضة (المجموع: {total})",
            templateListCreateButton: "إنشاء قالب",
            templateListSearchPlaceholder: "البحث في القوالب...",
            templateListAllCategories: "جميع الفئات",
            templateListAllStatus: "جميع الحالات",
            templateListStatusApproved: "معتمد",
            templateListStatusPending: "قيد المراجعة",
            templateListStatusRejected: "مرفوض",
            templateListRefresh: "تحديث",
            templateListTotalTemplates: "المجموع {count} قوالب",
            templateListCopied: "تم النسخ!",
            templateListCopy: "نسخ",
            templateListIdLabel: "المعرف:",
            templateListPreview: "معاينة",
            templateListEdit: "تعديل",
            templateListDelete: "حذف",
            templateListPreviewTitle: "معاينة القالب",
            templateListNameLabel: "الاسم:",
            templateListCategoryLabel: "الفئة:",
            templateListLanguageLabel: "اللغة:",
            templateListStatusLabel: "الحالة:",
            templateListReasonLabel: "السبب:",
            templateListRecommendationLabel: "التوصية:",
            templateListColumnName: "اسم القالب",
            templateListColumnCategory: "الفئة",
            templateListColumnStatus: "الحالة",
            templateListColumnLastEdited: "آخر تعديل",
            templateListStatusActive: "نشط",
            templateListStatusInReview: "قيد المراجعة",
            templateListStatusRejected: "مرفوض",
            templateListStatusFailed: "فشل",
            templateListQualityHigh: "جودة عالية",
            templateListQualityMedium: "جودة متوسطة",
            templateListQualityLow: "جودة منخفضة",
            templateListDeleteConfirmTitle: "حذف القالب",
            templateListDeleteConfirmContent: "هل أنت متأكد من حذف \"{{name}}\"؟",
            templateListDeleteConfirmOk: "حذف",
            templateListDeleteConfirmCancel: "إلغاء",
            templateListCopyIdError: "حدث خطأ أثناء نسخ المعرف",
            templateListDeletedSuccess: "تم حذف {{name}} بنجاح.",
            templateListDeleteFailed: "فشل حذف القالب.",
            templateNameRules: "اسم القالب يمكن أن يحتوي فقط على حروف صغيرة وأرقام وشرطات سفلية.",
            category: "الفئة",
            categoryDesc: "حدد نوع القالب الذي تريد إنشاءه",
            categoryUtility: "الأداة",
            categoryUtilityDesc: "أرسل معلومات مفيدة مثل تحديثات الحساب، تحديثات الطلبات، التنبيهات وأكثر.",
            categoryMarketing: "تسويق",
            categoryMarketingDesc: "أرسل عروض ترويجية، عروض منتجات، وأكثر لزيادة الوعي والمشاركة.",
            categoryAuth: "المصادقة",
            categoryAuthDesc: "أرسل رموزًا لعملائك للوصول إلى حساباتهم.",
            optional: "اختياري",
            languageDesc: "حدد اللغة التي سيتم إرسال رسالتك النموذجية بها",
            header: "عنوان",
            headerRules: "أضف عنوانًا يتكون من 60 حرفًا إلى رسالتك. يتم دعم متغير واحد فقط في العنوان.",
            headerOptionMedia: "وسائط",
            headerOptionText: "نص",
            none: "لا شيء",
            headerType: "نوع العنوان",
            headerText: "نص العنوان",
            body: "الجسم",
            bodyRules: "أدخل النص باللغة التي اخترتها لرسالتك",
            addVariable: "إضافة متغير",
            variables: "المتغيرات",
            variable: "متغير",
            defaultVariableName: "اسم المتغير الافتراضي",
            defaultVariableToolTip: "تظهر متغيراتك في القالب بهذا الاسم. <br><br> بالإضافة إلى ذلك ، يتم إرسال هذا القيمة كقيمة افتراضية في حالة وجود حالات أخرى.",
            selectATemplate: "اختر قالب الرسالة",
            variableSettings: "إعدادات المتغيرات",
            example: "مثال",
            footer: "تذييل",
            footerDesc: "أضف تذييلًا بطول 60 حرفًا إلى رسالتك. لا يتم دعم المتغيرات في التذييل.",
            buttons: "أزرار",
            buttonType: "نوع الزر",
            buttonTypeReply: "الرد",
            submit: "حفظ",
            submitting: "جاري الإرسال",
            addButton: "إضافة زر",
            rejectWhatsapp: "تم رفضها من قبل واتساب.",
            approvedWhatsapp: "تمت الموافقة عليها من قبل واتساب.",
            pendingWhatsapp: "قيد الانتظار للموافقة",
            daily_usages: "الاستخدامات اليومية",
            bussinesDesciption: "Bussines Açıklama ",
            succesDesc: "Profil bilgileriniz başarılı bir şekilde güncellendi.",
            reports: "Raporlar",
            dynamicUrlSampleNote: "Sample dynamic URL with variable (Note: Do not add the URL in your sample message body above)",
            bussinesDescription: "Business description",
            failedUpdateChannel: "Failed to update channel",
            postacellMessagepostacellMessage: "Envoyer un SMS",
            selectBusinessVertical: "Select Business Area",
            stateIfApplicable: "State (if applicable)"
        },
        multi_whatsapp_api: {
            profile: "الملف الشخصي",
            integration: "التكامل",
            detail: "التفاصيل",
            visibility: "الرؤية",
            templates: "جميع رسائل القوالب",
            settings_group: "الإعدادات",
            template_message_group: "رسائل القالب",
            new_template: "إنشاء قالب جديد",
            broadcast_group: "رسالة مجمعة",
            broadcast_requests: "إرسال رسائل مجمعة",
            customer_groups: "مجموعات العملاء",
            chat_initiator_template: "قالب بادئ الدردشة",
            contacts: "جهات الاتصال",
            numbers: "أرقام",
            all_contacts: "جميع جهات الاتصال"
        },
        archive: {
            destroyedBy: {
                agent: "الوكيل",
                visitor: "الزائر",
                system: "النظام",
                chatbot: "روبوت الدردشة"
            }
        },
        upgradeMessages: {
            ticket: "حتى عند عدم اتصالك بالإنترنت، تأكد من تسجيل طلباتك فورًا باستخدام الذكاء الاصطناعي والروبوتات. حافظ على رضا عملائك دائمًا!",
            tasks: "قم بإدارة مهامك ومشاريعك بسهولة. تعاون مع فريقك بسلاسة وسلم المشاريع في الوقت المحدد!",
            calendar: "خطط مواعيدك واجتماعاتك بسهولة. كن متزامنًا مع فريقك وأدر وقتك بكفاءة!",
            mail_integration: "قم بإدارة رسائل البريد الإلكتروني بسهولة. عزز تواصلك مع العملاء وحسن التعاون!",
            team_integration: "تواصل بشكل أسرع وأكثر فعالية مع فريقك. عزز التعاون واضمن تسليم المشاريع في الوقت المحدد!",
            webhook_integration: "قم بربط تطبيقاتك من خلال تكامل Webhook وسهل تبادل البيانات!",
            whatsapp_v2: "حسّن تواصلك مع عملائك من خلال تكامل WhatsApp لتجربة أسرع وأكثر كفاءة!",
            whatsapp: "قم بتحسين التواصل مع عملائك باستخدام تكامل WhatsApp لتحقيق تواصل أسرع وأكثر فعالية!",
            whatsapp_business_api: "استفد من واجهة WhatsApp Business API للتواصل مع عملائك بشكل أكثر فعالية وكفاءة!",
            instagram: "تفاعل مع عملائك بشكل أكثر كفاءة باستخدام تكامل Instagram!",
            messenger: "تواصل مع عملائك بسهولة من خلال تكامل Messenger!",
            sms_postacell: "تواصل مع عملائك بسرعة وفعالية من خلال تكامل الرسائل النصية القصيرة (SMS)!",
            ready_contents: "تساعدك المحتويات الجاهزة على التواصل مع عملائك بسرعة وفعالية.",
            automation: "قم بأتمتة سير عملك لتوفير الوقت وإدارة المهام بكفاءة!",
            form: "استخدم منشئ النماذج لتبسيط التفاعل مع العملاء، وجمع المعلومات القيمة، وتعزيز التعاون!",
            customer_tables: "قم بإنشاء جداول مخصصة وإدارة معلومات العملاء بكفاءة!",
            trendyol: "عزز تواصلك مع العملاء من خلال تكامل Trendyol لتحقيق تواصل سلس!",
            access_control: "احمِ بياناتك وامنع الوصول غير المصرح به باستخدام ميزات التحكم في الوصول!",
            upgrade: "ترقية اشتراكي",
            upgradeFeature: "اشترِ حزمة إضافية",
            featureNotAvailable: "الميزة غير متوفرة.",
            usageLimitExceeded: "تم تجاوز حد الاستخدام.",
            maxAgentCount: "قم بترقية خطتك لخدمة المزيد من العملاء عن طريق إضافة وكلاء إضافيين.",
            maxTriggerCount: "قم بترقية خطتك لإنشاء المزيد من التفاعلات عن طريق إضافة المزيد من المحفزات.",
            visitorStartChat: "قم بترقية خطتك لبدء المحادثات مع الزوار الذين لم يتفاعلوا من قبل.",
            voiceCalling: "قم بترقية خطتك للتواصل بشكل أكثر فاعلية مع العملاء من خلال المكالمات الصوتية.",
            videoCalling: "قم بترقية خطتك للتواصل بشكل أكثر فاعلية مع العملاء من خلال المكالمات المرئية.",
            fileAndVoiceMessage: "قم بترقية خطتك لإرسال الملفات والرسائل الصوتية لعملائك.",
            autoTranslation: "قم بترقية خطتك لخدمة المزيد من العملاء باستخدام الترجمة التلقائية للرسائل.",
            telegramEntegration: "قم بترقية خطتك لتمكين التكامل مع تيليجرام.",
            chatCopilot: "قم بترقية خطتك لتوفير خدمة أفضل باستخدام مساعد الدردشة المدعوم بالذكاء الاصطناعي.",
            calenderEntegration: "قم بترقية خطتك لمزامنة تقويمك مع التطبيقات الأخرى.",
            mailEntegration: "قم بترقية خطتك لإدارة البريد الإلكتروني بشكل أكثر فاعلية وتحسين التواصل مع العملاء.",
            smsEntegration: "قم بترقية خطتك للوصول إلى عملائك بشكل أسرع من خلال تكامل الرسائل القصيرة.",
            ticketSystem: "قم بترقية خطتك لإدارة طلبات العملاء بشكل أكثر كفاءة من خلال نظام التذاكر.",
            taskManagementEntegration: "قم بترقية خطتك لتحسين تدفق العمل من خلال تكامل إدارة المهام.",
            webhookEntegration: "قم بترقية خطتك لمزامنة التطبيقات الأخرى من خلال تكامل webhook.",
            readyContents: "قم بترقية خطتك لتعزيز التواصل مع العملاء من خلال المحتوى الجاهز.",
            automationEntegration: "قم بترقية خطتك لتحسين تدفق العمل باستخدام تكامل الأتمتة.",
            customerTablesEntegration: "قم بترقية خطتك لإدارة بيانات العملاء بشكل أكثر فعالية باستخدام جداول العملاء.",
            formEntegration: "قم بترقية خطتك لإدارة طلبات العملاء بشكل أكثر فعالية باستخدام النماذج.",
            maxFormLimit: "قم بترقية خطتك لإنشاء المزيد من النماذج وإدارة طلبات العملاء بشكل أفضل.",
            maxFormFieldLimit: "قم بترقية خطتك لإضافة المزيد من الحقول إلى النماذج وتحسين إدارة طلبات العملاء.",
            maxCustomerTableCount: "قم بترقية خطتك لإضافة المزيد من جداول العملاء.",
            maxCustomerTableFieldCount: "قم بترقية خطتك لإضافة المزيد من الحقول إلى جداول العملاء.",
            maxCustomerTableViewCount: "قم بترقية خطتك لحفظ المزيد من عرض جداول العملاء.",
            maxCustomerTableRecordCount: "قم بترقية خطتك لإضافة المزيد من السجلات إلى جداول العملاء.",
            maxAutomationButton: "قم بترقية خطتك لإضافة المزيد من كتل الأتمتة.",
            automationTimerBase: "قم بترقية خطتك لاستخدام مؤقتات الأتمتة.",
            automationEventBase: "قم بترقية خطتك لاستخدام أحداث الأتمتة.",
            automationWebhookBase: "قم بترقية خطتك لاستخدام webhooks للأتمتة.",
            automationButtonBase: "قم بترقية خطتك لاستخدام أزرار الأتمتة.",
            liveScore: "قم بترقية خطتك لتمكين ميزة المراقبة الحية.",
            multipleChatWindow: "قم بترقية خطتك لفتح عدة نوافذ للدردشة في نفس الوقت.",
            maxTaskWorkflowLimit: "قم بترقية خطتك لإضافة المزيد من تدفقات العمل المهام.",
            maxTaskColumnLimit: "قم بترقية خطتك لإضافة المزيد من الأعمدة في المهام.",
            maxTaskRowLimit: "قم بترقية خطتك لإضافة المزيد من الصفوف في المهام.",
            maxDepartmentLimit: "قم بترقية خطتك لإضافة المزيد من الأقسام.",
            maxRoleLimit: "قم بترقية خطتك لإضافة المزيد من الأدوار.",
            maxReadyContentsLimit: "قم بترقية خطتك لإضافة المزيد من المحتويات الجاهزة.",
            excelDownload: "قم بترقية خطتك لتمكين ميزة تنزيل ملفات Excel.",
            customerGroup: "قم بترقية خطتك لاستخدام ميزة مجموعات العملاء.",
            maxMailCount: "قم بترقية خطتك لإرسال المزيد من الرسائل الإلكترونية.",
            maxWhatsappChannel: "قم بترقية خطتك لإضافة المزيد من قنوات واتساب.",
            maxBusinessWhatsappChannel: "قم بترقية خطتك لإضافة المزيد من قنوات واتساب للأعمال.",
            maxInstagramChannel: "قم بترقية خطتك لإضافة المزيد من قنوات إنستاجرام.",
            maxMessengerChannel: "قم بترقية خطتك لإضافة المزيد من قنوات ماسنجر.",
            maxTelegramChannel: "قم بترقية خطتك لإضافة المزيد من قنوات تيليجرام.",
            maxTrendyolChannel: "قم بترقية خطتك لإضافة المزيد من قنوات ترينديول.",
            maxMetaLeadChannel: "قم بترقية خطتك لإضافة المزيد من قنوات ميتا ليد."
        },
        setupWizard: {
            finishModalVideos: "مقاطع فيديو تدريبية",
            finishModalDoc: "الوثائق",
            finsihModalLiveSupport: "الدعم المباشر",
            completed: "حسنًا، فهمت",
            completedWarning: "انقر على الزر لإكمال الإعداد وإنهاء الدليل",
            supsisSetupGuide: "دليل إعداد Supsis",
            supsisSetupGuideDescription: "يرجى إكمال هذه الخطوات للاستفادة الكاملة من Supsis.",
            goToSetup: "اذهب إلى الإعداد",
            completionPercentageDescription: "أنت تستخدم فقط % {percentage} من الميزات التي تقدمها Supsis.",
            aiChatbot: {
                title: "روبوت الدردشة بالذكاء الاصطناعي",
                content: "الرد على الرسائل الواردة تلقائياً، فوراً، وبذكاء باستخدام روبوت الدردشة بالذكاء الاصطناعي من Supsis.",
                steps: {
                    step1: {
                        title: "إنشاء روبوت دردشة",
                        content: "استخدم هذا الزر لإنشاء <b>سيناريو روبوت دردشة</b> جديد. يمكنك البدء بسرعة باختيار أحد القوالب المعدة خصيصًا لك، أو تصميم سيناريو أصلي بالكامل من الصفر لإنشاء روبوت دردشة يلبي احتياجات عملك بالكامل."
                    },
                    step2: {
                        title: "سيناريوهات جاهزة",
                        content: "فهم منطق العمل الأساسي لروبوت الدردشة بسهولة باستخدام <b>القوالب الجاهزة</b> هنا. وفر الوقت عن طريق تخصيص هذه القوالب وفقًا لاحتياجاتك وتطوير حلول مصممة خصيصًا. يمكنك البدء باختيار أي من القوالب المدرجة أدناه، والمناسبة لحالات الاستخدام المختلفة."
                    },
                    step3: {
                        title: "تكاملات روبوت الدردشة",
                        content: "ادمج روبوت الدردشة الذي أعددته مع <b>منصات التواصل الاجتماعي الشهيرة مثل واتساب وإنستغرام وفيسبوك</b>. بهذه الطريقة، يمكنك تفعيل روبوت الدردشة الخاص بك مباشرة على القنوات التي يستخدمها عملاؤك، مما يزيد من إمكانية الوصول والمشاركة."
                    },
                    step4: {
                        title: "تحليلات روبوت الدردشة",
                        content: "عرض وتحليل <b>أداء روبوت الدردشة الخاص بك باستخدام الرسوم البيانية والإحصائيات التفصيلية</b>. من خلال التصفية حسب فترات زمنية محددة أو المنصات التي قمت بدمجها، يمكنك قياس فعالية روبوت الدردشة الخاص بك، وتحديد مجالات التحسين، وتحسين استراتيجياتك."
                    }
                }
            },
            aiAssistant: {
                title: "المساعد الذكي",
                content: "تفعيل المساعد الرقمي لمساعدة فريق الدعم الخاص بك.",
                steps: {
                    step1: {
                        title: "تكامل OpenAI",
                        content: "<p>قم بإنشاء <b>تكامل سلس</b> بين OpenAI وSupsis AI لزيادة كفاءة عملك. وبهذه الطريقة، سيتم تفعيل مساعدك الذكي القوي وسيبدأ في تحسين عملياتك. لإكمال التكامل، كل ما عليك فعله هو إدخال مفتاح API الخاص بك لـ OpenAI. <br> <br> <b>للحصول على مفتاح API الخاص بك لـ OpenAI، <a href='https://platform.openai.com/account/api-keys' target='_blank'>انقر هنا</a>.</b></p>"
                    }
                }
            },
            aiLiveSupport: {
                title: "الدعم المباشر بالذكاء الاصطناعي",
                content: "تفعيل نظام الدردشة المباشرة المدعوم بالذكاء الاصطناعي.",
                steps: {
                    step1: {
                        title: "تصفية المحادثات",
                        content: "يمكنك إدارة <b>جميع محادثات العملاء</b> بسهولة من هذه المنطقة. يمكنك ترتيب المحادثات حسب الأولوية عن طريق تصفيتها إلى فئات مختلفة مثل غير المقروءة، المعلقة، أو تلك الجارية مع الروبوت الدردشة، مما يضمن عدم إغفال أي طلب."
                    },
                    step2: {
                        title: "عرض أكثر تفصيلاً",
                        content: "استخدم هذه الخيارات لفحص محادثات العملاء بعمق أكبر. يمكنك تطبيق <b>فلاتر أكثر تفصيلاً</b> مثل المحادثات غير المجاب عليها من الأمس أو العملاء المحددين الذين تواصلوا معك، أو إنشاء فلاتر مخصصة خاصة بك لتخصيص سير عملك."
                    },
                    step3: {
                        title: "شاشة الدعم المباشر",
                        content: "انتقل إلى هذا العرض <b>لإدارة جميع محادثات الدعم المباشر الخاصة بك بكفاءة من شاشة مركزية</b>. عرض جميع الرسائل، ردود الوكلاء، الحالات الحالية، ومعلومات التاريخ لكل محادثة في مكان واحد، مما يمكّنك من اتخاذ قرارات سريعة ودقيقة."
                    },
                    step4: {
                        title: "صفحة الاختبار",
                        content: "ادخل إلى هذا القسم لاختبار أداء وتشغيل برنامج الدردشة الآلي الذي أنشأته في الوقت الفعلي. عن طريق إرسال الرسائل كزائر، يمكنك <b>مراقبة استجابات وسلوكيات برنامج الدردشة الآلي الخاص بك عن كثب</b>، مما يسمح لك بإجراء جميع التحسينات اللازمة قبل تقديمه للمستخدمين النهائيين."
                    }
                }
            },
            aiAutomation: {
                title: "التحكم الآلي بالذكاء الاصطناعي",
                content: "أتمتة عمليات الدعم الخاصة بك وتوفير الوقت.",
                steps: {
                    step1: {
                        title: "إنشاء أتمتة جديدة",
                        content: "استخدم هذا الزر لإنشاء أتمتة جديدة لتبسيط عمليات عملك. يمكنك تصميم أتمتة تعتمد على الأحداث (مثل، عند وصول رسالة جديدة)، أو على الوقت (مثل، في وقت محدد كل صباح)، أو <b>تعتمد على Webhook</b> لجعل سير عملك أكثر ذكاءً."
                    },
                    step2: {
                        title: "فئات الأتمتة",
                        content: "عندما يكون لديك العديد من الأتمتة، قم بإنشاء <b>فئات الأتمتة</b> من هذا القسم لتسهيل الإدارة. تساعدك التصنيفات على تنظيم الأتمتة الخاصة بك والعثور عليها بسرعة عند الحاجة. استخدم هذا الزر لإنشاء فئة جديدة."
                    },
                    step3: {
                        title: "المهام المنفذة",
                        content: "بعد إنشاء ونشر الأتمتة الخاصة بك، يمكنك <b>تتبع عدد المهام التي نفذتها الأتمتة الخاصة بك على الفور</b> من هذا القسم. يتيح لك ذلك ملاحظة مدى نشاط الأتمتة الخاصة بك والعمليات التي تؤثر عليها."
                    },
                    step4: {
                        title: "إحصائيات الأتمتة",
                        content: "راجع <b>إحصائيات الأداء الشاملة</b> لأتمتةك في هذا القسم. شاهد عدد مرات تشغيل كل أتمتة، وعدد المهام الناجحة، ومعدل النجاح، وأي معدلات خطأ لتحسين استراتيجيات الأتمتة الخاصة بك."
                    }
                }
            },
            aiDynamicCrm: {
                title: "إدارة علاقات العملاء بالذكاء الاصطناعي (AI CRM)",
                content: "تحليل وإدارة تفاعلات العملاء الخاصة بك باستخدام الذكاء الاصطناعي.",
                steps: {
                    step1: {
                        title: "تصفية الزوار",
                        content: "يمكنك <b>تصفية الزوار</b> في قاعدة بيانات العملاء الخاصة بك بسهولة. يمكنك البحث عن الزوار حسب الاسم، عنوان البريد الإلكتروني، رقم الهاتف، العلامة، أو حقول الملف الشخصي المخصصة. يمكنك أيضًا الوصول إلى هذا القسم للحصول على عرض وتحليل أكثر تفصيلاً."
                    },
                    step2: {
                        title: "عرض الزوار",
                        content: "جميع زوارك مدرجون في هذا الجدول. <b>انقر نقرًا مزدوجًا على الصف ذي الصلة للوصول إلى مزيد من المعلومات واتخاذ إجراء بشأن الزائر</b>. في النافذة المفتوحة، يمكنك الوصول إلى سجل اتصالات الزائر وملاحظاته ومعلومات تفصيلية أخرى."
                    },
                    step3: {
                        title: "الحظر اليدوي",
                        content: "يمكنك <b>حظر الزوار يدويًا</b> الذين يظهرون سلوكًا غير مرغوب فيه أو غير لائق. يتم عرض الزوار المحظورين في قائمة منفصلة، ويمكنك إزالة الحظر من هذا القسم إذا لزم الأمر."
                    },
                    step4: {
                        title: "العلامات",
                        content: "اجعل نظام إدارة علاقات العملاء (CRM) الخاص بك أكثر تنظيمًا وسهولة في الإدارة من خلال <b>تصنيف زوارك باستخدام العلامات</b>. لتعيين علامات للزوار، تحتاج أولاً إلى إنشاء علامات خاصة بك. استخدم هذا الزر لإنشاء علامة جديدة."
                    },
                    step5: {
                        title: "حقول الملف الشخصي",
                        content: "تسمح لك <b>حقول الملف الشخصي</b> بجمع معلومات إضافية عن زوارك وإدارة هذه المعلومات بطريقة منظمة. بهذه الطريقة، يمكنك تعميق تقسيم العملاء الخاص بك، وتقديم خدمة مخصصة، وجعل علاقاتك مع العملاء أكثر فعالية."
                    }
                }
            },
            whatsappBusiness: {
                title: "واتساب للأعمال",
                content: "إدارة رسائل الدعم الخاصة بك عن طريق ربط حسابك في واتساب للأعمال.",
                steps: {
                    step1: {
                        title: "تكامل واتساب للأعمال",
                        content: "<p><b>قم بربط حسابك في واتساب للأعمال مع Supsis</b> وقم بإدارة جميع رسائل دعم العملاء الخاصة بك من لوحة تحكم مركزية واحدة. مع هذا التكامل، يمكنك إرسال رسائل فورية عبر واتساب، وإجراء إعلانات جماعية، وإعداد ردود تلقائية، وتتبع تفاعلات عملائك بشكل شامل.</p>"
                    }
                }
            },
            whatsappWeb: {
                title: "واتساب ويب",
                content: "إدارة الرسائل المستلمة عبر واتساب ويب باستخدام Supsis AI.",
                steps: {
                    step1: {
                        title: "تكامل واتساب ويب",
                        content: "<p><b>إدارة جميع الرسائل المستلمة عبر واتساب ويب بسلاسة باستخدام Supsis AI.</b> مع هذا التكامل، يمكنك إرسال رسائل فورية عبر واتساب، وإنشاء رسائل جماعية، وإعداد ردود تلقائية، وتتبع تفاعلات عملائك بسهولة. بهذه الطريقة، تجعل تواصلك مع العملاء أكثر كفاءة.</p>"
                    }
                }
            },
            instagram: {
                title: "إنستغرام",
                content: "الرد على رسائل إنستغرام المباشرة عبر Supsis AI.",
                steps: {
                    step1: {
                        title: "تكامل إنستغرام",
                        content: "<p><b>ركز تواصلك مع العملاء بالرد مباشرة على رسائل إنستغرام المباشرة عبر Supsis AI.</b> مع هذا التكامل، يمكنك إرسال رسائل فورية عبر إنستغرام، وإجراء إعلانات جماعية، وإعداد ردود تلقائية، وتتبع تفاعلات عملائك بشكل شامل.</p>"
                    }
                }
            },
            facebook: {
                title: "فيسبوك",
                content: "إدارة الرسائل من صفحتك على فيسبوك في لوحة تحكم واحدة.",
                steps: {
                    step1: {
                        title: "تكامل فيسبوك",
                        content: "<p><b>إدارة جميع الرسائل من صفحتك على فيسبوك بفعالية باستخدام Supsis AI.</b> مع هذا التكامل، يمكنك إرسال رسائل فورية عبر فيسبوك ماسنجر، وإنشاء رسائل جماعية، وإعداد ردود تلقائية، وتتبع تفاعلات عملائك.</p>"
                    }
                }
            },
            telegram: {
                title: "تليغرام",
                content: "دمج رسائل تليغرام مع Supsis AI.",
                steps: {
                    step1: {
                        title: "تكامل تليغرام",
                        content: "<p><b>ادمج رسائل تليغرام مع Supsis AI</b> وقم بإدارة تواصلك مع العملاء من لوحة واحدة. بفضل هذا التكامل، يمكنك إرسال رسائل فورية عبر تليغرام، وإنشاء رسائل جماعية، وإعداد ردود تلقائية، وتتبع جميع تفاعلات عملائك بسهولة.</p>"
                    }
                }
            },
            mail: {
                title: "بريد إلكتروني",
                content: "دمج رسائل البريد الإلكتروني للدعم الخاصة بك في نظام Supsis AI.",
                steps: {
                    step1: {
                        title: "إنشاء بريد إلكتروني جديد",
                        content: "<p>استخدم هذا الزر لإرسال بريد إلكتروني جديد. <b>من خلال ملء محتوى البريد الإلكتروني والمستلمين والمعلومات الضرورية الأخرى</b>، يمكنك إرسال رسائل البريد الإلكتروني الشخصية أو الجماعية بسرعة.</p>"
                    },
                    step2: {
                        title: "قوالب البريد الإلكتروني",
                        content: "<p><b>إدارة</b> قوالب البريد الإلكتروني الخاصة بك من هذا القسم. يمكنك تحرير أو حذف أو إنشاء قوالب جديدة. باستخدام القوالب المُعدة مسبقًا، يمكنك تسريع عمليات إرسال البريد الإلكتروني الخاصة بك وضمان تواصل متسق.</p>"
                    },
                    step3: {
                        title: "إرسال رسائل بريد إلكتروني جماعية",
                        content: "<p>استخدم هذه المنطقة <b>لإرسال رسائل بريد إلكتروني جماعية</b> للوصول إلى جمهور كبير. من خلال ملء الحقول المطلوبة، يمكنك بسهولة إرسال رسائل بريد إلكتروني جماعية إلى قائمة عملائك أو مجموعات محددة في Supsis.</p>"
                    },
                    step4: {
                        title: "إدارة مجموعات العملاء الخاصة بك",
                        content: "<p><b>إدارة</b> مجموعات العملاء الخاصة بك بفعالية من هذا القسم. يمكنك تحرير أو حذف أو إنشاء مجموعات جديدة. باستخدام هذه المجموعات، يمكنك تنظيم حملات بريد إلكتروني مستهدفة وتخصيص تواصلك بشكل أكبر.</p>"
                    }
                }
            },
            metaLead: {
                title: "ميتال ليد",
                content: "إدارة النماذج المستلمة من إعلاناتك على فيسبوك وإنستغرام.",
                steps: {
                    step1: {
                        title: "تكامل Meta Lead",
                        content: "<p>مع <b>تكامل Meta Lead</b>، قم بإدارة نماذج العملاء المحتملين المستلمة من إعلاناتك على فيسبوك وإنستغرام مباشرة من خلال Supsis. بفضل هذا التكامل، يمكنك تتبع العملاء المحتملين الذين تحصل عليهم من حملاتك الإعلانية بشكل أكثر كفاءة، وتسريع تواصلك مع العملاء المحتملين، وزيادة معدلات التحويل الخاصة بك.</p>"
                    }
                }
            },
            trendyol: {
                title: "ترينديول",
                content: "إدارة طلباتك ورسائل العملاء في ترينديول.",
                steps: {
                    step1: {
                        title: "تكامل ترينديول",
                        content: "<p>بفضل <b>عمليات تكامل ترينديول</b>، قم بإدارة طلباتك المستلمة عبر ترينديول مركزيًا من خلال Supsis. بعد إتمام هذا التكامل، يمكنك جعل عمليات طلباتك أكثر كفاءة، وتسهيل تواصلك مع العملاء، وتقليل عبء العمل التشغيلي الخاص بك.</p>"
                    }
                }
            },
            formSurvey: {
                title: "استبيانات النماذج",
                content: "إنشاء نماذج لجمع الملاحظات من العملاء.",
                steps: {
                    step1: {
                        title: "إنشاء نموذج جديد",
                        content: "<p>استخدم هذا الزر <b>لإنشاء نموذج أو استبيان جديد</b> لجمع التعليقات من عملائك. باستخدام النماذج التي تنشئها، يمكنك جمع تعليقات العملاء القيمة وجعل تواصلك أكثر كفاءة.</p>"
                    },
                    step2: {
                        title: "إدارة نماذجك",
                        content: "<p><b>إدارة جميع نماذجك بفعالية</b> من هذه المنطقة. يمكنك تعديل أو أرشفة أو حذف أو إنشاء نماذج جديدة. يمكنك أيضًا تتبع أداء النماذج المنشورة لديك، وعرض معدلات الاستجابة، وإجراء تعديلات فورية عند الضرورة. من خلال إدارة النماذج، يمكنك جمع وتحليل تعليقات العملاء بشكل أكثر فعالية.</p>"
                    }
                }
            },
            processManagement: {
                title: "إدارة العمليات",
                content: "خطط وأدر عمليات الدعم الخاصة بك خطوة بخطوة.",
                steps: {
                    step1: {
                        title: "إدارة عمليات عملك",
                        content: "<p>يتيح لك هذا القسم إدارة جميع عمليات عملك بفعالية. <b>يمكنك إنشاء المهام، وتعيينها لأعضاء فريقك، وتحسين سير عملك.</b> بهذه الطريقة، يمكنك جعل عملياتك أكثر كفاءة، وتتبع حالة المهام على الفور، وزيادة أداء فريقك.</p>"
                    },
                    step2: {
                        title: "قائمة المهام",
                        content: "<p><b>عرض جميع مهامك في عرض قائمة</b> من هذا القسم. يمكنك تصفية أو حذف أو إنشاء مهام جديدة. تتبع عبء عملك بسهولة من خلال عرض قائمة شاملة.</p>"
                    },
                    step3: {
                        title: "تصنيفات المهام",
                        content: "<p><b>إنشاء تصنيفات</b> لتنظيم وإدارة مهامك بشكل أفضل. باستخدام هذه التصنيفات، يمكنك بسهولة تصنيف المهام وتسريع عمليات البحث الخاصة بك. يمكنك استخدام هذا الزر لإنشاء تصنيفات.</p>"
                    },
                    step4: {
                        title: "أرشفة المهام",
                        content: "<p><b>أرشفة المهام المكتملة أو غير النشطة للحفاظ على تنظيم مساحة عملك</b>. يتم عرض المهام المؤرشفة هنا ويمكن استعادتها بسهولة عند الحاجة.</p>"
                    },
                    step5: {
                        title: "المهام المكتملة",
                        content: "<p>عرض <b>مهامك المكتملة</b> من هذا القسم. يمكنك تغيير حالة المهام المكتملة وأرشفتها إذا كنت ترغب في ذلك. بهذه الطريقة، يمكنك الاحتفاظ بسجل لعملك المكتمل وتحليل الأداء السابق.</p>"
                    }
                }
            },
            calendar: {
                title: "التقويم",
                content: "إدارة تقويم الاجتماعات والمهام الخاصة بك.",
                steps: {
                    step1: {
                        title: "التقويم",
                        content: "<p>خطط لاجتماعاتك اليومية بسهولة باستخدام هذا <b>التقويم</b> التفاعلي. يمكنك إنشاء مواعيد جديدة، أو تحديث الاجتماعات الموجودة من خلال التقويم، أو إلغائها. قم بتحسين إدارة مواعيدك وتحكم بفعالية في جدولك الزمني.</p>"
                    },
                    step2: {
                        title: "موقع الحجز",
                        content: "<p>اسمح لعملائك بحجز المواعيد بسهولة باستخدام <b>موقع الحجز</b> الخاص بك. يمكن لعملائك إجراء الحجوزات، وعرض، وتحديث، أو إلغاء مواعيدهم الحالية عبر هذا الموقع.</p>"
                    },
                    step3: {
                        title: "عرض موقعك الإلكتروني",
                        content: "<p>استخدم هذا الزر لعرض موقع الحجز الذي أنشأته على الفور. <b>تحقق من الإصدار النهائي لموقعك الإلكتروني</b> واختبر كيف سيرى عملاؤك حجوزاتهم. ستُدرج جميع حجوزاتك النشطة على موقعك الإلكتروني.</p>"
                    },
                    step4: {
                        title: "إنشاء حجز جديد",
                        content: "<p>استخدم هذا الزر <b>لإنشاء حجز جديد يدويًا</b>. من خلال ملء جميع المعلومات الضرورية، يمكنك إضافة الموعد بسرعة إلى التقويم الخاص بك وتخطيط اجتماعاتك مع عملائك.</p>"
                    }
                }
            },
            websiteAnalysis: {
                title: "تحليل الموقع",
                content: "تحليل سلوك الزوار والحصول على رؤى.",
                steps: {
                    step1: {
                        title: "إجمالي الزوار",
                        content: "<p>عرض <b>إجمالي عدد الزوار</b> لموقعك الإلكتروني من هذه المنطقة. يقيس هذا المقياس العدد الكلي للزوار الفريدين لموقعك ضمن فترة زمنية محددة ويساعدك على فهم مدى وصول موقعك الإجمالي.</p>"
                    },
                    step2: {
                        title: "متوسط الزوار",
                        content: "<p>تتبع <b>متوسط عدد الزوار اليومي أو الدوري</b> لموقعك الإلكتروني هنا. هذا المقياس مؤشر حاسم لتقييم الأداء الثابت لموقعك بمرور الوقت.</p>"
                    },
                    step3: {
                        title: "أقصى عدد من الزوار",
                        content: "<p>راقب <b>الأوقات التي وصل فيها موقع الويب الخاص بك إلى أكبر عدد من الزوار</b> باستخدام هذا المقياس. يوضح هذا المقياس أعلى عدد من الزوار لموقعك خلال فترة زمنية محددة، مما يساعدك على تحديد فترات الذروة للحملات أو المحتوى.</p>"
                    },
                    step4: {
                        title: "أدنى عدد من الزوار",
                        content: "<p>تتبع <b>الأوقات التي تلقى فيها موقع الويب الخاص بك أقل عدد من الزوار</b> باستخدام هذا المقياس. يوضح هذا المقياس أقل عدد من الزوار لموقعك خلال فترة زمنية محددة، مما يساعدك على تحديد فترات الأداء المنخفض واتخاذ الإجراءات اللازمة.</p>"
                    }
                }
            },
            ticketSystem: {
                title: "نظام تذاكر الدعم",
                content: "تنظيم طلبات العملاء بنظام التذاكر.",
                steps: {
                    step1: {
                        title: "حالة جديدة",
                        content: "<p><b>إنشاء حالات جديدة</b> لتسهيل إدارة طلبات الدعم الخاصة بك. على سبيل المثال، من خلال تحديد حالات مخصصة مثل 'قيد التنفيذ'، 'تم الحل'، 'معلق'، يمكنك جعل تدفق الطلبات أكثر شفافية.</p>"
                    },
                    step2: {
                        title: "الحالات",
                        content: "<p><b>عرض الحالات الحالية</b> لكل طلب دعم مفتوح هنا. من خلال تتبع الحالات مثل 'مقروء'، 'مجاب عليه'، 'ملغى'، يمكنك بسهولة رؤية المراحل الحالية للطلبات وتمكين إدارة فعالة للعمليات.</p>"
                    },
                    step3: {
                        title: "وضع العرض",
                        content: "<p>يمكنك التبديل بين <b>عرض القائمة أو كانبان</b> لإدارة طلبات الدعم الخاصة بك بشكل أكثر فعالية. من خلال تغيير وضع العرض، يمكنك تتبع حالات الطلبات بصريًا واختيار التخطيط الذي يناسب سير عملك.</p>"
                    }
                }
            },
            dynamicTables: {
                title: "جداول ديناميكية",
                content: "تخصيص وإدارة بياناتك عن طريق التصفية.",
                steps: {
                    step1: {
                        title: "إنشاء فئة",
                        content: "<p><b>تنظيم وإدارة بياناتك بشكل أفضل عن طريق تصنيف جداولك</b>. باستخدام زر إنشاء الفئة، يمكنك تحديد فئات جديدة، وتجميع جداولك، والوصول إلى البيانات التي تبحث عنها بسرعة أكبر.</p>"
                    },
                    step2: {
                        title: "إنشاء جدول جديد",
                        content: "<p>استخدم هذا الزر <b>لإنشاء جدول ديناميكي جديد مصمم خصيصًا لاحتياجاتك</b>. من خلال ملء المعلومات المطلوبة على شاشة إنشاء الجدول، يمكنك تخزين وإدارة بياناتك في بنية مخصصة.</p>"
                    },
                    step3: {
                        title: "إنشاء جدول بالذكاء الاصطناعي",
                        content: "<p>استخدم هذا الزر <b>لإنشاء جداول جديدة بسرعة بدعم من الذكاء الاصطناعي</b>. يكفي إدخال المعلومات ذات الصلة لإنشاء جدول بالذكاء الاصطناعي؛ سيساعدك النظام على تصميم جداول فعالة باقتراحات ذكية.</p>"
                    }
                }
            },
            aiVoice: {
                title: "وكيل صوتي بالذكاء الاصطناعي",
                content: "إدارة محادثات المستخدمين لديك مع وكلاء صوتيين مدعومين بالذكاء الاصطناعي.",
                steps: {
                    step1: {
                        title: "تكامل وكيل الصوت بالذكاء الاصطناعي",
                        content: "<p><b>ادمج وكيل الصوت بالذكاء الاصطناعي الخاص بك في Supsis</b> لأتمتة وتحسين عمليات التواصل مع عملائك. بعد إكمال التكامل، يمكنك إدارة التفاعلات الصوتية بكفاءة أكبر وزيادة رضا العملاء.</p>"
                    }
                }
            }
        },
        common: {
            cancel: "إلغاء",
            save: "حفظ",
            yes: "نعم",
            no: "لا",
            create: "إنشاء",
            delete: "حذف",
            edit: "تعديل",
            add: "إضافة",
            back: "عودة",
            active: "نشط",
            inactive: "غير نشط"
        },
        youtubeChannel: {
            youtubeIntegration: "تكامل يوتيوب",
            deleteYoutubeChannelInfo: "هل أنت متأكد أنك تريد حذف قناة يوتيوب هذه؟",
            youtubeChannels: "قنوات يوتيوب",
            title: "تعليقات يوتيوب",
            channelName: "اسم القناة",
            channelDetail: "تفاصيل القناة",
            channelDetailDesc: "إدارة قناة يوتيوب الخاصة بك",
            youtubeChannel: "قناة يوتيوب",
            status: "الحالة",
            active: "نشط",
            inactive: "غير نشط",
            detail: "التفاصيل",
            visibility: "الرؤية",
            videos: "الفيديوهات",
            comments: "التعليقات",
            visibilitySettings: "إعدادات الرؤية",
            visibilityDescription: "حدد المستخدمين والأقسام التي يمكنها رؤية هذه القناة",
            users: "المستخدمون",
            departments: "الأقسام",
            owners: "المالكون",
            selectUsers: "اختر المستخدمين",
            selectDepartments: "اختر الأقسام",
            selectOwners: "اختر المالكين",
            deleteChannel: "حذف القناة",
            deleteChannelDescription: "هل أنت متأكد أنك تريد حذف قناة يوتيوب هذه؟",
            channelUpdatedSuccess: "تم تحديث القناة بنجاح",
            failedUpdateChannel: "فشل تحديث القناة",
            connectedSuccess: "تم ربط حساب يوتيوب بنجاح",
            failedToCreateChannel: "فشل إنشاء القناة",
            requiredChannel: "اسم القناة مطلوب",
            oauthTimeout: "انتهت مهلة التفويض",
            all: "الكل",
            new: "جديد",
            replied: "تم الرد",
            resolved: "تم الحل",
            searchComments: "بحث في التعليقات",
            noCommentsFound: "لم يتم العثور على تعليقات",
            replies: "الردود",
            like: "إعجاب",
            reply: "رد",
            replyToComment: "الرد على التعليق",
            writeYourReply: "اكتب ردك",
            pleaseEnterReply: "يرجى إدخال رد",
            replySuccess: "تم إرسال الرد بنجاح",
            errorSendingReply: "خطأ في إرسال الرد",
            statusUpdated: "تم تحديث الحالة",
            errorUpdatingStatus: "خطأ في تحديث الحالة",
            errorFetchingComments: "خطأ في جلب التعليقات",
            commentLiked: "تم الإعجاب بالتعليق",
            errorLikingComment: "خطأ في الإعجاب بالتعليق",
            noVideosFound: "لم يتم العثور على فيديوهات",
            errorFetchingVideos: "خطأ في جلب الفيديوهات",
            refresh: "تحديث",
            loadMore: "تحميل المزيد",
            ensureYouTubeAccount: "تأكد من أن لديك حساب Google/YouTube",
            ensureYouTubeChannel: "تأكد من أن لديك قناة YouTube",
            permissionDesc: "تحتاج إلى السماح لـ Supsis بالوصول إلى تعليقات YouTube الخاصة بك.",
            connectToYouTube: "الاتصال بـ YouTube",
            views: "المشاهدات",
            likes: "الإعجابات",
            sync: "مزامنة",
            commentsSynced: "تمت مزامنة التعليقات",
            errorSyncingComments: "خطأ في مزامنة التعليقات",
            pending: "قيد الانتظار",
            rejected: "مرفوض",
            moderation: "الإشراف",
            publish: "نشر",
            holdForReview: "الاحتفاظ للمراجعة",
            reject: "رفض",
            rejectAndBan: "رفض وحظر",
            moderationSuccess: "تم الإشراف بنجاح",
            errorModeration: "فشل الإشراف",
            videoDetail: "تفاصيل الفيديو",
            duration: "المدة",
            showMore: "عرض المزيد",
            showLess: "عرض أقل",
            loadingVideo: "جاري تحميل الفيديو...",
            videoNotFound: "الفيديو غير موجود",
            goBack: "عودة",
            errorLoadingVideo: "خطأ في تحميل الفيديو",
            videosSynced: "تمت مزامنة الفيديوهات",
            errorSyncingVideos: "خطأ في مزامنة الفيديوهات",
            selectVideo: "اختر الفيديو",
            allVideos: "كل الفيديوهات",
            selectCommentToPreview: "اختر تعليقاً للمعاينه",
            viewDetails: "عرض التفاصيل",
            published: "منشور",
            heldForReview: "قيد المراجعة"
        },
        googleBusiness: {
            title: "مراجعات Google Business",
            channels: "قنوات Google Business",
            channelName: "اسم القناة",
            channelDetails: "تفاصيل القناة",
            connectToGoogleBusiness: "الاتصال بـ Google Business",
            ensureGoogleAccount: "تأكد من أن لديك حساب Google",
            ensureBusinessProfile: "تأكد من أن لديك حساب Google Business Profile",
            permissionDesc: "تحتاج إلى السماح لـ Supsis بالوصول إلى مراجعات Google Business الخاصة بك.",
            requiredChannel: "اسم القناة مطلوب",
            failedToCreateChannel: "فشل إنشاء القناة",
            connectedSuccess: "تم ربط حساب Google Business بنجاح",
            oauthTimeout: "انتهت مهلة التفويض",
            deleteChannelInfo: "هل أنت متأكد من حذف قناة Google Business هذه؟",
            deleteChannel: "حذف القناة",
            deleteChannelDescription: "هل أنت متأكد من حذف قناة Google Business هذه؟",
            detail: "التفاصيل",
            visibility: "الرؤية",
            locations: "المواقع",
            reviews: "المراجعات",
            accountInfo: "معلومات الحساب",
            accountName: "اسم الحساب",
            accountId: "معرف الحساب",
            status: "الحالة",
            enabled: "مفعّل",
            disabled: "معطّل",
            save: "حفظ",
            channelUpdated: "تم تحديث القناة بنجاح",
            errorUpdatingChannel: "خطأ في تحديث القناة",
            visibilityDescription: "حدد المستخدمين والأقسام الذين يمكنهم رؤية هذه القناة",
            visibleToUsers: "مرئي للمستخدمين",
            visibleToDepartments: "مرئي للأقسام",
            selectUsers: "اختيار المستخدمين",
            selectDepartments: "اختيار الأقسام",
            visibilityUpdated: "تم تحديث إعدادات الرؤية",
            errorUpdatingVisibility: "خطأ في تحديث إعدادات الرؤية",
            sync: "مزامنة",
            refresh: "تحديث",
            locationsSynced: "تمت مزامنة المواقع",
            errorSyncingLocations: "خطأ في مزامنة المواقع",
            errorFetchingLocations: "خطأ في جلب المواقع",
            noLocationsFound: "لم يتم العثور على مواقع",
            selectLocation: "اختيار الموقع",
            allLocations: "جميع المواقع",
            allRatings: "جميع التقييمات",
            all: "الكل",
            new: "جديد",
            replied: "تم الرد",
            resolved: "تم الحل",
            noReviewsFound: "لم يتم العثور على مراجعات",
            noComment: "لا يوجد نص تعليق",
            selectReviewToPreview: "اختر مراجعة للمعاينة",
            yourReply: "ردك",
            reply: "الرد",
            updateReply: "تحديث الرد",
            replyToReview: "الرد على المراجعة",
            writeYourReply: "اكتب ردك",
            pleaseEnterReply: "يرجى إدخال رد",
            replySuccess: "تم إرسال الرد بنجاح",
            errorSendingReply: "خطأ في إرسال الرد",
            statusUpdated: "تم تحديث الحالة",
            errorUpdatingStatus: "خطأ في تحديث الحالة",
            errorFetchingReviews: "خطأ في جلب المراجعات"
        },
        googlePlay: {
            title: "مراجعات Google Play",
            channels: "قنوات Google Play",
            channelName: "اسم القناة",
            channelDetails: "تفاصيل القناة",
            connectToGooglePlay: "الاتصال بـ Google Play",
            ensureGoogleAccount: "تأكد من أن لديك حساب Google",
            ensurePlayConsole: "تأكد من أن لديك حساب Google Play Console",
            permissionDesc: "تحتاج إلى السماح لـ Supsis بالوصول إلى مراجعات Google Play الخاصة بك.",
            requiredChannel: "اسم القناة مطلوب",
            failedToCreateChannel: "فشل إنشاء القناة",
            connectedSuccess: "تم ربط حساب Google Play بنجاح",
            oauthTimeout: "انتهت مهلة التفويض",
            deleteChannelInfo: "هل أنت متأكد من حذف قناة Google Play هذه؟",
            deleteChannel: "حذف القناة",
            deleteChannelDescription: "هل أنت متأكد من حذف قناة Google Play هذه؟",
            detail: "التفاصيل",
            visibility: "الرؤية",
            apps: "التطبيقات",
            reviews: "المراجعات",
            status: "الحالة",
            enabled: "مفعّل",
            disabled: "معطّل",
            save: "حفظ",
            channelUpdated: "تم تحديث القناة بنجاح",
            errorUpdatingChannel: "خطأ في تحديث القناة",
            visibilityDescription: "حدد المستخدمين والأقسام الذين يمكنهم رؤية هذه القناة",
            visibleToUsers: "مرئي للمستخدمين",
            visibleToDepartments: "مرئي للأقسام",
            selectUsers: "اختيار المستخدمين",
            selectDepartments: "اختيار الأقسام",
            visibilityUpdated: "تم تحديث إعدادات الرؤية",
            errorUpdatingVisibility: "خطأ في تحديث إعدادات الرؤية",
            addApp: "إضافة تطبيق",
            refresh: "تحديث",
            noAppsFound: "لم يتم العثور على تطبيقات",
            packageName: "اسم الحزمة",
            appName: "اسم التطبيق",
            appNamePlaceholder: "مثال: تطبيقي",
            iconUrl: "رابط الأيقونة",
            fillRequiredFields: "يرجى ملء الحقول المطلوبة",
            appAdded: "تمت إضافة التطبيق بنجاح",
            errorAddingApp: "خطأ في إضافة التطبيق",
            syncReviews: "مزامنة المراجعات",
            reviewsSynced: "تمت مزامنة المراجعات",
            errorSyncingReviews: "خطأ في مزامنة المراجعات",
            removeApp: "إزالة التطبيق",
            removeAppConfirm: "هل أنت متأكد من إزالة {name}؟ سيتم حذف جميع المراجعات المرتبطة أيضاً.",
            appRemoved: "تمت إزالة التطبيق",
            errorRemovingApp: "خطأ في إزالة التطبيق",
            errorFetchingApps: "خطأ في جلب التطبيقات",
            selectApp: "اختيار التطبيق",
            allApps: "جميع التطبيقات",
            allRatings: "جميع التقييمات",
            all: "الكل",
            new: "جديد",
            replied: "تم الرد",
            resolved: "تم الحل",
            noReviewsFound: "لم يتم العثور على مراجعات",
            noComment: "لا يوجد نص تعليق",
            selectReviewToPreview: "اختر مراجعة للمعاينة",
            yourReply: "ردك",
            reply: "الرد",
            updateReply: "تحديث الرد",
            replyToReview: "الرد على المراجعة",
            writeYourReply: "اكتب ردك (بحد أقصى 350 حرفاً)",
            pleaseEnterReply: "يرجى إدخال رد",
            replyTooLong: "لا يمكن أن يتجاوز الرد 350 حرفاً",
            replySuccess: "تم إرسال الرد بنجاح",
            errorSendingReply: "خطأ في إرسال الرد",
            statusUpdated: "تم تحديث الحالة",
            errorUpdatingStatus: "خطأ في تحديث الحالة",
            errorFetchingReviews: "خطأ في جلب المراجعات",
            deviceInfo: "معلومات الجهاز",
            device: "الجهاز",
            appVersion: "إصدار التطبيق",
            manufacturer: "الشركة المصنعة"
        },
        googleDrive: {
            title: "Google Drive",
            googleDriveChannels: "قنوات Google Drive",
            googleDriveIntegration: "تكامل Google Drive",
            channelName: "اسم القناة",
            channelInfo: "معلومات القناة",
            channelSettings: "إعدادات القناة",
            connectedAccount: "الحساب المتصل",
            storageQuota: "حصة التخزين",
            connectToGoogleDrive: "الاتصال بـ Google Drive",
            ensureGoogleAccount: "تأكد من أن لديك حساب Google",
            ensureGoogleDriveAccess: "تأكد من أن لديك صلاحية الوصول إلى Google Drive",
            permissionDesc: "تحتاج إلى السماح لـ Supsis بالوصول إلى ملفات Google Drive الخاصة بك.",
            requiredChannel: "اسم القناة مطلوب",
            failedToCreateChannel: "فشل إنشاء القناة",
            connectedSuccess: "تم ربط حساب Google Drive بنجاح",
            oauthTimeout: "انتهت مهلة التفويض",
            deleteGoogleDriveChannelInfo: "هل أنت متأكد من حذف قناة Google Drive هذه؟",
            deleteChannel: "حذف القناة",
            deleteChannelDescription: "هل أنت متأكد من حذف قناة Google Drive هذه؟",
            driveExplorer: "مستكشف Drive",
            myDrive: "القرص الخاص بي",
            sharedDrives: "الأقراص المشتركة",
            searchFiles: "البحث في الملفات...",
            noSharedDrives: "لم يتم العثور على أقراص مشتركة",
            noFiles: "لم يتم العثور على ملفات",
            loadMore: "تحميل المزيد",
            filesSelected: "ملف محدد",
            downloadToSupsis: "تنزيل إلى Supsis",
            fileDownloaded: "تم تنزيل الملف بنجاح",
            errorLoadingFiles: "خطأ في تحميل الملفات",
            errorLoadingDrives: "خطأ في تحميل الأقراص",
            errorSearching: "خطأ في البحث",
            errorDownloading: "خطأ في تنزيل الملف",
            fileName: "اسم الملف",
            fileSize: "الحجم",
            modifiedTime: "وقت التعديل",
            selectFile: "اختيار ملف",
            selectFileFromGoogleDrive: "اختيار ملف من Google Drive",
            selectChannel: "اختيار القناة",
            noChannelsAvailable: "لم يتم العثور على قنوات Google Drive قابلة للوصول",
            selectedFiles: "الملفات المحددة",
            upload: "رفع",
            selectUploadMethod: "اختيار طريقة الرفع:",
            uploadFromComputer: "الرفع من الجهاز",
            downloadingFiles: "جاري تنزيل الملفات...",
            myChannel: "قناتي",
            manageWhoCanAccess: "إدارة من يمكنه الوصول إلى هذه القناة",
            download: "تنزيل",
            openInNewTab: "فتح في تبويب جديد",
            openInGoogleDrive: "فتح في Google Drive",
            fileType: "نوع الملف",
            owner: "المالك",
            previewNotAvailable: "المعاينة غير متاحة لهذا النوع من الملفات",
            byocTitle: "استخدام بيانات اعتماد Google Cloud الخاصة بك",
            byocDescription: "لتكامل Google Drive، تحتاج إلى إنشاء بيانات اعتماد عميل OAuth من Google Cloud Console الخاص بك.",
            clientId: "معرف عميل OAuth",
            clientIdPlaceholder: "xxxxxxxx.apps.googleusercontent.com",
            clientIdRequired: "معرف العميل مطلوب",
            clientSecret: "سر عميل OAuth",
            clientSecretPlaceholder: "GOCSPX-xxxxxxxxxx",
            clientSecretRequired: "سر العميل مطلوب",
            redirectUriCopied: "تم نسخ رابط إعادة التوجيه",
            setupGuideTitle: "دليل الإعداد (انقر للتوسيع)",
            setupStep1: "انتقل إلى Google Cloud Console وأنشئ مشروعاً جديداً أو اختر مشروعاً موجوداً.",
            setupStep2: "انتقل إلى APIs & Services > Credentials.",
            setupStep3: "انقر \"+ CREATE CREDENTIALS\" > \"OAuth client ID\". اختر \"Web application\" كنوع التطبيق.",
            setupStep4: "أضف الرابط التالي إلى قسم Authorized redirect URIs:",
            setupStep5: "فعّل \"Google Drive API\" من APIs & Services > Library.",
            setupStep6: "انسخ قيم Client ID و Client Secret والصقهما في الحقول أعلاه."
        },
        appStore: {
            title: "مراجعات App Store",
            channels: "قنوات App Store",
            channelName: "اسم القناة",
            channelDetails: "تفاصيل القناة",
            connectToAppStore: "الاتصال بـ App Store",
            credentials: "بيانات اعتماد API",
            credentialsHelp: "أدخل بيانات اعتماد App Store Connect API. يمكنك إنشاء مفتاح API من",
            issuerId: "معرف المصدر",
            issuerIdPlaceholder: "xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx",
            keyId: "معرف المفتاح",
            keyIdPlaceholder: "XXXXXXXXXX",
            privateKey: "المفتاح الخاص (محتوى ملف .p8)",
            privateKeyPlaceholder: "-----BEGIN PRIVATE KEY-----\n...\n-----END PRIVATE KEY-----",
            requiredField: "هذا الحقل مطلوب",
            validateCredentials: "التحقق من البيانات",
            credentialsValid: "البيانات صالحة",
            credentialsInvalid: "بيانات غير صالحة",
            pleaseValidateFirst: "يرجى التحقق من بياناتك أولاً",
            failedToCreateChannel: "فشل إنشاء القناة",
            connectedSuccess: "تم ربط حساب App Store بنجاح",
            deleteChannelInfo: "هل أنت متأكد من حذف قناة App Store هذه؟",
            deleteChannel: "حذف القناة",
            deleteChannelDescription: "هل أنت متأكد من حذف قناة App Store هذه؟",
            detail: "التفاصيل",
            visibility: "الرؤية",
            apps: "التطبيقات",
            reviews: "المراجعات",
            status: "الحالة",
            enabled: "مفعّل",
            disabled: "معطّل",
            save: "حفظ",
            channelUpdated: "تم تحديث القناة بنجاح",
            errorUpdatingChannel: "خطأ في تحديث القناة",
            visibilityDescription: "حدد المستخدمين والأقسام الذين يمكنهم رؤية هذه القناة",
            visibleToUsers: "مرئي للمستخدمين",
            visibleToDepartments: "مرئي للأقسام",
            selectUsers: "اختيار المستخدمين",
            selectDepartments: "اختيار الأقسام",
            visibilityUpdated: "تم تحديث إعدادات الرؤية",
            errorUpdatingVisibility: "خطأ في تحديث إعدادات الرؤية",
            syncApps: "مزامنة التطبيقات",
            refresh: "تحديث",
            noAppsFound: "لم يتم العثور على تطبيقات",
            appsAutoFetch: "يتم جلب التطبيقات تلقائياً من App Store Connect. انقر \"مزامنة التطبيقات\" لتحديث القائمة.",
            appsSynced: "تمت مزامنة التطبيقات بنجاح",
            errorSyncingApps: "خطأ في مزامنة التطبيقات",
            syncReviews: "مزامنة المراجعات",
            reviewsSynced: "تمت مزامنة المراجعات",
            errorSyncingReviews: "خطأ في مزامنة المراجعات",
            errorFetchingApps: "خطأ في جلب التطبيقات",
            selectApp: "اختيار التطبيق",
            allApps: "جميع التطبيقات",
            all: "الكل",
            new: "جديد",
            replied: "تم الرد",
            resolved: "تم الحل",
            noReviewsFound: "لم يتم العثور على مراجعات",
            noComment: "لا يوجد نص تعليق",
            anonymous: "مجهول",
            selectReviewToPreview: "اختر مراجعة للمعاينة",
            yourReply: "ردك",
            reply: "الرد",
            edit: "تحرير",
            delete: "حذف",
            editReply: "تحرير الرد",
            replyToReview: "الرد على المراجعة",
            writeYourReply: "اكتب ردك",
            pleaseEnterReply: "يرجى إدخال رد",
            replySuccess: "تم إرسال الرد بنجاح",
            errorSendingReply: "خطأ في إرسال الرد",
            deleteResponse: "حذف الرد",
            deleteResponseConfirm: "هل أنت متأكد من حذف هذا الرد؟",
            responseDeleted: "تم حذف الرد بنجاح",
            errorDeletingResponse: "خطأ في حذف الرد",
            statusUpdated: "تم تحديث الحالة",
            errorUpdatingStatus: "خطأ في تحديث الحالة",
            errorFetchingReviews: "خطأ في جلب المراجعات",
            territory: "المنطقة",
            region: "المنطقة"
        },
        LinkedinContacts: "جهات اتصال لينكدإن",
        TelegramContacts: "جهات اتصال تيليجرام",
        announcements: {
            menu: "الإعلانات",
            newAnnouncementForm: "نموذج تسجيل إعلان جديد",
            updateAnnouncementForm: "نموذج تحديث الإعلان"
        },
        packages: {
            mostPopular: "الأكثر اختياراً",
            currency: "₺",
            activePlan: "الخطة النشطة"
        },
        totalCost: {
            title: "تكلفة SUPSIS",
            monthlyPayments: "الدفعات الشهرية",
            currency: "₺",
            currencyMonthly: "₺ / شهرياً",
            oneTimePayments: "الدفعات لمرة واحدة",
            oneTimeDiscount: "خصم الباقة السنوية",
            currencyYearly: "₺ / سنوياً",
            totalOneTimeCost: "إجمالي المبلغ المستحق دفعة واحدة",
            totalTax: "الضريبة (%18)",
            referenceCode: "هل لديك رمز إحالة؟",
            referencePlaceholder: "يرجى إدخال الرمز",
            codeButton: "تطبيق",
            monthlyCost: "المبلغ الذي سيُخصم شهرياً من حسابك؟",
            oneTimeFullCost: "المبلغ الشامل لمرة واحدة؟",
            payment: "إتمام الدفع"
        },
        probel: {
            branchCode: "رمز الفرع",
            branchCodeDesc: "اكتب أو اختر رمز الفرع...",
            hospitalBranchCode: "رمز المركز",
            hospitalBranchCodeDesc: "اكتب أو اختر رمز المركز...",
            clinicCode: "رمز العيادة",
            clinicCodeDesc: "اكتب أو اختر رمز العيادة...",
            date: "تاريخ الموعد",
            dateDesc: "أدخل أو اختر تاريخ الموعد...",
            patientToken: "رمز المريض",
            patientTokenDesc: "اكتب أو اختر رمز المريض...",
            appointmentId: "معرف الموعد",
            appointmentIdDesc: "اكتب أو اختر معرف الموعد...",
            identityType: "نوع الهوية",
            identityNumber: "رقم الهوية",
            name: "اسم المريض",
            surname: "لقب المريض",
            gender: "جنس المريض",
            birthDay: "تاريخ ميلاد المريض",
            phoneNumber: "رقم هاتف المريض",
            identityTypeDesc: "اكتب أو اختر نوع الهوية...",
            identityNumberDesc: "اكتب أو اختر رقم الهوية...",
            nameDesc: "اكتب أو اختر اسم المريض...",
            surnameDesc: "اكتب أو اختر لقب المريض...",
            genderDesc: "اكتب أو اختر جنس المريض...",
            birthDayDesc: "اكتب أو اختر تاريخ ميلاد المريض...",
            phoneNumberDesc: "اكتب أو اختر رقم هاتف المريض..."
        },
        waba: {
            templateCreationFailed: "فشل إنشاء القالب",
            templateError_2388040: "تجاوز حد الأحرف",
            templateErrorDesc_2388040: "تجاوز حقل في القالب الحد الأقصى المسموح به للأحرف.",
            templateError_2388047: "تنسيق ترويسة الرسالة غير صحيح",
            templateErrorDesc_2388047: "ترويسة الرسالة تحتوي على تنسيق غير صالح.",
            templateError_2388072: "تنسيق نص الرسالة غير صحيح",
            templateErrorDesc_2388072: "نص الرسالة يحتوي على تنسيق غير صالح.",
            templateError_2388073: "تنسيق تذييل الرسالة غير صحيح",
            templateErrorDesc_2388073: "تذييل الرسالة يحتوي على تنسيق غير صالح.",
            templateError_2388293: "نسبة المعلمات تتجاوز الحد",
            templateErrorDesc_2388293: "هذا القالب يحتوي على متغيرات كثيرة بالنسبة لطوله. قلّل عدد المتغيرات أو زِد طول الرسالة.",
            templateError_2388299: "المتغيرات في البداية أو النهاية غير مسموحة",
            templateErrorDesc_2388299: "لا يمكن أن تكون المتغيرات في بداية أو نهاية القالب."
        },
        profile: {
            subtitle: "إدارة إعدادات حسابك وجلساتك"
        },
        integrations: {
            requiredField: "هذا الحقل مطلوب",
            existingChannels: "القنوات الموجودة",
            createNewChannel: "إنشاء قناة جديدة",
            channelName: "اسم القناة",
            createChannel: "إنشاء قناة",
            channelCreated: "تم إنشاء القناة بنجاح",
            channelCreateError: "حدث خطأ أثناء إنشاء القناة",
            channelActivated: "تم تفعيل القناة",
            channelDeactivated: "تم تعطيل القناة",
            channelUpdateError: "حدث خطأ أثناء تحديث القناة",
            deleteChannelConfirm: "حذف القناة",
            deleteChannelConfirmContent: "هل أنت متأكد من حذف قناة {name}؟",
            channelDeleted: "تم حذف القناة بنجاح",
            channelDeleteError: "حدث خطأ أثناء حذف القناة",
            slackIntegration: "تكامل Slack",
            slackDescription: "إرسال رسائل إلى مساحة عمل Slack عبر أتمتة Supsis وروبوت الدردشة.",
            slackSetupTitle: "خطوات الإعداد:",
            slackStep1: "انتقل إلى api.slack.com/apps",
            slackStep2: "اختر تطبيق Slack الموجود أو أنشئ تطبيقاً جديداً",
            slackStep3: "انقر \"Incoming Webhooks\" من القائمة اليسرى وفعّله",
            slackStep4: "انقر \"Add New Webhook to Workspace\" واختر القناة التي تريد إرسال الرسائل إليها",
            slackCardDescription: "إرسال رسائل إلى قنوات Slack عبر الأتمتة وروبوت الدردشة",
            slackChannelNamePlaceholder: "مثال: إشعارات الدعم",
            slackWebhookUrl: "رابط Webhook",
            slackWebhookUrlPlaceholder: "https://hooks.slack.com/services/...",
            slackWebhookUrlHelper: "انتقل إلى Slack App > Incoming Webhooks > Add New Webhook to Workspace",
            slackWebhookUrlInvalid: "يرجى إدخال رابط Slack webhook صالح",
            slackDefaultChannel: "القناة الافتراضية (اختياري)",
            slackDefaultChannelPlaceholder: "#general",
            slackDefaultChannelHelper: "إذا لم تُحدد، ستُستخدم القناة المتصلة بالـ webhook",
            pushoverIntegration: "تكامل Pushover",
            pushoverCardDescription: "إرسال إشعارات push إلى أجهزتك المحمولة عبر الأتمتة وروبوت الدردشة",
            pushoverDescription: "إرسال إشعارات push إلى أجهزتك المحمولة عبر أتمتة Supsis وروبوت الدردشة. يمكنك إنشاء حساب والحصول على User Key و Application Token من pushover.net.",
            pushoverChannelNamePlaceholder: "مثال: إشعارات الجوال",
            pushoverUserKey: "مفتاح المستخدم",
            pushoverUserKeyPlaceholder: "مفتاح مستخدم Pushover",
            pushoverUserKeyHelper: "يمكنك الحصول عليه من صفحة حسابك على pushover.net",
            pushoverAppToken: "رمز التطبيق",
            pushoverAppTokenPlaceholder: "رمز تطبيق Pushover",
            pushoverAppTokenHelper: "يمكنك إنشاء تطبيق على pushover.net للحصول على الرمز"
        },
        "At the end of the month, an invoice will be created according to your usage amount": {
            "": "#VALUE!"
        },
        "No money will be withdrawn from your account": {
            "": "#VALUE!"
        },
        addWebhook: "إضافة خطاف ويب",
        allIntegrations: "جميع التكاملات",
        editWebhook: "تحرير خطاف الويب",
        integrateYourCBwithChatGpt3: "يمكن دمج روبوت الدردشة مع GPT-4. مفتاح GPT-4 API مطلوب.",
        integrateYourCBwithChatWidget: "دمج روبوت الدردشة مع عنصر الدردشة.",
        integrateYourCBwithIntegratable: "تمرير معلومات الدردشة بسهولة بين روبوت الدردشة و {integratable}.",
        integrateYourCBwithWebHook: "تمرير معلومات الدردشة بسهولة بين روبوت الدردشة وخدماتك على الويب.",
        newWebhook: "خطاف ويب جديد",
        webhookPassword: "كلمة مرور خطاف الويب",
        webhookTitle: "عنوان خطاف الويب",
        webhookToken: "رمز خطاف الويب",
        webhookUrl: "رابط خطاف الويب",
        webhookUsername: "اسم مستخدم خطاف الويب",
        "{contentOfChatBubble}": "#VALUE!",
        task_reports: {
            title: "تقارير المهام",
            date: "التاريخ",
            workflow: "سير العمل",
            select: "تحديد",
            agent: "الوكيل",
            all: "الكل",
            select_workflow_to_view_reports: "حدد سير عمل لعرض التقارير.",
            created_task: "مهمة تم إنشاؤها",
            updated_task: "مهمة تم تحديثها",
            assigned_tasks_by_personnel: "المهام المعينة حسب الموظفين",
            assigned_task: "مهمة معينة",
            no_assigned_task_found_in_date_range: "لم يتم العثور على مهام معينة في النطاق الزمني المحدد.",
            updated_tasks: "المهام المحدثة",
            task: "مهمة",
            current_stage: "المرحلة الحالية",
            assigned: "معين",
            update: "تحديث",
            no_updated_task_found_in_date_range: "لم يتم العثور على مهام محدثة في النطاق الزمني المحدد.",
            task_distribution_by_agent: "توزيع المهام حسب الوكيل",
            total: "الإجمالي",
            no_assigned_task_found: "لم يتم العثور على مهام معينة.",
            timeline: "الجدول الزمني",
            unassigned_tasks: "المهام غير المعينة",
            transition_process: "عملية الانتقال",
            no_active_task_found_for_agent: "لم يتم العثور على مهام نشطة لهذا الوكيل.",
            select_agent_to_view_timeline: "حدد وكيلاً لعرض الجدول الزمني.",
            entry: "دخول",
            exit: "خروج",
            still_in_this_stage: "لا يزال في هذه المرحلة",
            duration: "المدة",
            day: "يوم",
            hour: "ساعة",
            max_30_days_range_warning: "يمكنك تحديد نطاق زمني يصل إلى 30 يومًا.",
            today: "اليوم",
            this_week: "هذا الأسبوع",
            this_month: "هذا الشهر",
            last_month: "الشهر الماضي",
            unknown: "مجهول",
            unassigned: "غير معين",
            gantt: "غانت",
            table: "جدول"
        },
        customBlockErrors: {
            BLOCK_NOT_FOUND: "الكتلة غير موجودة",
            BLOCK_NOT_APPROVED: "لم تتم الموافقة على هذه الكتلة بعد",
            BLOCK_ALREADY_IMPORTED: "تم استيراد هذه الكتلة بالفعل",
            BLOCK_IMPORT_FAILED: "فشل استيراد الكتلة"
        },
        developer: {
            webhookUrls: "روابط Webhook",
            webhookUrlsDescription: "سيتم إرسال الرسائل الواردة إلى هذه الروابط.",
            webhookNamePlaceholder: "الاسم (مثال: نظامي)",
            webhookUrlPlaceholder: "https://...",
            addWebhook: "إضافة Webhook",
            webhookSaved: "تم حفظ روابط Webhook.",
            webhookSaveError: "تعذّر الحفظ.",
            webhookValidationError: "يجب ملء جميع حقول webhook.",
            messagingApi: "واجهة برمجة الرسائل",
            messagingApiDescription: "أرسل رسائل عبر هذه القناة من أنظمتك الخاصة.",
            endpoint: "نقطة النهاية",
            authentication: "المصادقة",
            requestBody: "جسم الطلب (أمثلة)",
            webhookPayload: "بيانات Webhook (رسالة واردة)",
            noToken: "لم يتم إنشاء أي رمز بعد.",
            tokenGenerateWarning: "إذا نقرت على إنشاء رمز، ستنتهي صلاحية الرمز الحالي.",
            tokenGenerated: "تم إنشاء الرمز بنجاح.",
            tokenGenerateError: "فشل إنشاء الرمز.",
            copied: "تم النسخ.",
            sendMessageDesc: "يرسل رسالة إلى العميل المحدد عبر هذه القناة.",
            fromParamsDesc: "from: api (افتراضي) | user | chatbot. userId مطلوب عند from=user. chatbot يرسل كشات بوت.",
            userIdParamsDesc: "userId (User ObjectId) مطلوب. يتم إرسال الرسالة نيابة عن المستخدم المحدد.",
            fromUserIdParamsDesc: "from (User ObjectId) مطلوب. يتم إرسال الرسالة نيابة عن المستخدم المحدد.",
            contactIdParamsDesc: "هذا هو معرّف الزائر. يمكنك الحصول عليه من حقل visitor.id في بيانات الـ webhook.",
            webhookEventReceived: "رسالة واردة",
            webhookEventSent: "رسالة صادرة",
            yourWebhookUrl: "<رابط-webhook-الخاص-بك>",
            webhookPayloadDesc: "يتم إرسال طلب POST إلى روابط webhook المحددة لكل رسالة واردة.",
            webhookSentDesc: "عند معالجة الرسائل المرسلة عبر API، يتم إرسال حدث message.sent إلى webhook. status: sent (سيتم إضافة delivered، failed لاحقاً).",
            curlExample: "مثال cURL",
        }
    }
};

export default messagesAR;
